export const LANGS = {
  en: "English",
  es: "Español",
  fr: "Français",
  de: "Deutsch",
  pt: "Português",
  it: "Italiano",
  ar: "العربية",
  he: "עברית",
};

export const COUNTRIES = [
  { code: "US", name: "United States", flag: "🇺🇸", lang: "en", currency: "USD" },
  { code: "GB", name: "United Kingdom", flag: "🇬🇧", lang: "en", currency: "GBP" },
  { code: "CA", name: "Canada", flag: "🇨🇦", lang: "en", currency: "CAD" },
  { code: "AU", name: "Australia", flag: "🇦🇺", lang: "en", currency: "AUD" },
  { code: "FR", name: "France", flag: "🇫🇷", lang: "fr", currency: "EUR" },
  { code: "DE", name: "Germany", flag: "🇩🇪", lang: "de", currency: "EUR" },
  { code: "ES", name: "Spain", flag: "🇪🇸", lang: "es", currency: "EUR" },
  { code: "IT", name: "Italy", flag: "🇮🇹", lang: "it", currency: "EUR" },
  { code: "MX", name: "Mexico", flag: "🇲🇽", lang: "es", currency: "MXN" },
  { code: "BR", name: "Brazil", flag: "🇧🇷", lang: "pt", currency: "BRL" },
  { code: "IL", name: "Israel", flag: "🇮🇱", lang: "he", currency: "ILS" },
  { code: "SA", name: "Saudi Arabia", flag: "🇸🇦", lang: "ar", currency: "SAR" },
  { code: "AE", name: "United Arab Emirates", flag: "🇦🇪", lang: "ar", currency: "AED" },
];

export const CURRENCY_RATES = { USD: 1, EUR: 0.92, GBP: 0.79, CAD: 1.36, AUD: 1.52, MXN: 17.2, BRL: 5.1, ILS: 3.65, SAR: 3.75, AED: 3.67 };
export const CURRENCY_SYMBOLS = { USD: "$", EUR: "€", GBP: "£", CAD: "CA$", AUD: "A$", MXN: "MX$", BRL: "R$", ILS: "₪", SAR: "SR ", AED: "AED " };

export const translations = {
  en: {
    "nav.events": "Events",
    "leaderboard.youOnBoard": "🏆 You're on the leaderboard!",
    "leaderboard.youOnBoardSub": "members on the other side see you ranked here. Keep shining!",
    "events.title": "Events",
    "events.subtitle": "Exclusive member events — come meet in real life.",
    "events.empty": "No upcoming events right now — check back soon!",
    "events.loading": "Loading events…",
    "events.spotsLeft": "{n} spots left",
    "events.soldOut": "Sold out",
    "events.joinedChip": "You're in!",
    "events.free": "Free",
    "events.feeNote": "${price} + $2 handling fee",
    "events.payCredits": "Join with {n} credits",
    "events.payPaypal": "Pay with PayPal · ${total}",
    "events.joinFree": "Join free",
    "events.notEnough": "Not enough credits — this event costs {n} credits",
    "events.joinedToast": "🎟️ You're in! Check your email for confirmation.",
    "events.payCancelled": "Payment cancelled",
    "events.captureFail": "We couldn't confirm your payment — please try again",
    "events.bannerTitle": "🎉 Upcoming event",
    "events.bannerCta": "See events",
    "notif.eventJoined.t": "🎟️ You're going!",
    "notif.eventJoined.b": "Your spot at \"{title}\" is confirmed. See you there!",
    "notif.eventCancelled.t": "😔 Event cancelled",
    "notif.eventCancelled.b": "\"{title}\" was cancelled. If you paid, your refund is on the way.",
    "terms.contactT": "Contact Us",
    "terms.contactP": "Questions, concerns or feedback? Reach us anytime:",
    "msdluxe.tapSound": "Tap for sound",
    "msdluxe.badge": "Your AI hostess",
    "msdluxe.title1": "Meet Ms DLuxe",
    "msdluxe.title2": "She'll show you around",
    "msdluxe.desc": "Ms DLuxe herself explains exactly how it works — credits, premium date offers, earnings and safety.",
    "msdluxe.luxeCard": "How LuxeMeet works",
    "msdluxe.dluxeCard": "How DLuxe works",
    "msdluxe.download": "Download",
    "msdluxe.share": "Save them, post them, send them to a friend — they're yours to share.",
    "nav.msdluxeVideos": "How it works · Ms DLuxe",
    "credits.requestRefund": "Request refund",
    "credits.refundRequested": "Refund requested",
    "credits.refunded": "Refunded",
    "credits.refundDeniedChip": "Not approved",
    "credits.refundDialogTitle": "Request a refund",
    "credits.refundDialogDesc": "Tell us why you'd like a refund for this purchase. Our team reviews every request and you'll get a notification and email with the decision.",
    "credits.refundReasonPh": "Why would you like a refund?",
    "credits.refundSubmit": "Submit request",
    "credits.refundSent": "Refund request sent — we'll review it shortly",
    "safety.checkinToggle": "Safety check-in",
    "safety.checkinDesc": "Pick a time — we'll ask if you got home safe. No answer within 2 hours and your friend gets an alert.",
    "safety.checkinPast": "Pick a check-in time in the future",
    "safety.checkinScheduled": "Sent! Your friend has the details and your safety check-in is scheduled.",
    "checkin.title": "Did you get home safe?",
    "checkin.body": "Tap to confirm — otherwise {email} gets an alert.",
    "checkin.confirmBtn": "I'm home safe ✅",
    "checkin.confirmed": "Glad you're safe! Your friend has been notified 💛",
    "notif.safetyCheckin.t": "🛟 Did you get home safe?",
    "notif.safetyCheckin.b": "Tap to confirm you're home safe — otherwise {email} gets an alert in 2 hours.",
    "landing.freeCreditsPromo": "New members get 50 free credits — exactly enough to have an AI companion send your crush on social media a secret admirer invite.",
    "landing.langHighlight": "Available in 8 languages with in-app chat translation — meet people around the world.",
    "saPromo.title": "Your free credits are waiting",
    "saPromo.body": "You have {n} credits — enough to have an AI companion send a secret admirer invite to your crush on social media.",
    "saPromo.cta": "Send a secret admirer invite",
    "notif.refundApproved.t": "✅ Refund approved",
    "notif.refundApproved.b": "Your refund for {desc} was approved — your account has been adjusted. Check your email for details.",
    "notif.refundDenied.t": "Refund request update",
    "notif.refundDenied.b": "Your refund request for {desc} was reviewed — check your email for details.",
    "safety.share": "Share plan with a friend",
    "safety.title": "Send your date plan to a friend",
    "safety.desc": "For your safety, email your itinerary and your date's profile to someone you trust.",
    "safety.emailPh": "friend@email.com",
    "safety.notePh": "Optional note to your friend…",
    "safety.send": "Send",
    "safety.sent": "Sent! Your friend has the details.",
    "discover.companionsTitle": "Meet the AI companions",
    "incog.title": "Incognito Mode",
    "incog.desc": "Control who can find your profile while you keep full access to chats, offers and meetups.",
    "incog.toggleLabel": "Hide my profile from Discover",
    "incog.toggleDesc": "Nobody can find you while browsing. Existing conversations and offers keep working.",
    "incog.on": "Incognito mode is ON — you're hidden from Discover",
    "incog.off": "You're visible in Discover again",
    "incog.hiddenFrom": "You're also individually hidden from {n} member(s) (via the eye button on their profile).",
    "ratep.title": "Date Ratings Privacy",
    "ratep.desc": "Choose whether you take part in date ratings and what shows on your profile.",
    "ratep.partLabel": "Participate in date ratings",
    "ratep.partDesc": "When off, no one can rate your dates and no rating shows on your profile",
    "ratep.commentsLabel": "Show written reviews on my profile",
    "ratep.commentsDesc": "When off, only your star rating is shown — written comments stay private",
    "ratep.saved": "Rating preferences saved",
    "offers.planDate": "Plan a Date",
    "planDate.title": "Plan a date with…",
    "planDate.desc": "Pick anyone from the member list to send them a premium date offer.",
    "planDate.search": "Search by name…",
    "planDate.empty": "No members found",
    "notif.promoRedeemed.t": "🎁 Promo code redeemed!",
    "notif.promoRedeemed.b": "Your code {code} added {what} to your account. Enjoy!",
    "notif.creditsGranted.t": "🎁 Credits added!",
    "notif.creditsGranted.b": "{n} credits were added to your account by the LuxeMeet team.",
    "notif.slotGranted.t": "🎁 Free premium date slot!",
    "notif.slotGranted.b": "You received {n} free $50 premium date offer slot(s) — plan a date from the Offers page!",
    "register.saRevealed": "💌 Your secret admirer is revealed — check your notifications and chat!",
    "tour.replayTitle": "60-second tour",
    "tour.replayDesc": "Missed the guided test drive? Replay it anytime with your AI companion.",
    "tour.replayBtn": "Watch again",
    "notif.saReveal.t": "💌 Secret admirer revealed!",
    "notif.saReveal.b": "It was {admirer} all along! {name} left the full story in your chat. Tap to view their profile.",
    "register.saBanner": "💌 Your secret admirer is waiting — create your free account to reveal who it is.",
    "credits.earnerNote": "Chatting is free for you in this mode — credits are used for extras like Secret Admirer requests (50 credits).",
    "si.trackJoined": "Joined as {name} — view profile",
    "notif.siJoined.t": "🎉 They're here!",
    "notif.siJoined.b": "{invitee} just joined from your secret admirer invite to {handle}. Go find them!",
    "si.trackTitle": "Your Secret Admirer Requests",
    "si.trackLine": "{kind} to {handle} on {platform}",
    "si.trackVia": "via {name}",
    "si.trackKindAdmirer": "Secret admirer message",
    "si.trackKindDate": "Date request",
    "si.trackPending": "Pending",
    "si.trackSent": "Sent",
    "si.trackRefunded": "Refunded",
    "discover.boosted": "Boosted",
    "discover.inDemand": "🔥 In demand",
    "discover.diamond": "Diamond",
    "discover.verifiedBadge": "Verified",
    "gal.addPhoto": "Add Photo",
    "gal.addVideo": "Add Video",
    "gal.videoIntros": "Video Intros ({n}/2)",
    "gal.videoRules": "Up to 2 short videos (max 60s, 50MB). AI-screened — no nudity or sexual content.",
    "gal.noPhotos": "No photos yet. Add your first photo to get started!",
    "si.button": "Social Secret Admirer",
    "si.title": "Secret Admirer via {name}",
    "si.desc": "{name} will send a secret admirer message or date request to anyone you choose on social media — with an invite to the app. Delivered within 24 hours.",
    "si.typeLabel": "What should be sent?",
    "si.typeAdmirer": "Secret admirer message",
    "si.typeDate": "Date request",
    "si.platform": "Platform",
    "si.handle": "Their username / handle",
    "si.note": "Personal touch (optional)",
    "si.notePh": "Anything {name} should mention?",
    "si.submit": "Send request ({n} credits)",
    "si.success": "Request queued! You'll get a notification once {name} has sent it.",
    "si.errHandle": "Please enter their social media handle",
    "notif.siPending.t": "💌 Request received!",
    "notif.siPending.b": "{name} will send your {kind} to {handle} on {platform}. 50 credits were charged — you'll be notified once it's sent.",
    "notif.siSent.t": "💘 It's out there!",
    "notif.siSent.b": "{name} sent your {kind} to {handle} on {platform}. Fingers crossed!",
    "notif.siDeclined.t": "Request refunded",
    "notif.siDeclined.b": "Your {kind} via {name} couldn't be sent. Your 50 credits have been refunded.",
    "notif.kindAdmirer": "secret admirer message",
    "notif.kindDate": "date request",
    "help.title": "Luxe Assistant",
    "help.subtitle": "Ask me anything about LuxeMeet",
    "help.hi": "Hi{name}! 👋",
    "help.welcome": "I can explain how credits, premium date offers, escrow, confirmation codes and payouts work. What would you like to know?",
    "help.thinking": "Luxe is thinking...",
    "help.inputPh": "Type your question...",
    "help.error": "Sorry, I'm having trouble right now. Please try again in a moment.",
    "chat.translate": "Translate",
    "chat.showOriginal": "Show original",
    "chat.translating": "Translating...",
    "chat.translateFail": "Couldn't translate right now",
    "chat.sentCredits": "Message sent ({n} credits)",
    "chat.noCredits": "Insufficient credits",
    "chat.tapToUse": "{ai} — tap to use",
    "chat.member": "{app} member",
    "land.newMatch": "New Match!",
    "land.firstMove": "Make the first move",
    "land.dateTerms": "Date on your terms",
    "land.youChoose": "You choose. You offer.",
    "land.startChatting": "Start chatting now",
    "land.likes": "{n} Likes",
    "land.thisWeek": "This week",
    "promo.title": "See what makes it special",
    "promo.desc": "A quick tour of LuxeMeet & DLuxe — real dates, premium offers and AI-powered romance.",
    "promo.tapSound": "Tap for sound",
    "promo.shareInvite": "Share the film — your invite link is included 🎁",
    "promo.shareFriends": "Share the film with friends",
    "promo.copiedInvite": "Film link with your invite code copied!",
    "promo.copied": "Film link copied!",
    "promo.shareMsg": "🎬 Watch this — LuxeMeet, the dating app where real dates actually happen.",
    "promo.joinInvite": "Join with my invite link:",
    "promo.shareTg": "🎬 Watch this — the dating app where real dates actually happen",
    "promo.mute": "Mute soundtrack",
    "promo.unmute": "Unmute soundtrack",
    "prof.back": "Back",
    "prof.addPhotosHint": "Add photos to get noticed",
    "prof.noPhotos": "{name} hasn't added photos yet",
    "prof.addPhotos": "Add Photos",
    "prof.aiCompanion": "AI Companion",
    "prof.reviewOne": "date review",
    "prof.reviewMany": "date reviews",
    "prof.bioEmptyOwn": "Your bio is empty — a couple of sentences about you goes a long way.",
    "prof.bioEmptyOther": "{name} is keeping an air of mystery — say hi to learn more.",
    "prof.afterDate": "— {name}, after their date",
    "prof.interests": "INTERESTS",
    "prof.photos": "PHOTOS",
    "prof.videos": "VIDEOS",
    "prof.thinking": "Thinking...",
    "prof.suggestOpener": "{ai}: suggest an opener",
    "prof.offerSent": "Offer sent! Check your Offers page for status.",
    "prof.tSuggestFail": "Couldn't get suggestions right now",
    "prof.tRequestFail": "Could not send the request",
    "prof.tFavAdded": "Added to favorites ❤️",
    "prof.tFavRemoved": "Removed from favorites",
    "prof.tFavFail": "Failed to update favorites",
    "prof.tVisibilityFail": "Failed to update visibility",
    "prof.tHidden": "You're now hidden from {name} in Discover",
    "prof.tVisible": "You're visible to {name} again",
    "prof.tLoadFail": "Failed to load profile",
    "prof.tMsgEmpty": "Please enter a message",
    "prof.tNoCredits": "Insufficient credits. Buy more credits to continue.",
    "prof.tMsgFail": "Failed to send message",
    "prof.tMeetupMissing": "Please fill in date and location",
    "prof.tMeetupFail": "Failed to send meetup request",
    "nb.title": "Notifications",
    "nb.empty": "No notifications yet",
    "time.now": "just now",
    "time.m": "{n}m ago",
    "time.h": "{n}h ago",
    "time.d": "{n}d ago",
    "notif.photoVerified.t": "✅ You're verified!",
    "notif.photoVerified.b": "Your selfie check passed — the Verified badge now shows on your profile.",
    "notif.relRequest.t": "💍 Go Official?",
    "notif.relRequest.b": "{name} wants to make it official with you! Accept in Settings and you'll both disappear from everyone else's feed.",
    "notif.relDeclined.t": "Go Official request declined",
    "notif.relDeclined.b": "{name} isn't ready to go official just yet.",
    "notif.relActive.t": "💞 You're officially together!",
    "notif.relActive.b": "{name} said YES. You're both now hidden from everyone else — the app is just for the two of you.",
    "notif.relEnded.t": "Official relationship ended",
    "notif.relEnded.b": "{name} ended the official relationship. You're both visible on the app again.",
    "notif.dateReview.t": "{stars} New date review!",
    "notif.dateReview.b": "{name} rated your date {rating}/5. {comment}",
    "notif.escrow.t": "💰 Date payment received!",
    "notif.escrow.b": "{name} paid ${amount} for your date. ${payout} is held in escrow. Confirm the date with their 6-digit code to get paid.",
    "notif.escrowBoost.t": "💰 Date payment received!",
    "notif.escrowBoost.b": "{name} paid ${amount} for your date. ${payout} is held in escrow — includes your 90% referral boost! Confirm the date with their 6-digit code to get paid.",
    "notif.offerPaid.t": "💘 Date booked!",
    "notif.offerPaid.b": "Your payment for the date with {name} is confirmed. Your 6-digit confirmation code is ready on the Offers page — share it with your date afterwards.",
    "notif.refSlot.t": "🎁 Free premium slot earned!",
    "notif.refSlot.b": "{name} you referred just bought a premium slot — you've received a FREE $50 slot as a reward!",
    "notif.boostActivated.t": "🚀 Profile Boosted!",
    "notif.boostActivated.b": "Your profile is now featured at the top of Discover for the next 24 hours.",
    "notif.creditsAdded.t": "🪙 Credits added!",
    "notif.creditsAdded.b": "{credits} credits from your {package} purchase are now in your account. New balance: {balance}.",
    "notif.unlimited.t": "♾️ Unlimited offers activated!",
    "notif.unlimited.b": "Your champion prize is live — send unlimited date offers (no slots needed) for the next 2 weeks!",
    "notif.voucherGifted.t": "🎁 You received a champion voucher!",
    "notif.voucherGifted.b": "{name} gifted you 2 weeks of unlimited date offers — activate it in Settings before {date}.",
    "notif.voucherRedeemed.t": "🎁 Your gift was claimed!",
    "notif.voucherRedeemed.b": "{name} redeemed the champion voucher you gifted them.",
    "notif.refBoost.t": "🎁 Referral reward unlocked!",
    "notif.refBoost.b": "{name} you referred completed their first premium date — your NEXT earning date pays out 90% instead of 80%!",
    "notif.payoutProcessing.t": "✅ Date confirmed!",
    "notif.payoutProcessing.b": "Your ${amount} payout is being processed and will arrive in your PayPal within 24-48 hours.",
    "notif.offerExpiredSender.t": "⏰ Date offer expired",
    "notif.offerExpiredSender.b": "Your ${amount} date offer expired after 7 days. Your premium slot has been freed so you can send a new offer.",
    "notif.offerExpiredRecipient.t": "⏰ Date offer expired",
    "notif.offerExpiredRecipient.b": "A date offer you accepted expired because payment wasn't completed within 7 days.",
    "notif.dateReminder24.t": "💜 Date reminder: tomorrow!",
    "notif.dateReminder24.b": "Your date with {name} is tomorrow — {when}, {where}.",
    "notif.offerExpiringPay.t": "⏳ Offer expires in 24 hours!",
    "notif.offerExpiringPay.b": "Your ${amount} date offer to {name} expires tomorrow — complete the payment before it's gone and your slot is freed.",
    "notif.offerExpiringWait.t": "⏳ Offer expires in 24 hours!",
    "notif.offerExpiringWait.b": "Your ${amount} date offer to {name} expires tomorrow — await her response or follow up before it's gone and your slot is freed.",
    "notif.matchInsights.t": "💌 Your weekly Match Insights",
    "notif.matchInsights.b": "{views} profile views and {favs} new favorites this week — including {names}. Say hi or boost your profile to spark a date offer!",
    "notif.streak1.t": "🔥 Streak progress: {streak}/3",
    "notif.streak1.b": "One more 4★+ date and 150 free credits are yours!",
    "notif.streakN.t": "🔥 Streak progress: {streak}/3",
    "notif.streakN.b": "{togo} more 4★+ dates to unlock 150 free credits.",
    "notif.streakDone.t": "🔥 Streak progress: {streak}/3",
    "notif.streakDone.b": "Your reward is on its way!",
    "notif.rankUp.t": "🏆 You're #{rank} on the Top Rated board",
    "notif.rankUp.b": "You are #{rank} on the Top Rated board. 📈 Up {spots} from last week! Monthly #1 wins 2 weeks of unlimited date offers.",
    "notif.rankDown.t": "🏆 You're #{rank} on the Top Rated board",
    "notif.rankDown.b": "You are #{rank} on the Top Rated board. 📉 Down {spots} from last week — one great date brings you right back. Monthly #1 wins 2 weeks of unlimited date offers.",
    "notif.rankSteady.t": "🏆 You're #{rank} on the Top Rated board",
    "notif.rankSteady.b": "You are #{rank} on the Top Rated board. 🎯 Holding steady from last week. Monthly #1 wins 2 weeks of unlimited date offers.",
    "notif.rankNew.t": "🏆 You're #{rank} on the Top Rated board",
    "notif.rankNew.b": "🎉 NEW: you entered the Top Rated board at #{rank}! Monthly #1 wins 2 weeks of unlimited date offers.",
    "notif.rankOff.t": "🏆 Leaderboard update",
    "notif.rankOff.b": "You slipped off the Top Rated board this week — one great date puts you back on. Monthly #1 wins 2 weeks of unlimited date offers.",
    "notif.boostEnded.t": "⚡ Your boost has ended",
    "notif.boostEnded.b": "Your 24-hour boost has ended. It earned you {views} profile views. Boost again from the Discover page to stay on top!",
    "notif.boostEndedExtra.t": "⚡ Your boost has ended",
    "notif.boostEndedExtra.b": "Your 24-hour boost has ended. It earned you {views} profile views — about {extra} more than a normal day. Boost again from the Discover page to stay on top!",
    "notif.dateSoon1h.t": "⏰ Date starting soon!",
    "notif.dateSoon1h.b": "Your date with {name} is in less than an hour — {time} at {location}.{tip}",
    "notif.dateSoon24.t": "💜 Your date is 24 hours away!",
    "notif.dateSoon24.b": "Your date with {name} is in 24 hours — {time} at {location}.{tip}",
    "notif.dateSoonTip": " Open your offer for the live countdown, weather and outfit tips!",
    "notif.badgeFire.t": "🔥 You're on fire!",
    "notif.badgeFire.b": "You're one of the 3 most-contacted men on DLuxe this month — the 🔥 badge now shows on your profile.",
    "notif.hotStreak.t": "🔥 Hot streak! 150 FREE credits",
    "notif.hotStreak.b": "3 highly-rated dates in a row — the 150-credit Popular package was added to your account for FREE. Keep the streak alive!",
    "notif.badgeDiamond.t": "💎 Diamond badge earned!",
    "notif.badgeDiamond.b": "You've completed 3 premium dates of $500+ — the Diamond badge now shines on your profile.",
    "notif.champion.t": "🏆 Leaderboard Champion!",
    "notif.champion.b": "You finished #1 in '{section}' this month! Prizes: a FREE 7-day profile boost (already active) and a voucher for 2 weeks of UNLIMITED date offers — activate it in Settings any time in the next 6 months.",
    "notif.anniversary.t": "💞 {months} {monthsWord} together!",
    "notif.anniversary.b": "You and {name} just hit {months} {monthsWord} official. Celebrate it — idea: {idea}",
    "notif.monthWord": "month",
    "notif.monthsWord": "months",
    "notif.annIdea0": "Recreate your very first date — same place, same order, new memories.",
    "notif.annIdea1": "Cook a candlelit three-course dinner together at home, phones off.",
    "notif.annIdea2": "Sunset picnic with each other's favorite snacks and one shared playlist.",
    "notif.annIdea3": "Book a couples spa hour and toast with something sparkling after.",
    "notif.annIdea4": "Take a mini road trip to a town neither of you has ever visited.",
    "notif.annIdea5": "Stargazing night: blankets, hot chocolate and your song on repeat.",
    "notif.annIdea6": "Dance class for two — salsa, bachata or whatever makes you laugh.",
    "notif.annIdea7": "Museum or gallery date, then dessert somewhere fancy.",
    "notif.annIdea8": "Write each other a letter about your favorite moment so far and swap over dinner.",
    "notif.annIdea9": "Rooftop or terrace dinner reservation — dress up like it's date one.",
    "notif.annIdea10": "Wine or chocolate tasting followed by a slow walk home.",
    "notif.annIdea11": "Plan your dream trip together over breakfast in bed — then book one piece of it.",
    "notif.companionInvite.t": "💌 {name} has your surprise!",
    "notif.companionInvite.b": "Your mystery invitation has been revealed in your chat.",
    "notif.supportResolved.t": "✅ Support request resolved",
    "notif.supportResolved.b": "Your {label} \"{subject}\" has been reviewed and resolved.",
    "notif.supportResolvedResp.t": "✅ Support request resolved",
    "notif.supportResolvedResp.b": "Your {label} \"{subject}\" has been reviewed and resolved. Response: {resp}",
    "notif.labelRefund": "refund request",
    "notif.labelComplaint": "complaint",
    "notif.testMeetup.t": "{name} accepted your meetup! 🎉",
    "notif.testMeetup.b": "Test run complete — this is exactly how it looks when a real member accepts. No credits were charged.",
    "notif.testCounter.t": "{name} sent a counter-offer 💬",
    "notif.testCounter.b": "Test run: they countered ${amount}. Accept or decline to continue the flow — still no real money.",
    "notif.testOfferAccepted.t": "{name} accepted your date offer! 💜",
    "notif.testOfferAccepted.b": "Test run: hit the Simulate Payment button on the Offers page to see the rest of the flow — no real money involved.",
    "notif.testDateCompleted.t": "Test date with {name} completed! 🏆",
    "notif.testDateCompleted.b": "That was the full premium date lifecycle — offer, acceptance, payment, code and confirmation. No real money moved. Ready to try it with a real member?",
    "notif.refChat.t": "🎁 +{credits} credits earned!",
    "notif.refChat.b": "{name} just started chatting — {credits} bonus credits added to your balance.",
    "notif.payoutSent.t": "💸 Payout sent!",
    "notif.payoutSent.b": "${amount} has been sent to your PayPal ({recipient}).",
    "notif.favVerified.t": "✅ {name} is now verified!",
    "notif.favVerified.b": "{name} from your favorites just passed the selfie check and earned the Verified badge.",
    "notif.favReviewed.t": "⭐ {name} earned a great review!",
    "notif.favReviewed.b": "{name} from your favorites just received a {rating}-star date review. Great daters get booked fast!",
    "notif.favBoosted.t": "⚡ {name} just boosted!",
    "notif.favBoosted.b": "{name} from your favorites is featured at the top of Discover right now — say hi while they're in the spotlight!",
    "register.newMembers": "New members get",
    "register.promoLuxe1": "50 Free Credits",
    "register.promoDluxe1": "Free Access + Earnings",
    "register.promoLuxe2": "For ladies joining LuxeMeet",
    "register.promoDluxe2": "Gentlemen join DLuxe free — and earn from premium dates",
    "register.googleTerms": "By continuing with Google, you agree to our",
    "register.googleTermsLink": "Terms & Conditions",
    "register.orEmail": "or register with email",
    "register.hintF": "Women: free on LuxeMeet (50 starter credits) — or take the lead on DLuxe with premium date offers to men.",
    "register.hintM": "Men: invest to connect on LuxeMeet — and enjoy free access + earn from premium dates on DLuxe.",
    "register.hintNone": "Select your gender to see available features",
    "register.refCode": "Referral code",
    "register.refOptional": "(optional)",
    "register.refPh": "Have a code? Enter it here",
    "register.terms18": "I am 18 or older and I agree to the",
    "register.termsLink": "Terms & Conditions and Release of Liability",
    "register.create": "Create Account",
    "register.haveAccount": "Already have an account?",
    "register.errGender": "Please select your gender",
    "register.errTerms": "Please accept the Terms & Conditions to continue",
    "register.errFail": "Registration failed",
    "register.giftClaimed": "😕 This gift code ({code}) has already been claimed.",
    "register.giftExpired": "😕 This gift code ({code}) has expired.",
    "register.giftReady": "🎁 {name} gifted you a champion voucher ({code}) — it'll be added to your account right after you sign up!",
    "register.giftFriend": "A friend",
    "set.tImgFile": "Please select an image file",
    "set.tImgSize": "Image must be less than 5MB",
    "set.tPhotoUpdated": "Profile photo updated!",
    "set.tPhotoFail": "Failed to upload photo",
    "set.tPwMismatch": "New passwords don't match",
    "set.tPwShort": "Password must be at least 6 characters",
    "set.tPwChanged": "Password changed successfully!",
    "set.tPwFail": "Failed to change password",
    "set.tProfileUpdated": "Profile updated!",
    "set.tProfileFail": "Failed to update profile",
    "set.tLoggedOut": "Logged out successfully",
    "set.tDeactivated": "Account deactivated. Log back in within 30 days to reactivate.",
    "set.tDeleteFail": "Failed to delete account",
    "pp.errInvalidEmail": "Please enter a valid email address",
    "pp.errNoMatch": "Emails do not match",
    "pp.errConfirm": "Please confirm your PayPal email",
    "pp.errFix": "Please fix the errors before saving",
    "pp.savedOk": "PayPal settings saved and verified!",
    "pp.saveFail": "Failed to save settings",
    "pp.errImg": "Please upload an image file",
    "pp.errSize": "File size must be less than 5MB",
    "pp.qrUploaded": "QR code uploaded!",
    "pp.qrFail": "Failed to upload QR code",
    "terms.title": "Terms & Conditions",
    "terms.updated": "Including Release of Liability — Last updated: June 2026 (v5)",
    "terms.back": "Back",
    "terms.footer": "© 2026 LuxeMeet & DLuxe. All rights reserved.",
    "terms.s1t": "1. Acceptance of Terms",
    "terms.s1p1": "By creating an account or using LuxeMeet or its companion mode DLuxe (together, \"the Platform\"), you agree to be bound by these Terms & Conditions and our Release of Liability. If you do not agree, do not use the Platform.",
    "terms.s2t": "2. Eligibility (18+)",
    "terms.s2p1": "You must be at least 18 years old to use LuxeMeet. By registering, you represent and warrant that you are 18 or older and legally able to enter into this agreement. Accounts found to belong to minors will be terminated immediately without refund.",
    "terms.s3t": "3. Nature of the Service",
    "terms.s3p1": "LuxeMeet is an introduction platform only. We provide tools for adults to meet, message, and arrange dates. We are not a party to any interaction, conversation, date, or arrangement between members. We do not conduct criminal background checks on members and make no guarantees about any member's identity, conduct, intentions, or compatibility.",
    "terms.s3p2": "The Platform may display links to independent third-party services to help plan dates — such as OpenStreetMap and Google Maps for locations, Uber for transportation, and Airbnb Experiences for date ideas. These services are not operated by us; your use of them is governed by their own terms, and we are not responsible for their content, pricing, or availability.",
    "terms.s4t": "4. Credits, Payments & Premium Date Offers",
    "terms.s4p1": "Male members purchase credits to message and request meetups, premium offer slots to send date offers, and optional profile boosts. All payments are processed by PayPal. Prices are shown at the point of purchase and may include a handling fee.",
    "terms.s4p2": "For Premium Date Offers, the offered amount is held in escrow once paid. When the date takes place and the recipient enters the payer's 6-digit confirmation code, the payout (less the platform commission) is released to the recipient. The platform commission is disclosed in-app. Repeat dates: when a payer books a new date with someone they have already completed a date with through the Platform, no premium slot is required and a reduced platform commission of 10% applies (the recipient receives 90% of the offer amount). Optional transportation allowances are paid together with the offer and passed 100% to the recipient. Cancelled date offers are automatically removed from offer history 48 hours after cancellation. Champion vouchers: reward vouchers earned through the monthly Top Members leaderboard may be gifted once to another person via a single-use gift code; once gifted, the voucher cannot be used or reclaimed by the original holder, and received gift vouchers cannot be re-gifted. Vouchers have no cash value.",
    "terms.s4p3": "Refunds: Credits, slots, and boosts are non-refundable once delivered. Escrowed date payments are refundable only if the date does not occur and the offer is cancelled or expires per platform rules. Payments must be made from a PayPal account whose email matches your LuxeMeet login email; payments from mismatched emails may be delayed or unrecoverable. You may submit a refund request or a complaint at any time via Settings → Refunds & Complaints (or \"Help & Support\" in the app menu); each request is reviewed by our team and you will be notified of the outcome in-app and by email.",
    "terms.s5t": "5. Release of Liability & Assumption of Risk",
    "terms.s5p1": "YOU EXPRESSLY AGREE THAT MEETING ANOTHER MEMBER IN PERSON IS ENTIRELY AT YOUR OWN RISK. To the fullest extent permitted by law, you release, discharge, and hold harmless LuxeMeet, its owners, operators, employees, and affiliates from any and all claims, demands, damages, injuries, losses, or causes of action — whether known or unknown — arising out of or relating to your use of the Platform, your interactions or communications with other members, and any in-person meeting or date arranged through the Platform, including without limitation personal injury, emotional distress, property damage, theft, fraud, or financial loss.",
    "terms.s5p2": "You are solely responsible for your own safety. We strongly recommend meeting in public places, telling a friend where you are going, arranging your own transportation, and never sharing financial information with other members.",
    "terms.s6t": "6. Member Conduct",
    "terms.s6p1": "You agree not to: misrepresent your identity or age; harass, abuse, or harm other members; solicit money from members outside the Platform's offer system; use the Platform for any commercial, illegal, or exploitative purpose (including escort services or human trafficking); post explicit, offensive, or infringing content; or attempt to circumvent the Platform's payment systems.",
    "terms.s6p2": "Content policy: profile photos and videos must not contain nudity or sexually explicit or suggestive content. All uploaded photos and videos are automatically screened by AI before publication and prohibited content is rejected. Repeated attempts to upload prohibited content may result in account action.",
    "terms.s6p3": "Violation may result in immediate suspension or termination without refund, and referral to law enforcement where appropriate.",
    "terms.s7t": "7. Date Ratings, Reviews & Favorites",
    "terms.s7p1": "After a completed premium date, both participants may rate the date (1-5 stars) with an optional written comment. Participation in ratings is optional: you may opt out entirely in Settings, in which case no one can rate your dates and no rating appears on your profile. If you participate, you may separately choose whether written review comments are displayed publicly with your star rating.",
    "terms.s7p2": "Reviews must be honest, respectful, and based on an actual date. Defamatory, harassing, or false reviews may be removed and may result in account action. Members may also save other profiles to a private Favorites list; your favorites are visible only to you. If you favorite a member, you may receive notifications about their public profile activity (such as boosts, verification, or new reviews).",
    "terms.s8t": "8. AI Features",
    "terms.s8p1": "The Platform offers optional AI-powered features, including the \"AI Wingman\" (for male members) and \"AI Cupid\" (for female members) writing assistants — which can draft chat openers and replies, premium date offer notes, counter-offer messages, meetup request messages, and date review comments — the \"Luxe\" in-app help assistant, AI-curated date ideas, AI stylist outfit suggestions shown in the date-night countdown, weekly AI-assisted match insights, AI-assisted profile photos, and AI selfie-based photo verification. AI is also used to automatically screen all uploaded photos and gallery videos for prohibited content (nudity and sexual content) before they are published. AI content is generated automatically and may be inaccurate. You are responsible for any content you send or publish, including AI-assisted content. Profile photos must truthfully represent you; using AI images that materially misrepresent your appearance may result in account action. Verification selfies are used solely for the verification check and are never displayed publicly.",
    "terms.s9t": "9. Limitation of Liability",
    "terms.s9p1": "TO THE MAXIMUM EXTENT PERMITTED BY LAW, LUXEMEET SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR DATA, ARISING FROM YOUR USE OF THE PLATFORM. OUR TOTAL AGGREGATE LIABILITY FOR ANY CLAIM SHALL NOT EXCEED THE AMOUNT YOU PAID TO LUXEMEET IN THE SIX (6) MONTHS PRECEDING THE CLAIM.",
    "terms.s10t": "10. Privacy",
    "terms.s10p1": "We collect and process account information, messages, payment records, and usage data to operate the Platform, process payments and payouts, prevent fraud, and improve the service. Profile view counts are tracked to power boost analytics. You may enable Incognito Mode in Settings to hide your profile from Discover browsing — globally or from specific members — while your existing conversations, offers and meetups keep working. We do not sell your personal data. Emails may be sent for account, payment, and engagement purposes.",
    "terms.s11t": "11. Termination & Account Deletion",
    "terms.s11p1": "Deleting your account: you may delete your account at any time from Settings → Danger Zone. Your profile is hidden from Discover, leaderboards and favorites immediately. A 30-day grace period applies: logging back in within 30 days fully reactivates your account. After 30 days, your account and personal data (profile, photos, videos, messages, favorites and notifications) are permanently and irreversibly erased or anonymized. Unused credits, slots, boosts and any unwithdrawn balances are forfeited upon permanent erasure. Records required for financial and legal compliance (such as completed payment records) may be retained in anonymized form.",
    "terms.s11p2": "We may suspend or terminate accounts that violate these Terms. Unused credits, slots, and boosts are forfeited upon termination for cause.",
    "terms.s12t": "12. Changes to These Terms",
    "terms.s12p1": "We may update these Terms from time to time. Continued use of the Platform after changes take effect constitutes acceptance of the revised Terms.",
    "terms.s13t": "13. DLuxe Mode",
    "terms.s13p1": "The Platform includes a companion mode, \"DLuxe\", accessible via the in-app heart switch. DLuxe mirrors LuxeMeet with the paying roles reversed: female members pay for interactions (credits, premium offer slots, boosts and monetary date offers) and male members may receive date offer payouts. All Terms apply equally to both modes, with role-specific provisions applying to whichever side pays or receives payment in the active mode. A single account is used across both modes. Conversations and meetup requests are separated by mode: interactions started in LuxeMeet follow LuxeMeet payment rules (male members pay) and interactions started in DLuxe follow DLuxe rules (female members pay). Switching modes only changes which inbox is displayed and never changes who pays within an existing conversation. All Platform features — including AI assistants, leaderboards, champion rewards and voucher gifting — are available in both modes with mode-appropriate branding.",
    "terms.s14t": "14. Contact",
    "terms.s14p1": "Questions about these Terms? Use the in-app Help assistant. For refund requests and complaints, use Settings → Refunds & Complaints (or \"Help & Support\" in the app menu) — every submission is reviewed and answered.",
    "landing.badge": "Premium Dating Experience",
    "landing.heroLuxe1": "Where Quality",
    "landing.heroLuxe2": "Meets Connection",
    "landing.heroDluxe1": "Where Women",
    "landing.heroDluxe2": "Take The Lead",
    "landing.taglineLuxe": "An exclusive dating platform where meaningful connections are valued. Gentlemen invest credits to connect, ensuring genuine interest and quality interactions.",
    "landing.taglineDluxe": "An exclusive dating platform where bold women make the first move. Ladies invest credits to connect with exceptional men, ensuring genuine interest and quality interactions.",
    "landing.startJourney": "Start Your Journey",
    "landing.haveAccount": "I Have an Account",
    "landing.watchFilm": "Watch the film",
    "auth.signIn": "Sign In",
    "auth.getStarted": "Get Started",
    "login.welcomeBack": "Welcome back",
    "login.subtitle": "Sign in to continue your journey",
    "login.google": "Continue with Google",
    "login.orEmail": "or continue with email",
    "login.email": "Email",
    "login.password": "Password",
    "login.emailPh": "Enter your email",
    "login.passwordPh": "Enter your password",
    "login.forgot": "Forgot Password?",
    "login.noAccount": "Don't have an account?",
    "login.createOne": "Create one",
    "login.backHome": "Back to home",
    "register.title": "Create your account",
    "register.subtitle": "Start your journey to meaningful connections",
    "register.fullName": "Full Name",
    "register.namePh": "Enter your name",
    "register.passwordPh": "Create a password",
    "register.iAmA": "I am a",
    "register.man": "Man",
    "register.woman": "Woman",
    "nav.discover": "Discover",
    "nav.favorites": "Favorites",
    "nav.chat": "Chat",
    "nav.offers": "Offers",
    "nav.meetups": "Meetups",
    "nav.top": "Top",
    "nav.credits": "Credits",
    "nav.earnings": "Earnings",
    "nav.settings": "Settings",
    "nav.watchTour": "Watch app tour",
    "nav.helpSupport": "Help & Support",
    "discover.title": "Discover",
    "discover.subtitle": "Find your perfect match",
    "discover.newest": "Newest",
    "discover.topRated": "Top Rated",
    "discover.sendOffer": "Send Premium Date Offer",
    "discover.message": "Message",
    "discover.aiCompanion": "AI Companion",
    "discover.videoIntro": "Video",
    "settings.countryLanguage": "Country & Language",
    "settings.country": "Country",
    "settings.language": "Language",
    "settings.currency": "Currency",
    "settings.currencyNote": "Prices are shown approximately in your currency - payments are processed in USD.",
    "settings.refunds": "Refunds & Complaints",
    "settings.changePassword": "Change Password",
    "settings.logout": "Log Out",
    "settings.dangerZone": "Danger Zone",
    "settings.deleteAccount": "Delete My Account",
    "credits.billedUsd": "billed in USD",
    "common.accept": "Accept",
    "common.decline": "Decline",
    "common.pending": "Pending",
    "common.accepted": "Accepted",
    "common.declined": "Declined",
    "common.received": "Received",
    "common.sent": "Sent",
    "common.yourBalance": "Your Balance",
    "common.back": "Back",
    "common.cancel": "Cancel",
    "common.credits": "Credits",
    "common.viewMap": "View map",
    "common.getUber": "Get an Uber",
    "common.hours": "hours",
    "chat.title": "Messages",
    "chat.empty": "No conversations yet",
    "chat.emptySub": "Start connecting with people to begin chatting!",
    "chat.discoverProfiles": "Discover profiles",
    "chat.typeMessage": "Type a message...",
    "chat.inbox": "Inbox",
    "chat.noMessages": "No messages yet. Start the conversation!",
    "chat.startConvo": "Start the conversation!",
    "chat.costStart": "Starting a chat costs 10 credits",
    "chat.costMessage": "Sending a message costs 5 credits",
    "chat.inboxBadge": "{app} Inbox",
    "common.testRun": "Test Run",
    "offers.simulatePayment": "Simulate Payment (Test)",
    "offers.title": "Premium Date Offers",
    "offers.dateOffers": "Date Offers",
    "offers.slots": "Your Offer Slots",
    "offers.available": "Available",
    "offers.inUse": "In Use",
    "offers.consumed": "Consumed",
    "offers.sentOffers": "Your Sent Offers",
    "offers.none": "No offers yet",
    "offers.noneSent": "No offers sent yet",
    "offers.reviewRespond": "Review and respond to your premium date offers",
    "offers.subtitlePayer": "Purchase slots to send premium date offers to your matches",
    "offers.slotDesc": "$50 per slot • Reusable until offer is accepted",
    "offers.buySlot": "Buy Slot",
    "offers.noneDesc": "You haven't received any date offers yet",
    "offers.noneSentDesc": "Purchase a slot and send your first premium date offer",
    "offers.buyFirstSlot": "Buy Your First Slot",
    "offers.respond": "Respond",
    "offers.cancelOffer": "Cancel Offer",
    "offers.viewCounter": "View Counter-Offer",
    "offers.rateDate": "Rate this date",
    "offers.dateDetails": "Date Details & Reviews",
    "status.pending": "Pending",
    "status.paymentNeeded": "Payment Needed",
    "status.awaitingConfirmation": "Awaiting Confirmation",
    "status.countered": "Countered",
    "status.confirmed": "Confirmed",
    "status.completed": "Completed",
    "status.declined": "Declined",
    "status.expired": "Expired",
    "status.cancelled": "Cancelled",
    "meetups.title": "Meetup Requests",
    "meetups.none": "No requests yet",
    "meetups.noneSent": "No requests sent",
    "meetups.received": "Received",
    "meetups.sent": "Sent",
    "meetups.noneDesc": "Meetup requests from others will appear here.",
    "meetups.noneSentDesc": "Find someone you'd like to meet!",
    "meetups.browse": "Browse Profiles",
    "favorites.title": "Favorites",
    "favorites.subtitle": "Profiles you've saved",
    "favorites.none": "No favorites yet",
    "favorites.noneDesc": "Tap the heart on a profile you love and it'll be saved here.",
    "favorites.browse": "Browse Discover",
    "leaderboard.title": "Top Members",
    "leaderboard.you": "You",
    "leaderboard.subtitle": "The most in-demand, highest-rated and biggest-spending daters on the platform. Earn badges to claim your spot.",
    "leaderboard.prizeNote": "Monthly #1 in each section wins a free 7-day boost + 2 weeks of unlimited date offers.",
    "leaderboard.empty": "No badge holders yet — complete great dates to be the first on the board!",
    "leaderboard.loading": "Loading the leaderboard...",
    "leaderboard.fireTitle": "Most In-Demand on DLuxe",
    "leaderboard.fireSub": "The 3 most-contacted men on DLuxe this month",
    "leaderboard.diamondTitle": "Diamond Members",
    "leaderboard.diamondSub": "Completed 3+ premium dates of $500 or more",
    "leaderboard.ratedTitle": "Top Rated Daters",
    "leaderboard.ratedSub": "The highest date ratings from real reviews",
    "leaderboard.shareBadge": "Share badge",
    "leaderboard.datesCompleted": "premium dates completed",
    "earnings.title": "My Earnings",
    "earnings.escrow": "In Escrow",
    "earnings.total": "Total Earned",
    "earnings.dates": "Dates Done",
    "earnings.history": "Payment History",
    "earnings.none": "No earnings yet",
    "credits.costs": "Credit Costs",
    "credits.startChat": "Start a new chat",
    "credits.sendMessage": "Send a message",
    "credits.requestMeetup": "Request a meetup",
    "credits.buy": "Buy Credits",
    "credits.history": "Purchase History",
    "credits.noHistory": "No purchase history yet",
    "credits.completePayment": "Complete Payment",
    "credits.allSet": "You're All Set!",
    "credits.freeLuxe": "As a woman on LuxeMeet, you enjoy free access to messaging and all features.",
    "credits.freeDluxe": "As a man on DLuxe, you enjoy free access to messaging and all features.",
    "credits.bestValue": "Best Value",
    "credits.continuePayment": "Continue to Payment",
    "credits.processing": "Processing...",
    "profile.message": "Message",
    "profile.requestMeetup": "Request Meetup",
    "tour.tryWith": "Try it with",
    "settings.title": "Settings",
    "settings.photoHint": "Click camera to change photo",
    "settings.profileInfo": "Profile Information",
    "settings.displayName": "Display Name",
    "settings.age": "Age",
    "settings.location": "Location",
    "settings.locationPh": "City, Country",
    "settings.bio": "Bio",
    "settings.bioPh": "Tell others about yourself...",
    "settings.interests": "Interests",
    "settings.interestsPh": "Travel, Music, Food (comma separated)",
    "settings.interestsHint": "Separate interests with commas",
    "settings.saveChanges": "Save Changes",
    "settings.paypalTitle": "PayPal Payout Settings",
    "settings.paypalDesc": "Add your PayPal details to receive payouts from accepted date offers",
    "settings.dangerDesc": "Deleting your account hides your profile immediately. Change your mind? Just log back in within 30 days to reactivate — after that, your account and personal data are permanently erased and unused credits or balances are forfeited.",
    "settings.deleteTitle": "Delete your account?",
    "settings.deleteB1": "Your profile is hidden from everyone immediately",
    "settings.deleteB2": "Log back in within 30 days to reactivate",
    "settings.deleteB3": "After 30 days everything is permanently erased — photos, messages, and any unused credits or balance",
    "settings.confirmPasswordLabel": "Confirm your password",
    "settings.googleBlank": "Signed up with Google? Leave this blank.",
    "settings.deactivateDelete": "Deactivate & Delete",
    "settings.currentPassword": "Current Password",
    "settings.newPassword": "New Password",
    "settings.confirmNewPassword": "Confirm New Password",
    "ref.title": "Invite & Earn",
    "ref.desc": "Share your invite link. You earn 25 bonus credits the moment a friend you invited starts chatting. Plus: when a referral buys their first premium slot you get a FREE $50 slot — and when a referral completes their first premium date, your NEXT earning date pays out 90% instead of 80%.",
    "ref.friendsReferred": "Friends referred",
    "ref.bonusCredits": "Bonus credits earned",
    "ref.freeSlots": "Free slots earned",
    "ref.boosts": "90% boosts available",
    "ref.yourReferrals": "Your referrals",
    "ref.stJoined": "Joined",
    "ref.stChatting": "Started chatting ✓ (+25 credits)",
    "ref.stDate": "Completed a date ✓",
    "ref.stSlot": "Bought a slot ✓",
    "ref.topReferrers": "Top referrers this month",
    "ref.referralsWord": "referrals",
    "ref.copied": "Referral link copied!",
    "share.inviteMsg": "Join me on {app} — the premium dating app where real dates actually happen. Sign up with my invite link:",
    "share.dreamMsg": "💘 You're invited on a Dream Date! Join me on {app} and let's plan the perfect date together:",
    "share.inviteBtn": "Invite a friend",
    "share.dreamBtn": "💘 Dream Date invite",
    "share.hint": "Type your own message or leave blank to use the template — your invite link is added automatically.",
    "share.copied": "Invite message copied — paste it anywhere!",
    "landing.whyTitle": "Why Choose {app}?",
    "landing.whySub": "Our credit-based system ensures every interaction is meaningful and intentional.",
    "landing.f1Title": "Quality Connections",
    "landing.f1Desc": "Credits ensure genuine interest. No spam, no bots - just real people looking for real connections.",
    "landing.f2Title": "Premium Experience",
    "landing.f2DescLuxe": "Ladies enjoy free access while gentlemen invest in meaningful conversations and meetup requests.",
    "landing.f2DescDluxe": "Gentlemen enjoy free access while ladies invest in meaningful conversations and premium date offers.",
    "landing.f3Title": "Verified Profiles",
    "landing.f3Desc": "All profiles are verified to ensure authenticity. Meet real people, make real connections.",
    "landing.refBadge": "Refer & Earn",
    "landing.refTitle1": "Invite Friends,",
    "landing.refTitle2": "Unlock Rewards",
    "landing.refDesc1": "Every member gets a personal invite link. Share it with friends and earn a",
    "landing.refDescBold": "FREE $50 premium slot",
    "landing.refDesc2": "plus exclusive bonus features when they join and get active.",
    "landing.refCard1Title": "FREE $50 Premium Slot",
    "landing.refCard1Desc": "Earned for every friend who joins and gets active",
    "landing.refCard2Title": "Bonus Features",
    "landing.refCard2Desc": "Exclusive perks reserved for top referrers",
    "landing.refCta": "Join & Get Your Invite Link",
    "landing.ctaTitle": "Ready to Find Your Match?",
    "landing.ctaSub": "Join thousands of singles who've found meaningful connections on {app}.",
    "landing.ctaBtn": "Create Free Account",
    "landing.footerTerms": "Terms & Conditions",
    "pp.balance": "Available Balance",
    "pp.balanceNote": "From accepted date offers (80% payout after platform fee)",
    "pp.email": "PayPal Email *",
    "pp.emailHint": "This is where we'll send your payouts",
    "pp.confirmEmail": "Confirm PayPal Email *",
    "pp.confirmPh": "Re-enter your email",
    "pp.emailsMatch": "Emails match",
    "pp.verified": "Verified",
    "pp.username": "PayPal Username (Optional)",
    "pp.qr": "PayPal QR Code (Optional)",
    "pp.qrUpload": "Upload QR Code",
    "pp.qrHint": "Upload your PayPal payment QR code for easy transfers",
    "pp.save": "Save & Verify PayPal Settings",
    "pp.howTitle": "ℹ️ How Payouts Work",
    "pp.how1": "Members send date offers with monetary amounts ($100-$1000)",
    "pp.how2": "When you accept and they pay, you receive 80% (platform keeps 20%)",
    "pp.how3": "Payouts are processed to your PayPal email within 3-5 business days",
    "pp.how4": "Your balance will be updated after each confirmed date",
    "rel.title": "Official Relationship",
    "rel.activeWith": "💞 Officially together with {name}",
    "rel.activeSince": "Since {date} — you're both hidden from everyone else.",
    "rel.chat": "Chat",
    "rel.planDate": "Plan a date",
    "rel.end": "End relationship",
    "rel.incomingTitle": "💍 {name} wants to go official with you!",
    "rel.incomingDesc": "Accept and you'll both disappear from everyone else's feed — the app becomes just for the two of you.",
    "rel.accept": "Accept 💞",
    "rel.decline": "Not yet",
    "rel.waitingFor": "⏳ Waiting for {name}",
    "rel.waitingDesc": "Your Go Official request is pending their answer.",
    "rel.cancelRequest": "Cancel request",
    "rel.endTitle": "End the official relationship?",
    "rel.endDesc": "You and {name} will both become visible to everyone again and can browse other members. Your chats and history stay intact.",
    "rel.keepIt": "Keep it",
    "rel.goOfficial": "Go Official — hide us both from everyone else",
    "rel.requestSent": "⏳ Go Official request sent — waiting for {name}",
    "rel.togetherSince": "💞 Officially together since {date}",
    "rel.together": "💞 Officially together",
    "rel.coupleTitle": "💞 You're officially together",
    "rel.coupleDesc": "You and {name} are hidden from everyone else. The app is just for the two of you — chat, plan meetups and premium dates.",
    "rel.coupleHint": "Change of plans? Either of you can end it any time in Settings.",
    "rel.toastSent": "💍 Go Official request sent to {name}!",
    "rel.toastTogether": "💞 You and {name} are officially together!",
    "rel.toastEnded": "Relationship ended — you're visible on the app again",
    "rel.toastPrivate": "This member is in an official relationship 💞",
    "rel.toastActive": "You're in an official relationship — the app is just for you two now 💞",
    "invite.admirerTitle": "You have a secret admirer 💘",
    "invite.dreamTitle": "{name} is holding a dream date invitation for you",
    "invite.admirerSub": "{name} has a secret admirer message waiting for you — but it stays sealed until you join.",
    "invite.dreamSub": "Someone planned something special — the details are sealed until you join.",
    "invite.lock": "Sign up free to unlock your surprise",
    "invite.claimedNote": "This invitation has already been revealed. Join anyway and see who's waiting for you!",
    "invite.reveal": "Reveal my surprise",
    "invite.login": "Already a member? Log in",
    "invite.expired": "This invitation has expired",
    "invite.explore": "Explore LuxeMeet",
    "landing.goBadge": "Built for real endings",
    "landing.goTitle1": "When it gets serious,",
    "landing.goTitle2": "Go Official 💞",
    "landing.goDesc": "Found the one? One tap and you both vanish from everyone else's feed — no profiles, no messages, no distractions. The app becomes just for the two of you: private chat, meetups and premium dates. And if things change, either partner can switch it off any time.",
    "landing.goChip1": "🙈 Invisible to everyone else",
    "landing.goChip2": "💬 Everything stays open between you two",
    "landing.goChip3": "🔄 Reversible any time",
    "common.years": "years old",
    "form.proposedDateTime": "Proposed Date & Time",
    "form.duration": "Duration (optional)",
    "form.proposedLocation": "Proposed Location",
    "form.messageOptional": "Message (optional)",
    "form.openEnded": "Open-ended",
    "form.writeMessage": "Write your message...",
    "form.addPersonalMessage": "Add a personal message...",
    "form.searchVenue": "Search the exact venue or address...",
    "offerModal.selectDateType": "Select date type...",
    "offerModal.amountPlaceholder": "Enter amount (100-1000)",
    "offerModal.amountHint": "You'll pay this amount if your date accepts ({fee}% platform fee applies)",
    "offerModal.transportHint": "Paid together with your offer and passed 100% to your date for transportation (no platform fee).",
    "offerModal.durationHint": "How long you'd like the date to last — sets clear expectations for both of you.",
    "tour.subtitle": "A 60-second test drive — nothing is ever charged",
    "tour.step1Title": "Say hi in chat",
    "tour.step1Desc": "{name} already messaged you — send a reply",
    "tour.step2Title": "Request a meetup",
    "tour.step2Desc": "Totally free — watch it get accepted",
    "tour.step3Title": "Send a premium date offer",
    "tour.step3DescSent": "Sent! Simulate the payment on your Offers page",
    "tour.step3Desc": "No slot, no real money — full simulation",
    "tour.go": "Go",
    "tour.doneTitle": "You've mastered LuxeMeet! 🎉",
    "tour.doneDesc": "Chat, meetups and premium dates — you've tried it all. Now go find the real thing.",
    "tour.browseReal": "Browse real members",
    "common.freeTest": "Free test",
    "discover.aiTestNote": "Test companion — chat, meetups & premium dates are FREE simulations. No real payment, ever.",
    "discover.meetUp": "Meet Up",
    "profile.msgTitle": "Send a message to {name}",
    "profile.msgCostPayer": "Starting a conversation costs 10 credits, then 5 credits per message. Their replies are free.",
    "profile.msgFree": "Free for you on {app} — this chat lands in their {app} inbox, where replying costs them credits.",
    "profile.sendMessage": "Send Message",
    "profile.meetupTitle": "Request a meetup with {name}",
    "profile.meetupCost": "Requesting a meetup costs 25 credits.",
    "profile.meetupFree": "Free for you on {app} — they'll see it in their {app} meetups.",
    "profile.meetupTest": "🧪 Free test run — your AI companion will accept automatically so you can see the full flow. No credits charged.",
    "profile.sendMeetup": "Send Meetup Request",
    "profile.costsMsg": "Message: 10 credits (first) / 5 credits (reply)",
    "profile.costsMeetup": "Meetup request: 25 credits",
    "offerModal.title": "Send Premium Date Offer",
    "offerModal.desc": "Send a monetary date offer to {name}",
    "offerModal.testBanner": "🧪 Test run with {name} — no slot needed, and payment is simulated (never charged).",
    "offerModal.needSlot": "You need to purchase a premium slot first",
    "offerModal.purchaseSlot": "Purchase Slot ($50)",
    "offerModal.slotsAvailable": "Available slots: {n}",
    "offerModal.testNoSlot": "Test offer — no slot required",
    "offerModal.repeatNoSlot": "Repeat date — no slot required",
    "offerModal.amount": "Offer Amount *",
    "offerModal.transport": "Transportation Allowance (Optional)",
    "offerModal.proposedDate": "Proposed Date *",
    "offerModal.proposedTime": "Proposed Time *",
    "offerModal.duration": "Duration (Optional)",
    "offerModal.location": "Location *",
    "offerModal.dateType": "Date Type *",
    "offerModal.message": "Message (Optional)",
    "offerModal.sendOffer": "Send Offer",
    "voucher.unlimitedActive": "Unlimited date offers active 🏆",
    "voucher.unlimitedUntil": "No slots needed until {date} — champion's privilege.",
    "voucher.championPrize": "Champion prize: 2 weeks of unlimited offers",
    "voucher.giftFrom": "Gift from {name}: 2 weeks of unlimited offers",
    "voucher.activate": "Activate my 2 weeks",
    "voucher.giftIt": "Gift it",
    "voucher.haveCode": "Have a gift code?",
    "voucher.redeem": "Redeem",
    "voucher.giftsSent": "Gifts you've sent",
    "ideas.near": "Date inspiration near",
    "ideas.plan": "Plan this date",
    "ideas.popular": "Popular date spots on the platform",
    "ideas.map": "Map",
    "ideas.cityTitle": "Get date ideas for another city",
    "ideas.cityDesc": "Planning a trip or a date somewhere else? Pick any city and we'll curate ideas there.",
    "ideas.show": "Show ideas",
    "ideas.whoFor": "Who's this date for?",
    "ideas.pickDesc": "pick a match and we'll pre-fill your premium offer.",
    "ideas.emptyPrefix": "No matches yet — favorite someone in",
    "ideas.emptySuffix": "or start a chat first.",
    "profile.videos": "VIDEOS",
  },
  ar: {
    "nav.events": "الفعاليات",
    "leaderboard.youOnBoard": "🏆 أنتِ على لوحة المتصدرين!",
    "leaderboard.youOnBoardSub": "الأعضاء على الجانب الآخر يرون ترتيبكِ هنا. استمري في التألق!",
    "events.title": "الفعاليات",
    "events.subtitle": "فعاليات حصرية للأعضاء — تعالَي والتقي بهم في الواقع.",
    "events.empty": "لا توجد فعاليات قادمة الآن — تفقدي لاحقاً!",
    "events.loading": "جارٍ تحميل الفعاليات…",
    "events.spotsLeft": "{n} مقاعد متبقية",
    "events.soldOut": "نفدت المقاعد",
    "events.joinedChip": "أنتِ مسجلة!",
    "events.free": "مجاني",
    "events.feeNote": "${price} + رسوم معالجة $2",
    "events.payCredits": "انضمي بـ {n} كريدت",
    "events.payPaypal": "الدفع عبر PayPal · ${total}",
    "events.joinFree": "انضمي مجاناً",
    "events.notEnough": "كريديتك غير كافية — تكلفة هذه الفعالية {n} كريدت",
    "events.joinedToast": "🎟️ أنتِ مسجلة! تفقدي بريدك الإلكتروني للتأكيد.",
    "events.payCancelled": "تم إلغاء الدفع",
    "events.captureFail": "لم نتمكن من تأكيد دفعتك — يرجى المحاولة مرة أخرى",
    "events.bannerTitle": "🎉 فعالية قادمة",
    "events.bannerCta": "تصفحي الفعاليات",
    "notif.eventJoined.t": "🎟️ أنتِ ذاهبة!",
    "notif.eventJoined.b": "مقعدكِ في \"{title}\" مؤكد. إلى اللقاء هناك!",
    "notif.eventCancelled.t": "😔 تم إلغاء الفعالية",
    "notif.eventCancelled.b": "تم إلغاء \"{title}\". إذا كنتِ قد دفعتِ، فسيتم استرداد المبلغ قريباً.",
    "terms.contactT": "تواصلي معنا",
    "terms.contactP": "أسئلة، استفسارات أو ملاحظات؟ تواصلي معنا في أي وقت:",
    "msdluxe.tapSound": "اضغطي لتشغيل الصوت",
    "msdluxe.badge": "مضيفتكِ الذكية",
    "msdluxe.title1": "تعرفي على Ms DLuxe",
    "msdluxe.title2": "ستأخذكِ في جولة",
    "msdluxe.desc": "Ms DLuxe بنفسها تشرح لكِ كيف يعمل كل شيء — الكريدت، وعروض المواعيد المميزة، والأرباح والسلامة.",
    "msdluxe.luxeCard": "كيف يعمل LuxeMeet",
    "msdluxe.dluxeCard": "كيف يعمل DLuxe",
    "msdluxe.download": "تحميل",
    "msdluxe.share": "احفظيها، انشريها، أرسليها لصديقة — هي لكِ لمشاركتها.",
    "nav.msdluxeVideos": "كيف يعمل · Ms DLuxe",
    "credits.requestRefund": "طلب استرداد",
    "credits.refundRequested": "تم تقديم طلب الاسترداد",
    "credits.refunded": "تم الاسترداد",
    "credits.refundDeniedChip": "غير موافق عليه",
    "credits.refundDialogTitle": "طلب استرداد",
    "credits.refundDialogDesc": "أخبرنا سبب رغبتك في استرداد قيمة هذا الشراء. يراجع فريقنا كل طلب، وستتلقى إشعاراً وبريداً إلكترونياً بالقرار.",
    "credits.refundReasonPh": "لماذا تريد استرداد المبلغ؟",
    "credits.refundSubmit": "إرسال الطلب",
    "credits.refundSent": "تم إرسال طلب الاسترداد — سنراجعه قريباً",
    "safety.checkinToggle": "تسجيل السلامة",
    "safety.checkinDesc": "اختر وقتاً — وسنسألك إن كنت قد وصلت إلى المنزل بأمان. إذا لم يكن هناك رد خلال ساعتين، سيتلقى صديقك تنبيهاً.",
    "safety.checkinPast": "يرجى اختيار وقت تسجيل سلامة في المستقبل",
    "safety.checkinScheduled": "تم الإرسال! صديقك لديه التفاصيل وتم جدولة تسجيل سلامتك.",
    "checkin.title": "هل وصلت إلى المنزل بأمان؟",
    "checkin.body": "اضغط للتأكيد — وإلا سيتلقى {email} تنبيهاً.",
    "checkin.confirmBtn": "أنا بأمان في المنزل ✅",
    "checkin.confirmed": "يسعدنا أنك بخير! تم إشعار صديقك 💛",
    "notif.safetyCheckin.t": "🛟 هل وصلت إلى المنزل بأمان؟",
    "notif.safetyCheckin.b": "اضغط للتأكيد بأنك في المنزل بأمان — وإلا سيتلقى {email} تنبيهاً خلال ساعتين.",
    "landing.freeCreditsPromo": "يحصل الأعضاء الجدد على 50 رصيداً مجانياً — كافية تماماً ليرسل لك رفيق الذكاء الاصطناعي دعوة معجب سري إلى من تحب على وسائل التواصل الاجتماعي.",
    "landing.langHighlight": "متاح بـ 8 لغات مع ترجمة المحادثات داخل التطبيق — تعرّف على أشخاص من حول العالم.",
    "saPromo.title": "رصيدك المجاني بانتظارك",
    "saPromo.body": "لديك {n} رصيداً — كافٍ ليرسل رفيق الذكاء الاصطناعي دعوة معجب سري إلى من تحب على وسائل التواصل الاجتماعي.",
    "saPromo.cta": "أرسل دعوة معجب سري",
    "notif.refundApproved.t": "✅ تمت الموافقة على الاسترداد",
    "notif.refundApproved.b": "تمت الموافقة على استرداد {desc} — تم تعديل حسابك. تحقق من بريدك الإلكتروني للاطلاع على التفاصيل.",
    "notif.refundDenied.t": "تحديث طلب الاسترداد",
    "notif.refundDenied.b": "تمت مراجعة طلب استرداد {desc} — تحقق من بريدك الإلكتروني للاطلاع على التفاصيل.",
    "safety.share": "شارك خطتك مع صديق",
    "safety.title": "أرسل خطة موعدك إلى صديق",
    "safety.desc": "لسلامتك، أرسل بريداً إلكترونياً بجدولك الزمني وملف تعريف من ستلتقي به إلى شخص تثق به.",
    "safety.emailPh": "friend@email.com",
    "safety.notePh": "ملاحظة اختيارية لصديقك…",
    "safety.send": "إرسال",
    "safety.sent": "تم الإرسال! صديقك لديه التفاصيل.",
    "discover.companionsTitle": "تعرّف على رفاق الذكاء الاصطناعي",
    "incog.title": "وضع التخفي",
    "incog.desc": "تحكّم في من يمكنه العثور على ملفك الشخصي مع الاحتفاظ بإمكانية الوصول الكاملة إلى المحادثات والعروض واللقاءات.",
    "incog.toggleLabel": "إخفاء ملفي الشخصي من الاستكشاف",
    "incog.toggleDesc": "لا يمكن لأحد العثور عليك أثناء التصفح. المحادثات والعروض الموجودة تستمر في العمل.",
    "incog.on": "وضع التخفي مفعّل — أنت مخفي من الاستكشاف",
    "incog.off": "أنت مرئي في الاستكشاف مجدداً",
    "incog.hiddenFrom": "أنت مخفي أيضاً بشكل فردي عن {n} عضو/أعضاء (عبر زر العين في ملفاتهم الشخصية).",
    "ratep.title": "خصوصية تقييمات المواعيد",
    "ratep.desc": "اختر ما إذا كنت تشارك في تقييمات المواعيد وما يظهر على ملفك الشخصي.",
    "ratep.partLabel": "المشاركة في تقييمات المواعيد",
    "ratep.partDesc": "عند إيقاف التشغيل، لا يمكن لأحد تقييم مواعيدك ولن يظهر أي تقييم على ملفك الشخصي",
    "ratep.commentsLabel": "عرض التقييمات المكتوبة على ملفي الشخصي",
    "ratep.commentsDesc": "عند إيقاف التشغيل، يُعرض تقييمك بالنجوم فقط — وتبقى التعليقات المكتوبة خاصة",
    "ratep.saved": "تم حفظ تفضيلات التقييم",
    "offers.planDate": "خطّط لموعد",
    "planDate.title": "خطّط لموعد مع…",
    "planDate.desc": "اختر أي شخص من قائمة الأعضاء لإرسال عرض موعد مميز إليه.",
    "planDate.search": "ابحث بالاسم…",
    "planDate.empty": "لم يُعثر على أي عضو",
    "notif.promoRedeemed.t": "🎁 تم استخدام رمز الترويج!",
    "notif.promoRedeemed.b": "أضاف رمزك {code} إلى حسابك {what}. استمتع به!",
    "notif.creditsGranted.t": "🎁 تمت إضافة رصيد!",
    "notif.creditsGranted.b": "تمت إضافة {n} رصيد إلى حسابك من قِبَل فريق LuxeMeet.",
    "notif.slotGranted.t": "🎁 فتحة موعد مميز مجانية!",
    "notif.slotGranted.b": "لقد حصلت على {n} فتحة (فتحات) مجانية لعرض موعد مميز بقيمة $50 — خطّط لموعدك من صفحة العروض!",
    "register.saRevealed": "💌 تم الكشف عن معجبك السري — تحقق من إشعاراتك والدردشة!",
    "tour.replayTitle": "جولة من 60 ثانية",
    "tour.replayDesc": "فاتتك الجولة التوجيهية التجريبية؟ أعد مشاهدتها في أي وقت مع رفيقك الذكي.",
    "tour.replayBtn": "شاهد مجدداً",
    "notif.saReveal.t": "💌 تم الكشف عن المعجب السري!",
    "notif.saReveal.b": "كان {admirer} طوال الوقت! ترك {name} القصة كاملةً في دردشتك. اضغط لعرض ملفه الشخصي.",
    "register.saBanner": "💌 معجبك السري في انتظارك — أنشئ حسابك المجاني لمعرفة من يكون.",
    "credits.earnerNote": "الدردشة مجانية لك في هذا الوضع — يُستخدم الرصيد للميزات الإضافية كطلبات المعجب السري (50 رصيداً).",
    "si.trackJoined": "انضم باسم {name} — عرض الملف الشخصي",
    "notif.siJoined.t": "🎉 إنه هنا!",
    "notif.siJoined.b": "انضم {invitee} للتو عبر دعوتك السرية إلى {handle}. اذهب للقائه!",
    "si.trackTitle": "طلبات المعجب السري الخاصة بك",
    "si.trackLine": "{kind} إلى {handle} على {platform}",
    "si.trackVia": "عبر {name}",
    "si.trackKindAdmirer": "رسالة معجب سري",
    "si.trackKindDate": "طلب موعد",
    "si.trackPending": "قيد الانتظار",
    "si.trackSent": "تم الإرسال",
    "si.trackRefunded": "تم الاسترداد",
    "discover.boosted": "معزَّز",
    "discover.inDemand": "🔥 مطلوب بشدة",
    "discover.diamond": "داياموند",
    "discover.verifiedBadge": "موثّق",
    "gal.addPhoto": "إضافة صورة",
    "gal.addVideo": "إضافة فيديو",
    "gal.videoIntros": "مقاطع تعريفية ({n}/2)",
    "gal.videoRules": "حتى مقطعَين قصيرَين (60 ثانية كحد أقصى، 50 ميغابايت). تتم مراجعتها بالذكاء الاصطناعي — لا يُقبل أي محتوى مخل أو جنسي.",
    "gal.noPhotos": "لا توجد صور بعد. أضف صورتك الأولى للبدء!",
    "si.button": "معجب سري عبر وسائل التواصل",
    "si.title": "معجب سري عبر {name}",
    "si.desc": "ستُرسل {name} رسالة إعجاب سرية أو طلب موعد إلى أي شخص تختاره على وسائل التواصل الاجتماعي — مع دعوة للانضمام إلى التطبيق. يتم التسليم خلال 24 ساعة.",
    "si.typeLabel": "ماذا تريد أن يُرسَل؟",
    "si.typeAdmirer": "رسالة إعجاب سرية",
    "si.typeDate": "طلب موعد",
    "si.platform": "المنصة",
    "si.handle": "اسم المستخدم / المعرّف",
    "si.note": "لمسة شخصية (اختياري)",
    "si.notePh": "هل ثمة شيء تودّ أن تذكره {name}؟",
    "si.submit": "إرسال الطلب ({n} كريدت)",
    "si.success": "تم استلام طلبك! ستصلك إشعار بمجرد أن ترسله {name}.",
    "si.errHandle": "يرجى إدخال معرّف حساب التواصل الاجتماعي",
    "notif.siPending.t": "💌 تم استلام طلبك!",
    "notif.siPending.b": "ستقوم {name} بإرسال {kind} إلى {handle} على {platform}. تم خصم 50 كريدت — وسيتم إعلامك فور الإرسال.",
    "notif.siSent.t": "💘 تم الإرسال!",
    "notif.siSent.b": "أرسلت {name} {kind} إلى {handle} على {platform}. نتمنى لك حظاً موفقاً!",
    "notif.siDeclined.t": "تم استرداد الكريدت",
    "notif.siDeclined.b": "تعذّر إرسال {kind} عبر {name}. تم إعادة 50 كريدت إلى رصيدك.",
    "notif.kindAdmirer": "رسالة إعجاب سرية",
    "notif.kindDate": "طلب موعد",
    "help.title": "مساعد Luxe",
    "help.subtitle": "اسألني أي شيء عن LuxeMeet",
    "help.hi": "مرحباً{name}! 👋",
    "help.welcome": "بإمكاني شرح كيفية عمل الكريدت، وعروض المواعيد المميزة، والضمان، ورموز التأكيد، والمدفوعات. بماذا تودّ الاستفسار؟",
    "help.thinking": "Luxe يفكّر...",
    "help.inputPh": "اكتب سؤالك...",
    "help.error": "عذراً، أواجه بعض الصعوبات الآن. يرجى المحاولة مرة أخرى بعد قليل.",
    "chat.translate": "ترجمة",
    "chat.showOriginal": "عرض النص الأصلي",
    "chat.translating": "جارٍ الترجمة...",
    "chat.translateFail": "تعذّرت الترجمة في الوقت الحالي",
    "chat.sentCredits": "تم إرسال الرسالة ({n} كريدت)",
    "chat.noCredits": "رصيد الكريدت غير كافٍ",
    "chat.tapToUse": "{ai} — اضغط للاستخدام",
    "chat.member": "عضو {app}",
    "land.newMatch": "تطابق جديد!",
    "land.firstMove": "ابدأ الخطوة الأولى",
    "land.dateTerms": "مواعيد بشروطك",
    "land.youChoose": "أنتِ تختارين. أنتِ تقترحين.",
    "land.startChatting": "ابدأ المحادثة الآن",
    "land.likes": "{n} إعجاب",
    "land.thisWeek": "هذا الأسبوع",
    "promo.title": "اكتشف ما يجعله مميزاً",
    "promo.desc": "جولة سريعة في LuxeMeet و DLuxe — مواعيد حقيقية، عروض فاخرة ورومانسية مدعومة بالذكاء الاصطناعي.",
    "promo.tapSound": "اضغط للصوت",
    "promo.shareInvite": "شارك الفيلم — رابط دعوتك مضمّن 🎁",
    "promo.shareFriends": "شارك الفيلم مع الأصدقاء",
    "promo.copiedInvite": "تم نسخ رابط الفيلم مع رمز دعوتك!",
    "promo.copied": "تم نسخ رابط الفيلم!",
    "promo.shareMsg": "🎬 شاهد هذا — LuxeMeet، تطبيق المواعيد حيث تحدث المواعيد الحقيقية فعلاً.",
    "promo.joinInvite": "انضم برابط دعوتي:",
    "promo.shareTg": "🎬 شاهد هذا — تطبيق المواعيد حيث تحدث المواعيد الحقيقية فعلاً",
    "promo.mute": "كتم الموسيقى",
    "promo.unmute": "تشغيل الموسيقى",
    "prof.back": "رجوع",
    "prof.addPhotosHint": "أضف صوراً لتحظى بالاهتمام",
    "prof.noPhotos": "لم يضف {name} صوراً بعد",
    "prof.addPhotos": "إضافة صور",
    "prof.aiCompanion": "الرفيق الذكي",
    "prof.reviewOne": "تقييم موعد",
    "prof.reviewMany": "تقييمات المواعيد",
    "prof.bioEmptyOwn": "نبذتك فارغة — جملتان عنك تُحدثان فرقاً كبيراً.",
    "prof.bioEmptyOther": "يُبقي {name} على غموضه الجذّاب — قل مرحباً لتعرف أكثر.",
    "prof.afterDate": "— {name}، بعد موعده",
    "prof.interests": "الاهتمامات",
    "prof.photos": "الصور",
    "prof.videos": "الفيديوهات",
    "prof.thinking": "جارٍ التفكير...",
    "prof.suggestOpener": "{ai}: اقترح رسالة افتتاحية",
    "prof.offerSent": "تم إرسال العرض! تحقق من صفحة العروض لمتابعة الحالة.",
    "prof.tSuggestFail": "تعذّر الحصول على اقتراحات الآن",
    "prof.tRequestFail": "تعذّر إرسال الطلب",
    "prof.tFavAdded": "تمت الإضافة إلى المفضلة ❤️",
    "prof.tFavRemoved": "تمت الإزالة من المفضلة",
    "prof.tFavFail": "فشل تحديث المفضلة",
    "prof.tVisibilityFail": "فشل تحديث إعدادات الظهور",
    "prof.tHidden": "أنت مخفي الآن عن {name} في الاكتشاف",
    "prof.tVisible": "أصبحت مرئياً لـ {name} مجدداً",
    "prof.tLoadFail": "فشل تحميل الملف الشخصي",
    "prof.tMsgEmpty": "يرجى كتابة رسالة",
    "prof.tNoCredits": "رصيد غير كافٍ. اشترِ المزيد من الرصيد للمتابعة.",
    "prof.tMsgFail": "فشل إرسال الرسالة",
    "prof.tMeetupMissing": "يرجى تحديد التاريخ والموقع",
    "prof.tMeetupFail": "فشل إرسال طلب اللقاء",
    "nb.title": "الإشعارات",
    "nb.empty": "لا توجد إشعارات بعد",
    "time.now": "الآن",
    "time.m": "منذ {n} د",
    "time.h": "منذ {n} س",
    "time.d": "منذ {n} ي",
    "notif.photoVerified.t": "✅ تم التحقق منك!",
    "notif.photoVerified.b": "اجتاز التحقق من صورتك بنجاح — ستظهر شارة «موثوق» على ملفك الشخصي الآن.",
    "notif.relRequest.t": "💍 هل تصبحان رسميين؟",
    "notif.relRequest.b": "يريد {name} أن تكونا رسميين معاً! اقبل من الإعدادات وسيختفي كلاكما من قائمة الجميع.",
    "notif.relDeclined.t": "تم رفض طلب العلاقة الرسمية",
    "notif.relDeclined.b": "{name} ليس مستعداً لذلك في الوقت الحالي.",
    "notif.relActive.t": "💞 أنتما رسميان معاً!",
    "notif.relActive.b": "قال {name} نعم. أصبحتما الآن مخفيَّين عن الجميع — التطبيق أصبح حكراً لكما وحدكما.",
    "notif.relEnded.t": "انتهت العلاقة الرسمية",
    "notif.relEnded.b": "أنهى {name} العلاقة الرسمية. أصبحتما مرئيَّين على التطبيق مجدداً.",
    "notif.dateReview.t": "{stars} تقييم موعد جديد!",
    "notif.dateReview.b": "قيّم {name} موعدك بـ {rating}/5. {comment}",
    "notif.escrow.t": "💰 تم استلام دفعة الموعد!",
    "notif.escrow.b": "دفع {name} مبلغ ${amount} لموعدك. المبلغ ${payout} محتجز في الضمان. أكّد الموعد برمز {name} المكوّن من 6 أرقام لاستلام مدفوعاتك.",
    "notif.escrowBoost.t": "💰 تم استلام دفعة الموعد!",
    "notif.escrowBoost.b": "دفع {name} مبلغ ${amount} لموعدك. المبلغ ${payout} محتجز في الضمان — يشمل مكافأة الإحالة البالغة 90%! أكّد الموعد برمز {name} المكوّن من 6 أرقام لاستلام مدفوعاتك.",
    "notif.offerPaid.t": "💘 تم حجز الموعد!",
    "notif.offerPaid.b": "تم تأكيد دفعتك لموعدك مع {name}. رمز التأكيد المكوّن من 6 أرقام جاهز في صفحة العروض — شاركه مع رفيقك بعد الموعد.",
    "notif.refSlot.t": "🎁 حصلت على مقعد مميز مجاني!",
    "notif.refSlot.b": "اشترى {name} الذي أحلته مقعداً مميزاً — لقد حصلت على مقعد مجاني بقيمة $50 كمكافأة!",
    "notif.boostActivated.t": "🚀 تم تعزيز ملفك الشخصي!",
    "notif.boostActivated.b": "ملفك الشخصي يظهر الآن في مقدمة الاكتشاف لمدة 24 ساعة القادمة.",
    "notif.creditsAdded.t": "🪙 تمت إضافة الرصيد!",
    "notif.creditsAdded.b": "تمت إضافة {credits} رصيداً من حزمة {package} إلى حسابك. الرصيد الجديد: {balance}.",
    "notif.unlimited.t": "♾️ تم تفعيل العروض غير المحدودة!",
    "notif.unlimited.b": "جائزتك البطولية أصبحت فعّالة — أرسل عروض مواعيد غير محدودة (بدون الحاجة إلى خانات) للأسبوعين القادمين!",
    "notif.voucherGifted.t": "🎁 لقد استلمت قسيمة بطولية!",
    "notif.voucherGifted.b": "أهداك {name} أسبوعين من عروض المواعيد غير المحدودة — فعّلها في الإعدادات قبل {date}.",
    "notif.voucherRedeemed.t": "🎁 تم استخدام هديتك!",
    "notif.voucherRedeemed.b": "استخدم {name} القسيمة البطولية التي أهديتها إليه.",
    "notif.refBoost.t": "🎁 تم فتح مكافأة الإحالة!",
    "notif.refBoost.b": "أتمّ {name} الذي أحلته أولى مواعيده المميزة — موعد أرباحك القادم سيمنحك 90% بدلاً من 80%!",
    "notif.payoutProcessing.t": "✅ تم تأكيد الموعد!",
    "notif.payoutProcessing.b": "مدفوعاتك البالغة ${amount} قيد المعالجة وستصل إلى حساب PayPal خلال 24-48 ساعة.",
    "notif.offerExpiredSender.t": "⏰ انتهت صلاحية عرض الموعد",
    "notif.offerExpiredSender.b": "انتهت صلاحية عرض موعدك البالغ ${amount} بعد 7 أيام. تم تحرير خانتك المميزة لتتمكن من إرسال عرض جديد.",
    "notif.offerExpiredRecipient.t": "⏰ انتهت صلاحية عرض الموعد",
    "notif.offerExpiredRecipient.b": "انتهت صلاحية عرض موعد قبلته لأن الدفع لم يُكتمل خلال 7 أيام.",
    "notif.dateReminder24.t": "💜 تذكير بالموعد: غداً!",
    "notif.dateReminder24.b": "موعدك مع {name} غداً — {when}، {where}.",
    "notif.offerExpiringPay.t": "⏳ ينتهي العرض خلال 24 ساعة!",
    "notif.offerExpiringPay.b": "عرض موعدك البالغ ${amount} إلى {name} ينتهي غداً — أكمل الدفع قبل فوات الأوان وتحرير خانتك.",
    "notif.offerExpiringWait.t": "⏳ ينتهي العرض خلال 24 ساعة!",
    "notif.offerExpiringWait.b": "عرض موعدك البالغ ${amount} إلى {name} ينتهي غداً — انتظر ردّها أو تواصل معها قبل فوات الأوان وتحرير خانتك.",
    "notif.matchInsights.t": "💌 إحصاءات تطابقاتك الأسبوعية",
    "notif.matchInsights.b": "{views} مشاهدة لملفك الشخصي و{favs} مفضّلة جديدة هذا الأسبوع — من بينهم {names}. ألقِ التحية أو عزّز ملفك لإشعال عروض المواعيد!",
    "notif.streak1.t": "🔥 تقدّم السلسلة: {streak}/3",
    "notif.streak1.b": "موعد واحد بتقييم 4★ أو أعلى ويصبح لك 150 رصيداً مجانياً!",
    "notif.streakN.t": "🔥 تقدّم السلسلة: {streak}/3",
    "notif.streakN.b": "{togo} موعد آخر بتقييم 4★ أو أعلى لفتح 150 رصيداً مجانياً.",
    "notif.streakDone.t": "🔥 تقدّم السلسلة: {streak}/3",
    "notif.streakDone.b": "مكافأتك في الطريق إليك!",
    "notif.rankUp.t": "🏆 أنت في المرتبة #{rank} على لوحة الأعلى تقييماً",
    "notif.rankUp.b": "أنت في المرتبة #{rank} على لوحة الأعلى تقييماً. 📈 تقدّمت {spots} مركزاً عن الأسبوع الماضي! المركز الأول شهرياً يفوز بأسبوعين من عروض المواعيد غير المحدودة.",
    "notif.rankDown.t": "🏆 أنت في المرتبة #{rank} على لوحة الأعلى تقييماً",
    "notif.rankDown.b": "أنت في المرتبة #{rank} على لوحة الأعلى تقييماً. 📉 تراجعت {spots} مراكز عن الأسبوع الماضي — موعد رائع واحد يُعيدك إلى الصدارة. المركز الأول شهرياً يفوز بأسبوعين من عروض المواعيد غير المحدودة.",
    "notif.rankSteady.t": "🏆 أنت في المرتبة #{rank} على لوحة الأعلى تقييماً",
    "notif.rankSteady.b": "أنت في المرتبة #{rank} على لوحة الأعلى تقييماً. 🎯 محافظ على مركزك من الأسبوع الماضي. المركز الأول شهرياً يفوز بأسبوعين من عروض المواعيد غير المحدودة.",
    "notif.rankNew.t": "🏆 أنت في المرتبة #{rank} على لوحة الأعلى تقييماً",
    "notif.rankNew.b": "🎉 جديد: دخلت لوحة الأعلى تقييماً في المرتبة #{rank}! المركز الأول شهرياً يفوز بأسبوعين من عروض المواعيد غير المحدودة.",
    "notif.rankOff.t": "🏆 تحديث لوحة المتصدرين",
    "notif.rankOff.b": "خرجت من لوحة الأعلى تقييماً هذا الأسبوع — موعد رائع واحد يُعيدك إليها. المركز الأول شهرياً يفوز بأسبوعين من عروض المواعيد غير المحدودة.",
    "notif.boostEnded.t": "⚡ انتهى تعزيزك",
    "notif.boostEnded.b": "انتهى تعزيزك لمدة 24 ساعة. لقد حقق لك {views} مشاهدة لملفك الشخصي. عزّز مجدداً من صفحة الاكتشاف لتبقى في القمة!",
    "notif.boostEndedExtra.t": "⚡ انتهى تعزيزك",
    "notif.boostEndedExtra.b": "انتهى تعزيزك لمدة 24 ساعة. لقد حقق لك {views} مشاهدة لملفك الشخصي — أي ما يقارب {extra} مشاهدة أكثر من يوم عادي. عزّز مجدداً من صفحة الاكتشاف لتبقى في القمة!",
    "notif.dateSoon1h.t": "⏰ موعدك على وشك البدء!",
    "notif.dateSoon1h.b": "موعدك مع {name} بعد أقل من ساعة — {time} في {location}.{tip}",
    "notif.dateSoon24.t": "💜 موعدك بعد 24 ساعة!",
    "notif.dateSoon24.b": "موعدك مع {name} بعد 24 ساعة — {time} في {location}.{tip}",
    "notif.dateSoonTip": " افتح عرضك للاطلاع على العد التنازلي المباشر وتوقعات الطقس ونصائح الأناقة!",
    "notif.badgeFire.t": "🔥 أنت في القمة!",
    "notif.badgeFire.b": "أنت من بين أكثر 3 رجال تواصلاً معهم على DLuxe هذا الشهر — يظهر الآن شارة 🔥 على ملفك الشخصي.",
    "notif.hotStreak.t": "🔥 سلسلة موفّقة! 150 كريدت مجاناً",
    "notif.hotStreak.b": "3 مواعيد حظيت بتقييمات عالية على التوالي — تمت إضافة باقة الـ 150 كريدت الشعبية إلى حسابك مجاناً. حافظ على السلسلة!",
    "notif.badgeDiamond.t": "💎 حصلت على شارة الماس!",
    "notif.badgeDiamond.b": "أتممت 3 مواعيد مميزة بقيمة $500 أو أكثر — تتألق الآن شارة الماس على ملفك الشخصي.",
    "notif.champion.t": "🏆 بطل قائمة المتصدرين!",
    "notif.champion.b": "احتللت المركز الأول في '{section}' هذا الشهر! الجوائز: تعزيز مجاني لمدة 7 أيام لملفك الشخصي (مفعّل بالفعل) وقسيمة لأسبوعين من عروض المواعيد غير المحدودة — فعّلها من الإعدادات في أي وقت خلال الأشهر الستة القادمة.",
    "notif.anniversary.t": "💞 {months} {monthsWord} معاً!",
    "notif.anniversary.b": "أنت و{name} تحتفلان بـ {months} {monthsWord} رسمية. احتفلا بها — فكرة: {idea}",
    "notif.monthWord": "شهر",
    "notif.monthsWord": "أشهر",
    "notif.annIdea0": "أعيدا تمثيل موعدكما الأول — نفس المكان، نفس الطلب، وذكريات جديدة.",
    "notif.annIdea1": "اطبخا معاً عشاءً من ثلاثة أطباق على ضوء الشموع في المنزل، مع إيقاف الهواتف.",
    "notif.annIdea2": "نزهة عند الغروب مع المقرمشات المفضلة لكل منكما وقائمة تشغيل مشتركة واحدة.",
    "notif.annIdea3": "احجزا جلسة سبا للأزواج واحتفلا بعدها بمشروب فوّار.",
    "notif.annIdea4": "قوما برحلة قصيرة بالسيارة إلى بلدة لم يزرها أيٌّ منكما من قبل.",
    "notif.annIdea5": "ليلة مراقبة النجوم: بطانيات وشوكولاتة ساخنة وأغنيتكما على تكرار.",
    "notif.annIdea6": "درس رقص لاثنين — سالسا أو باتشاتا أو أي شيء يجعلكما تضحكان.",
    "notif.annIdea7": "موعد في متحف أو معرض فني، ثم حلوى في مكان أنيق.",
    "notif.annIdea8": "اكتبا لبعضكما رسالة عن لحظتكما المفضلة حتى الآن وتبادلاها على العشاء.",
    "notif.annIdea9": "احجزا عشاء على السطح أو التراس — تزيّنا كأنه الموعد الأول.",
    "notif.annIdea10": "تذوّقا النبيذ أو الشوكولاتة ثم استمتعا بنزهة هادئة عائدَين إلى المنزل.",
    "notif.annIdea11": "خططا لرحلة أحلامكما معاً على الإفطار في السرير — ثم احجزا جزءاً منها.",
    "notif.companionInvite.t": "💌 لدى {name} مفاجأتك!",
    "notif.companionInvite.b": "تمت الكشف عن دعوتك السرية في محادثتك.",
    "notif.supportResolved.t": "✅ تم حل طلب الدعم",
    "notif.supportResolved.b": "تمت مراجعة {label} \"{subject}\" الخاص بك وحله.",
    "notif.supportResolvedResp.t": "✅ تم حل طلب الدعم",
    "notif.supportResolvedResp.b": "تمت مراجعة {label} \"{subject}\" الخاص بك وحله. الرد: {resp}",
    "notif.labelRefund": "طلب استرداد",
    "notif.labelComplaint": "شكوى",
    "notif.testMeetup.t": "{name} قبل لقاءك! 🎉",
    "notif.testMeetup.b": "اكتملت التجربة — هكذا تبدو الإشعارات تماماً عندما يقبل عضو حقيقي. لم يتم خصم أي رصيد.",
    "notif.testCounter.t": "{name} أرسل عرضاً مضاداً 💬",
    "notif.testCounter.b": "تجربة: قدّم عرضاً مضاداً بـ ${amount}. اقبل أو ارفض لمتابعة الخطوات — لا أموال حقيقية.",
    "notif.testOfferAccepted.t": "{name} قبل عرض موعدك! 💜",
    "notif.testOfferAccepted.b": "تجربة: اضغط على زر محاكاة الدفع في صفحة العروض لرؤية بقية الخطوات — لا أموال حقيقية.",
    "notif.testDateCompleted.t": "اكتمل الموعد التجريبي مع {name}! 🏆",
    "notif.testDateCompleted.b": "كانت هذه دورة الموعد المميز الكاملة — العرض، القبول، الدفع، الرمز والتأكيد. لم تُنقل أي أموال حقيقية. هل أنت مستعد لتجربتها مع عضو حقيقي؟",
    "notif.refChat.t": "🎁 ربحت +{credits} رصيداً!",
    "notif.refChat.b": "بدأ {name} المحادثة للتو — تمت إضافة {credits} رصيداً مكافأة إلى رصيدك.",
    "notif.payoutSent.t": "💸 تم إرسال المدفوعات!",
    "notif.payoutSent.b": "تم إرسال ${amount} إلى PayPal الخاص بك ({recipient}).",
    "notif.favVerified.t": "✅ {name} موثّق الآن!",
    "notif.favVerified.b": "اجتاز {name} من قائمة مفضلتك التحقق بالصورة الشخصية وحصل على شارة الموثوقية.",
    "notif.favReviewed.t": "⭐ حصل {name} على تقييم رائع!",
    "notif.favReviewed.b": "تلقّى {name} من قائمة مفضلتك تقييماً بـ {rating} نجوم على موعده. المواعيد المميزة تُحجز بسرعة!",
    "notif.favBoosted.t": "⚡ قام {name} بتعزيز ظهوره للتو!",
    "notif.favBoosted.b": "{name} من قائمة مفضلتك يظهر الآن في صدارة الاكتشاف — أرسل تحية بينما هو في الواجهة!",
    "register.newMembers": "يحصل الأعضاء الجدد على",
    "register.promoLuxe1": "50 رصيداً مجاناً",
    "register.promoDluxe1": "وصول مجاني + أرباح",
    "register.promoLuxe2": "للسيدات المنضمات إلى LuxeMeet",
    "register.promoDluxe2": "انضم إلى DLuxe مجاناً واربح من المواعيد المميزة",
    "register.googleTerms": "بالمتابعة مع Google، فإنك توافق على",
    "register.googleTermsLink": "الشروط والأحكام",
    "register.orEmail": "أو سجّل بالبريد الإلكتروني",
    "register.hintF": "السيدات: الانضمام مجاني على LuxeMeet (50 رصيداً للبداية) — أو خذي زمام المبادرة على DLuxe بتقديم عروض مواعيد مميزة للرجال.",
    "register.hintM": "الرجال: استثمر للتواصل على LuxeMeet — واستمتع بالوصول المجاني والكسب من المواعيد المميزة على DLuxe.",
    "register.hintNone": "اختر جنسك لعرض الميزات المتاحة",
    "register.refCode": "رمز الإحالة",
    "register.refOptional": "(اختياري)",
    "register.refPh": "هل لديك رمز؟ أدخله هنا",
    "register.terms18": "أؤكد أنني أبلغ من العمر 18 عاماً أو أكثر وأوافق على",
    "register.termsLink": "الشروط والأحكام وإخلاء المسؤولية",
    "register.create": "إنشاء حساب",
    "register.haveAccount": "هل لديك حساب بالفعل؟",
    "register.errGender": "يرجى اختيار الجنس",
    "register.errTerms": "يرجى قبول الشروط والأحكام للمتابعة",
    "register.errFail": "فشل التسجيل",
    "register.giftClaimed": "😕 رمز الهدية هذا ({code}) تم استخدامه مسبقاً.",
    "register.giftExpired": "😕 انتهت صلاحية رمز الهدية هذا ({code}).",
    "register.giftReady": "🎁 أهداك {name} قسيمة بطولية ({code}) — ستُضاف إلى حسابك فور إتمام التسجيل!",
    "register.giftFriend": "صديق",
    "set.tImgFile": "يرجى اختيار ملف صورة",
    "set.tImgSize": "يجب أن يكون حجم الصورة أقل من 5 ميجابايت",
    "set.tPhotoUpdated": "تم تحديث صورة الملف الشخصي!",
    "set.tPhotoFail": "فشل تحميل الصورة",
    "set.tPwMismatch": "كلمتا المرور الجديدتان غير متطابقتين",
    "set.tPwShort": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
    "set.tPwChanged": "تم تغيير كلمة المرور بنجاح!",
    "set.tPwFail": "فشل تغيير كلمة المرور",
    "set.tProfileUpdated": "تم تحديث الملف الشخصي!",
    "set.tProfileFail": "فشل تحديث الملف الشخصي",
    "set.tLoggedOut": "تم تسجيل الخروج بنجاح",
    "set.tDeactivated": "تم تعطيل الحساب. سجّل الدخول مجدداً خلال 30 يوماً لإعادة تفعيله.",
    "set.tDeleteFail": "فشل حذف الحساب",
    "pp.errInvalidEmail": "يرجى إدخال عنوان بريد إلكتروني صحيح",
    "pp.errNoMatch": "عنوانا البريد الإلكتروني غير متطابقين",
    "pp.errConfirm": "يرجى تأكيد عنوان بريد PayPal الإلكتروني",
    "pp.errFix": "يرجى تصحيح الأخطاء قبل الحفظ",
    "pp.savedOk": "تم حفظ إعدادات PayPal والتحقق منها!",
    "pp.saveFail": "فشل حفظ الإعدادات",
    "pp.errImg": "يرجى تحميل ملف صورة",
    "pp.errSize": "يجب أن يكون حجم الملف أقل من 5 ميجابايت",
    "pp.qrUploaded": "تم تحميل رمز QR!",
    "pp.qrFail": "فشل تحميل رمز QR",
    "terms.title": "الشروط والأحكام",
    "terms.updated": "تشمل إخلاء المسؤولية — آخر تحديث: يونيو 2026 (الإصدار الخامس)",
    "terms.back": "رجوع",
    "terms.footer": "© 2026 LuxeMeet & DLuxe. جميع الحقوق محفوظة.",
    "terms.s1t": "1. قبول الشروط",
    "terms.s1p1": "بإنشائك حساباً أو باستخدامك LuxeMeet أو وضعها المرافق DLuxe (معاً، \"المنصة\")، فإنك توافق على الالتزام بهذه الشروط والأحكام وبيان إخلاء المسؤولية. إن لم توافق على ذلك، فيرجى عدم استخدام المنصة.",
    "terms.s2t": "2. شروط الأهلية (18 عاماً فأكثر)",
    "terms.s2p1": "يجب أن يكون عمرك 18 عاماً على الأقل لاستخدام LuxeMeet. بالتسجيل، فإنك تُقرّ وتضمن أنك بلغت هذا السن أو تجاوزته وأنك مؤهل قانونياً لإبرام هذه الاتفاقية. سيتم إنهاء أي حساب يتبيّن أنه يعود لقاصر فوراً دون أي استرداد.",
    "terms.s3t": "3. طبيعة الخدمة",
    "terms.s3p1": "LuxeMeet هي منصة تعارف فحسب. نوفّر أدوات تتيح للبالغين التعرف على بعضهم والتواصل وترتيب اللقاءات. ولا نكون طرفاً في أي تفاعل أو محادثة أو موعد أو ترتيب بين الأعضاء. كما لا نُجري فحوصات بحثية جنائية على الأعضاء ولا نقدم أي ضمانات بشأن هوية أي عضو أو سلوكه أو نواياه أو مدى توافقه مع الآخرين.",
    "terms.s3p2": "قد تعرض المنصة روابط لخدمات خارجية مستقلة تساعد في التخطيط للمواعيد — كـ OpenStreetMap وGoogle Maps للمواقع، وUber للتنقل، وAirbnb Experiences لأفكار المواعيد. هذه الخدمات ليست تحت إدارتنا؛ ويخضع استخدامك لها لشروطها الخاصة، ولسنا مسؤولين عن محتواها أو أسعارها أو مدى توافرها.",
    "terms.s4t": "4. الرصيد والمدفوعات وعروض المواعيد المميزة",
    "terms.s4p1": "يشتري الأعضاء الذكور رصيداً للمراسلة وطلب اللقاءات، وفتحات عروض مميزة لإرسال عروض المواعيد، وتعزيزات اختيارية للملف الشخصي. تتم معالجة جميع المدفوعات عبر PayPal. تُعرض الأسعار عند نقطة الشراء وقد تشمل رسوم معالجة.",
    "terms.s4p2": "فيما يخص عروض المواعيد المميزة، يُحتجز المبلغ المعروض في الضمان فور سداده. وعند إتمام الموعد وإدخال المستلم لرمز التأكيد المكوّن من 6 أرقام الخاص بالدافع، يُحرَّر المبلغ (بعد خصم عمولة المنصة) للمستلم. تُفصَح عن عمولة المنصة داخل التطبيق. المواعيد المتكررة: حين يحجز الدافع موعداً جديداً مع شخص أتمّ معه موعداً سابقاً عبر المنصة، لا يلزم شراء فتحة مميزة وتُطبَّق عمولة منصة مخفضة بنسبة 10% (يحصل المستلم على 90% من المبلغ المعروض). تُدفع بدلات النقل الاختيارية مع العرض وتُحوَّل بالكامل 100% إلى المستلم. تُحذف عروض المواعيد الملغاة تلقائياً من سجل العروض بعد 48 ساعة من الإلغاء. القسائم البطولية: قسائم المكافآت المكتسبة عبر لوحة المتصدرين الشهرية لأفضل الأعضاء يمكن إهداؤها مرة واحدة لشخص آخر عبر رمز هدية للاستخدام مرة واحدة فقط؛ وبمجرد الإهداء، لا يحق للمالك الأصلي استخدام القسيمة أو استردادها، كما لا يمكن إعادة إهداء القسائم المستلمة. لا قيمة نقدية للقسائم.",
    "terms.s4p3": "المبالغ المستردة: الاعتمادات والخانات والتعزيزات غير قابلة للاسترداد بمجرد تسليمها. المدفوعات المحجوزة للموعد قابلة للاسترداد فقط إذا لم يتم الموعد وتم إلغاء العرض أو انتهاء صلاحيته وفقاً لقواعد المنصة. يجب إجراء المدفوعات من حساب PayPal تتطابق بريده الإلكتروني مع بريد تسجيل الدخول إلى LuxeMeet؛ قد تتأخر المدفوعات الصادرة من عناوين بريد إلكتروني غير متطابقة أو يتعذر استردادها. يمكنك تقديم طلب استرداد أو شكوى في أي وقت عبر الإعدادات ← المبالغ المستردة والشكاوى (أو \"المساعدة والدعم\" في قائمة التطبيق)؛ تتم مراجعة كل طلب من قِبل فريقنا وستتلقى إشعاراً بالنتيجة داخل التطبيق وعبر البريد الإلكتروني.",
    "terms.s5t": "5. إخلاء المسؤولية وتحمّل المخاطر",
    "terms.s5p1": "أنتَ تُقرّ صراحةً بأن لقاء أي عضو آخر شخصياً يكون على مسؤوليتك الشخصية الكاملة. إلى أقصى حد يسمح به القانون، فإنك تُعفي LuxeMeet وملاكها ومشغليها وموظفيها وشركاتها التابعة وتُبرئ ذمتهم من أي وجميع المطالبات والمطالب والأضرار والإصابات والخسائر أو أسباب الدعاوى — سواء أكانت معلومة أم غير معلومة — الناشئة عن أو المتعلقة باستخدامك للمنصة، أو تفاعلاتك أو مراسلاتك مع الأعضاء الآخرين، أو أي لقاء شخصي أو موعد يُرتَّب عبر المنصة، بما في ذلك على سبيل المثال لا الحصر: الإصابة الجسدية، والضيق العاطفي، وتلف الممتلكات، والسرقة، والاحتيال، أو الخسارة المالية.",
    "terms.s5p2": "أنت المسؤول الوحيد عن سلامتك الشخصية. نوصي بشدة بالتقاء الأشخاص في أماكن عامة، وإخبار صديق بوجهتك، وترتيب وسيلة مواصلاتك الخاصة، وعدم مشاركة أي معلومات مالية مع الأعضاء الآخرين.",
    "terms.s6t": "6. سلوك الأعضاء",
    "terms.s6p1": "توافق على عدم: انتحال هويتك أو عمرك؛ مضايقة الأعضاء الآخرين أو إيذائهم أو إلحاق الضرر بهم؛ طلب أموال من الأعضاء خارج نظام العروض في المنصة؛ استخدام المنصة لأي غرض تجاري أو غير قانوني أو استغلالي (بما في ذلك خدمات المرافقة أو الاتجار بالبشر)؛ نشر محتوى صريح أو مسيء أو منتهك لحقوق الملكية؛ أو محاولة التحايل على أنظمة الدفع في المنصة.",
    "terms.s6p2": "سياسة المحتوى: يجب ألا تحتوي صور الملف الشخصي ومقاطع الفيديو على عري أو محتوى جنسي صريح أو إيحائي. تخضع جميع الصور ومقاطع الفيديو المرفوعة للفحص التلقائي بواسطة الذكاء الاصطناعي قبل نشرها، ويتم رفض المحتوى المحظور. قد تؤدي المحاولات المتكررة لرفع محتوى محظور إلى اتخاذ إجراء بشأن الحساب.",
    "terms.s6p3": "قد يترتب على المخالفة التعليق الفوري للحساب أو إنهاؤه دون استرداد للمبالغ المدفوعة، وإحالة الأمر إلى جهات إنفاذ القانون عند الاقتضاء.",
    "terms.s7t": "7. تقييمات المواعيد والمراجعات والمفضلة",
    "terms.s7p1": "بعد اكتمال موعد مميز، يمكن لكلا المشاركَين تقييم الموعد (من 1 إلى 5 نجوم) مع إمكانية إضافة تعليق مكتوب اختياري. المشاركة في التقييمات اختيارية: يمكنك إلغاء الاشتراك كلياً من الإعدادات، وفي هذه الحالة لن يتمكن أحد من تقييم مواعيدك ولن يظهر أي تقييم على ملفك الشخصي. إذا اخترت المشاركة، يمكنك تحديد ما إذا كانت تعليقات المراجعات المكتوبة ستُعرض للعموم مع تقييمك بالنجوم.",
    "terms.s7p2": "يجب أن تكون المراجعات صادقة ومحترمة ومستندة إلى موعد فعلي. قد تُحذف المراجعات التشهيرية أو التحرشية أو الكاذبة، وقد تؤدي إلى اتخاذ إجراء بشأن الحساب. يمكن للأعضاء أيضاً حفظ ملفات تعريف أخرى في قائمة مفضلة خاصة؛ لا تظهر مفضلتك إلا لك وحدك. إذا أضفت عضواً إلى مفضلتك، فقد تتلقى إشعارات حول نشاطه العام في الملف الشخصي (كالتعزيزات، أو التحقق، أو المراجعات الجديدة).",
    "terms.s8t": "8. ميزات الذكاء الاصطناعي",
    "terms.s8p1": "تُقدّم المنصة ميزات اختيارية مدعومة بالذكاء الاصطناعي، تشمل مساعدَي الكتابة \"AI Wingman\" (للأعضاء الذكور) و\"AI Cupid\" (للأعضاء الإناث) — اللذَين يمكنهما صياغة رسائل بدء المحادثة والردود، وملاحظات عروض المواعيد المميزة، ورسائل العروض المضادة، ورسائل طلبات اللقاء، وتعليقات مراجعات المواعيد — إضافةً إلى مساعد \"Luxe\" داخل التطبيق، وأفكار مواعيد منسّقة بالذكاء الاصطناعي، واقتراحات الأزياء من مصمم الأزياء الذكي المعروضة في العد التنازلي لليلة الموعد، ورؤى المطابقة الأسبوعية بمساعدة الذكاء الاصطناعي، وصور الملف الشخصي بمساعدة الذكاء الاصطناعي، والتحقق من الهوية عبر السيلفي بالذكاء الاصطناعي. يُستخدم الذكاء الاصطناعي أيضاً لفحص جميع الصور ومقاطع الفيديو المرفوعة تلقائياً بحثاً عن المحتوى المحظور (العري والمحتوى الجنسي) قبل نشرها. يتم إنشاء محتوى الذكاء الاصطناعي تلقائياً وقد يكون غير دقيق. أنت مسؤول عن أي محتوى ترسله أو تنشره، بما في ذلك المحتوى المُنشأ بمساعدة الذكاء الاصطناعي. يجب أن تمثّلك صور الملف الشخصي بصدق؛ قد يؤدي استخدام صور ذكاء اصطناعي تُشوّه مظهرك بشكل جوهري إلى اتخاذ إجراء بشأن الحساب. تُستخدم صور التحقق بالسيلفي حصراً لعملية التحقق ولا تُعرض للعموم أبداً.",
    "terms.s9t": "9. تحديد المسؤولية",
    "terms.s9p1": "إلى أقصى حد يسمح به القانون، لن تكون LuxeMeet مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية، أو أي خسارة في الأرباح أو البيانات، الناشئة عن استخدامك للمنصة. لن تتجاوز مجموع مسؤوليتنا الإجمالية عن أي مطالبة المبلغ الذي دفعته إلى LuxeMeet خلال الستة (6) أشهر السابقة للمطالبة.",
    "terms.s10t": "10. الخصوصية",
    "terms.s10p1": "نجمع معلومات الحساب والرسائل وسجلات الدفع وبيانات الاستخدام ونعالجها لتشغيل المنصة، ومعالجة المدفوعات والمستحقات، ومنع الاحتيال، وتحسين الخدمة. يتم تتبع عدد مشاهدات الملف الشخصي لدعم تحليلات التعزيز. يمكنك تفعيل وضع التخفي في الإعدادات لإخفاء ملفك الشخصي من تصفح الاكتشاف — بشكل كامل أو من أعضاء محددين — بينما تستمر محادثاتك الحالية وعروضك ولقاءاتك في العمل. لا نبيع بياناتك الشخصية. قد يتم إرسال رسائل بريد إلكتروني لأغراض متعلقة بالحساب والمدفوعات والتفاعل.",
    "terms.s11t": "11. إنهاء الخدمة وحذف الحساب",
    "terms.s11p1": "حذف حسابك: يمكنك حذف حسابك في أي وقت من الإعدادات ← منطقة الخطر. يُخفى ملفك الشخصي فوراً من الاكتشاف ولوائح المتصدرين والمفضلة. تسري فترة سماح مدتها 30 يوماً: يؤدي تسجيل الدخول مرة أخرى خلال 30 يوماً إلى إعادة تفعيل حسابك بالكامل. بعد 30 يوماً، يتم حذف حسابك وبياناتك الشخصية (الملف الشخصي والصور ومقاطع الفيديو والرسائل والمفضلة والإشعارات) بشكل دائم ونهائي أو يتم إخفاء هويتها. تُصادر الاعتمادات والخانات والتعزيزات غير المستخدمة وأي أرصدة غير مسحوبة عند الحذف النهائي. قد يتم الاحتفاظ بالسجلات المطلوبة للامتثال المالي والقانوني (كسجلات المدفوعات المكتملة) بصيغة مجهولة الهوية.",
    "terms.s11p2": "يحق لنا تعليق الحسابات التي تنتهك هذه الشروط أو إنهاؤها. تُصادر الاعتمادات والخانات والتعزيزات غير المستخدمة عند الإنهاء بسبب مخالفة.",
    "terms.s12t": "12. التغييرات على هذه الشروط",
    "terms.s12p1": "قد نُحدّث هذه الشروط من وقت لآخر. يُعدّ الاستمرار في استخدام المنصة بعد سريان التغييرات قبولاً للشروط المُعدَّلة.",
    "terms.s13t": "13. وضع DLuxe",
    "terms.s13p1": "تتضمن المنصة وضعاً مرافقاً هو \"DLuxe\"، يمكن الوصول إليه عبر مفتاح القلب داخل التطبيق. يعكس DLuxe تجربة LuxeMeet مع عكس أدوار الدفع: تدفع الأعضاء الإناث مقابل التفاعلات (الاعتمادات وخانات العروض المميزة والتعزيزات وعروض المواعيد المالية)، ويمكن للأعضاء الذكور استلام مستحقات عروض المواعيد. تنطبق جميع الشروط بالتساوي على كلا الوضعَين، مع تطبيق الأحكام الخاصة بكل دور على الطرف الذي يدفع أو يستلم الدفعة في الوضع النشط. يُستخدم حساب واحد عبر كلا الوضعَين. المحادثات وطلبات اللقاء مفصولة حسب الوضع: التفاعلات التي بدأت في LuxeMeet تتبع قواعد دفع LuxeMeet (يدفع الأعضاء الذكور) والتفاعلات التي بدأت في DLuxe تتبع قواعد DLuxe (تدفع الأعضاء الإناث). يغيّر التبديل بين الوضعَين صندوق البريد الوارد المعروض فقط ولا يغيّر أبداً من يدفع داخل محادثة قائمة. جميع ميزات المنصة — بما في ذلك مساعدو الذكاء الاصطناعي ولوائح المتصدرين ومكافآت البطولة وإهداء القسائم — متاحة في كلا الوضعَين بعلامة تجارية مناسبة لكل وضع.",
    "terms.s14t": "14. التواصل معنا",
    "terms.s14p1": "هل لديك أسئلة حول هذه الشروط؟ استخدم مساعد المساعدة داخل التطبيق. لطلبات الاسترداد والشكاوى، استخدم الإعدادات ← المبالغ المستردة والشكاوى (أو \"المساعدة والدعم\" في قائمة التطبيق) — يتم مراجعة كل طلب والرد عليه.",
    "landing.badge": "تجربة مواعيد فاخرة",
    "landing.heroLuxe1": "حيث الجودة",
    "landing.heroLuxe2": "تلتقي بالتواصل",
    "landing.heroDluxe1": "حيث المرأة",
    "landing.heroDluxe2": "تأخذ زمام المبادرة",
    "landing.taglineLuxe": "منصة مواعيد حصرية تُقدّر التواصل الحقيقي. يستثمر الرجال اعتمادات للتواصل، مما يضمن اهتماماً صادقاً وتفاعلات راقية.",
    "landing.taglineDluxe": "منصة مواعيد حصرية تُبادر فيها المرأة الجريئة بالخطوة الأولى. تستثمر السيدات اعتمادات للتواصل مع رجال استثنائيين، مما يضمن اهتماماً صادقاً وتفاعلات راقية.",
    "landing.startJourney": "ابدأ رحلتك",
    "landing.haveAccount": "لديّ حساب بالفعل",
    "landing.watchFilm": "شاهد الفيلم",
    "auth.signIn": "تسجيل الدخول",
    "auth.getStarted": "ابدأ الآن",
    "login.welcomeBack": "مرحباً بعودتك",
    "login.subtitle": "سجّل دخولك لمواصلة رحلتك",
    "login.google": "المتابعة مع Google",
    "login.orEmail": "أو المتابعة بالبريد الإلكتروني",
    "login.email": "البريد الإلكتروني",
    "login.password": "كلمة المرور",
    "login.emailPh": "أدخل بريدك الإلكتروني",
    "login.passwordPh": "أدخل كلمة المرور",
    "login.forgot": "نسيت كلمة المرور؟",
    "login.noAccount": "ليس لديك حساب؟",
    "login.createOne": "أنشئ حساباً",
    "login.backHome": "العودة إلى الرئيسية",
    "register.title": "أنشئ حسابك",
    "register.subtitle": "ابدأ رحلتك نحو علاقات حقيقية ومميزة",
    "register.fullName": "الاسم الكامل",
    "register.namePh": "أدخل اسمك",
    "register.passwordPh": "أنشئ كلمة مرور",
    "register.iAmA": "أنا",
    "register.man": "رجل",
    "register.woman": "امرأة",
    "nav.discover": "اكتشف",
    "nav.favorites": "المفضلة",
    "nav.chat": "المحادثات",
    "nav.offers": "العروض",
    "nav.meetups": "اللقاءات",
    "nav.top": "الأبرز",
    "nav.credits": "الرصيد",
    "nav.earnings": "الأرباح",
    "nav.settings": "الإعدادات",
    "nav.watchTour": "شاهد جولة التطبيق",
    "nav.helpSupport": "المساعدة والدعم",
    "discover.title": "اكتشف",
    "discover.subtitle": "ابحث عن توافقك المثالي",
    "discover.newest": "الأحدث",
    "discover.topRated": "الأعلى تقييماً",
    "discover.sendOffer": "إرسال عرض موعد مميز",
    "discover.message": "رسالة",
    "discover.aiCompanion": "الرفيق الذكي",
    "discover.videoIntro": "فيديو",
    "settings.countryLanguage": "الدولة واللغة",
    "settings.country": "الدولة",
    "settings.language": "اللغة",
    "settings.currency": "العملة",
    "settings.currencyNote": "تُعرض الأسعار بشكل تقريبي بعملتك - تتم معالجة المدفوعات بالدولار الأمريكي.",
    "settings.refunds": "المبالغ المستردة والشكاوى",
    "settings.changePassword": "تغيير كلمة المرور",
    "settings.logout": "تسجيل الخروج",
    "settings.dangerZone": "منطقة الخطر",
    "settings.deleteAccount": "حذف حسابي",
    "credits.billedUsd": "يُحسب بالدولار الأمريكي",
    "common.accept": "قبول",
    "common.decline": "رفض",
    "common.pending": "قيد الانتظار",
    "common.accepted": "مقبول",
    "common.declined": "مرفوض",
    "common.received": "مستلم",
    "common.sent": "مُرسل",
    "common.yourBalance": "رصيدك",
    "common.back": "رجوع",
    "common.cancel": "إلغاء",
    "common.credits": "كريدت",
    "common.viewMap": "عرض الخريطة",
    "common.getUber": "احجز Uber",
    "common.hours": "ساعات",
    "chat.title": "الرسائل",
    "chat.empty": "لا توجد محادثات بعد",
    "chat.emptySub": "ابدأ بالتواصل مع الأشخاص لتبدأ المحادثة!",
    "chat.discoverProfiles": "اكتشف الملفات الشخصية",
    "chat.typeMessage": "اكتب رسالة...",
    "chat.inbox": "صندوق الوارد",
    "chat.noMessages": "لا توجد رسائل بعد. ابدأ المحادثة!",
    "chat.startConvo": "ابدأ المحادثة!",
    "chat.costStart": "بدء المحادثة يكلف 10 كريدت",
    "chat.costMessage": "إرسال رسالة يكلف 5 كريدت",
    "chat.inboxBadge": "صندوق وارد {app}",
    "common.testRun": "تجربة تشغيل",
    "offers.simulatePayment": "محاكاة الدفع (اختبار)",
    "offers.title": "عروض المواعيد المميزة",
    "offers.dateOffers": "عروض المواعيد",
    "offers.slots": "فتحات عروضك",
    "offers.available": "متاح",
    "offers.inUse": "قيد الاستخدام",
    "offers.consumed": "مستهلك",
    "offers.sentOffers": "عروضك المُرسَلة",
    "offers.none": "لا توجد عروض بعد",
    "offers.noneSent": "لم يتم إرسال أي عروض بعد",
    "offers.reviewRespond": "راجع عروض المواعيد المميزة وأجب عليها",
    "offers.subtitlePayer": "اشترِ أماكن لإرسال عروض مواعيد مميزة إلى من تطابقوا معك",
    "offers.slotDesc": "$50 لكل مكان • قابل لإعادة الاستخدام حتى قبول العرض",
    "offers.buySlot": "شراء مكان",
    "offers.noneDesc": "لم تتلقَّ أي عروض مواعيد بعد",
    "offers.noneSentDesc": "اشترِ مكانًا وأرسل أول عرض موعد مميز لك",
    "offers.buyFirstSlot": "اشترِ مكانك الأول",
    "offers.respond": "الرد",
    "offers.cancelOffer": "إلغاء العرض",
    "offers.viewCounter": "عرض العرض المضاد",
    "offers.rateDate": "قيّم هذا الموعد",
    "offers.dateDetails": "تفاصيل الموعد والتقييمات",
    "status.pending": "قيد الانتظار",
    "status.paymentNeeded": "الدفع مطلوب",
    "status.awaitingConfirmation": "في انتظار التأكيد",
    "status.countered": "تم الرد بعرض مضاد",
    "status.confirmed": "مؤكد",
    "status.completed": "مكتمل",
    "status.declined": "مرفوض",
    "status.expired": "منتهي الصلاحية",
    "status.cancelled": "ملغى",
    "meetups.title": "طلبات اللقاء",
    "meetups.none": "لا توجد طلبات بعد",
    "meetups.noneSent": "لم يتم إرسال أي طلبات",
    "meetups.received": "المُستلَمة",
    "meetups.sent": "المُرسَلة",
    "meetups.noneDesc": "ستظهر هنا طلبات اللقاء الواردة من الآخرين.",
    "meetups.noneSentDesc": "ابحث عمّن تودّ اللقاء به!",
    "meetups.browse": "تصفح الملفات الشخصية",
    "favorites.title": "المفضلة",
    "favorites.subtitle": "الملفات الشخصية التي حفظتها",
    "favorites.none": "لا توجد مفضلات بعد",
    "favorites.noneDesc": "انقر على القلب في أي ملف شخصي يعجبك وسيُحفظ هنا.",
    "favorites.browse": "تصفح الاكتشاف",
    "leaderboard.title": "أبرز الأعضاء",
    "leaderboard.you": "أنت",
    "leaderboard.subtitle": "أكثر المواعدين طلبًا، وأعلاهم تقييمًا، وأكثرهم إنفاقًا على المنصة. اكسب الشارات لتحجز مكانك.",
    "leaderboard.prizeNote": "المركز الأول شهريًا في كل فئة يفوز بتعزيز مجاني لمدة 7 أيام + أسبوعين من عروض المواعيد غير المحدودة.",
    "leaderboard.empty": "لا يوجد حاملو شارات بعد — أتمم مواعيد رائعة لتكون الأول على اللوحة!",
    "leaderboard.loading": "جارٍ تحميل لوحة المتصدرين...",
    "leaderboard.fireTitle": "الأكثر طلبًا على DLuxe",
    "leaderboard.fireSub": "أكثر 3 رجال تم التواصل معهم على DLuxe هذا الشهر",
    "leaderboard.diamondTitle": "الأعضاء الماسيون",
    "leaderboard.diamondSub": "أتمّوا 3 مواعيد مميزة أو أكثر بقيمة $500 أو أعلى",
    "leaderboard.ratedTitle": "أعلى المواعدين تقييمًا",
    "leaderboard.ratedSub": "أعلى تقييمات المواعيد من مراجعات حقيقية",
    "leaderboard.shareBadge": "مشاركة الشارة",
    "leaderboard.datesCompleted": "مواعيد مميزة مكتملة",
    "earnings.title": "أرباحي",
    "earnings.escrow": "في الضمان",
    "earnings.total": "إجمالي الأرباح",
    "earnings.dates": "المواعيد المنجزة",
    "earnings.history": "سجل المدفوعات",
    "earnings.none": "لا توجد أرباح بعد",
    "credits.costs": "تكاليف الرصيد",
    "credits.startChat": "بدء محادثة جديدة",
    "credits.sendMessage": "إرسال رسالة",
    "credits.requestMeetup": "طلب لقاء",
    "credits.buy": "شراء رصيد",
    "credits.history": "سجل المشتريات",
    "credits.noHistory": "لا يوجد سجل مشتريات بعد",
    "credits.completePayment": "إتمام الدفع",
    "credits.allSet": "كل شيء جاهز!",
    "credits.freeLuxe": "بصفتكِ امرأة على LuxeMeet، تستمتعين بوصول مجاني إلى المراسلة وجميع الميزات.",
    "credits.freeDluxe": "بصفتك رجلًا على DLuxe، تستمتع بوصول مجاني إلى المراسلة وجميع الميزات.",
    "credits.bestValue": "أفضل قيمة",
    "credits.continuePayment": "المتابعة إلى الدفع",
    "credits.processing": "جارٍ المعالجة...",
    "profile.message": "مراسلة",
    "profile.requestMeetup": "طلب لقاء",
    "tour.tryWith": "جرّبه مع",
    "settings.title": "الإعدادات",
    "settings.photoHint": "انقر على الكاميرا لتغيير الصورة",
    "settings.profileInfo": "معلومات الملف الشخصي",
    "settings.displayName": "الاسم المعروض",
    "settings.age": "العمر",
    "settings.location": "الموقع",
    "settings.locationPh": "المدينة، الدولة",
    "settings.bio": "نبذة عنك",
    "settings.bioPh": "أخبر الآخرين عن نفسك...",
    "settings.interests": "الاهتمامات",
    "settings.interestsPh": "السفر، الموسيقى، الطعام (مفصولة بفواصل)",
    "settings.interestsHint": "افصل الاهتمامات بفواصل",
    "settings.saveChanges": "حفظ التغييرات",
    "settings.paypalTitle": "إعدادات الدفع عبر PayPal",
    "settings.paypalDesc": "أضف تفاصيل PayPal الخاصة بك لاستلام مدفوعاتك من عروض المواعيد المقبولة",
    "settings.dangerDesc": "حذف حسابك يُخفي ملفك الشخصي فوراً. هل غيّرت رأيك؟ ما عليك سوى تسجيل الدخول مجدداً خلال 30 يوماً لإعادة التفعيل — بعد ذلك، يُحذف حسابك وبياناتك الشخصية نهائياً وتُصادر أي رصيد أو أموال غير مستخدمة.",
    "settings.deleteTitle": "هل تريد حذف حسابك؟",
    "settings.deleteB1": "يُخفى ملفك الشخصي عن الجميع فوراً",
    "settings.deleteB2": "سجّل الدخول مجدداً خلال 30 يوماً لإعادة التفعيل",
    "settings.deleteB3": "بعد 30 يوماً يُحذف كل شيء نهائياً — الصور والرسائل وأي رصيد أو أموال غير مستخدمة",
    "settings.confirmPasswordLabel": "تأكيد كلمة المرور",
    "settings.googleBlank": "سجّلت عبر Google؟ اتركه فارغاً.",
    "settings.deactivateDelete": "تعطيل الحساب وحذفه",
    "settings.currentPassword": "كلمة المرور الحالية",
    "settings.newPassword": "كلمة المرور الجديدة",
    "settings.confirmNewPassword": "تأكيد كلمة المرور الجديدة",
    "ref.title": "ادعُ أصدقاءك واكسب",
    "ref.desc": "شارك رابط دعوتك. ستحصل على 25 رصيداً إضافياً فور بدء صديقك الذي دعوته بالمحادثة. والأكثر: عندما يشتري أحد المُحالين أول باقة مميزة، ستحصل على فتحة مجانية بقيمة $50 — وعندما يُكمل أحد المُحالين أول موعد مميز، ستحصل على 90% من أرباح موعدك التالي بدلاً من 80%.",
    "ref.friendsReferred": "الأصدقاء المُحالون",
    "ref.bonusCredits": "الرصيد الإضافي المكتسب",
    "ref.freeSlots": "الفتحات المجانية المكتسبة",
    "ref.boosts": "تعزيزات 90% المتاحة",
    "ref.yourReferrals": "إحالاتك",
    "ref.stJoined": "انضم",
    "ref.stChatting": "بدأ المحادثة ✓ (+25 رصيد)",
    "ref.stDate": "أكمل موعداً ✓",
    "ref.stSlot": "اشترى فتحة ✓",
    "ref.topReferrers": "أفضل المُحيلين هذا الشهر",
    "ref.referralsWord": "إحالات",
    "ref.copied": "تم نسخ رابط الإحالة!",
    "share.inviteMsg": "انضم إليّ على {app} — تطبيق المواعيد الفاخر حيث تتحقق المواعيد الحقيقية فعلاً. سجّل عبر رابط دعوتي:",
    "share.dreamMsg": "💘 أنت مدعوٌّ إلى موعد الأحلام! انضم إليّ على {app} ولنخطط معاً لأجمل موعد:",
    "share.inviteBtn": "ادعُ صديقاً",
    "share.dreamBtn": "💘 دعوة موعد الأحلام",
    "share.hint": "اكتب رسالتك الخاصة أو اتركها فارغة لاستخدام النموذج الجاهز — سيُضاف رابط دعوتك تلقائياً.",
    "share.copied": "تم نسخ رسالة الدعوة — الصقها أينما تريد!",
    "landing.whyTitle": "لماذا تختار {app}؟",
    "landing.whySub": "يضمن نظامنا القائم على الاعتمادات أن كل تفاعل يكون هادفاً ومقصوداً.",
    "landing.f1Title": "تواصل راقٍ وحقيقي",
    "landing.f1Desc": "تضمن الاعتمادات الاهتمام الحقيقي. لا رسائل مزعجة، لا روبوتات — فقط أشخاص حقيقيون يبحثون عن تواصل حقيقي.",
    "landing.f2Title": "تجربة فاخرة",
    "landing.f2DescLuxe": "تستمتع السيدات بالوصول المجاني بينما يستثمر الرجال في محادثات هادفة وطلبات لقاء مميزة.",
    "landing.f2DescDluxe": "يستمتع الرجال بالوصول المجاني بينما تستثمر السيدات في محادثات هادفة وعروض مواعيد حصرية.",
    "landing.f3Title": "ملفات شخصية موثّقة",
    "landing.f3Desc": "جميع الملفات الشخصية موثّقة لضمان الأصالة. التقِ بأشخاص حقيقيين وكوّن علاقات حقيقية.",
    "landing.refBadge": "أحِل واكسب",
    "landing.refTitle1": "ادعُ أصدقاءك،",
    "landing.refTitle2": "واحصل على مكافآت",
    "landing.refDesc1": "كل عضو لديه رابط دعوة شخصي. شاركه مع أصدقائك واكسب",
    "landing.refDescBold": "مقعداً مميزاً مجانياً بقيمة $50",
    "landing.refDesc2": "إضافةً إلى مميزات حصرية عند انضمامهم وتفاعلهم.",
    "landing.refCard1Title": "مقعد مميز مجاني بقيمة $50",
    "landing.refCard1Desc": "تكسبه مقابل كل صديق ينضم ويصبح نشطاً",
    "landing.refCard2Title": "مميزات إضافية",
    "landing.refCard2Desc": "امتيازات حصرية محجوزة لأبرز المُحيلين",
    "landing.refCta": "انضم واحصل على رابط دعوتك",
    "landing.ctaTitle": "هل أنت مستعد للعثور على شريك حياتك؟",
    "landing.ctaSub": "انضم إلى آلاف العُزّاب الذين وجدوا تواصلاً هادفاً على {app}.",
    "landing.ctaBtn": "إنشاء حساب مجاني",
    "landing.footerTerms": "الشروط والأحكام",
    "pp.balance": "الرصيد المتاح",
    "pp.balanceNote": "من عروض المواعيد المقبولة (80% من المبلغ بعد رسوم المنصة)",
    "pp.email": "البريد الإلكتروني لـ PayPal *",
    "pp.emailHint": "هذا هو المكان الذي سنرسل إليه مدفوعاتك",
    "pp.confirmEmail": "تأكيد البريد الإلكتروني لـ PayPal *",
    "pp.confirmPh": "أعد إدخال بريدك الإلكتروني",
    "pp.emailsMatch": "البريدان الإلكترونيان متطابقان",
    "pp.verified": "موثّق",
    "pp.username": "اسم مستخدم PayPal (اختياري)",
    "pp.qr": "رمز QR لـ PayPal (اختياري)",
    "pp.qrUpload": "رفع رمز QR",
    "pp.qrHint": "ارفع رمز QR الخاص بـ PayPal لتسهيل عمليات التحويل",
    "pp.save": "حفظ والتحقق من إعدادات PayPal",
    "pp.howTitle": "ℹ️ كيف تعمل المدفوعات",
    "pp.how1": "يرسل الأعضاء عروض مواعيد بمبالغ مالية ($100-$1000)",
    "pp.how2": "عندما تقبل ويدفع الطرف الآخر، تستلم 80% (تحتفظ المنصة بـ 20%)",
    "pp.how3": "تُعالَج المدفوعات إلى بريدك الإلكتروني على PayPal خلال 3-5 أيام عمل",
    "pp.how4": "سيتم تحديث رصيدك بعد كل موعد مؤكد",
    "rel.title": "علاقة رسمية",
    "rel.activeWith": "💞 معًا رسميًا مع {name}",
    "rel.activeSince": "منذ {date} — أنتما مخفيان عن الجميع.",
    "rel.chat": "محادثة",
    "rel.planDate": "رتّب موعدًا",
    "rel.end": "إنهاء العلاقة",
    "rel.incomingTitle": "💍 {name} يريد أن تكونا رسميًا معًا!",
    "rel.incomingDesc": "اقبل وسيختفي كلاكما من قائمة الجميع — يصبح التطبيق حكرًا على الاثنين فقط.",
    "rel.accept": "اقبل 💞",
    "rel.decline": "ليس الآن",
    "rel.waitingFor": "⏳ في انتظار {name}",
    "rel.waitingDesc": "طلب \"كونا رسميَّين\" في انتظار ردهم.",
    "rel.cancelRequest": "إلغاء الطلب",
    "rel.endTitle": "إنهاء العلاقة الرسمية؟",
    "rel.endDesc": "ستعود أنت و{name} مرئيَّين للجميع ويمكنكما تصفح الأعضاء الآخرين. تبقى محادثاتكما وسجلكما كما هي.",
    "rel.keepIt": "الإبقاء عليها",
    "rel.goOfficial": "كونا رسميَّين — اختفيا عن الجميع معًا",
    "rel.requestSent": "⏳ تم إرسال طلب \"كونا رسميَّين\" — في انتظار {name}",
    "rel.togetherSince": "💞 معًا رسميًا منذ {date}",
    "rel.together": "💞 معًا رسميًا",
    "rel.coupleTitle": "💞 أنتما رسميًا معًا",
    "rel.coupleDesc": "أنت و{name} مخفيان عن الجميع. التطبيق الآن حكر على الاثنين فقط — تحادثا، رتّبا لقاءات ومواعيد مميزة.",
    "rel.coupleHint": "تغيّرت الخطط؟ يمكن لأيٍّ منكما إنهاء العلاقة في أي وقت من الإعدادات.",
    "rel.toastSent": "💍 تم إرسال طلب \"كونا رسميَّين\" إلى {name}!",
    "rel.toastTogether": "💞 أنت و{name} معًا رسميًا الآن!",
    "rel.toastEnded": "انتهت العلاقة — أنت مرئي في التطبيق مجددًا",
    "rel.toastPrivate": "هذا العضو في علاقة رسمية 💞",
    "rel.toastActive": "أنت في علاقة رسمية — التطبيق الآن لكما وحدكما 💞",
    "invite.admirerTitle": "لديك معجب سري 💘",
    "invite.dreamTitle": "{name} يحتفظ بدعوة موعد أحلام لك",
    "invite.admirerSub": "{name} لديه رسالة إعجاب سرية تنتظرك — لكنها ستظل مغلقة حتى تنضم.",
    "invite.dreamSub": "شخص ما رتّب شيئًا مميزًا — التفاصيل مغلقة حتى تنضم.",
    "invite.lock": "سجّل مجانًا لتكشف مفاجأتك",
    "invite.claimedNote": "تم الكشف عن هذه الدعوة بالفعل. انضم على أي حال واكتشف من ينتظرك!",
    "invite.reveal": "اكشف مفاجأتي",
    "invite.login": "عضو بالفعل؟ سجّل دخولك",
    "invite.expired": "انتهت صلاحية هذه الدعوة",
    "invite.explore": "اكتشف LuxeMeet",
    "landing.goBadge": "صُمِّم للنهايات الحقيقية",
    "landing.goTitle1": "حين تصبح الأمور جدية،",
    "landing.goTitle2": "أعلنا علاقتكما رسمياً 💞",
    "landing.goDesc": "وجدت من تبحث عنه؟ بلمسة واحدة تختفيان معاً من قوائم الجميع — لا ملفات شخصية، لا رسائل من الآخرين، لا مشتتات. يصبح التطبيق حكراً عليكما: دردشة خاصة، لقاءات، ومواعيد فاخرة. وإن تغيّرت الأمور، يمكن لأيٍّ منكما إلغاء ذلك في أي وقت.",
    "landing.goChip1": "🙈 غير مرئيَّين للجميع",
    "landing.goChip2": "💬 كل شيء مفتوح بينكما",
    "landing.goChip3": "🔄 قابل للتراجع في أي وقت",
    "common.years": "سنة",
    "form.proposedDateTime": "التاريخ والوقت المقترحان",
    "form.duration": "المدة (اختياري)",
    "form.proposedLocation": "الموقع المقترح",
    "form.messageOptional": "رسالة (اختياري)",
    "form.openEnded": "مفتوح النهاية",
    "form.writeMessage": "اكتب رسالتك...",
    "form.addPersonalMessage": "أضف رسالة شخصية...",
    "form.searchVenue": "ابحث عن المكان أو العنوان بدقة...",
    "offerModal.selectDateType": "اختر نوع الموعد...",
    "offerModal.amountPlaceholder": "أدخل المبلغ (100-1000)",
    "offerModal.amountHint": "ستدفع هذا المبلغ عند قبول موعدك ({fee}% رسوم المنصة مشمولة)",
    "offerModal.transportHint": "يُدفع مع عرضك ويُحوَّل بالكامل 100% لموعدك كبدل تنقل (بدون رسوم منصة).",
    "offerModal.durationHint": "المدة التي تودّ أن يستغرقها الموعد — لتحديد التوقعات بوضوح لكليكما.",
    "tour.subtitle": "تجربة مجانية لمدة 60 ثانية — لا يُحسب عليك أي شيء",
    "tour.step1Title": "ابدأ بالتحية في الدردشة",
    "tour.step1Desc": "أرسل لك {name} رسالة بالفعل — ردّ عليه",
    "tour.step2Title": "اطلب لقاءً",
    "tour.step2Desc": "مجاني تماماً — شاهد كيف يُقبل",
    "tour.step3Title": "أرسل عرض موعد فاخر",
    "tour.step3DescSent": "تم الإرسال! جرّب محاكاة الدفع في صفحة عروضك",
    "tour.step3Desc": "بدون رصيد حقيقي، بدون مال فعلي — محاكاة كاملة",
    "tour.go": "انطلق",
    "tour.doneTitle": "أتقنت استخدام LuxeMeet! 🎉",
    "tour.doneDesc": "الدردشة، اللقاءات، والمواعيد الفاخرة — جرّبتها كلها. حان وقت البحث عن الحقيقي.",
    "tour.browseReal": "تصفّح الأعضاء الحقيقيين",
    "common.freeTest": "تجربة مجانية",
    "discover.aiTestNote": "رفيق تجريبي — الدردشة واللقاءات والمواعيد الفاخرة محاكاة مجانية. لا دفع حقيقي أبداً.",
    "discover.meetUp": "التقِ بها",
    "profile.msgTitle": "أرسل رسالة إلى {name}",
    "profile.msgCostPayer": "بدء المحادثة يكلّف 10 كريدت، ثم 5 كريدت لكل رسالة. ردودهم مجانية.",
    "profile.msgFree": "مجاني لك على {app} — ستصل هذه المحادثة إلى صندوق بريدهم على {app}، حيث يتطلب الرد منهم كريدت.",
    "profile.sendMessage": "إرسال رسالة",
    "profile.meetupTitle": "طلب لقاء مع {name}",
    "profile.meetupCost": "يكلّف طلب اللقاء 25 رصيداً.",
    "profile.meetupFree": "مجاني لك على {app} — سيظهر لهم في لقاءات {app} الخاصة بهم.",
    "profile.meetupTest": "🧪 تجربة مجانية — سيقبل رفيقك الذكي الطلب تلقائياً حتى تتمكن من رؤية التدفق الكامل. لن يُخصم أي رصيد.",
    "profile.sendMeetup": "إرسال طلب اللقاء",
    "profile.costsMsg": "الرسالة: 10 أرصدة (الأولى) / 5 أرصدة (الرد)",
    "profile.costsMeetup": "طلب اللقاء: 25 رصيداً",
    "offerModal.title": "إرسال عرض موعد مميز",
    "offerModal.desc": "إرسال عرض موعد مدفوع إلى {name}",
    "offerModal.testBanner": "🧪 تجربة مع {name} — لا حاجة لفتحة، والدفع محاكى فقط (لن يُحسب عليك شيء).",
    "offerModal.needSlot": "تحتاج إلى شراء فتحة مميزة أولاً",
    "offerModal.purchaseSlot": "شراء فتحة ($50)",
    "offerModal.slotsAvailable": "الفتحات المتاحة: {n}",
    "offerModal.testNoSlot": "عرض تجريبي — لا حاجة لفتحة",
    "offerModal.repeatNoSlot": "موعد متكرر — لا حاجة لفتحة",
    "offerModal.amount": "مبلغ العرض *",
    "offerModal.transport": "بدل المواصلات (اختياري)",
    "offerModal.proposedDate": "التاريخ المقترح *",
    "offerModal.proposedTime": "الوقت المقترح *",
    "offerModal.duration": "المدة (اختياري)",
    "offerModal.location": "الموقع *",
    "offerModal.dateType": "نوع الموعد *",
    "offerModal.message": "رسالة (اختياري)",
    "offerModal.sendOffer": "إرسال العرض",
    "voucher.unlimitedActive": "عروض المواعيد غير المحدودة مفعّلة 🏆",
    "voucher.unlimitedUntil": "لا حاجة لفتحات حتى {date} — امتياز البطل.",
    "voucher.championPrize": "جائزة البطل: أسبوعان من العروض غير المحدودة",
    "voucher.giftFrom": "هدية من {name}: أسبوعان من العروض غير المحدودة",
    "voucher.activate": "تفعيل أسبوعيّ",
    "voucher.giftIt": "أهدِها",
    "voucher.haveCode": "لديك رمز هدية؟",
    "voucher.redeem": "استبدال",
    "voucher.giftsSent": "الهدايا التي أرسلتها",
    "ideas.near": "إلهام مواعيد بالقرب من",
    "ideas.plan": "خطّط لهذا الموعد",
    "ideas.popular": "أماكن المواعيد الأكثر شعبية على المنصة",
    "ideas.map": "الخريطة",
    "ideas.cityTitle": "احصل على أفكار مواعيد في مدينة أخرى",
    "ideas.cityDesc": "تخطط لرحلة أو موعد في مكان آخر؟ اختر أي مدينة وسنقترح لك أفضل الأفكار هناك.",
    "ideas.show": "عرض الأفكار",
    "ideas.whoFor": "لمن هذا الموعد؟",
    "ideas.pickDesc": "اختر مطابقة وسنملأ عرضك المميز مسبقاً.",
    "ideas.emptyPrefix": "لا توجد مطابقات بعد — أضف شخصاً إلى المفضلة في",
    "ideas.emptySuffix": "أو ابدأ محادثة أولاً.",
    "profile.videos": "مقاطع الفيديو",
  },
  he: {
    "nav.events": "אירועים",
    "leaderboard.youOnBoard": "🏆 אתה מופיע בלוח המובילים!",
    "leaderboard.youOnBoardSub": "חברים בצד השני רואים אותך מדורג כאן. המשך לזהור!",
    "events.title": "אירועים",
    "events.subtitle": "אירועים בלעדיים לחברים — בואו להכיר בחיים האמיתיים.",
    "events.empty": "אין אירועים קרובים כרגע — חזרו בקרוב!",
    "events.loading": "טוען אירועים…",
    "events.spotsLeft": "נותרו {n} מקומות",
    "events.soldOut": "נגמר",
    "events.joinedChip": "אתה בפנים!",
    "events.free": "חינם",
    "events.feeNote": "${price} + $2 דמי טיפול",
    "events.payCredits": "הצטרף עם {n} קרדיטים",
    "events.payPaypal": "שלם עם PayPal · ${total}",
    "events.joinFree": "הצטרף בחינם",
    "events.notEnough": "אין מספיק קרדיטים — האירוע הזה עולה {n} קרדיטים",
    "events.joinedToast": "🎟️ אתה בפנים! בדוק את האימייל שלך לאישור.",
    "events.payCancelled": "התשלום בוטל",
    "events.captureFail": "לא הצלחנו לאשר את התשלום שלך — אנא נסה שוב",
    "events.bannerTitle": "🎉 אירוע קרוב",
    "events.bannerCta": "ראה אירועים",
    "notif.eventJoined.t": "🎟️ אתה הולך!",
    "notif.eventJoined.b": "מקומך ב־\"{title}\" אושר. נתראה שם!",
    "notif.eventCancelled.t": "😔 האירוע בוטל",
    "notif.eventCancelled.b": "\"{title}\" בוטל. אם שילמת, ההחזר בדרך אליך.",
    "terms.contactT": "צור קשר",
    "terms.contactP": "שאלות, חששות או משוב? פנה אלינו בכל עת:",
    "msdluxe.tapSound": "הקש להפעלת צליל",
    "msdluxe.badge": "המארחת החכמה שלך",
    "msdluxe.title1": "הכירו את Ms DLuxe",
    "msdluxe.title2": "היא תסביר לך הכול",
    "msdluxe.desc": "Ms DLuxe עצמה מסבירה בדיוק איך זה עובד — קרדיטים, הצעות דייטים פרימיום, רווחים ובטיחות.",
    "msdluxe.luxeCard": "איך LuxeMeet עובד",
    "msdluxe.dluxeCard": "איך DLuxe עובד",
    "msdluxe.download": "הורד",
    "msdluxe.share": "שמור אותם, פרסם אותם, שלח לחבר — הם שלך לשיתוף.",
    "nav.msdluxeVideos": "איך זה עובד · Ms DLuxe",
    "credits.requestRefund": "בקש החזר כספי",
    "credits.refundRequested": "בקשת ההחזר נשלחה",
    "credits.refunded": "הוחזר",
    "credits.refundDeniedChip": "לא אושר",
    "credits.refundDialogTitle": "בקשת החזר כספי",
    "credits.refundDialogDesc": "ספרו לנו מדוע תרצו החזר כספי על רכישה זו. הצוות שלנו בוחן כל בקשה ותקבלו התראה ואימייל עם ההחלטה.",
    "credits.refundReasonPh": "מדוע תרצו החזר כספי?",
    "credits.refundSubmit": "שליחת הבקשה",
    "credits.refundSent": "בקשת ההחזר נשלחה — נבחן אותה בקרוב",
    "safety.checkinToggle": "בדיקת ביטחון אישי",
    "safety.checkinDesc": "בחרו שעה — נשאל אם הגעתם הביתה בשלום. אם לא תענו תוך שעתיים, חברכם יקבל התראה.",
    "safety.checkinPast": "יש לבחור שעת בדיקה עתידית",
    "safety.checkinScheduled": "נשלח! לחברכם יש את הפרטים ובדיקת הביטחון האישי שלכם מתוזמנת.",
    "checkin.title": "הגעתם הביתה בשלום?",
    "checkin.body": "הקישו לאישור — אחרת {email} יקבל התראה.",
    "checkin.confirmBtn": "אני בבית בשלום ✅",
    "checkin.confirmed": "שמחים שאתם בטוחים! חברכם קיבל הודעה 💛",
    "notif.safetyCheckin.t": "🛟 הגעתם הביתה בשלום?",
    "notif.safetyCheckin.b": "הקישו לאישור שהגעתם הביתה בשלום — אחרת {email} יקבל התראה בעוד שעתיים.",
    "landing.freeCreditsPromo": "חברים חדשים מקבלים 50 קרדיטים חינם — בדיוק מספיק כדי שעוזר AI ישלח לאהבת חייכם ברשתות החברתיות הזמנה מעריץ סודי.",
    "landing.langHighlight": "זמין ב-8 שפות עם תרגום צ'אט בתוך האפליקציה — הכירו אנשים מכל העולם.",
    "saPromo.title": "הקרדיטים החינמיים שלכם ממתינים",
    "saPromo.body": "יש לכם {n} קרדיטים — מספיק כדי שעוזר AI ישלח הזמנת מעריץ סודי לאהבת חייכם ברשתות החברתיות.",
    "saPromo.cta": "שלחו הזמנת מעריץ סודי",
    "notif.refundApproved.t": "✅ ההחזר אושר",
    "notif.refundApproved.b": "ההחזר הכספי עבור {desc} אושר — חשבונכם עודכן בהתאם. בדקו את האימייל שלכם לפרטים נוספים.",
    "notif.refundDenied.t": "עדכון בקשת החזר כספי",
    "notif.refundDenied.b": "בקשת ההחזר הכספי שלכם עבור {desc} נבחנה — בדקו את האימייל שלכם לפרטים נוספים.",
    "safety.share": "שתפו את התוכנית עם חבר",
    "safety.title": "שלחו את תוכנית הדייט לחבר",
    "safety.desc": "לביטחונכם, שלחו את המסלול ואת פרופיל הדייט שלכם למישהו שאתם סומכים עליו.",
    "safety.emailPh": "friend@email.com",
    "safety.notePh": "הערה אופציונלית לחברכם…",
    "safety.send": "שליחה",
    "safety.sent": "נשלח! לחברכם יש את הפרטים.",
    "discover.companionsTitle": "הכירו את עוזרי ה-AI",
    "incog.title": "מצב אינקוגניטו",
    "incog.desc": "שלטו במי יכול למצוא את הפרופיל שלכם תוך שמירה על גישה מלאה לצ'אטים, הצעות ופגישות.",
    "incog.toggleLabel": "הסתירו את הפרופיל שלי מ-Discover",
    "incog.toggleDesc": "אף אחד לא יוכל למצוא אתכם בזמן גלישה. שיחות והצעות קיימות ימשיכו לפעול.",
    "incog.on": "מצב אינקוגניטו פעיל — אתם מוסתרים מ-Discover",
    "incog.off": "אתם גלויים שוב ב-Discover",
    "incog.hiddenFrom": "אתם גם מוסתרים באופן אישי מ-{n} חבר/ים (דרך כפתור העין בפרופיל שלהם).",
    "ratep.title": "פרטיות דירוגי הדייטים",
    "ratep.desc": "בחרו האם להשתתף בדירוגי דייטים ומה יוצג בפרופיל שלכם.",
    "ratep.partLabel": "השתתפות בדירוגי דייטים",
    "ratep.partDesc": "כשהאפשרות כבויה, אף אחד לא יוכל לדרג את הדייטים שלכם ולא יוצג דירוג בפרופיל",
    "ratep.commentsLabel": "הצגת ביקורות כתובות בפרופיל שלי",
    "ratep.commentsDesc": "כשהאפשרות כבויה, רק דירוג הכוכבים שלכם יוצג — התגובות הכתובות נשארות פרטיות",
    "ratep.saved": "העדפות הדירוג נשמרו",
    "offers.planDate": "תכנון דייט",
    "planDate.title": "תכנן דייט עם…",
    "planDate.desc": "בחרו מישהו מרשימת החברים כדי לשלוח להם הצעת דייט פרימיום.",
    "planDate.search": "חיפוש לפי שם…",
    "planDate.empty": "לא נמצאו חברים",
    "notif.promoRedeemed.t": "🎁 קוד הפרומו מומש!",
    "notif.promoRedeemed.b": "הקוד {code} הוסיף {what} לחשבון שלכם. תהנו!",
    "notif.creditsGranted.t": "🎁 קרדיטים נוספו!",
    "notif.creditsGranted.b": "{n} קרדיטים נוספו לחשבונכם על ידי צוות LuxeMeet.",
    "notif.slotGranted.t": "🎁 סלוט דייט פרימיום חינמי!",
    "notif.slotGranted.b": "קיבלתם {n} סלוט/ים חינמיים להצעת דייט פרימיום בשווי $50 — תכננו דייט מדף ההצעות!",
    "register.saRevealed": "💌 המעריץ הסודי שלכם נחשף — בדקו את ההתראות והצ׳אט!",
    "tour.replayTitle": "סיור של 60 שניות",
    "tour.replayDesc": "פספסתם את הסיור המודרך? הפעילו אותו מחדש בכל עת עם מלווה ה-AI שלכם.",
    "tour.replayBtn": "צפייה חוזרת",
    "notif.saReveal.t": "💌 המעריץ הסודי נחשף!",
    "notif.saReveal.b": "זה היה {admirer} כל הזמן! {name} השאיר את הסיפור המלא בצ׳אט שלכם. הקישו לצפייה בפרופיל.",
    "register.saBanner": "💌 המעריץ הסודי שלכם ממתין — צרו חשבון חינמי כדי לגלות מי זה.",
    "credits.earnerNote": "הצ׳אט חינמי עבורכם במצב זה — קרדיטים משמשים לתכונות נוספות כמו בקשות מעריץ סודי (50 קרדיטים).",
    "si.trackJoined": "הצטרף/ה כ-{name} — צפייה בפרופיל",
    "notif.siJoined.t": "🎉 הם כאן!",
    "notif.siJoined.b": "{invitee} הצטרף/ה זה עתה דרך הזמנת המעריץ הסודי שלכם אל {handle}. לכו למצוא אותם!",
    "si.trackTitle": "בקשות המעריץ הסודי שלכם",
    "si.trackLine": "{kind} אל {handle} ב-{platform}",
    "si.trackVia": "דרך {name}",
    "si.trackKindAdmirer": "הודעת מעריץ סודי",
    "si.trackKindDate": "בקשת דייט",
    "si.trackPending": "ממתין",
    "si.trackSent": "נשלח",
    "si.trackRefunded": "הוחזר",
    "discover.boosted": "ממומן",
    "discover.inDemand": "🔥 מבוקש",
    "discover.diamond": "Diamond",
    "discover.verifiedBadge": "מאומת",
    "gal.addPhoto": "הוסף תמונה",
    "gal.addVideo": "הוסף וידאו",
    "gal.videoIntros": "סרטוני היכרות ({n}/2)",
    "gal.videoRules": "עד 2 סרטונים קצרים (עד 60 שניות, 50MB). נבדקים על ידי AI — ללא עירום או תוכן מיני.",
    "gal.noPhotos": "אין תמונות עדיין. הוסף את התמונה הראשונה שלך כדי להתחיל!",
    "si.button": "מעריץ סודי חברתי",
    "si.title": "מעריץ סודי דרך {name}",
    "si.desc": "{name} ישלח הודעת מעריץ סודי או בקשת דייט לכל מי שתבחר ברשתות החברתיות — עם הזמנה לאפליקציה. יישלח תוך 24 שעות.",
    "si.typeLabel": "מה לשלוח?",
    "si.typeAdmirer": "הודעת מעריץ סודי",
    "si.typeDate": "בקשת דייט",
    "si.platform": "פלטפורמה",
    "si.handle": "שם המשתמש שלהם",
    "si.note": "נגיעה אישית (אופציונלי)",
    "si.notePh": "יש משהו ש-{name} צריך להזכיר?",
    "si.submit": "שלח בקשה ({n} קרדיטים)",
    "si.success": "הבקשה נקלטה! תקבל התראה ברגע ש-{name} ישלח אותה.",
    "si.errHandle": "אנא הזן את שם המשתמש שלהם ברשת החברתית",
    "notif.siPending.t": "💌 הבקשה התקבלה!",
    "notif.siPending.b": "{name} ישלח את {kind} שלך אל {handle} ב-{platform}. נגבו 50 קרדיטים — תקבל התראה ברגע שנשלח.",
    "notif.siSent.t": "💘 זה בדרך!",
    "notif.siSent.b": "{name} שלח את {kind} שלך אל {handle} ב-{platform}. בואו נצלב אצבעות!",
    "notif.siDeclined.t": "הבקשה זוכתה בחזרה",
    "notif.siDeclined.b": "ה-{kind} שלך דרך {name} לא הצליח להישלח. 50 הקרדיטים שלך הוחזרו.",
    "notif.kindAdmirer": "הודעת מעריץ סודי",
    "notif.kindDate": "בקשת דייט",
    "help.title": "עוזר Luxe",
    "help.subtitle": "שאל אותי כל שאלה על LuxeMeet",
    "help.hi": "היי{name}! 👋",
    "help.welcome": "אוכל להסביר כיצד עובדים קרדיטים, הצעות דייט פרמיום, נאמנות, קודי אישור ותשלומים. במה תרצה להתעמק?",
    "help.thinking": "Luxe חושב...",
    "help.inputPh": "הקלד את שאלתך...",
    "help.error": "מצטער, אני נתקל בקושי כרגע. אנא נסה שוב בעוד רגע.",
    "chat.translate": "תרגם",
    "chat.showOriginal": "הצג מקור",
    "chat.translating": "מתרגם...",
    "chat.translateFail": "לא ניתן היה לתרגם כרגע",
    "chat.sentCredits": "ההודעה נשלחה ({n} קרדיטים)",
    "chat.noCredits": "קרדיטים לא מספיקים",
    "chat.tapToUse": "{ai} — הקש לשימוש",
    "chat.member": "חבר {app}",
    "land.newMatch": "התאמה חדשה!",
    "land.firstMove": "תעשה את המהלך הראשון",
    "land.dateTerms": "דייט בתנאים שלך",
    "land.youChoose": "אתה בוחר. אתה מציע.",
    "land.startChatting": "התחל לשוחח עכשיו",
    "land.likes": "{n} לייקים",
    "land.thisWeek": "השבוע",
    "promo.title": "גלה מה הופך אותו למיוחד",
    "promo.desc": "סיור קצר ב-LuxeMeet וב-DLuxe — דייטים אמיתיים, הצעות פרימיום ורומנטיקה מבוססת בינה מלאכותית.",
    "promo.tapSound": "הקש להפעלת צליל",
    "promo.shareInvite": "שתף את הסרטון — קישור ההזמנה שלך כלול 🎁",
    "promo.shareFriends": "שתף את הסרטון עם חברים",
    "promo.copiedInvite": "קישור הסרטון עם קוד ההזמנה שלך הועתק!",
    "promo.copied": "קישור הסרטון הועתק!",
    "promo.shareMsg": "🎬 תראה את זה — LuxeMeet, אפליקציית הדייטינג שבה דייטים אמיתיים באמת קורים.",
    "promo.joinInvite": "הצטרף עם קישור ההזמנה שלי:",
    "promo.shareTg": "🎬 תראה את זה — אפליקציית הדייטינג שבה דייטים אמיתיים באמת קורים",
    "promo.mute": "השתק פסקול",
    "promo.unmute": "הפעל פסקול",
    "prof.back": "חזרה",
    "prof.addPhotosHint": "הוסף תמונות כדי שישימו לב אליך",
    "prof.noPhotos": "{name} עדיין לא הוסיף תמונות",
    "prof.addPhotos": "הוסף תמונות",
    "prof.aiCompanion": "AI Companion",
    "prof.reviewOne": "ביקורת דייט",
    "prof.reviewMany": "ביקורות דייט",
    "prof.bioEmptyOwn": "הביוגרפיה שלך ריקה — כמה משפטים עליך יכולים לעשות פלאים.",
    "prof.bioEmptyOther": "{name} שומר על אווירת מסתורין — שלח שלום כדי ללמוד עוד.",
    "prof.afterDate": "— {name}, אחרי הדייט שלהם",
    "prof.interests": "תחומי עניין",
    "prof.photos": "תמונות",
    "prof.videos": "סרטונים",
    "prof.thinking": "חושב...",
    "prof.suggestOpener": "{ai}: הצע פתיחת שיחה",
    "prof.offerSent": "ההצעה נשלחה! בדוק את דף ההצעות שלך לסטטוס.",
    "prof.tSuggestFail": "לא ניתן היה לקבל הצעות כרגע",
    "prof.tRequestFail": "לא ניתן היה לשלוח את הבקשה",
    "prof.tFavAdded": "נוסף למועדפים ❤️",
    "prof.tFavRemoved": "הוסר מהמועדפים",
    "prof.tFavFail": "עדכון המועדפים נכשל",
    "prof.tVisibilityFail": "עדכון הנראות נכשל",
    "prof.tHidden": "כעת אתה מוסתר מ-{name} בגילוי",
    "prof.tVisible": "{name} יכול/ה לראות אותך שוב",
    "prof.tLoadFail": "טעינת הפרופיל נכשלה",
    "prof.tMsgEmpty": "אנא הזן/י הודעה",
    "prof.tNoCredits": "אין מספיק קרדיטים. רכוש/י קרדיטים נוספים כדי להמשיך.",
    "prof.tMsgFail": "שליחת ההודעה נכשלה",
    "prof.tMeetupMissing": "אנא מלא/י תאריך ומיקום",
    "prof.tMeetupFail": "שליחת בקשת הפגישה נכשלה",
    "nb.title": "התראות",
    "nb.empty": "אין התראות עדיין",
    "time.now": "עכשיו",
    "time.m": "לפני {n}ד׳",
    "time.h": "לפני {n}ש׳",
    "time.d": "לפני {n} ימים",
    "notif.photoVerified.t": "✅ אומת/ה בהצלחה!",
    "notif.photoVerified.b": "בדיקת הסלפי שלך עברה בהצלחה — תג המאומת מופיע כעת בפרופיל שלך.",
    "notif.relRequest.t": "💍 להפוך את זה לרשמי?",
    "notif.relRequest.b": "{name} רוצה להפוך את הקשר ביניכם לרשמי! אשר/י בהגדרות ושניכם תיעלמו מהפיד של כולם.",
    "notif.relDeclined.t": "בקשת הקשר הרשמי נדחתה",
    "notif.relDeclined.b": "{name} עדיין לא מוכן/ה להפוך את זה לרשמי.",
    "notif.relActive.t": "💞 אתם רשמית יחד!",
    "notif.relActive.b": "{name} אמר/ה כן. שניכם מוסתרים כעת מכולם — האפליקציה היא רק בשבילכם.",
    "notif.relEnded.t": "הקשר הרשמי הסתיים",
    "notif.relEnded.b": "{name} סיים/ה את הקשר הרשמי. שניכם גלויים שוב באפליקציה.",
    "notif.dateReview.t": "{stars} ביקורת דייט חדשה!",
    "notif.dateReview.b": "{name} דירג/ה את הדייט שלך {rating}/5. {comment}",
    "notif.escrow.t": "💰 תשלום לדייט התקבל!",
    "notif.escrow.b": "{name} שילם/ה ${amount} עבור הדייט שלך. ${payout} מוחזק בנאמנות. אשר/י את הדייט עם הקוד בן 6 הספרות שלהם כדי לקבל תשלום.",
    "notif.escrowBoost.t": "💰 תשלום לדייט התקבל!",
    "notif.escrowBoost.b": "{name} שילם/ה ${amount} עבור הדייט שלך. ${payout} מוחזק בנאמנות — כולל בונוס הפניה של 90%! אשר/י את הדייט עם הקוד בן 6 הספרות שלהם כדי לקבל תשלום.",
    "notif.offerPaid.t": "💘 הדייט הוזמן!",
    "notif.offerPaid.b": "התשלום שלך עבור הדייט עם {name} אושר. קוד האישור בן 6 הספרות שלך מוכן בדף ההצעות — שתף/י אותו עם הדייט שלך לאחר מכן.",
    "notif.refSlot.t": "🎁 זכית בחריץ פרימיום חינם!",
    "notif.refSlot.b": "{name} שהפנית זה עתה רכש/ה חריץ פרימיום — קיבלת חריץ $50 חינם כפרס!",
    "notif.boostActivated.t": "🚀 הפרופיל קודם!",
    "notif.boostActivated.b": "הפרופיל שלך מוצג כעת בראש הגילוי למשך 24 השעות הקרובות.",
    "notif.creditsAdded.t": "🪙 קרדיטים נוספו!",
    "notif.creditsAdded.b": "{credits} קרדיטים מרכישת {package} שלך נוספו לחשבונך. יתרה חדשה: {balance}.",
    "notif.unlimited.t": "♾️ הצעות בלתי מוגבלות הופעלו!",
    "notif.unlimited.b": "פרס האלוף שלך פעיל — שלח הצעות דייט ללא הגבלה (ללא צורך בסלוטים) למשך שבועיים הקרובים!",
    "notif.voucherGifted.t": "🎁 קיבלת שובר אלוף!",
    "notif.voucherGifted.b": "{name} העניק לך שבועיים של הצעות דייט ללא הגבלה — הפעל אותו בהגדרות לפני {date}.",
    "notif.voucherRedeemed.t": "🎁 המתנה שלך נוצלה!",
    "notif.voucherRedeemed.b": "{name} מימש את שובר האלוף שהענקת לו.",
    "notif.refBoost.t": "🎁 תגמול הפניה פתוח!",
    "notif.refBoost.b": "{name} שהפנית השלים את הדייט הפרימיום הראשון שלו — דייט ההשתכרות הבא שלך ישלם 90% במקום 80%!",
    "notif.payoutProcessing.t": "✅ דייט אושר!",
    "notif.payoutProcessing.b": "תשלום של ${amount} מעובד כעת ויגיע ל-PayPal שלך תוך 24-48 שעות.",
    "notif.offerExpiredSender.t": "⏰ הצעת דייט פגה",
    "notif.offerExpiredSender.b": "הצעת הדייט שלך על ${amount} פגה לאחר 7 ימים. הסלוט הפרימיום שלך שוחרר ותוכל לשלוח הצעה חדשה.",
    "notif.offerExpiredRecipient.t": "⏰ הצעת דייט פגה",
    "notif.offerExpiredRecipient.b": "הצעת דייט שקיבלת פגה מכיוון שהתשלום לא הושלם תוך 7 ימים.",
    "notif.dateReminder24.t": "💜 תזכורת דייט: מחר!",
    "notif.dateReminder24.b": "הדייט שלך עם {name} הוא מחר — {when}, {where}.",
    "notif.offerExpiringPay.t": "⏳ ההצעה פוגת תוקף בעוד 24 שעות!",
    "notif.offerExpiringPay.b": "הצעת הדייט שלך על ${amount} ל-{name} פוגת תוקף מחר — השלם את התשלום לפני שתפוג והסלוט שלך ישתחרר.",
    "notif.offerExpiringWait.t": "⏳ ההצעה פוגת תוקף בעוד 24 שעות!",
    "notif.offerExpiringWait.b": "הצעת הדייט שלך על ${amount} ל-{name} פוגת תוקף מחר — המתן לתגובתה או פנה אליה לפני שתפוג והסלוט שלך ישתחרר.",
    "notif.matchInsights.t": "💌 תובנות ההתאמה השבועיות שלך",
    "notif.matchInsights.b": "{views} צפיות בפרופיל ו-{favs} מועדפים חדשים השבוע — כולל {names}. שלח שלום או הגבר את הפרופיל שלך כדי לעורר הצעת דייט!",
    "notif.streak1.t": "🔥 התקדמות רצף: {streak}/3",
    "notif.streak1.b": "עוד דייט אחד עם דירוג 4★+ ו-150 קרדיטים חינם הם שלך!",
    "notif.streakN.t": "🔥 התקדמות רצף: {streak}/3",
    "notif.streakN.b": "עוד {togo} דייטים עם דירוג 4★+ לביטול נעילה של 150 קרדיטים חינם.",
    "notif.streakDone.t": "🔥 התקדמות רצף: {streak}/3",
    "notif.streakDone.b": "הפרס שלך בדרך!",
    "notif.rankUp.t": "🏆 אתה מקום #{rank} בלוח המדורגים",
    "notif.rankUp.b": "אתה במקום #{rank} בלוח המדורגים. 📈 עלית {spots} מקומות מהשבוע שעבר! המקום הראשון החודשי זוכה בשבועיים של הצעות דייט ללא הגבלה.",
    "notif.rankDown.t": "🏆 אתה מקום #{rank} בלוח המדורגים",
    "notif.rankDown.b": "אתה במקום #{rank} בלוח המדורגים. 📉 ירדת {spots} מקומות מהשבוע שעבר — דייט מוצלח אחד יחזיר אותך מיד. המקום הראשון החודשי זוכה בשבועיים של הצעות דייט ללא הגבלה.",
    "notif.rankSteady.t": "🏆 אתה מקום #{rank} בלוח המדורגים",
    "notif.rankSteady.b": "אתה במקום #{rank} בלוח המדורגים. 🎯 יציב מהשבוע שעבר. המקום הראשון החודשי זוכה בשבועיים של הצעות דייט ללא הגבלה.",
    "notif.rankNew.t": "🏆 אתה מקום #{rank} בלוח המדורגים",
    "notif.rankNew.b": "🎉 חדש: נכנסת ללוח המדורגים במקום #{rank}! המקום הראשון החודשי זוכה בשבועיים של הצעות דייט ללא הגבלה.",
    "notif.rankOff.t": "🏆 עדכון לוח התוצאות",
    "notif.rankOff.b": "נפלת מלוח המדורגים השבוע — דייט מוצלח אחד יחזיר אותך. המקום הראשון החודשי זוכה בשבועיים של הצעות דייט ללא הגבלה.",
    "notif.boostEnded.t": "⚡ ה-Boost שלך הסתיים",
    "notif.boostEnded.b": "הבוסט של 24 השעות שלך הסתיים. הוא הניב לך {views} צפיות בפרופיל. בצע בוסט שוב מדף הגילוי כדי להישאר בראש!",
    "notif.boostEndedExtra.t": "⚡ הבוסט שלך הסתיים",
    "notif.boostEndedExtra.b": "הבוסט של 24 השעות שלך הסתיים. הוא הניב לך {views} צפיות בפרופיל — כ-{extra} יותר מיום רגיל. בצע בוסט שוב מדף הגילוי כדי להישאר בראש!",
    "notif.dateSoon1h.t": "⏰ הדייט מתחיל בקרוב!",
    "notif.dateSoon1h.b": "הדייט שלך עם {name} בעוד פחות משעה — {time} ב-{location}.{tip}",
    "notif.dateSoon24.t": "💜 הדייט שלך עוד 24 שעות!",
    "notif.dateSoon24.b": "הדייט שלך עם {name} בעוד 24 שעות — {time} ב-{location}.{tip}",
    "notif.dateSoonTip": " פתח את ההצעה שלך לספירה לאחור חיה, תחזית מזג האוויר וטיפים לסגנון לבוש!",
    "notif.badgeFire.t": "🔥 אתה בוער!",
    "notif.badgeFire.b": "אתה אחד מ-3 הגברים הכי מבוקשים ב-DLuxe החודש — תג 🔥 מופיע כעת בפרופיל שלך.",
    "notif.hotStreak.t": "🔥 רצף לוהט! 150 קרדיטים חינם",
    "notif.hotStreak.b": "3 דייטים עם דירוג גבוה ברצף — חבילת ה-150 קרדיטים הפופולרית נוספה לחשבונך בחינם. שמור על הרצף!",
    "notif.badgeDiamond.t": "💎 תג יהלום הושג!",
    "notif.badgeDiamond.b": "השלמת 3 דייטים פרמיום של $500+ — תג היהלום זוהר כעת בפרופיל שלך.",
    "notif.champion.t": "🏆 אלוף לוח התוצאות!",
    "notif.champion.b": "סיימת במקום הראשון בקטגוריית '{section}' החודש! פרסים: בוסט פרופיל חינמי ל-7 ימים (כבר פעיל) ושובר ל-2 שבועות של הצעות דייט בלתי מוגבלות — הפעל אותו בהגדרות בכל עת במהלך 6 החודשים הקרובים.",
    "notif.anniversary.t": "💞 {months} {monthsWord} ביחד!",
    "notif.anniversary.b": "אתה ו-{name} זה עתה חגגתם {months} {monthsWord} רשמיים. חגגו זאת — רעיון: {idea}",
    "notif.monthWord": "חודש",
    "notif.monthsWord": "חודשים",
    "notif.annIdea0": "שחזרו את הדייט הראשון שלכם — אותו מקום, אותה הזמנה, זיכרונות חדשים.",
    "notif.annIdea1": "בשלו יחד ארוחת שלושה קורסים לאור נרות בבית, בלי טלפונים.",
    "notif.annIdea2": "פיקניק בשקיעה עם חטיפים אהובים של כל אחד ופלייליסט משותף אחד.",
    "notif.annIdea3": "הזמינו שעת ספא לזוגות ותחגגו עם משהו מבעבע אחר כך.",
    "notif.annIdea4": "צאו לטיול רכב קצר לעיירה שאף אחד מכם לא ביקר בה.",
    "notif.annIdea5": "לילה של צפייה בכוכבים: שמיכות, שוקו חם והשיר שלכם בלופ.",
    "notif.annIdea6": "שיעור ריקוד לשניים — סלסה, באצ'טה או כל מה שמצחיק אתכם.",
    "notif.annIdea7": "דייט במוזיאון או גלריה, ואחר כך קינוח במקום מפנק.",
    "notif.annIdea8": "כתבו אחד לשני מכתב על הרגע האהוב עליכם עד כה והחליפו אותם על ארוחת ערב.",
    "notif.annIdea9": "הזמינו שולחן לארוחת ערב על גג או מרפסת — התלבשו כאילו זה הדייט הראשון.",
    "notif.annIdea10": "טעימות יין או שוקולד ואחר כך טיול רגלי נינוח הביתה.",
    "notif.annIdea11": "תכננו יחד את טיול החלומות שלכם על ארוחת בוקר במיטה — ואז הזמינו חלק אחד ממנו.",
    "notif.companionInvite.t": "💌 ל-{name} יש את ההפתעה שלך!",
    "notif.companionInvite.b": "ההזמנה המסתורית שלך נחשפה בצ'אט שלך.",
    "notif.supportResolved.t": "✅ פנייה לתמיכה טופלה",
    "notif.supportResolved.b": "{label} שלך בנושא \"{subject}\" נבדקה וטופלה.",
    "notif.supportResolvedResp.t": "✅ פנייה לתמיכה טופלה",
    "notif.supportResolvedResp.b": "{label} שלך בנושא \"{subject}\" נבדקה וטופלה. תגובה: {resp}",
    "notif.labelRefund": "בקשת החזר כספי",
    "notif.labelComplaint": "תלונה",
    "notif.testMeetup.t": "{name} אישר את הפגישה שלך! 🎉",
    "notif.testMeetup.b": "ריצת בדיקה הושלמה — כך בדיוק זה נראה כשחבר אמיתי מאשר. לא נוכו קרדיטים.",
    "notif.testCounter.t": "{name} שלח הצעת נגד 💬",
    "notif.testCounter.b": "ריצת בדיקה: הם הציעו נגד ${amount}. אשר או דחה כדי להמשיך את הזרימה — עדיין ללא כסף אמיתי.",
    "notif.testOfferAccepted.t": "{name} קיבל את הצעת הדייט שלך! 💜",
    "notif.testOfferAccepted.b": "ריצת בדיקה: לחץ על כפתור סימולציית התשלום בדף ההצעות כדי לראות את המשך התהליך — ללא כסף אמיתי.",
    "notif.testDateCompleted.t": "דייט בדיקה עם {name} הושלם! 🏆",
    "notif.testDateCompleted.b": "זה היה מחזור הדייט הפרימיום המלא — הצעה, אישור, תשלום, קוד ואישור סופי. לא עבר כסף אמיתי. מוכן לנסות עם חבר אמיתי?",
    "notif.refChat.t": "🎁 +{credits} קרדיטים נצברו!",
    "notif.refChat.b": "{name} התחיל לשוחח — {credits} קרדיטים בונוס נוספו ליתרה שלך.",
    "notif.payoutSent.t": "💸 התשלום נשלח!",
    "notif.payoutSent.b": "${amount} נשלח ל-PayPal שלך ({recipient}).",
    "notif.favVerified.t": "✅ {name} מאומת עכשיו!",
    "notif.favVerified.b": "{name} מהמועדפים שלך עבר את בדיקת הסלפי וקיבל את תג המאומת.",
    "notif.favReviewed.t": "⭐ {name} קיבל ביקורת מעולה!",
    "notif.favReviewed.b": "{name} מהמועדפים שלך זכה לביקורת דייט של {rating} כוכבים. דייטרים מצוינים נתפסים מהר!",
    "notif.favBoosted.t": "⚡ {name} הגביר נוכחות!",
    "notif.favBoosted.b": "{name} מהמועדפים שלך מוצג כעת בראש Discover — שלח שלום בזמן שהם בזרקור!",
    "register.newMembers": "חברים חדשים מקבלים",
    "register.promoLuxe1": "50 קרדיטים חינם",
    "register.promoDluxe1": "גישה חינם + הכנסות",
    "register.promoLuxe2": "לנשים שמצטרפות ל-LuxeMeet",
    "register.promoDluxe2": "גברים מצטרפים ל-DLuxe בחינם — ומרוויחים מדייטים פרימיום",
    "register.googleTerms": "בהמשך עם Google, אתה מסכים ל",
    "register.googleTermsLink": "תנאים והגבלות",
    "register.orEmail": "או הירשם עם אימייל",
    "register.hintF": "נשים: חינם ב-LuxeMeet (50 קרדיטים לתחילה) — או קחי את היוזמה ב-DLuxe עם הצעות דייט פרימיום לגברים.",
    "register.hintM": "גברים: השקיעו כדי להתחבר ב-LuxeMeet — ותהנו מגישה חינם + הרוויחו מדייטים פרימיום ב-DLuxe.",
    "register.hintNone": "בחר את המגדר שלך כדי לראות את התכונות הזמינות",
    "register.refCode": "קוד הפניה",
    "register.refOptional": "(אופציונלי)",
    "register.refPh": "יש לך קוד? הכנס אותו כאן",
    "register.terms18": "אני בן 18 ומעלה ואני מסכים ל",
    "register.termsLink": "תנאים והגבלות וכתב ויתור על אחריות",
    "register.create": "יצירת חשבון",
    "register.haveAccount": "כבר יש לך חשבון?",
    "register.errGender": "אנא בחר את המגדר שלך",
    "register.errTerms": "אנא אשר את התנאים וההגבלות כדי להמשיך",
    "register.errFail": "ההרשמה נכשלה",
    "register.giftClaimed": "😕 קוד המתנה הזה ({code}) כבר מומש.",
    "register.giftExpired": "😕 קוד המתנה הזה ({code}) פג תוקף.",
    "register.giftReady": "🎁 {name} הגיש/ה לך שובר אלוף ({code}) — הוא יתווסף לחשבונך מיד לאחר ההרשמה!",
    "register.giftFriend": "חבר/ה",
    "set.tImgFile": "אנא בחר/י קובץ תמונה",
    "set.tImgSize": "התמונה חייבת להיות קטנה מ-5MB",
    "set.tPhotoUpdated": "תמונת הפרופיל עודכנה!",
    "set.tPhotoFail": "העלאת התמונה נכשלה",
    "set.tPwMismatch": "הסיסמאות החדשות אינן תואמות",
    "set.tPwShort": "הסיסמה חייבת להכיל לפחות 6 תווים",
    "set.tPwChanged": "הסיסמה שונתה בהצלחה!",
    "set.tPwFail": "שינוי הסיסמה נכשל",
    "set.tProfileUpdated": "הפרופיל עודכן!",
    "set.tProfileFail": "עדכון הפרופיל נכשל",
    "set.tLoggedOut": "התנתקת בהצלחה",
    "set.tDeactivated": "החשבון הושהה. היכנס/י שוב תוך 30 יום כדי להפעילו מחדש.",
    "set.tDeleteFail": "מחיקת החשבון נכשלה",
    "pp.errInvalidEmail": "אנא הזן/י כתובת אימייל תקינה",
    "pp.errNoMatch": "כתובות האימייל אינן תואמות",
    "pp.errConfirm": "אנא אשר/י את כתובת האימייל של PayPal",
    "pp.errFix": "אנא תקן/י את השגיאות לפני השמירה",
    "pp.savedOk": "הגדרות PayPal נשמרו ואומתו!",
    "pp.saveFail": "שמירת ההגדרות נכשלה",
    "pp.errImg": "אנא העלה/י קובץ תמונה",
    "pp.errSize": "גודל הקובץ חייב להיות קטן מ-5MB",
    "pp.qrUploaded": "קוד QR הועלה!",
    "pp.qrFail": "העלאת קוד ה-QR נכשלה",
    "terms.title": "תנאים והגבלות",
    "terms.updated": "כולל ויתור על אחריות — עודכן לאחרונה: יוני 2026 (v5)",
    "terms.back": "חזרה",
    "terms.footer": "© 2026 LuxeMeet & DLuxe. כל הזכויות שמורות.",
    "terms.s1t": "1. קבלת התנאים",
    "terms.s1p1": "על ידי יצירת חשבון או שימוש ב-LuxeMeet או במצב הנלווה שלו DLuxe (יחד, \"הפלטפורמה\"), את/ה מסכים/ה להיות כפוף/ה לתנאים והגבלות אלה ולוויתור על האחריות. אם אינך מסכים/ה, אל תשתמש/י בפלטפורמה.",
    "terms.s2t": "2. זכאות (18+)",
    "terms.s2p1": "עליך להיות בן/בת 18 לפחות כדי להשתמש ב-LuxeMeet. בעצם ההרשמה, את/ה מצהיר/ה ומאשר/ת שהינך בן/בת 18 ומעלה ורשאי/ת מבחינה חוקית להתקשר בהסכם זה. חשבונות שנמצא כי שייכים לקטינים יסגרו לאלתר ללא החזר כספי.",
    "terms.s3t": "3. אופי השירות",
    "terms.s3p1": "LuxeMeet היא פלטפורמת היכרויות בלבד. אנו מספקים כלים למבוגרים להכיר, לשלוח הודעות ולתאם פגישות. איננו צד לאף אינטראקציה, שיחה, פגישה או הסדר בין חברים. אנו אינו מבצעים בדיקות רקע פלילי על החברים ואינו מעניקים כל ערובה לגבי זהות, התנהגות, כוונות או תאימות של כל חבר.",
    "terms.s3p2": "הפלטפורמה עשויה להציג קישורים לשירותי צד שלישי עצמאיים שיסייעו בתכנון פגישות — כגון OpenStreetMap ו-Google Maps למיקומים, Uber להסעות, ו-Airbnb Experiences לרעיונות לדייטים. שירותים אלה אינם מופעלים על ידינו; השימוש שלך בהם כפוף לתנאיהם שלהם, ואיננו אחראים לתוכנם, למחיריהם או לזמינותם.",
    "terms.s4t": "4. קרדיטים, תשלומים והצעות דייט פרמיום",
    "terms.s4p1": "חברים גברים רוכשים קרדיטים כדי לשלוח הודעות ולבקש פגישות, חריצי הצעות פרמיום לשליחת הצעות דייט, ובוסטים אופציונליים לפרופיל. כל התשלומים מעובדים על ידי PayPal. המחירים מוצגים בעת הרכישה ועשויים לכלול דמי טיפול.",
    "terms.s4p2": "עבור הצעות דייט פרמיום, הסכום המוצע מוחזק בנאמנות עם התשלום. כאשר הדייט מתקיים והמקבל/ת מזין/ה את קוד האישור בן 6 הספרות של המשלם, התשלום (בניכוי עמלת הפלטפורמה) משוחרר למקבל/ת. עמלת הפלטפורמה מפורסמת באפליקציה. דייטים חוזרים: כאשר משלם/ת מזמין/ה דייט חדש עם מי שכבר השלים/ה איתו/ה דייט דרך הפלטפורמה, אין צורך בחריץ פרמיום ועמלת פלטפורמה מופחתת של 10% חלה (המקבל/ת מקבל/ת 90% מסכום ההצעה). קצבאות תחבורה אופציונליות משולמות יחד עם ההצעה ומועברות במלואן למקבל/ת. הצעות דייט שבוטלו מוסרות אוטומטית מהיסטוריית ההצעות 48 שעות לאחר הביטול. שוברי אלוף: שוברי פרס הנצברים דרך לוח המובילים החודשי ניתנים להעברה פעם אחת לאדם אחר באמצעות קוד מתנה לשימוש חד-פעמי; לאחר ההעברה, לא ניתן לממש את השובר או לתבוע אותו בחזרה על ידי המחזיק המקורי, ושוברי מתנה שהתקבלו אינם ניתנים להעברה חוזרת. לשוברים אין ערך כספי.",
    "terms.s4p3": "החזרים: קרדיטים, סלוטים ובוסטים אינם ניתנים להחזר לאחר מסירתם. תשלומי דייטים שהופקדו באמנה ניתנים להחזר רק אם הדייט לא התקיים וההצעה בוטלה או פגה בהתאם לכללי הפלטפורמה. תשלומים חייבים להתבצע מחשבון PayPal שכתובת האימייל שלו תואמת לכתובת האימייל של חשבון LuxeMeet שלך; תשלומים מכתובות אימייל שאינן תואמות עלולים להתעכב או להיות בלתי ניתנים לשחזור. ניתן להגיש בקשת החזר או תלונה בכל עת דרך הגדרות ← החזרים ותלונות (או \"עזרה ותמיכה\" בתפריט האפליקציה); כל בקשה נבדקת על ידי הצוות שלנו ותקבל הודעה על התוצאה באפליקציה ובאימייל.",
    "terms.s5t": "5. ויתור על אחריות וקבלת סיכון",
    "terms.s5p1": "אתה/את מסכים/ה במפורש כי פגישה עם חבר/ת פלטפורמה אחר/ת פנים אל פנים היא באחריותך הבלעדית. במידה המרבית המותרת על פי חוק, אתה/את מוותר/ת, משחרר/ת ופוטר/ת את LuxeMeet, בעליה, מפעיליה, עובדיה והשותפות הקשורות אליה מכל תביעה, דרישה, נזק, פציעה, הפסד או עילת תביעה — ידועה או לא ידועה — הנובעת מהשימוש שלך בפלטפורמה, מהאינטראקציות והתקשורת שלך עם חברים אחרים, ומכל פגישה או דייט שסוכמו דרך הפלטפורמה, לרבות ומבלי להגביל נזק גופני, מצוקה רגשית, נזק לרכוש, גניבה, הונאה או הפסד כספי.",
    "terms.s5p2": "אתה/את אחראי/ת באופן בלעדי על בטיחותך האישית. אנו ממליצים בחום להיפגש במקומות ציבוריים, להודיע לחבר/ה לאן אתם הולכים, לדאוג להסעה עצמאית, ולעולם לא לשתף מידע פיננסי עם חברים אחרים בפלטפורמה.",
    "terms.s6t": "6. התנהגות חברים",
    "terms.s6p1": "אתה/את מסכים/ה שלא: להציג את עצמך בצורה מטעה בנוגע לזהותך או גילך; להטריד, להשפיל או לפגוע בחברים אחרים; לבקש כסף מחברים מחוץ למערכת ההצעות של הפלטפורמה; להשתמש בפלטפורמה לכל מטרה מסחרית, בלתי חוקית או מנצלת (לרבות שירותי ליווי או סחר בבני אדם); לפרסם תוכן מפורש, פוגעני או מפר זכויות; או לנסות לעקוף את מערכות התשלום של הפלטפורמה.",
    "terms.s6p2": "מדיניות תוכן: תמונות וסרטוני פרופיל אינם יכולים להכיל עירום או תוכן מיני מפורש או מרומז. כל התמונות והסרטונים המועלים עוברים סינון אוטומטי על ידי בינה מלאכותית לפני פרסום, ותוכן אסור נדחה. ניסיונות חוזרים להעלות תוכן אסור עלולים לגרור פעולה על החשבון.",
    "terms.s6p3": "הפרה עלולה להוביל להשעיה מיידית או סיום חשבון ללא החזר כספי, והפניה לרשויות אכיפת החוק במקרים המתאימים.",
    "terms.s7t": "7. דירוגי דייטים, ביקורות ומועדפים",
    "terms.s7p1": "לאחר דייט פרימיום שהושלם, שני המשתתפים רשאים לדרג את הדייט (1-5 כוכבים) עם תגובה כתובה אופציונלית. ההשתתפות בדירוגים היא רשותית: ניתן לבטל השתתפות לחלוטין בהגדרות, ובמקרה זה אף אחד לא יוכל לדרג את הדייטים שלך ואף דירוג לא יופיע בפרופיל שלך. אם אתה/את בוחר/ת להשתתף, ניתן לבחור בנפרד האם תגובות ביקורת כתובות יוצגו בפומבי יחד עם דירוג הכוכבים שלך.",
    "terms.s7p2": "ביקורות חייבות להיות כנות, מכבדות ומבוססות על דייט אמיתי. ביקורות משמיצות, מטרידות או כוזבות עלולות להיות מוסרות ועלולות לגרור פעולה על החשבון. חברים רשאים גם לשמור פרופילים אחרים ברשימת מועדפים פרטית; המועדפים שלך גלויים לך בלבד. אם תוסיף/י חבר/ה למועדפים, ייתכן שתקבל/י התראות על פעילות הפרופיל הציבורי שלו/ה (כגון בוסטים, אימות או ביקורות חדשות).",
    "terms.s8t": "8. תכונות בינה מלאכותית",
    "terms.s8p1": "הפלטפורמה מציעה תכונות אופציונליות מבוססות בינה מלאכותית, כולל עוזרי הכתיבה \"AI Wingman\" (לחברים גברים) ו-\"AI Cupid\" (לחברות נשים) — שיכולים לנסח פותחי שיחה ותגובות, הערות להצעות דייט פרימיום, הודעות נגד-הצעה, הודעות בקשת פגישה ותגובות לדירוגי דייטים — עוזר העזרה באפליקציה \"Luxe\", רעיונות דייט מאוצרים על ידי בינה מלאכותית, הצעות תלבושות מעצב-AI המוצגות בספירה לאחור לליל הדייט, תובנות התאמה שבועיות בסיוע AI, תמונות פרופיל בסיוע AI, ואימות תמונות מבוסס-סלפי AI. בינה מלאכותית משמשת גם לסינון אוטומטי של כל התמונות וסרטוני הגלריה המועלים לתוכן אסור (עירום ותוכן מיני) לפני פרסומם. תוכן AI נוצר אוטומטית ועלול להיות לא מדויק. אתה/את אחראי/ת לכל תוכן שאתה/את שולח/ת או מפרסם/ת, כולל תוכן בסיוע AI. תמונות פרופיל חייבות לייצג אותך באופן אמיתי; שימוש בתמונות AI שמציגות אותך באופן מטעה מהותי עלול לגרור פעולה על החשבון. סלפי אימות משמשים אך ורק לבדיקת האימות ולעולם אינם מוצגים בפומבי.",
    "terms.s9t": "9. הגבלת אחריות",
    "terms.s9p1": "במידה המרבית המותרת על פי חוק, LUXEMEET לא תהיה אחראית לכל נזק עקיף, נסיבתי, מיוחד, תוצאתי או עונשי, או לכל אובדן רווחים או נתונים, הנובע מהשימוש שלך בפלטפורמה. האחריות המצטברת הכוללת שלנו לכל תביעה לא תעלה על הסכום ששילמת ל-LUXEMEET בששת (6) החודשים שקדמו לתביעה.",
    "terms.s10t": "10. פרטיות",
    "terms.s10p1": "אנו אוספים ומעבדים מידע חשבון, הודעות, רשומות תשלום ונתוני שימוש להפעלת הפלטפורמה, עיבוד תשלומים ותשלומי יוצאים, מניעת הונאה ושיפור השירות. מספר צפיות בפרופיל נמדד לצורך ניתוח נתוני בוסטים. ניתן להפעיל מצב אינקוגניטו בהגדרות כדי להסתיר את הפרופיל שלך מגלישה בגלה — באופן גלובלי או ממשתמשים ספציפיים — בעוד שהשיחות, ההצעות והפגישות הקיימות שלך ממשיכות לפעול. אנו לא מוכרים את הנתונים האישיים שלך. אימיילים עשויים להישלח למטרות חשבון, תשלום ומעורבות.",
    "terms.s11t": "11. סיום חשבון ומחיקה",
    "terms.s11p1": "מחיקת חשבונך: ניתן למחוק את חשבונך בכל עת מהגדרות ← אזור סכנה. הפרופיל שלך מוסתר מגלה, לוחות מובילים ומועדפים באופן מיידי. חל תקופת חסד של 30 יום: כניסה מחדש תוך 30 יום מפעילה מחדש את החשבון שלך במלואו. לאחר 30 יום, החשבון שלך והנתונים האישיים (פרופיל, תמונות, סרטונים, הודעות, מועדפים והתראות) נמחקים לצמיתות וללא היתכנות שחזור או הופכים לאנונימיים. קרדיטים, סלוטים, בוסטים וכל יתרה שלא נמשכה יוחרמו עם המחיקה הקבועה. רשומות הנדרשות לציות פיננסי ומשפטי (כגון רשומות תשלום שהושלמו) עשויות להישמר בצורה אנונימית.",
    "terms.s11p2": "אנו רשאים להשעות או לסיים חשבונות שמפרים תנאים אלה. קרדיטים, סלוטים ובוסטים שלא נוצלו יוחרמו עם סיום חשבון מסיבה מוצדקת.",
    "terms.s12t": "12. שינויים בתנאים אלה",
    "terms.s12p1": "אנו עשויים לעדכן תנאים אלה מעת לעת. המשך שימוש בפלטפורמה לאחר כניסת השינויים לתוקף מהווה הסכמה לתנאים המעודכנים.",
    "terms.s13t": "13. מצב DLuxe",
    "terms.s13p1": "הפלטפורמה כוללת מצב נלווה, \"DLuxe\", הנגיש דרך מתג הלב באפליקציה. DLuxe משקף את LuxeMeet עם תפקידי התשלום הפוכים: חברות נשים משלמות עבור אינטראקציות (קרדיטים, סלוטים פרימיום, בוסטים והצעות דייט כספיות) וחברים גברים עשויים לקבל תשלומי הצעות דייט. כל התנאים חלים באופן שווה על שני המצבים, כאשר הוראות ספציפיות לתפקיד חלות על הצד שמשלם או מקבל תשלום במצב הפעיל. חשבון יחיד משמש בשני המצבים. שיחות ובקשות פגישה מופרדות לפי מצב: אינטראקציות שהחלו ב-LuxeMeet פועלות לפי כללי התשלום של LuxeMeet (חברים גברים משלמים) ואינטראקציות שהחלו ב-DLuxe פועלות לפי כללי DLuxe (חברות נשים משלמות). מעבר בין מצבים משנה רק איזה תיבת דואר נכנס מוצגת ולעולם אינו משנה מי משלם בשיחה קיימת. כל תכונות הפלטפורמה — כולל עוזרי AI, לוחות מובילים, פרסים לאלופים ומתנות שוברים — זמינות בשני המצבים עם מיתוג מותאם למצב.",
    "terms.s14t": "14. יצירת קשר",
    "terms.s14p1": "שאלות לגבי תנאים אלה? השתמש/י בעוזר העזרה באפליקציה. לבקשות החזר ותלונות, השתמש/י בהגדרות ← החזרים ותלונות (או \"עזרה ותמיכה\" בתפריט האפליקציה) — כל פנייה נבדקת ומקבלת מענה.",
    "landing.badge": "חוויית דייטינג פרימיום",
    "landing.heroLuxe1": "איכות פוגשת",
    "landing.heroLuxe2": "חיבור אמיתי",
    "landing.heroDluxe1": "שבה נשים",
    "landing.heroDluxe2": "לוקחות את ההגה",
    "landing.taglineLuxe": "פלטפורמת דייטינג בלעדית שבה חיבורים משמעותיים מוערכים. ג'נטלמנים משקיעים קרדיטים כדי להתחבר, מה שמבטיח עניין אמיתי ואינטראקציות איכותיות.",
    "landing.taglineDluxe": "פלטפורמת דייטינג בלעדית שבה נשים נועזות עושות את הצעד הראשון. גבירות משקיעות קרדיטים כדי להתחבר עם גברים יוצאי דופן, מה שמבטיח עניין אמיתי ואינטראקציות איכותיות.",
    "landing.startJourney": "התחל/י את המסע שלך",
    "landing.haveAccount": "יש לי חשבון",
    "landing.watchFilm": "צפה/י בסרטון",
    "auth.signIn": "כניסה",
    "auth.getStarted": "בואו נתחיל",
    "login.welcomeBack": "ברוך/ה שובך/ך",
    "login.subtitle": "כנס/י כדי להמשיך את המסע שלך",
    "login.google": "המשך עם Google",
    "login.orEmail": "או המשך עם אימייל",
    "login.email": "אימייל",
    "login.password": "סיסמה",
    "login.emailPh": "הזן את האימייל שלך",
    "login.passwordPh": "הזן את הסיסמה שלך",
    "login.forgot": "שכחת סיסמה?",
    "login.noAccount": "אין לך חשבון?",
    "login.createOne": "צור אחד",
    "login.backHome": "חזרה לדף הבית",
    "register.title": "צור את החשבון שלך",
    "register.subtitle": "התחל את המסע שלך לקשרים משמעותיים",
    "register.fullName": "שם מלא",
    "register.namePh": "הזן את שמך",
    "register.passwordPh": "צור סיסמה",
    "register.iAmA": "אני",
    "register.man": "גבר",
    "register.woman": "אישה",
    "nav.discover": "גלה",
    "nav.favorites": "מועדפים",
    "nav.chat": "צ'אט",
    "nav.offers": "הצעות",
    "nav.meetups": "פגישות",
    "nav.top": "מובחרים",
    "nav.credits": "קרדיטים",
    "nav.earnings": "הכנסות",
    "nav.settings": "הגדרות",
    "nav.watchTour": "צפה בסיור באפליקציה",
    "nav.helpSupport": "עזרה ותמיכה",
    "discover.title": "גלה",
    "discover.subtitle": "מצא את ההתאמה המושלמת שלך",
    "discover.newest": "חדשים ביותר",
    "discover.topRated": "מדורגים בראש",
    "discover.sendOffer": "שלח הצעת דייט פרימיום",
    "discover.message": "הודעה",
    "discover.aiCompanion": "AI Companion",
    "discover.videoIntro": "וידאו",
    "settings.countryLanguage": "מדינה ושפה",
    "settings.country": "מדינה",
    "settings.language": "שפה",
    "settings.currency": "מטבע",
    "settings.currencyNote": "המחירים מוצגים בקירוב במטבע שלך - התשלומים מעובדים בדולר אמריקאי.",
    "settings.refunds": "החזרים ותלונות",
    "settings.changePassword": "שינוי סיסמה",
    "settings.logout": "התנתקות",
    "settings.dangerZone": "אזור מסוכן",
    "settings.deleteAccount": "מחיקת החשבון שלי",
    "credits.billedUsd": "חיוב בדולר אמריקאי",
    "common.accept": "קבל",
    "common.decline": "דחה",
    "common.pending": "ממתין",
    "common.accepted": "התקבל",
    "common.declined": "נדחה",
    "common.received": "התקבל",
    "common.sent": "נשלח",
    "common.yourBalance": "היתרה שלך",
    "common.back": "חזרה",
    "common.cancel": "ביטול",
    "common.credits": "קרדיטים",
    "common.viewMap": "הצג מפה",
    "common.getUber": "הזמן Uber",
    "common.hours": "שעות",
    "chat.title": "הודעות",
    "chat.empty": "אין שיחות עדיין",
    "chat.emptySub": "התחל להתחבר עם אנשים וצא לשיחה!",
    "chat.discoverProfiles": "גלה פרופילים",
    "chat.typeMessage": "הקלד הודעה...",
    "chat.inbox": "תיבת דואר נכנס",
    "chat.noMessages": "אין הודעות עדיין. התחל את השיחה!",
    "chat.startConvo": "התחל את השיחה!",
    "chat.costStart": "פתיחת שיחה עולה 10 קרדיטים",
    "chat.costMessage": "שליחת הודעה עולה 5 קרדיטים",
    "chat.inboxBadge": "תיבת הדואר של {app}",
    "common.testRun": "ריצת בדיקה",
    "offers.simulatePayment": "סימולציית תשלום (בדיקה)",
    "offers.title": "הצעות דייט פרמיום",
    "offers.dateOffers": "הצעות דייט",
    "offers.slots": "חריצי ההצעות שלך",
    "offers.available": "זמין",
    "offers.inUse": "בשימוש",
    "offers.consumed": "נוצל",
    "offers.sentOffers": "ההצעות שלך שנשלחו",
    "offers.none": "אין הצעות עדיין",
    "offers.noneSent": "לא נשלחו הצעות עדיין",
    "offers.reviewRespond": "סקור/י והגב/י להצעות הדייט הפרימיום שלך",
    "offers.subtitlePayer": "רכוש/י חריצים לשליחת הצעות דייט פרימיום למשתמשים שלך",
    "offers.slotDesc": "$50 לחריץ • ניתן לשימוש חוזר עד קבלת ההצעה",
    "offers.buySlot": "רכוש/י חריץ",
    "offers.noneDesc": "טרם קיבלת הצעות דייט",
    "offers.noneSentDesc": "רכוש/י חריץ ושלח/י את הצעת הדייט הפרימיום הראשונה שלך",
    "offers.buyFirstSlot": "רכוש/י את החריץ הראשון שלך",
    "offers.respond": "הגב/י",
    "offers.cancelOffer": "בטל/י הצעה",
    "offers.viewCounter": "צפה/י בהצעה נגדית",
    "offers.rateDate": "דרג/י את הדייט הזה",
    "offers.dateDetails": "פרטי הדייט וביקורות",
    "status.pending": "ממתין",
    "status.paymentNeeded": "נדרש תשלום",
    "status.awaitingConfirmation": "ממתין לאישור",
    "status.countered": "הוגשה הצעה נגדית",
    "status.confirmed": "אושר",
    "status.completed": "הושלם",
    "status.declined": "נדחה",
    "status.expired": "פג תוקף",
    "status.cancelled": "בוטל",
    "meetups.title": "בקשות מפגש",
    "meetups.none": "אין בקשות עדיין",
    "meetups.noneSent": "לא נשלחו בקשות",
    "meetups.received": "התקבלו",
    "meetups.sent": "נשלחו",
    "meetups.noneDesc": "בקשות מפגש מאחרים יופיעו כאן.",
    "meetups.noneSentDesc": "מצא/י מישהו שתרצה/י להיפגש איתו!",
    "meetups.browse": "עיין/י בפרופילים",
    "favorites.title": "מועדפים",
    "favorites.subtitle": "פרופילים שמירת",
    "favorites.none": "אין מועדפים עדיין",
    "favorites.noneDesc": "הקש/י על הלב בפרופיל שאהבת והוא יישמר כאן.",
    "favorites.browse": "עיין/י בגילויים",
    "leaderboard.title": "החברים המובילים",
    "leaderboard.you": "את/ה",
    "leaderboard.subtitle": "הדייטרים המבוקשים ביותר, בעלי הדירוג הגבוה ביותר והמוציאים הגדולים ביותר בפלטפורמה. צברו תגים כדי לתפוס את מקומכם.",
    "leaderboard.prizeNote": "המדורג מספר 1 בכל קטגוריה מדי חודש זוכה בבוסט חינם ל-7 ימים + שבועיים של הצעות דייט ללא הגבלה.",
    "leaderboard.empty": "אין עדיין בעלי תגים — השלימו דייטים מעולים והיו הראשונים על הלוח!",
    "leaderboard.loading": "טוען את לוח המובילים...",
    "leaderboard.fireTitle": "המבוקשים ביותר ב-DLuxe",
    "leaderboard.fireSub": "3 הגברים שזכו לכי הרבה פניות ב-DLuxe החודש",
    "leaderboard.diamondTitle": "חברי Diamond",
    "leaderboard.diamondSub": "השלימו 3 דייטים פרימיום ומעלה בשווי $500 או יותר",
    "leaderboard.ratedTitle": "הדייטרים המדורגים בראש",
    "leaderboard.ratedSub": "הדירוגים הגבוהים ביותר מביקורות אמיתיות",
    "leaderboard.shareBadge": "שתפו תג",
    "leaderboard.datesCompleted": "דייטים פרימיום הושלמו",
    "earnings.title": "הרווחים שלי",
    "earnings.escrow": "בנאמנות",
    "earnings.total": "סה״כ הרווחים",
    "earnings.dates": "דייטים שהושלמו",
    "earnings.history": "היסטוריית תשלומים",
    "earnings.none": "אין עדיין רווחים",
    "credits.costs": "עלות קרדיטים",
    "credits.startChat": "פתיחת שיחה חדשה",
    "credits.sendMessage": "שליחת הודעה",
    "credits.requestMeetup": "בקשת פגישה",
    "credits.buy": "רכישת קרדיטים",
    "credits.history": "היסטוריית רכישות",
    "credits.noHistory": "אין עדיין היסטוריית רכישות",
    "credits.completePayment": "השלמת תשלום",
    "credits.allSet": "הכל מוכן!",
    "credits.freeLuxe": "כאישה ב-LuxeMeet, את נהנית מגישה חינמית למסרים ולכל התכונות.",
    "credits.freeDluxe": "כגבר ב-DLuxe, אתה נהנה מגישה חינמית למסרים ולכל התכונות.",
    "credits.bestValue": "הכי משתלם",
    "credits.continuePayment": "המשך לתשלום",
    "credits.processing": "מעבד...",
    "profile.message": "הודעה",
    "profile.requestMeetup": "בקשת פגישה",
    "tour.tryWith": "נסו עם",
    "settings.title": "הגדרות",
    "settings.photoHint": "לחצו על המצלמה כדי לשנות תמונה",
    "settings.profileInfo": "פרטי הפרופיל",
    "settings.displayName": "שם תצוגה",
    "settings.age": "גיל",
    "settings.location": "מיקום",
    "settings.locationPh": "עיר, מדינה",
    "settings.bio": "אודותי",
    "settings.bioPh": "ספר/י לאחרים על עצמך...",
    "settings.interests": "תחומי עניין",
    "settings.interestsPh": "טיולים, מוזיקה, אוכל (מופרדים בפסיקים)",
    "settings.interestsHint": "הפרד/י בין תחומי העניין בפסיקים",
    "settings.saveChanges": "שמור שינויים",
    "settings.paypalTitle": "הגדרות תשלום PayPal",
    "settings.paypalDesc": "הוסף/י את פרטי ה-PayPal שלך כדי לקבל תשלומים מהצעות דייט שאושרו",
    "settings.dangerDesc": "מחיקת החשבון מסתירה את הפרופיל שלך באופן מיידי. שינית את דעתך? פשוט התחבר/י מחדש תוך 30 יום כדי להפעיל אותו שוב — לאחר מכן, החשבון והנתונים האישיים שלך יימחקו לצמיתות, וקרדיטים או יתרות שלא נוצלו יאבדו.",
    "settings.deleteTitle": "למחוק את החשבון שלך?",
    "settings.deleteB1": "הפרופיל שלך מוסתר מכולם באופן מיידי",
    "settings.deleteB2": "התחבר/י מחדש תוך 30 יום כדי להפעיל את החשבון שוב",
    "settings.deleteB3": "לאחר 30 יום הכל נמחק לצמיתות — תמונות, הודעות וכל קרדיטים או יתרות שלא נוצלו",
    "settings.confirmPasswordLabel": "אמת/י את הסיסמה שלך",
    "settings.googleBlank": "נרשמת/ה עם Google? השאר/י שדה זה ריק.",
    "settings.deactivateDelete": "השבת ומחק",
    "settings.currentPassword": "סיסמה נוכחית",
    "settings.newPassword": "סיסמה חדשה",
    "settings.confirmNewPassword": "אמת/י סיסמה חדשה",
    "ref.title": "הזמן/י וצבור/י",
    "ref.desc": "שתף/י את קישור ההזמנה שלך. תרוויח/י 25 קרדיטים בונוס ברגע שחבר/ה שהזמנת מתחיל/ה לשוחח. בנוסף: כשחבר/ה מוזמן/ת קונה את החבילה הפרימיום הראשונה שלו/ה — תקבל/י חריץ $50 חינם, וכשחבר/ה מוזמן/ת משלים/ה את הדייט הפרימיום הראשון שלו/ה — הדייט הרווחי הבא שלך ישלם 90% במקום 80%.",
    "ref.friendsReferred": "חברים שהוזמנו",
    "ref.bonusCredits": "קרדיטים בונוס שנצברו",
    "ref.freeSlots": "חריצים חינמיים שנצברו",
    "ref.boosts": "בוסטים של 90% זמינים",
    "ref.yourReferrals": "ההפניות שלך",
    "ref.stJoined": "הצטרף/ה",
    "ref.stChatting": "התחיל/ה לשוחח ✓ (+25 קרדיטים)",
    "ref.stDate": "השלים/ה דייט ✓",
    "ref.stSlot": "רכש/ה חריץ ✓",
    "ref.topReferrers": "המפנים המובילים החודש",
    "ref.referralsWord": "הפניות",
    "ref.copied": "קישור ההפניה הועתק!",
    "share.inviteMsg": "הצטרף/י אליי ב-{app} — אפליקציית ההיכרויות הפרימיום שבה דייטים אמיתיים באמת קורים. הירשם/י עם קישור ההזמנה שלי:",
    "share.dreamMsg": "💘 הוזמנת לדייט החלומות! הצטרף/י אליי ב-{app} ונתכנן יחד את הדייט המושלם:",
    "share.inviteBtn": "הזמן/י חבר/ה",
    "share.dreamBtn": "💘 הזמנה לדייט החלומות",
    "share.hint": "כתוב/י הודעה משלך או השאר/י ריק כדי להשתמש בתבנית — קישור ההזמנה שלך יתווסף אוטומטית.",
    "share.copied": "הודעת ההזמנה הועתקה — הדביקי אותה בכל מקום!",
    "landing.whyTitle": "למה לבחור ב-{app}?",
    "landing.whySub": "מערכת הקרדיטים שלנו מבטיחה שכל אינטראקציה תהיה משמעותית ומכוונת.",
    "landing.f1Title": "חיבורים איכותיים",
    "landing.f1Desc": "הקרדיטים מבטיחים עניין אמיתי. ללא ספאם, ללא בוטים — רק אנשים אמיתיים שמחפשים קשרים אמיתיים.",
    "landing.f2Title": "חוויה פרימיום",
    "landing.f2DescLuxe": "הגברות נהנות מגישה חינמית, בעוד הגברים משקיעים בשיחות משמעותיות ובבקשות לפגישות.",
    "landing.f2DescDluxe": "הגברים נהנים מגישה חינמית, בעוד הגברות משקיעות בשיחות משמעותיות ובהצעות דייטים פרימיום.",
    "landing.f3Title": "פרופילים מאומתים",
    "landing.f3Desc": "כל הפרופילים עוברים אימות כדי להבטיח אותנטיות. פגשי אנשים אמיתיים, צרי קשרים אמיתיים.",
    "landing.refBadge": "הפנה וזכה",
    "landing.refTitle1": "הזמיני חברים,",
    "landing.refTitle2": "פתחי דלת לפרסים",
    "landing.refDesc1": "לכל חבר יש קישור הזמנה אישי. שתפי אותו עם חברים וזכי ב-",
    "landing.refDescBold": "חריץ פרימיום חינמי בשווי $50",
    "landing.refDesc2": "בנוסף לתכונות בונוס בלעדיות כשהם מצטרפים ומתחילים להיות פעילים.",
    "landing.refCard1Title": "חריץ פרימיום חינמי בשווי $50",
    "landing.refCard1Desc": "מוענק עבור כל חבר שמצטרף ומתחיל להיות פעיל",
    "landing.refCard2Title": "תכונות בונוס",
    "landing.refCard2Desc": "הטבות בלעדיות השמורות למפנים המובילים",
    "landing.refCta": "הצטרפי וקבלי את קישור ההזמנה שלך",
    "landing.ctaTitle": "מוכנה למצוא את ההתאמה שלך?",
    "landing.ctaSub": "הצטרפי לאלפי רווקים שמצאו קשרים משמעותיים ב-{app}.",
    "landing.ctaBtn": "צרי חשבון חינמי",
    "landing.footerTerms": "תנאים והגבלות",
    "pp.balance": "יתרה זמינה",
    "pp.balanceNote": "מהצעות דייטים שהתקבלו (80% תשלום לאחר עמלת הפלטפורמה)",
    "pp.email": "כתובת אימייל ב-PayPal *",
    "pp.emailHint": "לכאן נשלח את התשלומים שלך",
    "pp.confirmEmail": "אמתי כתובת אימייל ב-PayPal *",
    "pp.confirmPh": "הזיני שוב את האימייל שלך",
    "pp.emailsMatch": "כתובות האימייל תואמות",
    "pp.verified": "מאומת",
    "pp.username": "שם משתמש ב-PayPal (אופציונלי)",
    "pp.qr": "קוד QR של PayPal (אופציונלי)",
    "pp.qrUpload": "העלי קוד QR",
    "pp.qrHint": "העלי את קוד ה-QR של PayPal שלך להעברות נוחות",
    "pp.save": "שמרי ואמתי את הגדרות PayPal",
    "pp.howTitle": "ℹ️ איך פועלים התשלומים",
    "pp.how1": "חברים שולחים הצעות דייטים עם סכומים כספיים ($100-$1000)",
    "pp.how2": "כשאתה מאשר והם משלמים, אתה מקבל 80% (הפלטפורמה שומרת 20%)",
    "pp.how3": "התשלומים מועברים לכתובת ה-PayPal שלך תוך 3-5 ימי עסקים",
    "pp.how4": "היתרה שלך תתעדכן לאחר כל דייט מאושר",
    "rel.title": "מערכת יחסים רשמית",
    "rel.activeWith": "💞 יחד רשמית עם {name}",
    "rel.activeSince": "מאז {date} — שניכם מוסתרים מכל האחרים.",
    "rel.chat": "צ'אט",
    "rel.planDate": "תכנן דייט",
    "rel.end": "סיים מערכת יחסים",
    "rel.incomingTitle": "💍 {name} רוצה להפוך את זה לרשמי איתך!",
    "rel.incomingDesc": "קבל ושניכם תיעלמו מהפיד של כולם — האפליקציה תהפוך לשלכם בלבד.",
    "rel.accept": "קבל 💞",
    "rel.decline": "עדיין לא",
    "rel.waitingFor": "⏳ ממתין ל-{name}",
    "rel.waitingDesc": "בקשת ״הפוך לרשמי״ שלך ממתינה לתשובתם.",
    "rel.cancelRequest": "בטל בקשה",
    "rel.endTitle": "לסיים את מערכת היחסים הרשמית?",
    "rel.endDesc": "אתה ו-{name} תהיו גלויים לכולם שוב ותוכלו לעיין בחברים אחרים. הצ'אטים וההיסטוריה שלכם נשמרים.",
    "rel.keepIt": "שמור על זה",
    "rel.goOfficial": "הפוך לרשמי — הסתר את שנינו מכולם",
    "rel.requestSent": "⏳ בקשת ״הפוך לרשמי״ נשלחה — ממתין ל-{name}",
    "rel.togetherSince": "💞 יחד רשמית מאז {date}",
    "rel.together": "💞 יחד רשמית",
    "rel.coupleTitle": "💞 אתם יחד רשמית",
    "rel.coupleDesc": "אתה ו-{name} מוסתרים מכל האחרים. האפליקציה היא רק בשבילכם — שוחחו, תכננו מפגשים ודייטים פרימיום.",
    "rel.coupleHint": "שינוי תוכניות? כל אחד מכם יכול לסיים את זה בכל עת בהגדרות.",
    "rel.toastSent": "💍 בקשת ״הפוך לרשמי״ נשלחה ל-{name}!",
    "rel.toastTogether": "💞 אתה ו-{name} יחד רשמית!",
    "rel.toastEnded": "מערכת היחסים הסתיימה — אתה גלוי באפליקציה שוב",
    "rel.toastPrivate": "חבר זה נמצא במערכת יחסים רשמית 💞",
    "rel.toastActive": "אתה במערכת יחסים רשמית — האפליקציה היא רק בשבילכם עכשיו 💞",
    "invite.admirerTitle": "יש לך מעריץ סודי 💘",
    "invite.dreamTitle": "{name} שומר עבורך הזמנה לדייט חלומי",
    "invite.admirerSub": "ל-{name} יש הודעת מעריץ סודית שמחכה לך — אבל היא נשארת אטומה עד שתצטרף.",
    "invite.dreamSub": "מישהו תכנן משהו מיוחד — הפרטים אטומים עד שתצטרף.",
    "invite.lock": "הירשם בחינם כדי לפתוח את ההפתעה שלך",
    "invite.claimedNote": "ההזמנה הזו כבר נחשפה. הצטרף בכל זאת וראה מי מחכה לך!",
    "invite.reveal": "גלה את ההפתעה שלי",
    "invite.login": "כבר חבר? התחבר",
    "invite.expired": "תוקף ההזמנה פג",
    "invite.explore": "גלו את LuxeMeet",
    "landing.goBadge": "נבנה למערכות יחסים אמיתיות",
    "landing.goTitle1": "כשזה הופך לרציני,",
    "landing.goTitle2": "הפכו זאת רשמי 💞",
    "landing.goDesc": "מצאתם את האחד? בנגיעה אחת שניכם נעלמים מהפיד של כולם — אין פרופילים, אין הודעות, אין הסחות דעת. האפליקציה הופכת להיות רק בשבילכם: צ׳אט פרטי, פגישות ודייטים פרימיום. ואם משהו משתנה, כל אחד מהשניים יכול לבטל זאת בכל עת.",
    "landing.goChip1": "🙈 בלתי נראים לכולם",
    "landing.goChip2": "💬 הכל פתוח ביניכם",
    "landing.goChip3": "🔄 ניתן לביטול בכל עת",
    "common.years": "שנים",
    "form.proposedDateTime": "תאריך ושעה מוצעים",
    "form.duration": "משך זמן (אופציונלי)",
    "form.proposedLocation": "מיקום מוצע",
    "form.messageOptional": "הודעה (אופציונלית)",
    "form.openEnded": "ללא הגבלת זמן",
    "form.writeMessage": "כתבו את הודעתכם...",
    "form.addPersonalMessage": "הוסיפו הודעה אישית...",
    "form.searchVenue": "חפשו את המקום המדויק או הכתובת...",
    "offerModal.selectDateType": "בחרו סוג דייט...",
    "offerModal.amountPlaceholder": "הזינו סכום (100-1000)",
    "offerModal.amountHint": "תשלמו סכום זה אם הדייט שלכם יאשר ({fee}% דמי שירות)",
    "offerModal.transportHint": "משולם יחד עם ההצעה שלכם ומועבר 100% לדייט שלכם לכיסוי הנסיעה (ללא דמי שירות).",
    "offerModal.durationHint": "כמה זמן תרצו שהדייט יארך — מגדיר ציפיות ברורות לשניכם.",
    "tour.subtitle": "נסיעת מבחן של 60 שניות — ללא כל חיוב",
    "tour.step1Title": "אמרו שלום בצ׳אט",
    "tour.step1Desc": "{name} כבר שלח/ה לכם הודעה — שלחו תשובה",
    "tour.step2Title": "בקשו פגישה",
    "tour.step2Desc": "חינם לגמרי — צפו כיצד זה מאושר",
    "tour.step3Title": "שלחו הצעת דייט פרימיום",
    "tour.step3DescSent": "נשלח! סמלצו את התשלום בדף ההצעות שלכם",
    "tour.step3Desc": "ללא קרדיטים, ללא כסף אמיתי — סימולציה מלאה",
    "tour.go": "קדימה",
    "tour.doneTitle": "שלטתם ב-LuxeMeet! 🎉",
    "tour.doneDesc": "צ׳אט, פגישות ודייטים פרימיום — ניסיתם הכל. עכשיו לכו למצוא את הדבר האמיתי.",
    "tour.browseReal": "עיינו בחברים אמיתיים",
    "common.freeTest": "ניסיון חינם",
    "discover.aiTestNote": "חבר מלווה לניסיון — צ׳אט, פגישות ודייטים פרימיום הם סימולציות חינמיות. ללא תשלום אמיתי, לעולם לא.",
    "discover.meetUp": "קבעו פגישה",
    "profile.msgTitle": "שלחו הודעה ל-{name}",
    "profile.msgCostPayer": "פתיחת שיחה עולה 10 קרדיטים, לאחר מכן 5 קרדיטים להודעה. תשובותיהם חינמיות עבורכם.",
    "profile.msgFree": "חינם עבורכם ב-{app} — הצ׳אט מגיע לתיבת הדואר שלהם ב-{app}, שם מענה עולה להם קרדיטים.",
    "profile.sendMessage": "שלח הודעה",
    "profile.meetupTitle": "בקש פגישה עם {name}",
    "profile.meetupCost": "בקשת פגישה עולה 25 קרדיטים.",
    "profile.meetupFree": "בחינם עבורך ב-{app} — הם יראו את זה בפגישות {app} שלהם.",
    "profile.meetupTest": "🧪 ריצת ניסיון חינמית — הבן/בת לוויה ה-AI שלך יקבל/תקבל אוטומטית כדי שתוכל לראות את התהליך המלא. לא יחויבו קרדיטים.",
    "profile.sendMeetup": "שלח בקשת פגישה",
    "profile.costsMsg": "הודעה: 10 קרדיטים (ראשונה) / 5 קרדיטים (תגובה)",
    "profile.costsMeetup": "בקשת פגישה: 25 קרדיטים",
    "offerModal.title": "שלח הצעת דייט פרימיום",
    "offerModal.desc": "שלח הצעת דייט עם תמורה כספית ל-{name}",
    "offerModal.testBanner": "🧪 ריצת ניסיון עם {name} — לא נדרש סלוט, והתשלום מדומה (לא יחויב לעולם).",
    "offerModal.needSlot": "עליך לרכוש סלוט פרימיום תחילה",
    "offerModal.purchaseSlot": "רכישת סלוט ($50)",
    "offerModal.slotsAvailable": "סלוטים זמינים: {n}",
    "offerModal.testNoSlot": "הצעת ניסיון — לא נדרש סלוט",
    "offerModal.repeatNoSlot": "דייט חוזר — לא נדרש סלוט",
    "offerModal.amount": "סכום ההצעה *",
    "offerModal.transport": "תוספת נסיעות (אופציונלי)",
    "offerModal.proposedDate": "תאריך מוצע *",
    "offerModal.proposedTime": "שעה מוצעת *",
    "offerModal.duration": "משך הזמן (אופציונלי)",
    "offerModal.location": "מיקום *",
    "offerModal.dateType": "סוג הדייט *",
    "offerModal.message": "הודעה (אופציונלי)",
    "offerModal.sendOffer": "שלח הצעה",
    "voucher.unlimitedActive": "הצעות דייט ללא הגבלה פעילות 🏆",
    "voucher.unlimitedUntil": "לא נדרשים סלוטים עד {date} — פריבילגיה של אלוף.",
    "voucher.championPrize": "פרס אלוף: שבועיים של הצעות ללא הגבלה",
    "voucher.giftFrom": "מתנה מ-{name}: שבועיים של הצעות ללא הגבלה",
    "voucher.activate": "הפעל את השבועיים שלי",
    "voucher.giftIt": "שלח כמתנה",
    "voucher.haveCode": "יש לך קוד מתנה?",
    "voucher.redeem": "מימוש",
    "voucher.giftsSent": "מתנות ששלחת",
    "ideas.near": "השראה לדייטים ליד",
    "ideas.plan": "תכנן את הדייט הזה",
    "ideas.popular": "מקומות דייט פופולריים בפלטפורמה",
    "ideas.map": "מפה",
    "ideas.cityTitle": "קבל רעיונות לדייט בעיר אחרת",
    "ideas.cityDesc": "מתכנן טיול או דייט במקום אחר? בחר כל עיר ונאצור עבורך רעיונות שם.",
    "ideas.show": "הצג רעיונות",
    "ideas.whoFor": "למי הדייט הזה מיועד?",
    "ideas.pickDesc": "בחר התאמה ואנחנו נמלא מראש את ההצעה הפרימיום שלך.",
    "ideas.emptyPrefix": "עדיין אין התאמות — הוסף למועדפים מישהו ב",
    "ideas.emptySuffix": "או התחל צ'אט קודם.",
    "profile.videos": "סרטונים",
  },
  es: {
    "nav.events": "Eventos",
    "leaderboard.youOnBoard": "🏆 ¡Estás en la clasificación!",
    "leaderboard.youOnBoardSub": "los miembros del otro lado te ven clasificado aquí. ¡Sigue brillando!",
    "events.title": "Eventos",
    "events.subtitle": "Eventos exclusivos para miembros — ven a conocernos en persona.",
    "events.empty": "No hay eventos próximos por ahora — ¡vuelve pronto!",
    "events.loading": "Cargando eventos…",
    "events.spotsLeft": "{n} plazas libres",
    "events.soldOut": "Agotado",
    "events.joinedChip": "¡Estás dentro!",
    "events.free": "Gratis",
    "events.feeNote": "${price} + $2 de tarifa de gestión",
    "events.payCredits": "Unirse con {n} créditos",
    "events.payPaypal": "Pagar con PayPal · ${total}",
    "events.joinFree": "Unirse gratis",
    "events.notEnough": "No tienes créditos suficientes — este evento cuesta {n} créditos",
    "events.joinedToast": "🎟️ ¡Estás dentro! Revisa tu correo para la confirmación.",
    "events.payCancelled": "Pago cancelado",
    "events.captureFail": "No pudimos confirmar tu pago — inténtalo de nuevo",
    "events.bannerTitle": "🎉 Próximo evento",
    "events.bannerCta": "Ver eventos",
    "notif.eventJoined.t": "🎟️ ¡Vas a ir!",
    "notif.eventJoined.b": "Tu plaza en \"{title}\" está confirmada. ¡Nos vemos allí!",
    "notif.eventCancelled.t": "😔 Evento cancelado",
    "notif.eventCancelled.b": "\"{title}\" fue cancelado. Si pagaste, tu reembolso está en camino.",
    "terms.contactT": "Contáctanos",
    "terms.contactP": "¿Preguntas, inquietudes o comentarios? Contáctanos en cualquier momento:",
    "msdluxe.tapSound": "Toca para el sonido",
    "msdluxe.badge": "Tu anfitriona IA",
    "msdluxe.title1": "Conoce a Ms DLuxe",
    "msdluxe.title2": "Ella te lo enseña todo",
    "msdluxe.desc": "La propia Ms DLuxe explica exactamente cómo funciona: créditos, ofertas de citas premium, ganancias y seguridad.",
    "msdluxe.luxeCard": "Cómo funciona LuxeMeet",
    "msdluxe.dluxeCard": "Cómo funciona DLuxe",
    "msdluxe.download": "Descargar",
    "msdluxe.share": "Guárdalos, publícalos o envíalos a un amigo — son tuyos para compartir.",
    "nav.msdluxeVideos": "Cómo funciona · Ms DLuxe",
    "credits.requestRefund": "Solicitar reembolso",
    "credits.refundRequested": "Reembolso solicitado",
    "credits.refunded": "Reembolsado",
    "credits.refundDeniedChip": "No aprobado",
    "credits.refundDialogTitle": "Solicitar un reembolso",
    "credits.refundDialogDesc": "Cuéntanos por qué quieres un reembolso por esta compra. Nuestro equipo revisa cada solicitud y recibirás una notificación y un correo con la decisión.",
    "credits.refundReasonPh": "¿Por qué quieres un reembolso?",
    "credits.refundSubmit": "Enviar solicitud",
    "credits.refundSent": "Solicitud de reembolso enviada — la revisaremos pronto",
    "safety.checkinToggle": "Registro de seguridad",
    "safety.checkinDesc": "Elige una hora — te preguntaremos si llegaste bien a casa. Si no respondes en 2 horas, tu amigo recibe una alerta.",
    "safety.checkinPast": "Elige una hora de registro en el futuro",
    "safety.checkinScheduled": "¡Enviado! Tu amigo tiene los detalles y tu registro de seguridad está programado.",
    "checkin.title": "¿Llegaste bien a casa?",
    "checkin.body": "Toca para confirmar — si no, {email} recibirá una alerta.",
    "checkin.confirmBtn": "Llegué bien a casa ✅",
    "checkin.confirmed": "¡Qué bueno que estés bien! Tu amigo ha sido notificado 💛",
    "notif.safetyCheckin.t": "🛟 ¿Llegaste bien a casa?",
    "notif.safetyCheckin.b": "Toca para confirmar que llegaste bien — si no, {email} recibirá una alerta en 2 horas.",
    "landing.freeCreditsPromo": "Los nuevos miembros reciben 50 créditos gratis — justo lo necesario para que un acompañante IA envíe una invitación de admirador secreto a tu crush en redes sociales.",
    "landing.langHighlight": "Disponible en 8 idiomas con traducción de chat integrada — conoce gente de todo el mundo.",
    "saPromo.title": "Tus créditos gratis te esperan",
    "saPromo.body": "Tienes {n} créditos — suficientes para que un acompañante IA envíe una invitación de admirador secreto a tu crush en redes sociales.",
    "saPromo.cta": "Enviar invitación de admirador secreto",
    "notif.refundApproved.t": "✅ Reembolso aprobado",
    "notif.refundApproved.b": "Tu reembolso por {desc} fue aprobado — tu cuenta ha sido ajustada. Revisa tu correo para más detalles.",
    "notif.refundDenied.t": "Actualización de tu solicitud de reembolso",
    "notif.refundDenied.b": "Tu solicitud de reembolso por {desc} fue revisada — revisa tu correo para más detalles.",
    "safety.share": "Compartir plan con un amigo",
    "safety.title": "Envía tu plan de cita a un amigo",
    "safety.desc": "Por tu seguridad, envía por correo tu itinerario y el perfil de tu cita a alguien de confianza.",
    "safety.emailPh": "amigo@email.com",
    "safety.notePh": "Nota opcional para tu amigo…",
    "safety.send": "Enviar",
    "safety.sent": "¡Enviado! Tu amigo tiene los detalles.",
    "discover.companionsTitle": "Conoce a los acompañantes IA",
    "incog.title": "Modo incógnito",
    "incog.desc": "Controla quién puede encontrar tu perfil mientras mantienes acceso completo a chats, ofertas y citas.",
    "incog.toggleLabel": "Ocultar mi perfil de Descubrir",
    "incog.toggleDesc": "Nadie puede encontrarte al navegar. Las conversaciones y ofertas existentes siguen funcionando.",
    "incog.on": "Modo incógnito ACTIVADO — estás oculto en Descubrir",
    "incog.off": "Vuelves a ser visible en Descubrir",
    "incog.hiddenFrom": "También estás oculto individualmente para {n} miembro(s) (mediante el botón del ojo en su perfil).",
    "ratep.title": "Privacidad de valoraciones de citas",
    "ratep.desc": "Elige si participas en las valoraciones de citas y qué se muestra en tu perfil.",
    "ratep.partLabel": "Participar en las valoraciones de citas",
    "ratep.partDesc": "Si está desactivado, nadie puede valorar tus citas y no se muestra ninguna valoración en tu perfil",
    "ratep.commentsLabel": "Mostrar reseñas escritas en mi perfil",
    "ratep.commentsDesc": "Si está desactivado, solo se muestra tu puntuación de estrellas — los comentarios escritos quedan privados",
    "ratep.saved": "Preferencias de valoración guardadas",
    "offers.planDate": "Planear una cita",
    "planDate.title": "Planea una cita con…",
    "planDate.desc": "Elige a cualquiera de la lista de miembros para enviarle una oferta de cita premium.",
    "planDate.search": "Buscar por nombre…",
    "planDate.empty": "No se encontraron miembros",
    "notif.promoRedeemed.t": "🎁 ¡Código promocional canjeado!",
    "notif.promoRedeemed.b": "Tu código {code} añadió {what} a tu cuenta. ¡Disfruta!",
    "notif.creditsGranted.t": "🎁 ¡Créditos añadidos!",
    "notif.creditsGranted.b": "El equipo de LuxeMeet añadió {n} créditos a tu cuenta.",
    "notif.slotGranted.t": "🎁 ¡Espacio de cita premium gratis!",
    "notif.slotGranted.b": "Recibiste {n} espacio(s) gratis de oferta de cita premium de $50 — ¡planea una cita desde la página de Ofertas!",
    "register.saRevealed": "💌 Tu admirador secreto ha sido revelado — ¡revisa tus notificaciones y tu chat!",
    "tour.replayTitle": "Tour de 60 segundos",
    "tour.replayDesc": "¿Te perdiste la visita guiada? Repítela cuando quieras con tu acompañante IA.",
    "tour.replayBtn": "Ver de nuevo",
    "notif.saReveal.t": "💌 ¡Admirador secreto revelado!",
    "notif.saReveal.b": "¡Era {admirer} todo este tiempo! {name} te dejó toda la historia en tu chat. Toca para ver su perfil.",
    "register.saBanner": "💌 Tu admirador secreto te espera — crea tu cuenta gratis para descubrir quién es.",
    "credits.earnerNote": "Chatear es gratis para ti en este modo — los créditos se usan para extras como las solicitudes de admirador secreto (50 créditos).",
    "si.trackJoined": "Se unió como {name} — ver perfil",
    "notif.siJoined.t": "🎉 ¡Ya está aquí!",
    "notif.siJoined.b": "{invitee} acaba de unirse gracias a tu invitación de admirador secreto a {handle}. ¡Ve a buscarle!",
    "si.trackTitle": "Tus solicitudes de admirador secreto",
    "si.trackLine": "{kind} para {handle} en {platform}",
    "si.trackVia": "vía {name}",
    "si.trackKindAdmirer": "Mensaje de admirador secreto",
    "si.trackKindDate": "Solicitud de cita",
    "si.trackPending": "Pendiente",
    "si.trackSent": "Enviado",
    "si.trackRefunded": "Reembolsado",
    "discover.boosted": "Impulsado",
    "discover.inDemand": "🔥 En demanda",
    "discover.diamond": "Diamante",
    "discover.verifiedBadge": "Verificado",
    "gal.addPhoto": "Añadir foto",
    "gal.addVideo": "Añadir video",
    "gal.videoIntros": "Videos de presentación ({n}/2)",
    "gal.videoRules": "Hasta 2 videos cortos (máx. 60s, 50MB). Revisados por IA — sin desnudos ni contenido sexual.",
    "gal.noPhotos": "Aún no hay fotos. ¡Añade tu primera foto para empezar!",
    "si.button": "Admirador secreto en redes",
    "si.title": "Admirador secreto vía {name}",
    "si.desc": "{name} enviará un mensaje de admirador secreto o una solicitud de cita a quien elijas en redes sociales — con una invitación a la app. Se envía en un plazo de 24 horas.",
    "si.typeLabel": "¿Qué se debe enviar?",
    "si.typeAdmirer": "Mensaje de admirador secreto",
    "si.typeDate": "Solicitud de cita",
    "si.platform": "Plataforma",
    "si.handle": "Su nombre de usuario",
    "si.note": "Toque personal (opcional)",
    "si.notePh": "¿Algo que {name} deba mencionar?",
    "si.submit": "Enviar solicitud ({n} créditos)",
    "si.success": "¡Solicitud en cola! Recibirás una notificación cuando {name} la haya enviado.",
    "si.errHandle": "Ingresa su usuario de redes sociales",
    "notif.siPending.t": "💌 ¡Solicitud recibida!",
    "notif.siPending.b": "{name} enviará tu {kind} a {handle} en {platform}. Se cobraron 50 créditos — te avisaremos cuando se envíe.",
    "notif.siSent.t": "💘 ¡Ya está enviado!",
    "notif.siSent.b": "{name} envió tu {kind} a {handle} en {platform}. ¡Crucemos los dedos!",
    "notif.siDeclined.t": "Solicitud reembolsada",
    "notif.siDeclined.b": "Tu {kind} vía {name} no se pudo enviar. Tus 50 créditos han sido reembolsados.",
    "notif.kindAdmirer": "mensaje de admirador secreto",
    "notif.kindDate": "solicitud de cita",
    "help.title": "Luxe Assistant",
    "help.subtitle": "Pregúntame lo que quieras sobre LuxeMeet",
    "help.hi": "¡Hola{name}! 👋",
    "help.welcome": "Puedo explicarte cómo funcionan los créditos, las ofertas de citas premium, el depósito en garantía, los códigos de confirmación y los pagos. ¿Qué te gustaría saber?",
    "help.thinking": "Luxe está pensando...",
    "help.inputPh": "Escribe tu pregunta...",
    "help.error": "Lo siento, tengo problemas en este momento. Inténtalo de nuevo en un momento.",
    "chat.translate": "Traducir",
    "chat.showOriginal": "Ver original",
    "chat.translating": "Traduciendo...",
    "chat.translateFail": "No se pudo traducir ahora",
    "chat.sentCredits": "Mensaje enviado ({n} créditos)",
    "chat.noCredits": "Créditos insuficientes",
    "chat.tapToUse": "{ai} — toca para usar",
    "chat.member": "Miembro de {app}",
    "land.newMatch": "¡Nuevo match!",
    "land.firstMove": "Da el primer paso",
    "land.dateTerms": "Citas a tu manera",
    "land.youChoose": "Tú eliges. Tú ofreces.",
    "land.startChatting": "Empieza a chatear ahora",
    "land.likes": "{n} me gusta",
    "land.thisWeek": "Esta semana",
    "promo.title": "Descubre qué lo hace especial",
    "promo.desc": "Un recorrido rápido por LuxeMeet y DLuxe — citas reales, ofertas premium y romance impulsado por IA.",
    "promo.tapSound": "Toca para el sonido",
    "promo.shareInvite": "Comparte el video — tu enlace de invitación está incluido 🎁",
    "promo.shareFriends": "Comparte el video con amigos",
    "promo.copiedInvite": "¡Enlace del video con tu código de invitación copiado!",
    "promo.copied": "¡Enlace del video copiado!",
    "promo.shareMsg": "🎬 Mira esto — LuxeMeet, la app de citas donde las citas reales sí ocurren.",
    "promo.joinInvite": "Únete con mi enlace de invitación:",
    "promo.shareTg": "🎬 Mira esto — la app de citas donde las citas reales sí ocurren",
    "promo.mute": "Silenciar la música",
    "promo.unmute": "Activar la música",
    "prof.back": "Volver",
    "prof.addPhotosHint": "Añade fotos para destacar",
    "prof.noPhotos": "{name} aún no ha añadido fotos",
    "prof.addPhotos": "Añadir fotos",
    "prof.aiCompanion": "Compañera IA",
    "prof.reviewOne": "reseña de cita",
    "prof.reviewMany": "reseñas de citas",
    "prof.bioEmptyOwn": "Tu biografía está vacía — un par de frases sobre ti marcan la diferencia.",
    "prof.bioEmptyOther": "{name} mantiene un aire de misterio — saluda para saber más.",
    "prof.afterDate": "— {name}, después de su cita",
    "prof.interests": "INTERESES",
    "prof.photos": "FOTOS",
    "prof.videos": "VIDEOS",
    "prof.thinking": "Pensando...",
    "prof.suggestOpener": "{ai}: sugiere una apertura",
    "prof.offerSent": "¡Oferta enviada! Revisa tu página de Ofertas para ver el estado.",
    "prof.tSuggestFail": "No se pudieron obtener sugerencias ahora",
    "prof.tRequestFail": "No se pudo enviar la solicitud",
    "prof.tFavAdded": "Añadido a favoritos ❤️",
    "prof.tFavRemoved": "Eliminado de favoritos",
    "prof.tFavFail": "Error al actualizar favoritos",
    "prof.tVisibilityFail": "Error al actualizar la visibilidad",
    "prof.tHidden": "Ahora estás oculto para {name} en Descubrir",
    "prof.tVisible": "Vuelves a ser visible para {name}",
    "prof.tLoadFail": "Error al cargar el perfil",
    "prof.tMsgEmpty": "Escribe un mensaje",
    "prof.tNoCredits": "Créditos insuficientes. Compra más créditos para continuar.",
    "prof.tMsgFail": "Error al enviar el mensaje",
    "prof.tMeetupMissing": "Completa la fecha y el lugar",
    "prof.tMeetupFail": "Error al enviar la solicitud de encuentro",
    "nb.title": "Notificaciones",
    "nb.empty": "Aún no hay notificaciones",
    "time.now": "ahora mismo",
    "time.m": "hace {n}m",
    "time.h": "hace {n}h",
    "time.d": "hace {n}d",
    "notif.photoVerified.t": "✅ ¡Estás verificado!",
    "notif.photoVerified.b": "Tu verificación por selfie fue aprobada — la insignia Verificado ya aparece en tu perfil.",
    "notif.relRequest.t": "💍 ¿Hacerlo oficial?",
    "notif.relRequest.b": "¡{name} quiere hacerlo oficial contigo! Acepta en Ajustes y ambos desaparecerán del feed de los demás.",
    "notif.relDeclined.t": "Solicitud de hacerlo oficial rechazada",
    "notif.relDeclined.b": "{name} aún no está listo para hacerlo oficial.",
    "notif.relActive.t": "💞 ¡Están oficialmente juntos!",
    "notif.relActive.b": "{name} dijo que SÍ. Ahora ambos están ocultos para los demás — la app es solo para ustedes dos.",
    "notif.relEnded.t": "Relación oficial terminada",
    "notif.relEnded.b": "{name} terminó la relación oficial. Ambos vuelven a ser visibles en la app.",
    "notif.dateReview.t": "{stars} ¡Nueva reseña de cita!",
    "notif.dateReview.b": "{name} calificó tu cita con {rating}/5. {comment}",
    "notif.escrow.t": "💰 ¡Pago de cita recibido!",
    "notif.escrow.b": "{name} pagó ${amount} por tu cita. ${payout} está retenido en depósito. Confirma la cita con su código de 6 dígitos para recibir el pago.",
    "notif.escrowBoost.t": "💰 ¡Pago de cita recibido!",
    "notif.escrowBoost.b": "{name} pagó ${amount} por tu cita. ${payout} está retenido en depósito — ¡incluye tu bono de referido del 90%! Confirma la cita con su código de 6 dígitos para recibir el pago.",
    "notif.offerPaid.t": "💘 ¡Cita reservada!",
    "notif.offerPaid.b": "Tu pago por la cita con {name} está confirmado. Tu código de confirmación de 6 dígitos está listo en la página de Ofertas — compártelo con tu cita después.",
    "notif.refSlot.t": "🎁 ¡Slot premium gratis ganado!",
    "notif.refSlot.b": "{name}, a quien invitaste, acaba de comprar un slot premium — ¡recibiste un slot de $50 GRATIS como recompensa!",
    "notif.boostActivated.t": "🚀 ¡Perfil potenciado!",
    "notif.boostActivated.b": "Tu perfil ahora aparece destacado en la parte superior de Descubrir durante las próximas 24 horas.",
    "notif.creditsAdded.t": "🪙 ¡Créditos añadidos!",
    "notif.creditsAdded.b": "{credits} créditos de tu compra {package} ya están en tu cuenta. Nuevo saldo: {balance}.",
    "notif.unlimited.t": "♾️ ¡Ofertas ilimitadas activadas!",
    "notif.unlimited.b": "Tu premio de campeón está activo — ¡envía ofertas de cita ilimitadas (sin necesidad de slots) durante las próximas 2 semanas!",
    "notif.voucherGifted.t": "🎁 ¡Recibiste un vale de campeón!",
    "notif.voucherGifted.b": "{name} te regaló 2 semanas de ofertas de cita ilimitadas — actívalo en Ajustes antes del {date}.",
    "notif.voucherRedeemed.t": "🎁 ¡Tu regalo fue reclamado!",
    "notif.voucherRedeemed.b": "{name} canjeó el vale de campeón que le regalaste.",
    "notif.refBoost.t": "🎁 ¡Recompensa de referido desbloqueada!",
    "notif.refBoost.b": "{name}, a quien invitaste, completó su primera cita premium — ¡tu PRÓXIMA cita con ganancias paga el 90% en vez del 80%!",
    "notif.payoutProcessing.t": "✅ ¡Cita confirmada!",
    "notif.payoutProcessing.b": "Tu pago de ${amount} está en proceso y llegará a tu PayPal en 24-48 horas.",
    "notif.offerExpiredSender.t": "⏰ Oferta de cita expirada",
    "notif.offerExpiredSender.b": "Tu oferta de cita de ${amount} expiró tras 7 días. Tu slot premium ha sido liberado para que puedas enviar una nueva oferta.",
    "notif.offerExpiredRecipient.t": "⏰ Oferta de cita expirada",
    "notif.offerExpiredRecipient.b": "Una oferta de cita que aceptaste expiró porque el pago no se completó en 7 días.",
    "notif.dateReminder24.t": "💜 Recordatorio: ¡cita mañana!",
    "notif.dateReminder24.b": "Tu cita con {name} es mañana — {when}, {where}.",
    "notif.offerExpiringPay.t": "⏳ ¡La oferta expira en 24 horas!",
    "notif.offerExpiringPay.b": "Tu oferta de cita de ${amount} para {name} expira mañana — completa el pago antes de que desaparezca y se libere tu slot.",
    "notif.offerExpiringWait.t": "⏳ ¡La oferta expira en 24 horas!",
    "notif.offerExpiringWait.b": "Tu oferta de cita de ${amount} para {name} expira mañana — espera su respuesta o insiste antes de que desaparezca y se libere tu slot.",
    "notif.matchInsights.t": "💌 Tus estadísticas semanales de matches",
    "notif.matchInsights.b": "{views} visitas a tu perfil y {favs} nuevos favoritos esta semana — incluyendo a {names}. ¡Saluda o potencia tu perfil para provocar una oferta de cita!",
    "notif.streak1.t": "🔥 Progreso de racha: {streak}/3",
    "notif.streak1.b": "¡Una cita más de 4★+ y 150 créditos gratis son tuyos!",
    "notif.streakN.t": "🔥 Progreso de racha: {streak}/3",
    "notif.streakN.b": "{togo} citas más de 4★+ para desbloquear 150 créditos gratis.",
    "notif.streakDone.t": "🔥 Progreso de racha: {streak}/3",
    "notif.streakDone.b": "¡Tu recompensa está en camino!",
    "notif.rankUp.t": "🏆 Eres el #{rank} en el ranking de Mejor Valorados",
    "notif.rankUp.b": "Eres el #{rank} en el ranking de Mejor Valorados. 📈 ¡Subiste {spots} puestos desde la semana pasada! El #1 mensual gana 2 semanas de ofertas de cita ilimitadas.",
    "notif.rankDown.t": "🏆 Eres el #{rank} en el ranking de Mejor Valorados",
    "notif.rankDown.b": "Eres el #{rank} en el ranking de Mejor Valorados. 📉 Bajaste {spots} puestos desde la semana pasada — una gran cita te devuelve arriba. El #1 mensual gana 2 semanas de ofertas de cita ilimitadas.",
    "notif.rankSteady.t": "🏆 Eres el #{rank} en el ranking de Mejor Valorados",
    "notif.rankSteady.b": "Eres el #{rank} en el ranking de Mejor Valorados. 🎯 Te mantienes estable desde la semana pasada. El #1 mensual gana 2 semanas de ofertas de cita ilimitadas.",
    "notif.rankNew.t": "🏆 Eres el #{rank} en el ranking de Mejor Valorados",
    "notif.rankNew.b": "🎉 NUEVO: ¡entraste al ranking de Mejor Valorados en el puesto #{rank}! El #1 mensual gana 2 semanas de ofertas de cita ilimitadas.",
    "notif.rankOff.t": "🏆 Actualización del ranking",
    "notif.rankOff.b": "Saliste del ranking de Mejor Valorados esta semana — una gran cita te devuelve al ranking. El #1 mensual gana 2 semanas de ofertas de cita ilimitadas.",
    "notif.boostEnded.t": "⚡ Tu boost ha terminado",
    "notif.boostEnded.b": "Tu boost de 24 horas ha terminado. Te consiguió {views} visitas al perfil. ¡Potencia de nuevo desde la página Descubrir para mantenerte arriba!",
    "notif.boostEndedExtra.t": "⚡ Tu boost ha terminado",
    "notif.boostEndedExtra.b": "Tu boost de 24 horas ha terminado. Te consiguió {views} visitas al perfil — unas {extra} más que un día normal. ¡Potencia de nuevo desde la página Descubrir para mantenerte arriba!",
    "notif.dateSoon1h.t": "⏰ ¡Tu cita empieza pronto!",
    "notif.dateSoon1h.b": "Tu cita con {name} es en menos de una hora — {time} en {location}.{tip}",
    "notif.dateSoon24.t": "💜 ¡Tu cita es en 24 horas!",
    "notif.dateSoon24.b": "Tu cita con {name} es en 24 horas — {time} en {location}.{tip}",
    "notif.dateSoonTip": " ¡Abre tu oferta para ver la cuenta regresiva en vivo, el clima y consejos de atuendo!",
    "notif.badgeFire.t": "🔥 ¡Estás en llamas!",
    "notif.badgeFire.b": "Eres uno de los 3 hombres más contactados en DLuxe este mes — la insignia 🔥 ya aparece en tu perfil.",
    "notif.hotStreak.t": "🔥 ¡Racha caliente! 150 créditos GRATIS",
    "notif.hotStreak.b": "3 citas muy bien valoradas seguidas — el paquete Popular de 150 créditos se añadió GRATIS a tu cuenta. ¡Mantén viva la racha!",
    "notif.badgeDiamond.t": "💎 ¡Insignia de diamante ganada!",
    "notif.badgeDiamond.b": "Completaste 3 citas premium de $500+ — la insignia de Diamante ya brilla en tu perfil.",
    "notif.champion.t": "🏆 ¡Campeón del ranking!",
    "notif.champion.b": "¡Terminaste #1 en '{section}' este mes! Premios: un boost de perfil de 7 días GRATIS (ya activo) y un vale de 2 semanas de ofertas de cita ILIMITADAS — actívalo en Ajustes en cualquier momento durante los próximos 6 meses.",
    "notif.anniversary.t": "💞 ¡{months} {monthsWord} juntos!",
    "notif.anniversary.b": "Tú y {name} acaban de cumplir {months} {monthsWord} oficiales. Celébrenlo — idea: {idea}",
    "notif.monthWord": "mes",
    "notif.monthsWord": "meses",
    "notif.annIdea0": "Recreen su primera cita — mismo lugar, mismo pedido, nuevos recuerdos.",
    "notif.annIdea1": "Cocinen juntos una cena de tres platos a la luz de las velas, sin teléfonos.",
    "notif.annIdea2": "Picnic al atardecer con los snacks favoritos de cada uno y una playlist compartida.",
    "notif.annIdea3": "Reserven una hora de spa en pareja y brinden con algo espumoso después.",
    "notif.annIdea4": "Hagan un mini viaje por carretera a un pueblo que ninguno haya visitado.",
    "notif.annIdea5": "Noche de estrellas: mantas, chocolate caliente y su canción en repetición.",
    "notif.annIdea6": "Clase de baile para dos — salsa, bachata o lo que los haga reír.",
    "notif.annIdea7": "Cita en museo o galería, y luego postre en un lugar elegante.",
    "notif.annIdea8": "Escríbanse una carta sobre su momento favorito hasta ahora e intercámbienlas en la cena.",
    "notif.annIdea9": "Reserva para cenar en una azotea o terraza — vístanse como en la primera cita.",
    "notif.annIdea10": "Cata de vino o chocolate seguida de un paseo tranquilo a casa.",
    "notif.annIdea11": "Planeen juntos su viaje soñado con desayuno en la cama — y reserven una parte de él.",
    "notif.companionInvite.t": "💌 ¡{name} tiene tu sorpresa!",
    "notif.companionInvite.b": "Tu invitación misteriosa ha sido revelada en tu chat.",
    "notif.supportResolved.t": "✅ Solicitud de soporte resuelta",
    "notif.supportResolved.b": "Tu {label} \"{subject}\" ha sido revisada y resuelta.",
    "notif.supportResolvedResp.t": "✅ Solicitud de soporte resuelta",
    "notif.supportResolvedResp.b": "Tu {label} \"{subject}\" ha sido revisada y resuelta. Respuesta: {resp}",
    "notif.labelRefund": "solicitud de reembolso",
    "notif.labelComplaint": "queja",
    "notif.testMeetup.t": "¡{name} aceptó tu encuentro! 🎉",
    "notif.testMeetup.b": "Prueba completada — así se ve exactamente cuando un miembro real acepta. No se cobraron créditos.",
    "notif.testCounter.t": "{name} envió una contraoferta 💬",
    "notif.testCounter.b": "Prueba: contraofertó ${amount}. Acepta o rechaza para continuar el flujo — sigue sin haber dinero real.",
    "notif.testOfferAccepted.t": "¡{name} aceptó tu oferta de cita! 💜",
    "notif.testOfferAccepted.b": "Prueba: pulsa el botón Simular Pago en la página de Ofertas para ver el resto del flujo — sin dinero real.",
    "notif.testDateCompleted.t": "¡Cita de prueba con {name} completada! 🏆",
    "notif.testDateCompleted.b": "Ese fue el ciclo completo de una cita premium — oferta, aceptación, pago, código y confirmación. No se movió dinero real. ¿Listo para probarlo con un miembro real?",
    "notif.refChat.t": "🎁 ¡+{credits} créditos ganados!",
    "notif.refChat.b": "{name} acaba de empezar a chatear — {credits} créditos de bono añadidos a tu saldo.",
    "notif.payoutSent.t": "💸 ¡Pago enviado!",
    "notif.payoutSent.b": "${amount} ha sido enviado a tu PayPal ({recipient}).",
    "notif.favVerified.t": "✅ ¡{name} ya está verificado!",
    "notif.favVerified.b": "{name}, de tus favoritos, acaba de pasar la verificación por selfie y ganó la insignia Verificado.",
    "notif.favReviewed.t": "⭐ ¡{name} recibió una gran reseña!",
    "notif.favReviewed.b": "{name}, de tus favoritos, acaba de recibir una reseña de cita de {rating} estrellas. ¡Las buenas citas se reservan rápido!",
    "notif.favBoosted.t": "⚡ ¡{name} acaba de potenciarse!",
    "notif.favBoosted.b": "{name}, de tus favoritos, aparece destacado ahora mismo en la parte superior de Descubrir — ¡saluda mientras está en el centro de atención!",
    "register.newMembers": "Los nuevos miembros reciben",
    "register.promoLuxe1": "50 créditos gratis",
    "register.promoDluxe1": "Acceso gratis + Ganancias",
    "register.promoLuxe2": "Para las damas que se unen a LuxeMeet",
    "register.promoDluxe2": "Los caballeros se unen a DLuxe gratis — y ganan con citas premium",
    "register.googleTerms": "Al continuar con Google, aceptas nuestros",
    "register.googleTermsLink": "Términos y Condiciones",
    "register.orEmail": "o regístrate con correo",
    "register.hintF": "Mujeres: gratis en LuxeMeet (50 créditos iniciales) — o toma la iniciativa en DLuxe con ofertas de citas premium para hombres.",
    "register.hintM": "Hombres: invierte para conectar en LuxeMeet — y disfruta de acceso gratis + gana con citas premium en DLuxe.",
    "register.hintNone": "Selecciona tu género para ver las funciones disponibles",
    "register.refCode": "Código de referido",
    "register.refOptional": "(opcional)",
    "register.refPh": "¿Tienes un código? Ingrésalo aquí",
    "register.terms18": "Tengo 18 años o más y acepto los",
    "register.termsLink": "Términos y Condiciones y la Exención de Responsabilidad",
    "register.create": "Crear cuenta",
    "register.haveAccount": "¿Ya tienes una cuenta?",
    "register.errGender": "Por favor selecciona tu género",
    "register.errTerms": "Acepta los Términos y Condiciones para continuar",
    "register.errFail": "El registro falló",
    "register.giftClaimed": "😕 Este código de regalo ({code}) ya fue reclamado.",
    "register.giftExpired": "😕 Este código de regalo ({code}) ha expirado.",
    "register.giftReady": "🎁 {name} te regaló un vale de campeón ({code}) — ¡se añadirá a tu cuenta justo después de registrarte!",
    "register.giftFriend": "Un amigo",
    "set.tImgFile": "Selecciona un archivo de imagen",
    "set.tImgSize": "La imagen debe pesar menos de 5MB",
    "set.tPhotoUpdated": "¡Foto de perfil actualizada!",
    "set.tPhotoFail": "Error al subir la foto",
    "set.tPwMismatch": "Las nuevas contraseñas no coinciden",
    "set.tPwShort": "La contraseña debe tener al menos 6 caracteres",
    "set.tPwChanged": "¡Contraseña cambiada con éxito!",
    "set.tPwFail": "Error al cambiar la contraseña",
    "set.tProfileUpdated": "¡Perfil actualizado!",
    "set.tProfileFail": "Error al actualizar el perfil",
    "set.tLoggedOut": "Sesión cerrada con éxito",
    "set.tDeactivated": "Cuenta desactivada. Vuelve a iniciar sesión en un plazo de 30 días para reactivarla.",
    "set.tDeleteFail": "Error al eliminar la cuenta",
    "pp.errInvalidEmail": "Ingresa un correo electrónico válido",
    "pp.errNoMatch": "Los correos no coinciden",
    "pp.errConfirm": "Confirma tu correo de PayPal",
    "pp.errFix": "Corrige los errores antes de guardar",
    "pp.savedOk": "¡Configuración de PayPal guardada y verificada!",
    "pp.saveFail": "Error al guardar la configuración",
    "pp.errImg": "Sube un archivo de imagen",
    "pp.errSize": "El archivo debe pesar menos de 5MB",
    "pp.qrUploaded": "¡Código QR subido!",
    "pp.qrFail": "Error al subir el código QR",
    "terms.title": "Términos y Condiciones",
    "terms.updated": "Incluye la Exención de Responsabilidad — Última actualización: junio de 2026 (v5)",
    "terms.back": "Volver",
    "terms.footer": "© 2026 LuxeMeet & DLuxe. Todos los derechos reservados.",
    "terms.s1t": "1. Aceptación de los Términos",
    "terms.s1p1": "Al crear una cuenta o usar LuxeMeet o su modo complementario DLuxe (en conjunto, \"la Plataforma\"), aceptas quedar vinculado por estos Términos y Condiciones y nuestra Exención de Responsabilidad. Si no estás de acuerdo, no uses la Plataforma.",
    "terms.s2t": "2. Elegibilidad (18+)",
    "terms.s2p1": "Debes tener al menos 18 años para usar LuxeMeet. Al registrarte, declaras y garantizas que tienes 18 años o más y que puedes celebrar legalmente este acuerdo. Las cuentas que pertenezcan a menores serán canceladas de inmediato sin reembolso.",
    "terms.s3t": "3. Naturaleza del Servicio",
    "terms.s3p1": "LuxeMeet es únicamente una plataforma de presentación. Proporcionamos herramientas para que adultos se conozcan, se envíen mensajes y organicen citas. No somos parte de ninguna interacción, conversación, cita o acuerdo entre miembros. No realizamos verificaciones de antecedentes penales y no ofrecemos garantías sobre la identidad, conducta, intenciones o compatibilidad de ningún miembro.",
    "terms.s3p2": "La Plataforma puede mostrar enlaces a servicios independientes de terceros para ayudar a planear citas — como OpenStreetMap y Google Maps para ubicaciones, Uber para transporte y Airbnb Experiences para ideas de citas. Estos servicios no son operados por nosotros; su uso se rige por sus propios términos y no somos responsables de su contenido, precios o disponibilidad.",
    "terms.s4t": "4. Créditos, Pagos y Ofertas de Citas Premium",
    "terms.s4p1": "Los miembros masculinos compran créditos para enviar mensajes y solicitar encuentros, slots de oferta premium para enviar ofertas de citas y boosts de perfil opcionales. Todos los pagos son procesados por PayPal. Los precios se muestran en el momento de la compra y pueden incluir una tarifa de gestión.",
    "terms.s4p2": "En las Ofertas de Citas Premium, el monto ofrecido queda retenido en depósito una vez pagado. Cuando la cita tiene lugar y el destinatario introduce el código de confirmación de 6 dígitos del pagador, el pago (menos la comisión de la plataforma) se libera al destinatario. La comisión de la plataforma se indica en la app. Citas repetidas: cuando un pagador reserva una nueva cita con alguien con quien ya completó una cita a través de la Plataforma, no se requiere slot premium y se aplica una comisión reducida del 10% (el destinatario recibe el 90% del monto ofrecido). Las asignaciones de transporte opcionales se pagan junto con la oferta y se transfieren al 100% al destinatario. Las ofertas de cita canceladas se eliminan automáticamente del historial 48 horas después de la cancelación. Vales de campeón: los vales de recompensa obtenidos en el ranking mensual de Mejores Miembros pueden regalarse una vez a otra persona mediante un código de regalo de un solo uso; una vez regalado, el vale no puede ser usado ni recuperado por el titular original, y los vales recibidos como regalo no pueden volver a regalarse. Los vales no tienen valor en efectivo.",
    "terms.s4p3": "Reembolsos: los créditos, slots y boosts no son reembolsables una vez entregados. Los pagos de citas en depósito solo son reembolsables si la cita no ocurre y la oferta se cancela o expira según las reglas de la plataforma. Los pagos deben realizarse desde una cuenta de PayPal cuyo correo coincida con tu correo de inicio de sesión en LuxeMeet; los pagos desde correos que no coincidan pueden retrasarse o ser irrecuperables. Puedes enviar una solicitud de reembolso o una queja en cualquier momento desde Ajustes → Reembolsos y Quejas (o \"Ayuda y Soporte\" en el menú de la app); cada solicitud es revisada por nuestro equipo y se te notificará el resultado en la app y por correo.",
    "terms.s5t": "5. Exención de Responsabilidad y Asunción de Riesgo",
    "terms.s5p1": "ACEPTAS EXPRESAMENTE QUE REUNIRTE EN PERSONA CON OTRO MIEMBRO ES COMPLETAMENTE BAJO TU PROPIO RIESGO. En la máxima medida permitida por la ley, liberas, exoneras y mantienes indemne a LuxeMeet, sus propietarios, operadores, empleados y afiliados de todas las reclamaciones, demandas, daños, lesiones, pérdidas o causas de acción — conocidas o desconocidas — que surjan de o se relacionen con tu uso de la Plataforma, tus interacciones o comunicaciones con otros miembros y cualquier encuentro o cita en persona organizada a través de la Plataforma, incluyendo sin limitación lesiones personales, angustia emocional, daños a la propiedad, robo, fraude o pérdida financiera.",
    "terms.s5p2": "Eres el único responsable de tu propia seguridad. Recomendamos encarecidamente reunirse en lugares públicos, avisar a un amigo adónde vas, organizar tu propio transporte y nunca compartir información financiera con otros miembros.",
    "terms.s6t": "6. Conducta de los Miembros",
    "terms.s6p1": "Aceptas no: falsear tu identidad o edad; acosar, abusar o dañar a otros miembros; solicitar dinero a miembros fuera del sistema de ofertas de la Plataforma; usar la Plataforma para fines comerciales, ilegales o de explotación (incluidos servicios de acompañantes o trata de personas); publicar contenido explícito, ofensivo o infractor; ni intentar eludir los sistemas de pago de la Plataforma.",
    "terms.s6p2": "Política de contenido: las fotos y videos de perfil no deben contener desnudos ni contenido sexualmente explícito o sugerente. Todas las fotos y videos subidos son examinados automáticamente por IA antes de su publicación y el contenido prohibido es rechazado. Los intentos repetidos de subir contenido prohibido pueden resultar en medidas sobre la cuenta.",
    "terms.s6p3": "La infracción puede resultar en suspensión o cancelación inmediata sin reembolso, y remisión a las autoridades cuando corresponda.",
    "terms.s7t": "7. Calificaciones de Citas, Reseñas y Favoritos",
    "terms.s7p1": "Después de una cita premium completada, ambos participantes pueden calificar la cita (1-5 estrellas) con un comentario escrito opcional. La participación en las calificaciones es opcional: puedes desactivarla por completo en Ajustes, en cuyo caso nadie puede calificar tus citas y no aparece ninguna calificación en tu perfil. Si participas, puedes elegir por separado si los comentarios escritos se muestran públicamente junto con tu calificación de estrellas.",
    "terms.s7p2": "Las reseñas deben ser honestas, respetuosas y basadas en una cita real. Las reseñas difamatorias, acosadoras o falsas pueden ser eliminadas y pueden resultar en medidas sobre la cuenta. Los miembros también pueden guardar otros perfiles en una lista privada de Favoritos; tus favoritos solo son visibles para ti. Si agregas a un miembro a favoritos, puedes recibir notificaciones sobre la actividad pública de su perfil (como boosts, verificación o nuevas reseñas).",
    "terms.s8t": "8. Funciones de IA",
    "terms.s8p1": "La Plataforma ofrece funciones opcionales impulsadas por IA, incluidos los asistentes de escritura \"AI Wingman\" (para miembros masculinos) y \"AI Cupid\" (para miembros femeninos) — que pueden redactar aperturas y respuestas de chat, notas de ofertas de citas premium, mensajes de contraoferta, mensajes de solicitud de encuentro y comentarios de reseñas de citas — el asistente de ayuda \"Luxe\" en la app, ideas de citas seleccionadas por IA, sugerencias de atuendo del estilista IA mostradas en la cuenta regresiva de la cita, estadísticas semanales de matches asistidas por IA, fotos de perfil asistidas por IA y verificación de fotos basada en selfies con IA. La IA también se usa para examinar automáticamente todas las fotos y videos de galería subidos en busca de contenido prohibido (desnudos y contenido sexual) antes de su publicación. El contenido de IA se genera automáticamente y puede ser inexacto. Eres responsable de cualquier contenido que envíes o publiques, incluido el contenido asistido por IA. Las fotos de perfil deben representarte fielmente; usar imágenes de IA que tergiversen materialmente tu apariencia puede resultar en medidas sobre la cuenta. Los selfies de verificación se usan únicamente para la verificación y nunca se muestran públicamente.",
    "terms.s9t": "9. Limitación de Responsabilidad",
    "terms.s9p1": "EN LA MÁXIMA MEDIDA PERMITIDA POR LA LEY, LUXEMEET NO SERÁ RESPONSABLE DE NINGÚN DAÑO INDIRECTO, INCIDENTAL, ESPECIAL, CONSECUENTE O PUNITIVO, NI DE NINGUNA PÉRDIDA DE BENEFICIOS O DATOS, DERIVADOS DE TU USO DE LA PLATAFORMA. NUESTRA RESPONSABILIDAD TOTAL AGREGADA POR CUALQUIER RECLAMACIÓN NO EXCEDERÁ EL MONTO QUE PAGASTE A LUXEMEET EN LOS SEIS (6) MESES ANTERIORES A LA RECLAMACIÓN.",
    "terms.s10t": "10. Privacidad",
    "terms.s10p1": "Recopilamos y procesamos información de cuenta, mensajes, registros de pago y datos de uso para operar la Plataforma, procesar pagos y retiros, prevenir fraudes y mejorar el servicio. Los recuentos de visitas al perfil se registran para las analíticas de boost. Puedes activar el Modo Incógnito en Ajustes para ocultar tu perfil de la navegación en Descubrir — globalmente o de miembros específicos — mientras tus conversaciones, ofertas y encuentros existentes siguen funcionando. No vendemos tus datos personales. Podemos enviar correos con fines de cuenta, pago e interacción.",
    "terms.s11t": "11. Cancelación y Eliminación de Cuenta",
    "terms.s11p1": "Eliminar tu cuenta: puedes eliminar tu cuenta en cualquier momento desde Ajustes → Zona de Peligro. Tu perfil se oculta de inmediato de Descubrir, rankings y favoritos. Se aplica un período de gracia de 30 días: iniciar sesión de nuevo dentro de 30 días reactiva completamente tu cuenta. Después de 30 días, tu cuenta y datos personales (perfil, fotos, videos, mensajes, favoritos y notificaciones) se borran o anonimizan de forma permanente e irreversible. Los créditos, slots, boosts no usados y cualquier saldo no retirado se pierden con el borrado permanente. Los registros necesarios para el cumplimiento financiero y legal (como registros de pagos completados) pueden conservarse de forma anonimizada.",
    "terms.s11p2": "Podemos suspender o cancelar cuentas que violen estos Términos. Los créditos, slots y boosts no usados se pierden en caso de cancelación por causa justificada.",
    "terms.s12t": "12. Cambios en estos Términos",
    "terms.s12p1": "Podemos actualizar estos Términos ocasionalmente. El uso continuado de la Plataforma después de que los cambios entren en vigor constituye la aceptación de los Términos revisados.",
    "terms.s13t": "13. Modo DLuxe",
    "terms.s13p1": "La Plataforma incluye un modo complementario, \"DLuxe\", accesible mediante el interruptor de corazón en la app. DLuxe refleja LuxeMeet con los roles de pago invertidos: las miembros femeninas pagan por las interacciones (créditos, slots de oferta premium, boosts y ofertas monetarias de citas) y los miembros masculinos pueden recibir pagos por ofertas de citas. Todos los Términos se aplican por igual a ambos modos, con disposiciones específicas de rol aplicándose a quien paga o recibe el pago en el modo activo. Se usa una sola cuenta en ambos modos. Las conversaciones y solicitudes de encuentro están separadas por modo: las interacciones iniciadas en LuxeMeet siguen las reglas de pago de LuxeMeet (pagan los hombres) y las iniciadas en DLuxe siguen las reglas de DLuxe (pagan las mujeres). Cambiar de modo solo cambia qué bandeja de entrada se muestra y nunca cambia quién paga dentro de una conversación existente. Todas las funciones de la Plataforma — incluidos los asistentes de IA, rankings, recompensas de campeón y regalo de vales — están disponibles en ambos modos con la marca correspondiente.",
    "terms.s14t": "14. Contacto",
    "terms.s14p1": "¿Preguntas sobre estos Términos? Usa el asistente de Ayuda en la app. Para solicitudes de reembolso y quejas, usa Ajustes → Reembolsos y Quejas (o \"Ayuda y Soporte\" en el menú de la app) — cada envío es revisado y respondido.",
    "landing.badge": "Experiencia de citas premium",
    "landing.heroLuxe1": "Donde la calidad",
    "landing.heroLuxe2": "encuentra la conexión",
    "landing.heroDluxe1": "Donde las mujeres",
    "landing.heroDluxe2": "toman la iniciativa",
    "landing.taglineLuxe": "Una plataforma de citas exclusiva donde se valoran las conexiones auténticas. Los caballeros invierten créditos para conectar, garantizando interés genuino e interacciones de calidad.",
    "landing.taglineDluxe": "Una plataforma de citas exclusiva donde las mujeres audaces dan el primer paso. Ellas invierten créditos para conectar con hombres excepcionales, garantizando interés genuino e interacciones de calidad.",
    "landing.startJourney": "Comienza tu aventura",
    "landing.haveAccount": "Ya tengo cuenta",
    "landing.watchFilm": "Ver la película",
    "auth.signIn": "Iniciar sesión",
    "auth.getStarted": "Empezar",
    "login.welcomeBack": "Bienvenido de nuevo",
    "login.subtitle": "Inicia sesión para continuar tu aventura",
    "login.google": "Continuar con Google",
    "login.orEmail": "o continúa con tu correo",
    "login.email": "Correo electrónico",
    "login.password": "Contraseña",
    "login.emailPh": "Introduce tu correo",
    "login.passwordPh": "Introduce tu contraseña",
    "login.forgot": "¿Olvidaste tu contraseña?",
    "login.noAccount": "¿No tienes cuenta?",
    "login.createOne": "Crea una",
    "login.backHome": "Volver al inicio",
    "register.title": "Crea tu cuenta",
    "register.subtitle": "Comienza tu camino hacia conexiones auténticas",
    "register.fullName": "Nombre completo",
    "register.namePh": "Introduce tu nombre",
    "register.passwordPh": "Crea una contraseña",
    "register.iAmA": "Soy",
    "register.man": "Hombre",
    "register.woman": "Mujer",
    "nav.discover": "Descubrir",
    "nav.favorites": "Favoritos",
    "nav.chat": "Chat",
    "nav.offers": "Ofertas",
    "nav.meetups": "Citas",
    "nav.top": "Top",
    "nav.credits": "Créditos",
    "nav.earnings": "Ganancias",
    "nav.settings": "Ajustes",
    "nav.watchTour": "Ver el tour",
    "nav.helpSupport": "Ayuda y soporte",
    "discover.title": "Descubrir",
    "discover.subtitle": "Encuentra tu pareja ideal",
    "discover.newest": "Nuevos",
    "discover.topRated": "Mejor valorados",
    "discover.sendOffer": "Enviar oferta de cita premium",
    "discover.message": "Mensaje",
    "discover.aiCompanion": "Compañía IA",
    "discover.videoIntro": "Video",
    "settings.countryLanguage": "País e idioma",
    "settings.country": "País",
    "settings.language": "Idioma",
    "settings.currency": "Moneda",
    "settings.currencyNote": "Los precios se muestran de forma aproximada en tu moneda; los pagos se procesan en USD.",
    "settings.refunds": "Reembolsos y quejas",
    "settings.changePassword": "Cambiar contraseña",
    "settings.logout": "Cerrar sesión",
    "settings.dangerZone": "Zona de peligro",
    "settings.deleteAccount": "Eliminar mi cuenta",
    "credits.billedUsd": "facturado en USD",
    "common.accept": "Aceptar",
    "common.decline": "Rechazar",
    "common.pending": "Pendiente",
    "common.accepted": "Aceptada",
    "common.declined": "Rechazada",
    "common.received": "Recibidas",
    "common.sent": "Enviadas",
    "common.yourBalance": "Tu saldo",
    "common.back": "Atrás",
    "common.cancel": "Cancelar",
    "common.credits": "Créditos",
    "common.viewMap": "Ver mapa",
    "common.getUber": "Pedir un Uber",
    "common.hours": "horas",
    "chat.title": "Mensajes",
    "chat.empty": "Aún no hay conversaciones",
    "chat.emptySub": "¡Conecta con personas para empezar a chatear!",
    "chat.discoverProfiles": "Descubrir perfiles",
    "chat.typeMessage": "Escribe un mensaje...",
    "chat.inbox": "Bandeja",
    "chat.noMessages": "Aún no hay mensajes. ¡Inicia la conversación!",
    "chat.startConvo": "¡Inicia la conversación!",
    "chat.costStart": "Iniciar un chat cuesta 10 créditos",
    "chat.costMessage": "Enviar un mensaje cuesta 5 créditos",
    "chat.inboxBadge": "Bandeja {app}",
    "common.testRun": "Prueba",
    "offers.simulatePayment": "Simular pago (prueba)",
    "offers.title": "Ofertas de citas premium",
    "offers.dateOffers": "Ofertas de citas",
    "offers.slots": "Tus cupos de ofertas",
    "offers.available": "Disponibles",
    "offers.inUse": "En uso",
    "offers.consumed": "Consumidos",
    "offers.sentOffers": "Tus ofertas enviadas",
    "offers.none": "Aún no hay ofertas",
    "offers.noneSent": "Aún no has enviado ofertas",
    "offers.reviewRespond": "Revisa y responde a tus ofertas de citas premium",
    "offers.subtitlePayer": "Compra cupos para enviar ofertas de citas premium a tus matches",
    "offers.slotDesc": "$50 por cupo • Reutilizable hasta que se acepte una oferta",
    "offers.buySlot": "Comprar cupo",
    "offers.noneDesc": "Aún no has recibido ofertas de citas",
    "offers.noneSentDesc": "Compra un cupo y envía tu primera oferta de cita premium",
    "offers.buyFirstSlot": "Compra tu primer cupo",
    "offers.respond": "Responder",
    "offers.cancelOffer": "Cancelar oferta",
    "offers.viewCounter": "Ver contraoferta",
    "offers.rateDate": "Calificar esta cita",
    "offers.dateDetails": "Detalles y reseñas de la cita",
    "status.pending": "Pendiente",
    "status.paymentNeeded": "Pago requerido",
    "status.awaitingConfirmation": "Esperando confirmación",
    "status.countered": "Contraoferta",
    "status.confirmed": "Confirmada",
    "status.completed": "Completada",
    "status.declined": "Rechazada",
    "status.expired": "Expirada",
    "status.cancelled": "Cancelada",
    "meetups.title": "Solicitudes de cita",
    "meetups.none": "Aún no hay solicitudes",
    "meetups.noneSent": "No has enviado solicitudes",
    "meetups.received": "Recibidas",
    "meetups.sent": "Enviadas",
    "meetups.noneDesc": "Las solicitudes de cita de otros aparecerán aquí.",
    "meetups.noneSentDesc": "¡Encuentra a alguien que te gustaría conocer!",
    "meetups.browse": "Explorar perfiles",
    "favorites.title": "Favoritos",
    "favorites.subtitle": "Perfiles que has guardado",
    "favorites.none": "Aún no tienes favoritos",
    "favorites.noneDesc": "Toca el corazón en un perfil que te encante y se guardará aquí.",
    "favorites.browse": "Explorar Descubrir",
    "leaderboard.title": "Miembros top",
    "leaderboard.you": "Tú",
    "leaderboard.subtitle": "Los miembros más solicitados, mejor valorados y más generosos de la plataforma. Gana insignias para reclamar tu lugar.",
    "leaderboard.prizeNote": "El #1 mensual de cada sección gana un boost gratis de 7 días + 2 semanas de ofertas de citas ilimitadas.",
    "leaderboard.empty": "Aún no hay miembros con insignias: ¡completa citas geniales para ser el primero!",
    "leaderboard.loading": "Cargando la clasificación...",
    "leaderboard.fireTitle": "Los más solicitados en DLuxe",
    "leaderboard.fireSub": "Los 3 hombres más contactados en DLuxe este mes",
    "leaderboard.diamondTitle": "Miembros Diamante",
    "leaderboard.diamondSub": "Completaron 3+ citas premium de $500 o más",
    "leaderboard.ratedTitle": "Mejor valorados",
    "leaderboard.ratedSub": "Las mejores calificaciones de citas reales",
    "leaderboard.shareBadge": "Compartir insignia",
    "leaderboard.datesCompleted": "citas premium completadas",
    "earnings.title": "Mis ganancias",
    "earnings.escrow": "En depósito",
    "earnings.total": "Total ganado",
    "earnings.dates": "Citas realizadas",
    "earnings.history": "Historial de pagos",
    "earnings.none": "Aún no hay ganancias",
    "credits.costs": "Costos en créditos",
    "credits.startChat": "Iniciar un chat nuevo",
    "credits.sendMessage": "Enviar un mensaje",
    "credits.requestMeetup": "Solicitar una cita",
    "credits.buy": "Comprar créditos",
    "credits.history": "Historial de compras",
    "credits.noHistory": "Aún no hay compras",
    "credits.completePayment": "Completar pago",
    "credits.allSet": "¡Todo listo!",
    "credits.freeLuxe": "Como mujer en LuxeMeet, disfrutas de acceso gratuito a los mensajes y todas las funciones.",
    "credits.freeDluxe": "Como hombre en DLuxe, disfrutas de acceso gratuito a los mensajes y todas las funciones.",
    "credits.bestValue": "Mejor valor",
    "credits.continuePayment": "Continuar al pago",
    "credits.processing": "Procesando...",
    "profile.message": "Mensaje",
    "profile.requestMeetup": "Solicitar cita",
    "tour.tryWith": "Pruébalo con",
    "settings.title": "Ajustes",
    "settings.photoHint": "Toca la cámara para cambiar tu foto",
    "settings.profileInfo": "Información del perfil",
    "settings.displayName": "Nombre visible",
    "settings.age": "Edad",
    "settings.location": "Ubicación",
    "settings.locationPh": "Ciudad, País",
    "settings.bio": "Biografía",
    "settings.bioPh": "Cuéntales a los demás sobre ti...",
    "settings.interests": "Intereses",
    "settings.interestsPh": "Viajes, Música, Comida (separados por comas)",
    "settings.interestsHint": "Separa los intereses con comas",
    "settings.saveChanges": "Guardar cambios",
    "settings.paypalTitle": "Ajustes de pago de PayPal",
    "settings.paypalDesc": "Añade tus datos de PayPal para recibir los pagos de las ofertas de cita aceptadas",
    "settings.dangerDesc": "Eliminar tu cuenta oculta tu perfil de inmediato. ¿Cambias de opinión? Vuelve a iniciar sesión en un plazo de 30 días para reactivarla — después, tu cuenta y datos personales se borran permanentemente y los créditos o saldos no usados se pierden.",
    "settings.deleteTitle": "¿Eliminar tu cuenta?",
    "settings.deleteB1": "Tu perfil se oculta de inmediato para todos",
    "settings.deleteB2": "Vuelve a iniciar sesión en 30 días para reactivarla",
    "settings.deleteB3": "Después de 30 días todo se borra permanentemente — fotos, mensajes y cualquier crédito o saldo no usado",
    "settings.confirmPasswordLabel": "Confirma tu contraseña",
    "settings.googleBlank": "¿Te registraste con Google? Déjalo en blanco.",
    "settings.deactivateDelete": "Desactivar y eliminar",
    "settings.currentPassword": "Contraseña actual",
    "settings.newPassword": "Nueva contraseña",
    "settings.confirmNewPassword": "Confirmar nueva contraseña",
    "ref.title": "Invita y gana",
    "ref.desc": "Comparte tu enlace de invitación. Ganas 25 créditos extra en cuanto un amigo que invitaste empieza a chatear. Además: cuando un referido compra su primer cupo premium recibes un cupo de $50 GRATIS — y cuando un referido completa su primera cita premium, tu SIGUIENTE cita pagada te da el 90% en vez del 80%.",
    "ref.friendsReferred": "Amigos referidos",
    "ref.bonusCredits": "Créditos extra ganados",
    "ref.freeSlots": "Cupos gratis ganados",
    "ref.boosts": "Boosts del 90% disponibles",
    "ref.yourReferrals": "Tus referidos",
    "ref.stJoined": "Se unió",
    "ref.stChatting": "Empezó a chatear ✓ (+25 créditos)",
    "ref.stDate": "Completó una cita ✓",
    "ref.stSlot": "Compró un cupo ✓",
    "ref.topReferrers": "Mejores embajadores del mes",
    "ref.referralsWord": "referidos",
    "ref.copied": "¡Enlace de invitación copiado!",
    "share.inviteMsg": "Únete a mí en {app} — la app de citas premium donde las citas reales sí ocurren. Regístrate con mi enlace:",
    "share.dreamMsg": "💘 ¡Estás invitado a una cita de ensueño! Únete a mí en {app} y planeemos la cita perfecta:",
    "share.inviteBtn": "Invitar a un amigo",
    "share.dreamBtn": "💘 Invitación a cita de ensueño",
    "share.hint": "Escribe tu propio mensaje o déjalo en blanco para usar la plantilla — tu enlace se añade automáticamente.",
    "share.copied": "Mensaje de invitación copiado — ¡pégalo donde quieras!",
    "landing.whyTitle": "¿Por qué elegir {app}?",
    "landing.whySub": "Nuestro sistema de créditos garantiza que cada interacción sea significativa e intencional.",
    "landing.f1Title": "Conexiones de calidad",
    "landing.f1Desc": "Los créditos garantizan interés genuino. Sin spam, sin bots — solo personas reales buscando conexiones reales.",
    "landing.f2Title": "Experiencia premium",
    "landing.f2DescLuxe": "Ellas disfrutan de acceso gratis mientras ellos invierten en conversaciones significativas y solicitudes de encuentro.",
    "landing.f2DescDluxe": "Ellos disfrutan de acceso gratis mientras ellas invierten en conversaciones significativas y ofertas de citas premium.",
    "landing.f3Title": "Perfiles verificados",
    "landing.f3Desc": "Todos los perfiles se verifican para garantizar autenticidad. Conoce gente real, crea conexiones reales.",
    "landing.refBadge": "Recomienda y gana",
    "landing.refTitle1": "Invita amigos,",
    "landing.refTitle2": "desbloquea recompensas",
    "landing.refDesc1": "Cada miembro tiene un enlace de invitación personal. Compártelo con tus amigos y gana un",
    "landing.refDescBold": "cupo premium de $50 GRATIS",
    "landing.refDesc2": "más funciones extra exclusivas cuando se unen y se activan.",
    "landing.refCard1Title": "Cupo premium de $50 GRATIS",
    "landing.refCard1Desc": "Ganado por cada amigo que se une y se activa",
    "landing.refCard2Title": "Funciones extra",
    "landing.refCard2Desc": "Ventajas exclusivas reservadas para los mejores embajadores",
    "landing.refCta": "Únete y consigue tu enlace",
    "landing.ctaTitle": "¿Listo para encontrar a tu media naranja?",
    "landing.ctaSub": "Únete a miles de solteros que han encontrado conexiones significativas en {app}.",
    "landing.ctaBtn": "Crear cuenta gratis",
    "landing.footerTerms": "Términos y condiciones",
    "pp.balance": "Saldo disponible",
    "pp.balanceNote": "De ofertas de cita aceptadas (pago del 80% tras la comisión de la plataforma)",
    "pp.email": "Email de PayPal *",
    "pp.emailHint": "Aquí es donde enviaremos tus pagos",
    "pp.confirmEmail": "Confirmar email de PayPal *",
    "pp.confirmPh": "Vuelve a escribir tu email",
    "pp.emailsMatch": "Los emails coinciden",
    "pp.verified": "Verificado",
    "pp.username": "Usuario de PayPal (opcional)",
    "pp.qr": "Código QR de PayPal (opcional)",
    "pp.qrUpload": "Subir código QR",
    "pp.qrHint": "Sube tu código QR de pago de PayPal para transferencias fáciles",
    "pp.save": "Guardar y verificar ajustes de PayPal",
    "pp.howTitle": "ℹ️ Cómo funcionan los pagos",
    "pp.how1": "Los miembros envían ofertas de cita con montos ($100-$1000)",
    "pp.how2": "Cuando aceptas y pagan, recibes el 80% (la plataforma retiene el 20%)",
    "pp.how3": "Los pagos se procesan a tu email de PayPal en 3-5 días hábiles",
    "pp.how4": "Tu saldo se actualiza después de cada cita confirmada",
    "rel.title": "Relación oficial",
    "rel.activeWith": "💞 Oficialmente juntos con {name}",
    "rel.activeSince": "Desde {date} — ambos están ocultos para todos los demás.",
    "rel.chat": "Chatear",
    "rel.planDate": "Planear una cita",
    "rel.end": "Terminar la relación",
    "rel.incomingTitle": "💍 ¡{name} quiere hacerlo oficial contigo!",
    "rel.incomingDesc": "Acepta y ambos desaparecerán del feed de los demás — la app será solo para ustedes dos.",
    "rel.accept": "Aceptar 💞",
    "rel.decline": "Aún no",
    "rel.waitingFor": "⏳ Esperando a {name}",
    "rel.waitingDesc": "Tu solicitud de relación oficial está pendiente de respuesta.",
    "rel.cancelRequest": "Cancelar solicitud",
    "rel.endTitle": "¿Terminar la relación oficial?",
    "rel.endDesc": "Tú y {name} volverán a ser visibles para todos y podrán ver otros miembros. Sus chats e historial se conservan.",
    "rel.keepIt": "Mantenerla",
    "rel.goOfficial": "Hacerlo oficial — ocúltanos de todos los demás",
    "rel.requestSent": "⏳ Solicitud enviada — esperando a {name}",
    "rel.togetherSince": "💞 Oficialmente juntos desde {date}",
    "rel.together": "💞 Oficialmente juntos",
    "rel.coupleTitle": "💞 Están oficialmente juntos",
    "rel.coupleDesc": "Tú y {name} están ocultos para todos los demás. La app es solo para ustedes dos — chat, quedadas y citas premium.",
    "rel.coupleHint": "¿Cambio de planes? Cualquiera de los dos puede terminarlo en Ajustes.",
    "rel.toastSent": "💍 ¡Solicitud enviada a {name}!",
    "rel.toastTogether": "💞 ¡Tú y {name} están oficialmente juntos!",
    "rel.toastEnded": "Relación terminada — vuelves a ser visible en la app",
    "rel.toastPrivate": "Este miembro está en una relación oficial 💞",
    "rel.toastActive": "Estás en una relación oficial — la app es solo para ustedes dos 💞",
    "invite.admirerTitle": "Tienes un admirador secreto 💘",
    "invite.dreamTitle": "{name} guarda una invitación a una cita de ensueño para ti",
    "invite.admirerSub": "{name} tiene un mensaje de un admirador secreto esperándote — pero permanece sellado hasta que te unas.",
    "invite.dreamSub": "Alguien planeó algo especial — los detalles están sellados hasta que te unas.",
    "invite.lock": "Regístrate gratis para desbloquear tu sorpresa",
    "invite.claimedNote": "Esta invitación ya fue revelada. ¡Únete igualmente y descubre quién te espera!",
    "invite.reveal": "Revelar mi sorpresa",
    "invite.login": "¿Ya eres miembro? Inicia sesión",
    "invite.expired": "Esta invitación ha expirado",
    "invite.explore": "Explorar LuxeMeet",
    "landing.goBadge": "Hecho para finales reales",
    "landing.goTitle1": "Cuando va en serio,",
    "landing.goTitle2": "Háganlo oficial 💞",
    "landing.goDesc": "¿Encontraste a tu persona? Con un toque, ambos desaparecen del feed de los demás — sin perfiles, sin mensajes, sin distracciones. La app será solo para ustedes dos: chat privado, quedadas y citas premium. Y si algo cambia, cualquiera puede desactivarlo en cualquier momento.",
    "landing.goChip1": "🙈 Invisibles para los demás",
    "landing.goChip2": "💬 Todo sigue abierto entre ustedes dos",
    "landing.goChip3": "🔄 Reversible en cualquier momento",
    "common.years": "años",
    "form.proposedDateTime": "Fecha y hora propuestas",
    "form.duration": "Duración (opcional)",
    "form.proposedLocation": "Lugar propuesto",
    "form.messageOptional": "Mensaje (opcional)",
    "form.openEnded": "Sin límite",
    "form.writeMessage": "Escribe tu mensaje...",
    "form.addPersonalMessage": "Añade un mensaje personal...",
    "form.searchVenue": "Busca el lugar o la dirección exacta...",
    "offerModal.selectDateType": "Selecciona el tipo de cita...",
    "offerModal.amountPlaceholder": "Introduce el monto (100-1000)",
    "offerModal.amountHint": "Pagarás este monto si tu cita acepta (se aplica {fee}% de comisión)",
    "offerModal.transportHint": "Se paga junto con tu oferta y se entrega 100% a tu cita para el transporte (sin comisión).",
    "offerModal.durationHint": "Cuánto quieres que dure la cita — deja las expectativas claras para ambos.",
    "tour.subtitle": "Una prueba de 60 segundos — nunca se cobra nada",
    "tour.step1Title": "Saluda en el chat",
    "tour.step1Desc": "{name} ya te escribió — envía una respuesta",
    "tour.step2Title": "Solicita una cita",
    "tour.step2Desc": "Totalmente gratis — mira cómo la acepta",
    "tour.step3Title": "Envía una oferta de cita premium",
    "tour.step3DescSent": "¡Enviada! Simula el pago en tu página de Ofertas",
    "tour.step3Desc": "Sin cupo, sin dinero real — simulación completa",
    "tour.go": "Ir",
    "tour.doneTitle": "¡Dominaste LuxeMeet! 🎉",
    "tour.doneDesc": "Chat, citas y ofertas premium — lo probaste todo. Ahora ve a por lo real.",
    "tour.browseReal": "Explorar miembros reales",
    "common.freeTest": "Prueba gratis",
    "discover.aiTestNote": "Compañía de prueba — chat, citas y ofertas premium son simulaciones GRATIS. Nunca hay pagos reales.",
    "discover.meetUp": "Quedar",
    "profile.msgTitle": "Envía un mensaje a {name}",
    "profile.msgCostPayer": "Iniciar una conversación cuesta 10 créditos, luego 5 créditos por mensaje. Sus respuestas son gratis.",
    "profile.msgFree": "Gratis para ti en {app} — este chat llega a su bandeja de {app}, donde responder le cuesta créditos.",
    "profile.sendMessage": "Enviar mensaje",
    "profile.meetupTitle": "Solicita una cita con {name}",
    "profile.meetupCost": "Solicitar una cita cuesta 25 créditos.",
    "profile.meetupFree": "Gratis para ti en {app} — lo verá en sus citas de {app}.",
    "profile.meetupTest": "🧪 Prueba gratis — tu compañía IA aceptará automáticamente para que veas todo el proceso. Sin créditos.",
    "profile.sendMeetup": "Enviar solicitud de cita",
    "profile.costsMsg": "Mensaje: 10 créditos (primero) / 5 créditos (respuesta)",
    "profile.costsMeetup": "Solicitud de cita: 25 créditos",
    "offerModal.title": "Enviar oferta de cita premium",
    "offerModal.desc": "Envía una oferta económica de cita a {name}",
    "offerModal.testBanner": "🧪 Prueba con {name} — sin cupo, y el pago es simulado (nunca se cobra).",
    "offerModal.needSlot": "Primero necesitas comprar un cupo premium",
    "offerModal.purchaseSlot": "Comprar cupo ($50)",
    "offerModal.slotsAvailable": "Cupos disponibles: {n}",
    "offerModal.testNoSlot": "Oferta de prueba — sin cupo",
    "offerModal.repeatNoSlot": "Cita repetida — sin cupo",
    "offerModal.amount": "Monto de la oferta *",
    "offerModal.transport": "Transporte (opcional)",
    "offerModal.proposedDate": "Fecha propuesta *",
    "offerModal.proposedTime": "Hora propuesta *",
    "offerModal.duration": "Duración (opcional)",
    "offerModal.location": "Lugar *",
    "offerModal.dateType": "Tipo de cita *",
    "offerModal.message": "Mensaje (opcional)",
    "offerModal.sendOffer": "Enviar oferta",
    "voucher.unlimitedActive": "Ofertas de citas ilimitadas activas 🏆",
    "voucher.unlimitedUntil": "Sin cupos necesarios hasta {date} — privilegio de campeón.",
    "voucher.championPrize": "Premio de campeón: 2 semanas de ofertas ilimitadas",
    "voucher.giftFrom": "Regalo de {name}: 2 semanas de ofertas ilimitadas",
    "voucher.activate": "Activar mis 2 semanas",
    "voucher.giftIt": "Regalar",
    "voucher.haveCode": "¿Tienes un código de regalo?",
    "voucher.redeem": "Canjear",
    "voucher.giftsSent": "Regalos enviados",
    "ideas.near": "Inspiración para citas cerca de",
    "ideas.plan": "Planear esta cita",
    "ideas.popular": "Lugares de cita populares en la plataforma",
    "ideas.map": "Mapa",
    "ideas.cityTitle": "Ideas de citas para otra ciudad",
    "ideas.cityDesc": "¿Planeas un viaje o una cita en otro lugar? Elige una ciudad y seleccionaremos ideas allí.",
    "ideas.show": "Mostrar ideas",
    "ideas.whoFor": "¿Para quién es esta cita?",
    "ideas.pickDesc": "elige un match y pre-rellenaremos tu oferta premium.",
    "ideas.emptyPrefix": "Aún sin matches — marca a alguien como favorito en",
    "ideas.emptySuffix": "o inicia un chat primero.",
    "profile.videos": "VIDEOS",
  },
  fr: {
    "nav.events": "Événements",
    "leaderboard.youOnBoard": "🏆 Vous êtes au classement !",
    "leaderboard.youOnBoardSub": "les membres de l'autre côté vous voient classé ici. Continuez à briller !",
    "events.title": "Événements",
    "events.subtitle": "Événements exclusifs pour les membres — rencontrez-vous dans la vraie vie.",
    "events.empty": "Aucun événement à venir pour le moment — revenez bientôt !",
    "events.loading": "Chargement des événements…",
    "events.spotsLeft": "{n} places restantes",
    "events.soldOut": "Complet",
    "events.joinedChip": "Vous y êtes !",
    "events.free": "Gratuit",
    "events.feeNote": "{price} $ + 2 $ de frais de traitement",
    "events.payCredits": "Rejoindre avec {n} crédits",
    "events.payPaypal": "Payer avec PayPal · {total} $",
    "events.joinFree": "Rejoindre gratuitement",
    "events.notEnough": "Crédits insuffisants — cet événement coûte {n} crédits",
    "events.joinedToast": "🎟️ Vous y êtes ! Vérifiez votre e-mail pour la confirmation.",
    "events.payCancelled": "Paiement annulé",
    "events.captureFail": "Nous n'avons pas pu confirmer votre paiement — veuillez réessayer",
    "events.bannerTitle": "🎉 Événement à venir",
    "events.bannerCta": "Voir les événements",
    "notif.eventJoined.t": "🎟️ Vous y allez !",
    "notif.eventJoined.b": "Votre place pour « {title} » est confirmée. À bientôt !",
    "notif.eventCancelled.t": "😔 Événement annulé",
    "notif.eventCancelled.b": "« {title} » a été annulé. Si vous avez payé, votre remboursement est en cours.",
    "terms.contactT": "Nous contacter",
    "terms.contactP": "Des questions, des préoccupations ou des commentaires ? Contactez-nous à tout moment :",
    "msdluxe.tapSound": "Touchez pour le son",
    "msdluxe.badge": "Votre hôtesse IA",
    "msdluxe.title1": "Rencontrez Ms DLuxe",
    "msdluxe.title2": "Elle vous fait visiter",
    "msdluxe.desc": "Ms DLuxe explique elle-même exactement comment ça marche : crédits, offres de rendez-vous premium, gains et sécurité.",
    "msdluxe.luxeCard": "Comment fonctionne LuxeMeet",
    "msdluxe.dluxeCard": "Comment fonctionne DLuxe",
    "msdluxe.download": "Télécharger",
    "msdluxe.share": "Enregistrez-les, publiez-les, envoyez-les à un ami — ils sont à vous.",
    "nav.msdluxeVideos": "Comment ça marche · Ms DLuxe",
    "credits.requestRefund": "Demander un remboursement",
    "credits.refundRequested": "Remboursement demandé",
    "credits.refunded": "Remboursé",
    "credits.refundDeniedChip": "Non approuvé",
    "credits.refundDialogTitle": "Demander un remboursement",
    "credits.refundDialogDesc": "Dites-nous pourquoi vous souhaitez un remboursement pour cet achat. Notre équipe examine chaque demande et vous recevrez une notification et un e-mail avec la décision.",
    "credits.refundReasonPh": "Pourquoi souhaitez-vous un remboursement ?",
    "credits.refundSubmit": "Envoyer la demande",
    "credits.refundSent": "Demande de remboursement envoyée — nous l'examinerons sous peu",
    "safety.checkinToggle": "Vérification de sécurité",
    "safety.checkinDesc": "Choisissez une heure — nous vous demanderons si vous êtes bien rentré(e). Sans réponse sous 2 heures, votre ami reçoit une alerte.",
    "safety.checkinPast": "Choisissez une heure de vérification dans le futur",
    "safety.checkinScheduled": "Envoyé ! Votre ami a les détails et votre vérification de sécurité est programmée.",
    "checkin.title": "Êtes-vous bien rentré(e) ?",
    "checkin.body": "Appuyez pour confirmer — sinon {email} recevra une alerte.",
    "checkin.confirmBtn": "Je suis bien rentré(e) ✅",
    "checkin.confirmed": "Ravi que vous soyez en sécurité ! Votre ami a été prévenu 💛",
    "notif.safetyCheckin.t": "🛟 Êtes-vous bien rentré(e) ?",
    "notif.safetyCheckin.b": "Appuyez pour confirmer que vous êtes bien rentré(e) — sinon {email} recevra une alerte dans 2 heures.",
    "landing.freeCreditsPromo": "Les nouveaux membres reçoivent 50 crédits gratuits — exactement ce qu'il faut pour qu'un compagnon IA envoie une invitation d'admirateur secret à votre crush sur les réseaux sociaux.",
    "landing.langHighlight": "Disponible en 8 langues avec traduction du chat intégrée — rencontrez des gens du monde entier.",
    "saPromo.title": "Vos crédits gratuits vous attendent",
    "saPromo.body": "Vous avez {n} crédits — assez pour qu'un compagnon IA envoie une invitation d'admirateur secret à votre crush sur les réseaux sociaux.",
    "saPromo.cta": "Envoyer une invitation d'admirateur secret",
    "notif.refundApproved.t": "✅ Remboursement approuvé",
    "notif.refundApproved.b": "Votre remboursement pour {desc} a été approuvé — votre compte a été ajusté. Consultez votre e-mail pour les détails.",
    "notif.refundDenied.t": "Mise à jour de votre demande de remboursement",
    "notif.refundDenied.b": "Votre demande de remboursement pour {desc} a été examinée — consultez votre e-mail pour les détails.",
    "safety.share": "Partager le plan avec un ami",
    "safety.title": "Envoyez votre plan de rendez-vous à un ami",
    "safety.desc": "Pour votre sécurité, envoyez par e-mail votre itinéraire et le profil de votre rendez-vous à une personne de confiance.",
    "safety.emailPh": "ami@email.com",
    "safety.notePh": "Note facultative pour votre ami…",
    "safety.send": "Envoyer",
    "safety.sent": "Envoyé ! Votre ami a les détails.",
    "discover.companionsTitle": "Rencontrez les compagnons IA",
    "incog.title": "Mode incognito",
    "incog.desc": "Contrôlez qui peut trouver votre profil tout en gardant un accès complet aux chats, offres et rencontres.",
    "incog.toggleLabel": "Masquer mon profil de Découvrir",
    "incog.toggleDesc": "Personne ne peut vous trouver en naviguant. Les conversations et offres existantes continuent de fonctionner.",
    "incog.on": "Mode incognito ACTIVÉ — vous êtes masqué de Découvrir",
    "incog.off": "Vous êtes à nouveau visible dans Découvrir",
    "incog.hiddenFrom": "Vous êtes aussi masqué individuellement pour {n} membre(s) (via le bouton œil sur leur profil).",
    "ratep.title": "Confidentialité des évaluations de rendez-vous",
    "ratep.desc": "Choisissez si vous participez aux évaluations de rendez-vous et ce qui apparaît sur votre profil.",
    "ratep.partLabel": "Participer aux évaluations de rendez-vous",
    "ratep.partDesc": "Si désactivé, personne ne peut évaluer vos rendez-vous et aucune note n'apparaît sur votre profil",
    "ratep.commentsLabel": "Afficher les avis écrits sur mon profil",
    "ratep.commentsDesc": "Si désactivé, seule votre note en étoiles est affichée — les commentaires écrits restent privés",
    "ratep.saved": "Préférences d'évaluation enregistrées",
    "offers.planDate": "Planifier un rendez-vous",
    "planDate.title": "Planifiez un rendez-vous avec…",
    "planDate.desc": "Choisissez n'importe qui dans la liste des membres pour lui envoyer une offre de rendez-vous premium.",
    "planDate.search": "Rechercher par nom…",
    "planDate.empty": "Aucun membre trouvé",
    "notif.promoRedeemed.t": "🎁 Code promo utilisé !",
    "notif.promoRedeemed.b": "Votre code {code} a ajouté {what} à votre compte. Profitez-en !",
    "notif.creditsGranted.t": "🎁 Crédits ajoutés !",
    "notif.creditsGranted.b": "L'équipe LuxeMeet a ajouté {n} crédits à votre compte.",
    "notif.slotGranted.t": "🎁 Créneau de rendez-vous premium offert !",
    "notif.slotGranted.b": "Vous avez reçu {n} créneau(x) gratuit(s) d'offre de rendez-vous premium de 50 $ — planifiez un rendez-vous depuis la page Offres !",
    "register.saRevealed": "💌 Votre admirateur secret est révélé — consultez vos notifications et votre chat !",
    "tour.replayTitle": "Visite de 60 secondes",
    "tour.replayDesc": "Vous avez manqué la visite guidée ? Rejouez-la à tout moment avec votre compagnon IA.",
    "tour.replayBtn": "Revoir",
    "notif.saReveal.t": "💌 Admirateur secret révélé !",
    "notif.saReveal.b": "C'était {admirer} depuis le début ! {name} vous a laissé toute l'histoire dans votre chat. Touchez pour voir son profil.",
    "register.saBanner": "💌 Votre admirateur secret vous attend — créez votre compte gratuit pour découvrir qui c'est.",
    "credits.earnerNote": "Discuter est gratuit pour vous dans ce mode — les crédits servent aux extras comme les demandes d'admirateur secret (50 crédits).",
    "si.trackJoined": "Inscrit·e sous {name} — voir le profil",
    "notif.siJoined.t": "🎉 Il/elle est là !",
    "notif.siJoined.b": "{invitee} vient de s'inscrire grâce à votre invitation d'admirateur secret à {handle}. Allez le/la retrouver !",
    "si.trackTitle": "Vos demandes d'admirateur secret",
    "si.trackLine": "{kind} pour {handle} sur {platform}",
    "si.trackVia": "via {name}",
    "si.trackKindAdmirer": "Message d'admirateur secret",
    "si.trackKindDate": "Demande de rendez-vous",
    "si.trackPending": "En attente",
    "si.trackSent": "Envoyé",
    "si.trackRefunded": "Remboursé",
    "discover.boosted": "Boosté",
    "discover.inDemand": "🔥 Très demandé",
    "discover.diamond": "Diamant",
    "discover.verifiedBadge": "Vérifié",
    "gal.addPhoto": "Ajouter une photo",
    "gal.addVideo": "Ajouter une vidéo",
    "gal.videoIntros": "Vidéos d'intro ({n}/2)",
    "gal.videoRules": "Jusqu'à 2 courtes vidéos (max 60s, 50 Mo). Filtrées par IA — pas de nudité ni de contenu sexuel.",
    "gal.noPhotos": "Pas encore de photos. Ajoutez votre première photo pour commencer !",
    "si.button": "Admirateur secret sur les réseaux",
    "si.title": "Admirateur secret via {name}",
    "si.desc": "{name} enverra un message d'admirateur secret ou une demande de rendez-vous à la personne de votre choix sur les réseaux sociaux — avec une invitation à l'appli. Envoyé sous 24 heures.",
    "si.typeLabel": "Que faut-il envoyer ?",
    "si.typeAdmirer": "Message d'admirateur secret",
    "si.typeDate": "Demande de rendez-vous",
    "si.platform": "Plateforme",
    "si.handle": "Son nom d'utilisateur",
    "si.note": "Touche personnelle (facultatif)",
    "si.notePh": "Une chose que {name} devrait mentionner ?",
    "si.submit": "Envoyer la demande ({n} crédits)",
    "si.success": "Demande enregistrée ! Vous serez notifié dès que {name} l'aura envoyée.",
    "si.errHandle": "Veuillez saisir son identifiant sur les réseaux",
    "notif.siPending.t": "💌 Demande reçue !",
    "notif.siPending.b": "{name} enverra votre {kind} à {handle} sur {platform}. 50 crédits ont été débités — vous serez notifié dès l'envoi.",
    "notif.siSent.t": "💘 C'est envoyé !",
    "notif.siSent.b": "{name} a envoyé votre {kind} à {handle} sur {platform}. Croisons les doigts !",
    "notif.siDeclined.t": "Demande remboursée",
    "notif.siDeclined.b": "Votre {kind} via {name} n'a pas pu être envoyé. Vos 50 crédits ont été remboursés.",
    "notif.kindAdmirer": "message d'admirateur secret",
    "notif.kindDate": "demande de rendez-vous",
    "help.title": "Luxe Assistant",
    "help.subtitle": "Posez-moi vos questions sur LuxeMeet",
    "help.hi": "Salut{name} ! 👋",
    "help.welcome": "Je peux vous expliquer comment fonctionnent les crédits, les offres de rendez-vous premium, le séquestre, les codes de confirmation et les versements. Que souhaitez-vous savoir ?",
    "help.thinking": "Luxe réfléchit...",
    "help.inputPh": "Écrivez votre question...",
    "help.error": "Désolé, je rencontre un problème pour le moment. Veuillez réessayer dans un instant.",
    "chat.translate": "Traduire",
    "chat.showOriginal": "Voir l'original",
    "chat.translating": "Traduction...",
    "chat.translateFail": "Impossible de traduire pour le moment",
    "chat.sentCredits": "Message envoyé ({n} crédits)",
    "chat.noCredits": "Crédits insuffisants",
    "chat.tapToUse": "{ai} — touchez pour utiliser",
    "chat.member": "Membre {app}",
    "land.newMatch": "Nouveau match !",
    "land.firstMove": "Faites le premier pas",
    "land.dateTerms": "Des rendez-vous selon vos règles",
    "land.youChoose": "Vous choisissez. Vous offrez.",
    "land.startChatting": "Commencez à discuter maintenant",
    "land.likes": "{n} J'aime",
    "land.thisWeek": "Cette semaine",
    "promo.title": "Découvrez ce qui le rend spécial",
    "promo.desc": "Un tour rapide de LuxeMeet & DLuxe — vrais rendez-vous, offres premium et romance boostée par l'IA.",
    "promo.tapSound": "Touchez pour le son",
    "promo.shareInvite": "Partagez le film — votre lien d'invitation est inclus 🎁",
    "promo.shareFriends": "Partagez le film avec des amis",
    "promo.copiedInvite": "Lien du film avec votre code d'invitation copié !",
    "promo.copied": "Lien du film copié !",
    "promo.shareMsg": "🎬 Regardez ça — LuxeMeet, l'appli de rencontres où les vrais rendez-vous arrivent vraiment.",
    "promo.joinInvite": "Rejoignez avec mon lien d'invitation :",
    "promo.shareTg": "🎬 Regardez ça — l'appli de rencontres où les vrais rendez-vous arrivent vraiment",
    "promo.mute": "Couper la musique",
    "promo.unmute": "Activer la musique",
    "prof.back": "Retour",
    "prof.addPhotosHint": "Ajoutez des photos pour vous faire remarquer",
    "prof.noPhotos": "{name} n'a pas encore ajouté de photos",
    "prof.addPhotos": "Ajouter des photos",
    "prof.aiCompanion": "Compagnon IA",
    "prof.reviewOne": "avis de rendez-vous",
    "prof.reviewMany": "avis de rendez-vous",
    "prof.bioEmptyOwn": "Votre bio est vide — quelques phrases sur vous font toute la différence.",
    "prof.bioEmptyOther": "{name} garde une part de mystère — dites bonjour pour en savoir plus.",
    "prof.afterDate": "— {name}, après leur rendez-vous",
    "prof.interests": "CENTRES D'INTÉRÊT",
    "prof.photos": "PHOTOS",
    "prof.videos": "VIDÉOS",
    "prof.thinking": "Réflexion...",
    "prof.suggestOpener": "{ai} : suggérer une entrée en matière",
    "prof.offerSent": "Offre envoyée ! Consultez votre page Offres pour le statut.",
    "prof.tSuggestFail": "Impossible d'obtenir des suggestions pour le moment",
    "prof.tRequestFail": "Impossible d'envoyer la demande",
    "prof.tFavAdded": "Ajouté aux favoris ❤️",
    "prof.tFavRemoved": "Retiré des favoris",
    "prof.tFavFail": "Échec de la mise à jour des favoris",
    "prof.tVisibilityFail": "Échec de la mise à jour de la visibilité",
    "prof.tHidden": "Vous êtes désormais masqué pour {name} dans Découvrir",
    "prof.tVisible": "Vous êtes de nouveau visible pour {name}",
    "prof.tLoadFail": "Échec du chargement du profil",
    "prof.tMsgEmpty": "Veuillez saisir un message",
    "prof.tNoCredits": "Crédits insuffisants. Achetez plus de crédits pour continuer.",
    "prof.tMsgFail": "Échec de l'envoi du message",
    "prof.tMeetupMissing": "Veuillez renseigner la date et le lieu",
    "prof.tMeetupFail": "Échec de l'envoi de la demande de rencontre",
    "nb.title": "Notifications",
    "nb.empty": "Pas encore de notifications",
    "time.now": "à l'instant",
    "time.m": "il y a {n} min",
    "time.h": "il y a {n} h",
    "time.d": "il y a {n} j",
    "notif.photoVerified.t": "✅ Vous êtes vérifié !",
    "notif.photoVerified.b": "Votre vérification par selfie est validée — le badge Vérifié apparaît désormais sur votre profil.",
    "notif.relRequest.t": "💍 Officialiser ?",
    "notif.relRequest.b": "{name} veut officialiser avec vous ! Acceptez dans les Paramètres et vous disparaîtrez tous les deux du fil des autres.",
    "notif.relDeclined.t": "Demande d'officialisation refusée",
    "notif.relDeclined.b": "{name} n'est pas encore prêt à officialiser.",
    "notif.relActive.t": "💞 Vous êtes officiellement ensemble !",
    "notif.relActive.b": "{name} a dit OUI. Vous êtes désormais invisibles pour les autres — l'appli est rien que pour vous deux.",
    "notif.relEnded.t": "Relation officielle terminée",
    "notif.relEnded.b": "{name} a mis fin à la relation officielle. Vous êtes de nouveau visibles sur l'appli.",
    "notif.dateReview.t": "{stars} Nouvel avis de rendez-vous !",
    "notif.dateReview.b": "{name} a noté votre rendez-vous {rating}/5. {comment}",
    "notif.escrow.t": "💰 Paiement du rendez-vous reçu !",
    "notif.escrow.b": "{name} a payé ${amount} pour votre rendez-vous. ${payout} sont bloqués sous séquestre. Confirmez le rendez-vous avec son code à 6 chiffres pour être payée.",
    "notif.escrowBoost.t": "💰 Paiement du rendez-vous reçu !",
    "notif.escrowBoost.b": "{name} a payé ${amount} pour votre rendez-vous. ${payout} sont bloqués sous séquestre — avec votre boost parrainage de 90 % ! Confirmez le rendez-vous avec son code à 6 chiffres pour être payée.",
    "notif.offerPaid.t": "💘 Rendez-vous réservé !",
    "notif.offerPaid.b": "Votre paiement pour le rendez-vous avec {name} est confirmé. Votre code de confirmation à 6 chiffres est prêt sur la page Offres — partagez-le avec votre rendez-vous après coup.",
    "notif.refSlot.t": "🎁 Emplacement premium gratuit gagné !",
    "notif.refSlot.b": "{name}, que vous avez parrainé, vient d'acheter un emplacement premium — vous recevez un emplacement de 50 $ GRATUIT en récompense !",
    "notif.boostActivated.t": "🚀 Profil boosté !",
    "notif.boostActivated.b": "Votre profil est mis en avant en haut de Découvrir pendant les prochaines 24 heures.",
    "notif.creditsAdded.t": "🪙 Crédits ajoutés !",
    "notif.creditsAdded.b": "{credits} crédits de votre achat {package} sont maintenant sur votre compte. Nouveau solde : {balance}.",
    "notif.unlimited.t": "♾️ Offres illimitées activées !",
    "notif.unlimited.b": "Votre prix de champion est actif — envoyez des offres de rendez-vous illimitées (sans emplacement) pendant les 2 prochaines semaines !",
    "notif.voucherGifted.t": "🎁 Vous avez reçu un bon champion !",
    "notif.voucherGifted.b": "{name} vous a offert 2 semaines d'offres de rendez-vous illimitées — activez-le dans les Paramètres avant le {date}.",
    "notif.voucherRedeemed.t": "🎁 Votre cadeau a été utilisé !",
    "notif.voucherRedeemed.b": "{name} a utilisé le bon champion que vous lui avez offert.",
    "notif.refBoost.t": "🎁 Récompense de parrainage débloquée !",
    "notif.refBoost.b": "{name}, que vous avez parrainé, a terminé son premier rendez-vous premium — votre PROCHAIN rendez-vous rémunéré paie 90 % au lieu de 80 % !",
    "notif.payoutProcessing.t": "✅ Rendez-vous confirmé !",
    "notif.payoutProcessing.b": "Votre versement de ${amount} est en cours de traitement et arrivera sur votre PayPal sous 24 à 48 heures.",
    "notif.offerExpiredSender.t": "⏰ Offre de rendez-vous expirée",
    "notif.offerExpiredSender.b": "Votre offre de rendez-vous de ${amount} a expiré après 7 jours. Votre emplacement premium a été libéré pour envoyer une nouvelle offre.",
    "notif.offerExpiredRecipient.t": "⏰ Offre de rendez-vous expirée",
    "notif.offerExpiredRecipient.b": "Une offre de rendez-vous que vous aviez acceptée a expiré car le paiement n'a pas été effectué sous 7 jours.",
    "notif.dateReminder24.t": "💜 Rappel : rendez-vous demain !",
    "notif.dateReminder24.b": "Votre rendez-vous avec {name} est demain — {when}, {where}.",
    "notif.offerExpiringPay.t": "⏳ L'offre expire dans 24 heures !",
    "notif.offerExpiringPay.b": "Votre offre de rendez-vous de ${amount} à {name} expire demain — finalisez le paiement avant qu'elle ne disparaisse et que votre emplacement soit libéré.",
    "notif.offerExpiringWait.t": "⏳ L'offre expire dans 24 heures !",
    "notif.offerExpiringWait.b": "Votre offre de rendez-vous de ${amount} à {name} expire demain — attendez sa réponse ou relancez avant qu'elle ne disparaisse et que votre emplacement soit libéré.",
    "notif.matchInsights.t": "💌 Vos statistiques hebdomadaires de rencontres",
    "notif.matchInsights.b": "{views} vues de profil et {favs} nouveaux favoris cette semaine — dont {names}. Dites bonjour ou boostez votre profil pour déclencher une offre de rendez-vous !",
    "notif.streak1.t": "🔥 Progression de série : {streak}/3",
    "notif.streak1.b": "Encore un rendez-vous 4★+ et 150 crédits gratuits sont à vous !",
    "notif.streakN.t": "🔥 Progression de série : {streak}/3",
    "notif.streakN.b": "Encore {togo} rendez-vous 4★+ pour débloquer 150 crédits gratuits.",
    "notif.streakDone.t": "🔥 Progression de série : {streak}/3",
    "notif.streakDone.b": "Votre récompense est en route !",
    "notif.rankUp.t": "🏆 Vous êtes n°{rank} du classement des Mieux Notés",
    "notif.rankUp.b": "Vous êtes n°{rank} du classement des Mieux Notés. 📈 Vous avez gagné {spots} places depuis la semaine dernière ! Le n°1 mensuel gagne 2 semaines d'offres de rendez-vous illimitées.",
    "notif.rankDown.t": "🏆 Vous êtes n°{rank} du classement des Mieux Notés",
    "notif.rankDown.b": "Vous êtes n°{rank} du classement des Mieux Notés. 📉 Vous avez perdu {spots} places depuis la semaine dernière — un excellent rendez-vous vous y ramène. Le n°1 mensuel gagne 2 semaines d'offres de rendez-vous illimitées.",
    "notif.rankSteady.t": "🏆 Vous êtes n°{rank} du classement des Mieux Notés",
    "notif.rankSteady.b": "Vous êtes n°{rank} du classement des Mieux Notés. 🎯 Position stable depuis la semaine dernière. Le n°1 mensuel gagne 2 semaines d'offres de rendez-vous illimitées.",
    "notif.rankNew.t": "🏆 Vous êtes n°{rank} du classement des Mieux Notés",
    "notif.rankNew.b": "🎉 NOUVEAU : vous entrez au classement des Mieux Notés à la place n°{rank} ! Le n°1 mensuel gagne 2 semaines d'offres de rendez-vous illimitées.",
    "notif.rankOff.t": "🏆 Mise à jour du classement",
    "notif.rankOff.b": "Vous êtes sorti du classement des Mieux Notés cette semaine — un excellent rendez-vous vous y ramène. Le n°1 mensuel gagne 2 semaines d'offres de rendez-vous illimitées.",
    "notif.boostEnded.t": "⚡ Votre boost est terminé",
    "notif.boostEnded.b": "Votre boost de 24 heures est terminé. Il vous a rapporté {views} vues de profil. Boostez à nouveau depuis la page Découvrir pour rester en haut !",
    "notif.boostEndedExtra.t": "⚡ Votre boost est terminé",
    "notif.boostEndedExtra.b": "Votre boost de 24 heures est terminé. Il vous a rapporté {views} vues de profil — environ {extra} de plus qu'un jour normal. Boostez à nouveau depuis la page Découvrir pour rester en haut !",
    "notif.dateSoon1h.t": "⏰ Votre rendez-vous commence bientôt !",
    "notif.dateSoon1h.b": "Votre rendez-vous avec {name} est dans moins d'une heure — {time} à {location}.{tip}",
    "notif.dateSoon24.t": "💜 Votre rendez-vous est dans 24 heures !",
    "notif.dateSoon24.b": "Votre rendez-vous avec {name} est dans 24 heures — {time} à {location}.{tip}",
    "notif.dateSoonTip": " Ouvrez votre offre pour le compte à rebours en direct, la météo et des conseils de tenue !",
    "notif.badgeFire.t": "🔥 Vous êtes en feu !",
    "notif.badgeFire.b": "Vous êtes l'un des 3 hommes les plus contactés sur DLuxe ce mois-ci — le badge 🔥 apparaît désormais sur votre profil.",
    "notif.hotStreak.t": "🔥 Série en feu ! 150 crédits GRATUITS",
    "notif.hotStreak.b": "3 rendez-vous très bien notés d'affilée — le pack Popular de 150 crédits a été ajouté GRATUITEMENT à votre compte. Gardez la série en vie !",
    "notif.badgeDiamond.t": "💎 Badge diamant obtenu !",
    "notif.badgeDiamond.b": "Vous avez réalisé 3 rendez-vous premium de 500 $ ou plus — le badge Diamant brille désormais sur votre profil.",
    "notif.champion.t": "🏆 Champion du classement !",
    "notif.champion.b": "Vous avez terminé n°1 dans « {section} » ce mois-ci ! Prix : un boost de profil de 7 jours GRATUIT (déjà actif) et un bon pour 2 semaines d'offres de rendez-vous ILLIMITÉES — activez-le dans les Paramètres à tout moment dans les 6 prochains mois.",
    "notif.anniversary.t": "💞 {months} {monthsWord} ensemble !",
    "notif.anniversary.b": "Vous et {name} venez d'atteindre {months} {monthsWord} en officiel. Célébrez-le — idée : {idea}",
    "notif.monthWord": "mois",
    "notif.monthsWord": "mois",
    "notif.annIdea0": "Recréez votre tout premier rendez-vous — même lieu, même commande, nouveaux souvenirs.",
    "notif.annIdea1": "Cuisinez ensemble un dîner trois services aux chandelles, téléphones éteints.",
    "notif.annIdea2": "Pique-nique au coucher du soleil avec vos snacks préférés et une playlist partagée.",
    "notif.annIdea3": "Réservez une heure de spa en couple et trinquez avec des bulles ensuite.",
    "notif.annIdea4": "Faites un mini road trip vers une ville qu'aucun de vous n'a jamais visitée.",
    "notif.annIdea5": "Nuit d'observation des étoiles : couvertures, chocolat chaud et votre chanson en boucle.",
    "notif.annIdea6": "Cours de danse pour deux — salsa, bachata ou ce qui vous fait rire.",
    "notif.annIdea7": "Rendez-vous au musée ou en galerie, puis dessert dans un endroit chic.",
    "notif.annIdea8": "Écrivez-vous une lettre sur votre moment préféré jusqu'ici et échangez-les au dîner.",
    "notif.annIdea9": "Réservation d'un dîner sur un rooftop ou une terrasse — habillez-vous comme au premier rendez-vous.",
    "notif.annIdea10": "Dégustation de vin ou de chocolat suivie d'une balade tranquille jusqu'à la maison.",
    "notif.annIdea11": "Planifiez ensemble votre voyage de rêve au petit-déjeuner au lit — puis réservez-en une partie.",
    "notif.companionInvite.t": "💌 {name} a votre surprise !",
    "notif.companionInvite.b": "Votre invitation mystère a été révélée dans votre chat.",
    "notif.supportResolved.t": "✅ Demande de support résolue",
    "notif.supportResolved.b": "Votre {label} « {subject} » a été examinée et résolue.",
    "notif.supportResolvedResp.t": "✅ Demande de support résolue",
    "notif.supportResolvedResp.b": "Votre {label} « {subject} » a été examinée et résolue. Réponse : {resp}",
    "notif.labelRefund": "demande de remboursement",
    "notif.labelComplaint": "réclamation",
    "notif.testMeetup.t": "{name} a accepté votre rencontre ! 🎉",
    "notif.testMeetup.b": "Essai terminé — c'est exactement à quoi ça ressemble quand un vrai membre accepte. Aucun crédit n'a été débité.",
    "notif.testCounter.t": "{name} a envoyé une contre-offre 💬",
    "notif.testCounter.b": "Essai : elle a contre-proposé ${amount}. Acceptez ou refusez pour continuer le flux — toujours pas d'argent réel.",
    "notif.testOfferAccepted.t": "{name} a accepté votre offre de rendez-vous ! 💜",
    "notif.testOfferAccepted.b": "Essai : appuyez sur le bouton Simuler le Paiement sur la page Offres pour voir la suite du flux — aucun argent réel.",
    "notif.testDateCompleted.t": "Rendez-vous test avec {name} terminé ! 🏆",
    "notif.testDateCompleted.b": "C'était le cycle complet d'un rendez-vous premium — offre, acceptation, paiement, code et confirmation. Aucun argent réel n'a bougé. Prêt à essayer avec un vrai membre ?",
    "notif.refChat.t": "🎁 +{credits} crédits gagnés !",
    "notif.refChat.b": "{name} vient de commencer à discuter — {credits} crédits bonus ajoutés à votre solde.",
    "notif.payoutSent.t": "💸 Versement envoyé !",
    "notif.payoutSent.b": "${amount} ont été envoyés sur votre PayPal ({recipient}).",
    "notif.favVerified.t": "✅ {name} est maintenant vérifié !",
    "notif.favVerified.b": "{name}, de vos favoris, vient de passer la vérification par selfie et a obtenu le badge Vérifié.",
    "notif.favReviewed.t": "⭐ {name} a reçu un excellent avis !",
    "notif.favReviewed.b": "{name}, de vos favoris, vient de recevoir un avis de rendez-vous de {rating} étoiles. Les bons partenaires sont vite réservés !",
    "notif.favBoosted.t": "⚡ {name} vient de se booster !",
    "notif.favBoosted.b": "{name}, de vos favoris, est en vedette en haut de Découvrir en ce moment — dites bonjour pendant qu'il est sous les projecteurs !",
    "register.newMembers": "Les nouveaux membres reçoivent",
    "register.promoLuxe1": "50 crédits gratuits",
    "register.promoDluxe1": "Accès gratuit + Gains",
    "register.promoLuxe2": "Pour les femmes qui rejoignent LuxeMeet",
    "register.promoDluxe2": "Les hommes rejoignent DLuxe gratuitement — et gagnent grâce aux rendez-vous premium",
    "register.googleTerms": "En continuant avec Google, vous acceptez nos",
    "register.googleTermsLink": "Conditions Générales",
    "register.orEmail": "ou inscrivez-vous par e-mail",
    "register.hintF": "Femmes : gratuit sur LuxeMeet (50 crédits de départ) — ou prenez les devants sur DLuxe avec des offres de rendez-vous premium aux hommes.",
    "register.hintM": "Hommes : investissez pour vous connecter sur LuxeMeet — et profitez d'un accès gratuit + gagnez grâce aux rendez-vous premium sur DLuxe.",
    "register.hintNone": "Sélectionnez votre genre pour voir les fonctionnalités disponibles",
    "register.refCode": "Code de parrainage",
    "register.refOptional": "(facultatif)",
    "register.refPh": "Vous avez un code ? Saisissez-le ici",
    "register.terms18": "J'ai 18 ans ou plus et j'accepte les",
    "register.termsLink": "Conditions Générales et la Décharge de Responsabilité",
    "register.create": "Créer un compte",
    "register.haveAccount": "Vous avez déjà un compte ?",
    "register.errGender": "Veuillez sélectionner votre genre",
    "register.errTerms": "Veuillez accepter les Conditions Générales pour continuer",
    "register.errFail": "L'inscription a échoué",
    "register.giftClaimed": "😕 Ce code cadeau ({code}) a déjà été utilisé.",
    "register.giftExpired": "😕 Ce code cadeau ({code}) a expiré.",
    "register.giftReady": "🎁 {name} vous a offert un bon champion ({code}) — il sera ajouté à votre compte juste après votre inscription !",
    "register.giftFriend": "Un ami",
    "set.tImgFile": "Veuillez sélectionner un fichier image",
    "set.tImgSize": "L'image doit faire moins de 5 Mo",
    "set.tPhotoUpdated": "Photo de profil mise à jour !",
    "set.tPhotoFail": "Échec du téléchargement de la photo",
    "set.tPwMismatch": "Les nouveaux mots de passe ne correspondent pas",
    "set.tPwShort": "Le mot de passe doit contenir au moins 6 caractères",
    "set.tPwChanged": "Mot de passe modifié avec succès !",
    "set.tPwFail": "Échec du changement de mot de passe",
    "set.tProfileUpdated": "Profil mis à jour !",
    "set.tProfileFail": "Échec de la mise à jour du profil",
    "set.tLoggedOut": "Déconnexion réussie",
    "set.tDeactivated": "Compte désactivé. Reconnectez-vous sous 30 jours pour le réactiver.",
    "set.tDeleteFail": "Échec de la suppression du compte",
    "pp.errInvalidEmail": "Veuillez saisir une adresse e-mail valide",
    "pp.errNoMatch": "Les e-mails ne correspondent pas",
    "pp.errConfirm": "Veuillez confirmer votre e-mail PayPal",
    "pp.errFix": "Veuillez corriger les erreurs avant d'enregistrer",
    "pp.savedOk": "Paramètres PayPal enregistrés et vérifiés !",
    "pp.saveFail": "Échec de l'enregistrement des paramètres",
    "pp.errImg": "Veuillez télécharger un fichier image",
    "pp.errSize": "Le fichier doit faire moins de 5 Mo",
    "pp.qrUploaded": "Code QR téléchargé !",
    "pp.qrFail": "Échec du téléchargement du code QR",
    "terms.title": "Conditions Générales",
    "terms.updated": "Incluant la Décharge de Responsabilité — Dernière mise à jour : juin 2026 (v5)",
    "terms.back": "Retour",
    "terms.footer": "© 2026 LuxeMeet & DLuxe. Tous droits réservés.",
    "terms.s1t": "1. Acceptation des Conditions",
    "terms.s1p1": "En créant un compte ou en utilisant LuxeMeet ou son mode compagnon DLuxe (ensemble, « la Plateforme »), vous acceptez d'être lié par ces Conditions Générales et notre Décharge de Responsabilité. Si vous n'êtes pas d'accord, n'utilisez pas la Plateforme.",
    "terms.s2t": "2. Éligibilité (18+)",
    "terms.s2p1": "Vous devez avoir au moins 18 ans pour utiliser LuxeMeet. En vous inscrivant, vous déclarez et garantissez avoir 18 ans ou plus et être légalement capable de conclure cet accord. Les comptes appartenant à des mineurs seront résiliés immédiatement sans remboursement.",
    "terms.s3t": "3. Nature du Service",
    "terms.s3p1": "LuxeMeet est uniquement une plateforme de mise en relation. Nous fournissons des outils permettant à des adultes de se rencontrer, d'échanger des messages et d'organiser des rendez-vous. Nous ne sommes partie à aucune interaction, conversation, rendez-vous ou arrangement entre membres. Nous n'effectuons pas de vérification de casier judiciaire et n'offrons aucune garantie quant à l'identité, la conduite, les intentions ou la compatibilité d'un membre.",
    "terms.s3p2": "La Plateforme peut afficher des liens vers des services tiers indépendants pour aider à planifier des rendez-vous — comme OpenStreetMap et Google Maps pour les lieux, Uber pour le transport et Airbnb Experiences pour des idées de rendez-vous. Ces services ne sont pas exploités par nous ; votre utilisation est régie par leurs propres conditions, et nous ne sommes pas responsables de leur contenu, de leurs prix ou de leur disponibilité.",
    "terms.s4t": "4. Crédits, Paiements et Offres de Rendez-vous Premium",
    "terms.s4p1": "Les membres masculins achètent des crédits pour envoyer des messages et demander des rencontres, des emplacements d'offre premium pour envoyer des offres de rendez-vous, et des boosts de profil facultatifs. Tous les paiements sont traités par PayPal. Les prix sont affichés au moment de l'achat et peuvent inclure des frais de gestion.",
    "terms.s4p2": "Pour les Offres de Rendez-vous Premium, le montant offert est placé sous séquestre une fois payé. Lorsque le rendez-vous a lieu et que le destinataire saisit le code de confirmation à 6 chiffres du payeur, le versement (moins la commission de la plateforme) est libéré au destinataire. La commission de la plateforme est indiquée dans l'application. Rendez-vous répétés : lorsqu'un payeur réserve un nouveau rendez-vous avec une personne avec qui il a déjà réalisé un rendez-vous via la Plateforme, aucun emplacement premium n'est requis et une commission réduite de 10 % s'applique (le destinataire reçoit 90 % du montant de l'offre). Les indemnités de transport facultatives sont payées avec l'offre et reversées à 100 % au destinataire. Les offres de rendez-vous annulées sont automatiquement supprimées de l'historique 48 heures après l'annulation. Bons champion : les bons de récompense obtenus via le classement mensuel des Meilleurs Membres peuvent être offerts une seule fois à une autre personne via un code cadeau à usage unique ; une fois offert, le bon ne peut être utilisé ni récupéré par son titulaire d'origine, et les bons reçus en cadeau ne peuvent pas être offerts à nouveau. Les bons n'ont aucune valeur monétaire.",
    "terms.s4p3": "Remboursements : les crédits, emplacements et boosts ne sont pas remboursables une fois livrés. Les paiements de rendez-vous sous séquestre ne sont remboursables que si le rendez-vous n'a pas lieu et que l'offre est annulée ou expire selon les règles de la plateforme. Les paiements doivent être effectués depuis un compte PayPal dont l'e-mail correspond à votre e-mail de connexion LuxeMeet ; les paiements depuis des e-mails non concordants peuvent être retardés ou irrécupérables. Vous pouvez soumettre une demande de remboursement ou une réclamation à tout moment via Paramètres → Remboursements et Réclamations (ou « Aide et Support » dans le menu de l'application) ; chaque demande est examinée par notre équipe et vous serez informé du résultat dans l'application et par e-mail.",
    "terms.s5t": "5. Décharge de Responsabilité et Acceptation des Risques",
    "terms.s5p1": "VOUS ACCEPTEZ EXPRESSÉMENT QUE RENCONTRER UN AUTRE MEMBRE EN PERSONNE EST ENTIÈREMENT À VOS PROPRES RISQUES. Dans toute la mesure permise par la loi, vous libérez, déchargez et dégagez de toute responsabilité LuxeMeet, ses propriétaires, exploitants, employés et affiliés de toutes réclamations, demandes, dommages, blessures, pertes ou causes d'action — connues ou inconnues — découlant de ou liées à votre utilisation de la Plateforme, vos interactions ou communications avec d'autres membres, et toute rencontre ou rendez-vous en personne organisé via la Plateforme, y compris sans limitation les blessures corporelles, la détresse émotionnelle, les dommages matériels, le vol, la fraude ou la perte financière.",
    "terms.s5p2": "Vous êtes seul responsable de votre propre sécurité. Nous recommandons vivement de vous rencontrer dans des lieux publics, de dire à un ami où vous allez, d'organiser votre propre transport et de ne jamais partager d'informations financières avec d'autres membres.",
    "terms.s6t": "6. Conduite des Membres",
    "terms.s6p1": "Vous vous engagez à ne pas : falsifier votre identité ou votre âge ; harceler, maltraiter ou nuire à d'autres membres ; solliciter de l'argent auprès de membres en dehors du système d'offres de la Plateforme ; utiliser la Plateforme à des fins commerciales, illégales ou d'exploitation (y compris les services d'escorte ou la traite d'êtres humains) ; publier du contenu explicite, offensant ou contrefaisant ; ou tenter de contourner les systèmes de paiement de la Plateforme.",
    "terms.s6p2": "Politique de contenu : les photos et vidéos de profil ne doivent pas contenir de nudité ni de contenu sexuellement explicite ou suggestif. Toutes les photos et vidéos téléchargées sont automatiquement examinées par IA avant publication et le contenu interdit est rejeté. Des tentatives répétées de téléchargement de contenu interdit peuvent entraîner des mesures sur le compte.",
    "terms.s6p3": "Toute violation peut entraîner une suspension ou une résiliation immédiate sans remboursement, et un signalement aux forces de l'ordre le cas échéant.",
    "terms.s7t": "7. Notes de Rendez-vous, Avis et Favoris",
    "terms.s7p1": "Après un rendez-vous premium terminé, les deux participants peuvent noter le rendez-vous (1 à 5 étoiles) avec un commentaire écrit facultatif. La participation aux notes est facultative : vous pouvez la désactiver entièrement dans les Paramètres, auquel cas personne ne peut noter vos rendez-vous et aucune note n'apparaît sur votre profil. Si vous participez, vous pouvez choisir séparément si les commentaires écrits sont affichés publiquement avec votre note.",
    "terms.s7p2": "Les avis doivent être honnêtes, respectueux et fondés sur un rendez-vous réel. Les avis diffamatoires, harcelants ou faux peuvent être supprimés et entraîner des mesures sur le compte. Les membres peuvent également enregistrer d'autres profils dans une liste privée de Favoris ; vos favoris ne sont visibles que par vous. Si vous ajoutez un membre à vos favoris, vous pouvez recevoir des notifications sur l'activité publique de son profil (boosts, vérification ou nouveaux avis).",
    "terms.s8t": "8. Fonctionnalités d'IA",
    "terms.s8p1": "La Plateforme propose des fonctionnalités facultatives alimentées par l'IA, notamment les assistants d'écriture « AI Wingman » (pour les membres masculins) et « AI Cupid » (pour les membres féminins) — qui peuvent rédiger des ouvertures et réponses de chat, des notes d'offres de rendez-vous premium, des messages de contre-offre, des messages de demande de rencontre et des commentaires d'avis de rendez-vous — l'assistant d'aide « Luxe » dans l'application, des idées de rendez-vous sélectionnées par l'IA, des suggestions de tenues du styliste IA affichées dans le compte à rebours du rendez-vous, des statistiques hebdomadaires de rencontres assistées par l'IA, des photos de profil assistées par l'IA et une vérification photo par selfie basée sur l'IA. L'IA est également utilisée pour examiner automatiquement toutes les photos et vidéos de galerie téléchargées à la recherche de contenu interdit (nudité et contenu sexuel) avant leur publication. Le contenu IA est généré automatiquement et peut être inexact. Vous êtes responsable de tout contenu que vous envoyez ou publiez, y compris le contenu assisté par l'IA. Les photos de profil doivent vous représenter fidèlement ; utiliser des images IA qui déforment matériellement votre apparence peut entraîner des mesures sur le compte. Les selfies de vérification sont utilisés uniquement pour le contrôle de vérification et ne sont jamais affichés publiquement.",
    "terms.s9t": "9. Limitation de Responsabilité",
    "terms.s9p1": "DANS TOUTE LA MESURE PERMISE PAR LA LOI, LUXEMEET NE SERA PAS RESPONSABLE DES DOMMAGES INDIRECTS, ACCESSOIRES, SPÉCIAUX, CONSÉCUTIFS OU PUNITIFS, NI DE TOUTE PERTE DE PROFITS OU DE DONNÉES, DÉCOULANT DE VOTRE UTILISATION DE LA PLATEFORME. NOTRE RESPONSABILITÉ TOTALE CUMULÉE POUR TOUTE RÉCLAMATION NE DÉPASSERA PAS LE MONTANT QUE VOUS AVEZ PAYÉ À LUXEMEET AU COURS DES SIX (6) MOIS PRÉCÉDANT LA RÉCLAMATION.",
    "terms.s10t": "10. Confidentialité",
    "terms.s10p1": "Nous collectons et traitons les informations de compte, les messages, les registres de paiement et les données d'utilisation pour exploiter la Plateforme, traiter les paiements et versements, prévenir la fraude et améliorer le service. Le nombre de vues de profil est suivi pour alimenter les statistiques de boost. Vous pouvez activer le Mode Incognito dans les Paramètres pour masquer votre profil de la navigation Découvrir — globalement ou pour certains membres — tandis que vos conversations, offres et rencontres existantes continuent de fonctionner. Nous ne vendons pas vos données personnelles. Des e-mails peuvent être envoyés à des fins de compte, de paiement et d'engagement.",
    "terms.s11t": "11. Résiliation et Suppression de Compte",
    "terms.s11p1": "Suppression de votre compte : vous pouvez supprimer votre compte à tout moment depuis Paramètres → Zone de Danger. Votre profil est immédiatement masqué de Découvrir, des classements et des favoris. Un délai de grâce de 30 jours s'applique : vous reconnecter sous 30 jours réactive entièrement votre compte. Après 30 jours, votre compte et vos données personnelles (profil, photos, vidéos, messages, favoris et notifications) sont effacés ou anonymisés de manière permanente et irréversible. Les crédits, emplacements, boosts non utilisés et tout solde non retiré sont perdus lors de l'effacement définitif. Les enregistrements requis pour la conformité financière et légale (comme les registres de paiements effectués) peuvent être conservés sous forme anonymisée.",
    "terms.s11p2": "Nous pouvons suspendre ou résilier les comptes qui violent ces Conditions. Les crédits, emplacements et boosts non utilisés sont perdus en cas de résiliation pour motif valable.",
    "terms.s12t": "12. Modifications de ces Conditions",
    "terms.s12p1": "Nous pouvons mettre à jour ces Conditions de temps à autre. L'utilisation continue de la Plateforme après l'entrée en vigueur des modifications constitue une acceptation des Conditions révisées.",
    "terms.s13t": "13. Mode DLuxe",
    "terms.s13p1": "La Plateforme comprend un mode compagnon, « DLuxe », accessible via le bouton cœur dans l'application. DLuxe reflète LuxeMeet avec les rôles de paiement inversés : les membres féminines paient pour les interactions (crédits, emplacements d'offre premium, boosts et offres monétaires de rendez-vous) et les membres masculins peuvent recevoir des versements d'offres de rendez-vous. Toutes les Conditions s'appliquent également aux deux modes, les dispositions spécifiques au rôle s'appliquant à la partie qui paie ou reçoit un paiement dans le mode actif. Un seul compte est utilisé pour les deux modes. Les conversations et demandes de rencontre sont séparées par mode : les interactions commencées sur LuxeMeet suivent les règles de paiement de LuxeMeet (les hommes paient) et celles commencées sur DLuxe suivent les règles de DLuxe (les femmes paient). Changer de mode ne change que la boîte de réception affichée et ne change jamais qui paie dans une conversation existante. Toutes les fonctionnalités de la Plateforme — y compris les assistants IA, les classements, les récompenses champion et les bons cadeaux — sont disponibles dans les deux modes avec l'image de marque appropriée.",
    "terms.s14t": "14. Contact",
    "terms.s14p1": "Des questions sur ces Conditions ? Utilisez l'assistant d'Aide dans l'application. Pour les demandes de remboursement et les réclamations, utilisez Paramètres → Remboursements et Réclamations (ou « Aide et Support » dans le menu de l'application) — chaque envoi est examiné et reçoit une réponse.",
    "landing.badge": "Expérience de rencontres premium",
    "landing.heroLuxe1": "Là où la qualité",
    "landing.heroLuxe2": "rencontre la connexion",
    "landing.heroDluxe1": "Là où les femmes",
    "landing.heroDluxe2": "prennent les devants",
    "landing.taglineLuxe": "Une plateforme de rencontres exclusive où les connexions authentiques sont valorisées. Les gentlemen investissent des crédits pour se connecter, garantissant un intérêt sincère et des échanges de qualité.",
    "landing.taglineDluxe": "Une plateforme de rencontres exclusive où les femmes audacieuses font le premier pas. Elles investissent des crédits pour rencontrer des hommes exceptionnels, garantissant un intérêt sincère et des échanges de qualité.",
    "landing.startJourney": "Commencez votre aventure",
    "landing.haveAccount": "J'ai déjà un compte",
    "landing.watchFilm": "Voir le film",
    "auth.signIn": "Se connecter",
    "auth.getStarted": "Commencer",
    "login.welcomeBack": "Bon retour",
    "login.subtitle": "Connectez-vous pour continuer votre aventure",
    "login.google": "Continuer avec Google",
    "login.orEmail": "ou continuez avec votre e-mail",
    "login.email": "E-mail",
    "login.password": "Mot de passe",
    "login.emailPh": "Entrez votre e-mail",
    "login.passwordPh": "Entrez votre mot de passe",
    "login.forgot": "Mot de passe oublié ?",
    "login.noAccount": "Pas encore de compte ?",
    "login.createOne": "Créez-en un",
    "login.backHome": "Retour à l'accueil",
    "register.title": "Créez votre compte",
    "register.subtitle": "Commencez votre chemin vers des connexions authentiques",
    "register.fullName": "Nom complet",
    "register.namePh": "Entrez votre nom",
    "register.passwordPh": "Créez un mot de passe",
    "register.iAmA": "Je suis",
    "register.man": "Un homme",
    "register.woman": "Une femme",
    "nav.discover": "Découvrir",
    "nav.favorites": "Favoris",
    "nav.chat": "Chat",
    "nav.offers": "Offres",
    "nav.meetups": "Rendez-vous",
    "nav.top": "Top",
    "nav.credits": "Crédits",
    "nav.earnings": "Gains",
    "nav.settings": "Réglages",
    "nav.watchTour": "Voir la visite",
    "nav.helpSupport": "Aide et support",
    "discover.title": "Découvrir",
    "discover.subtitle": "Trouvez votre match idéal",
    "discover.newest": "Nouveaux",
    "discover.topRated": "Mieux notés",
    "discover.sendOffer": "Envoyer une offre de rendez-vous premium",
    "discover.message": "Message",
    "discover.aiCompanion": "Compagnon IA",
    "discover.videoIntro": "Vidéo",
    "settings.countryLanguage": "Pays et langue",
    "settings.country": "Pays",
    "settings.language": "Langue",
    "settings.currency": "Devise",
    "settings.currencyNote": "Les prix sont affichés approximativement dans votre devise ; les paiements sont traités en USD.",
    "settings.refunds": "Remboursements et réclamations",
    "settings.changePassword": "Changer le mot de passe",
    "settings.logout": "Se déconnecter",
    "settings.dangerZone": "Zone de danger",
    "settings.deleteAccount": "Supprimer mon compte",
    "credits.billedUsd": "facturé en USD",
    "common.accept": "Accepter",
    "common.decline": "Refuser",
    "common.pending": "En attente",
    "common.accepted": "Acceptée",
    "common.declined": "Refusée",
    "common.received": "Reçues",
    "common.sent": "Envoyées",
    "common.yourBalance": "Votre solde",
    "common.back": "Retour",
    "common.cancel": "Annuler",
    "common.credits": "Crédits",
    "common.viewMap": "Voir la carte",
    "common.getUber": "Prendre un Uber",
    "common.hours": "heures",
    "chat.title": "Messages",
    "chat.empty": "Pas encore de conversations",
    "chat.emptySub": "Connectez-vous avec des personnes pour commencer à discuter !",
    "chat.discoverProfiles": "Découvrir des profils",
    "chat.typeMessage": "Écrivez un message...",
    "chat.inbox": "Boîte",
    "chat.noMessages": "Pas encore de messages. Lancez la conversation !",
    "chat.startConvo": "Lancez la conversation !",
    "chat.costStart": "Démarrer une discussion coûte 10 crédits",
    "chat.costMessage": "Envoyer un message coûte 5 crédits",
    "chat.inboxBadge": "Boîte {app}",
    "common.testRun": "Essai",
    "offers.simulatePayment": "Simuler le paiement (essai)",
    "offers.title": "Offres de rendez-vous premium",
    "offers.dateOffers": "Offres de rendez-vous",
    "offers.slots": "Vos emplacements d'offres",
    "offers.available": "Disponibles",
    "offers.inUse": "En cours",
    "offers.consumed": "Utilisés",
    "offers.sentOffers": "Vos offres envoyées",
    "offers.none": "Pas encore d'offres",
    "offers.noneSent": "Aucune offre envoyée",
    "offers.reviewRespond": "Consultez et répondez à vos offres de rendez-vous premium",
    "offers.subtitlePayer": "Achetez des emplacements pour envoyer des offres de rendez-vous premium à vos matchs",
    "offers.slotDesc": "50 $ par emplacement • Réutilisable jusqu'à l'acceptation d'une offre",
    "offers.buySlot": "Acheter un emplacement",
    "offers.noneDesc": "Vous n'avez pas encore reçu d'offres de rendez-vous",
    "offers.noneSentDesc": "Achetez un emplacement et envoyez votre première offre de rendez-vous premium",
    "offers.buyFirstSlot": "Achetez votre premier emplacement",
    "offers.respond": "Répondre",
    "offers.cancelOffer": "Annuler l'offre",
    "offers.viewCounter": "Voir la contre-offre",
    "offers.rateDate": "Noter ce rendez-vous",
    "offers.dateDetails": "Détails et avis du rendez-vous",
    "status.pending": "En attente",
    "status.paymentNeeded": "Paiement requis",
    "status.awaitingConfirmation": "En attente de confirmation",
    "status.countered": "Contre-offre",
    "status.confirmed": "Confirmé",
    "status.completed": "Terminé",
    "status.declined": "Refusé",
    "status.expired": "Expiré",
    "status.cancelled": "Annulé",
    "meetups.title": "Demandes de rendez-vous",
    "meetups.none": "Pas encore de demandes",
    "meetups.noneSent": "Aucune demande envoyée",
    "meetups.received": "Reçues",
    "meetups.sent": "Envoyées",
    "meetups.noneDesc": "Les demandes de rendez-vous des autres apparaîtront ici.",
    "meetups.noneSentDesc": "Trouvez quelqu'un que vous aimeriez rencontrer !",
    "meetups.browse": "Parcourir les profils",
    "favorites.title": "Favoris",
    "favorites.subtitle": "Profils que vous avez enregistrés",
    "favorites.none": "Pas encore de favoris",
    "favorites.noneDesc": "Touchez le cœur d'un profil qui vous plaît et il sera enregistré ici.",
    "favorites.browse": "Parcourir Découvrir",
    "leaderboard.title": "Meilleurs membres",
    "leaderboard.you": "Vous",
    "leaderboard.subtitle": "Les membres les plus demandés, les mieux notés et les plus généreux de la plateforme. Gagnez des badges pour prendre votre place.",
    "leaderboard.prizeNote": "Le n°1 mensuel de chaque section gagne un boost gratuit de 7 jours + 2 semaines d'offres de rendez-vous illimitées.",
    "leaderboard.empty": "Pas encore de détenteurs de badges — réussissez de belles rencontres pour être le premier !",
    "leaderboard.loading": "Chargement du classement...",
    "leaderboard.fireTitle": "Les plus demandés sur DLuxe",
    "leaderboard.fireSub": "Les 3 hommes les plus contactés sur DLuxe ce mois-ci",
    "leaderboard.diamondTitle": "Membres Diamant",
    "leaderboard.diamondSub": "Ont réalisé 3+ rendez-vous premium de 500 $ ou plus",
    "leaderboard.ratedTitle": "Les mieux notés",
    "leaderboard.ratedSub": "Les meilleures notes issues d'avis réels",
    "leaderboard.shareBadge": "Partager le badge",
    "leaderboard.datesCompleted": "rendez-vous premium réalisés",
    "earnings.title": "Mes gains",
    "earnings.escrow": "Sous séquestre",
    "earnings.total": "Total gagné",
    "earnings.dates": "Rendez-vous réalisés",
    "earnings.history": "Historique des paiements",
    "earnings.none": "Pas encore de gains",
    "credits.costs": "Coûts en crédits",
    "credits.startChat": "Démarrer une nouvelle discussion",
    "credits.sendMessage": "Envoyer un message",
    "credits.requestMeetup": "Demander un rendez-vous",
    "credits.buy": "Acheter des crédits",
    "credits.history": "Historique des achats",
    "credits.noHistory": "Pas encore d'achats",
    "credits.completePayment": "Finaliser le paiement",
    "credits.allSet": "Vous êtes paré !",
    "credits.freeLuxe": "En tant que femme sur LuxeMeet, vous profitez d'un accès gratuit à la messagerie et à toutes les fonctionnalités.",
    "credits.freeDluxe": "En tant qu'homme sur DLuxe, vous profitez d'un accès gratuit à la messagerie et à toutes les fonctionnalités.",
    "credits.bestValue": "Meilleure offre",
    "credits.continuePayment": "Continuer vers le paiement",
    "credits.processing": "Traitement...",
    "profile.message": "Message",
    "profile.requestMeetup": "Demander un rendez-vous",
    "tour.tryWith": "Essayez avec",
    "settings.title": "Paramètres",
    "settings.photoHint": "Touchez l'appareil photo pour changer de photo",
    "settings.profileInfo": "Informations du profil",
    "settings.displayName": "Nom affiché",
    "settings.age": "Âge",
    "settings.location": "Localisation",
    "settings.locationPh": "Ville, Pays",
    "settings.bio": "Bio",
    "settings.bioPh": "Parlez de vous aux autres...",
    "settings.interests": "Centres d'intérêt",
    "settings.interestsPh": "Voyages, Musique, Cuisine (séparés par des virgules)",
    "settings.interestsHint": "Séparez les centres d'intérêt par des virgules",
    "settings.saveChanges": "Enregistrer les modifications",
    "settings.paypalTitle": "Paramètres de paiement PayPal",
    "settings.paypalDesc": "Ajoutez vos informations PayPal pour recevoir les paiements des offres de rendez-vous acceptées",
    "settings.dangerDesc": "La suppression de votre compte masque immédiatement votre profil. Vous changez d'avis ? Reconnectez-vous sous 30 jours pour le réactiver — passé ce délai, votre compte et vos données personnelles sont définitivement effacés et les crédits ou soldes non utilisés sont perdus.",
    "settings.deleteTitle": "Supprimer votre compte ?",
    "settings.deleteB1": "Votre profil est immédiatement masqué pour tout le monde",
    "settings.deleteB2": "Reconnectez-vous sous 30 jours pour le réactiver",
    "settings.deleteB3": "Après 30 jours, tout est définitivement effacé — photos, messages et tout crédit ou solde non utilisé",
    "settings.confirmPasswordLabel": "Confirmez votre mot de passe",
    "settings.googleBlank": "Inscrit avec Google ? Laissez ce champ vide.",
    "settings.deactivateDelete": "Désactiver et supprimer",
    "settings.currentPassword": "Mot de passe actuel",
    "settings.newPassword": "Nouveau mot de passe",
    "settings.confirmNewPassword": "Confirmer le nouveau mot de passe",
    "ref.title": "Invitez et gagnez",
    "ref.desc": "Partagez votre lien d'invitation. Vous gagnez 25 crédits bonus dès qu'un ami invité commence à discuter. En plus : quand un filleul achète son premier créneau premium, vous recevez un créneau de 50 $ GRATUIT — et quand un filleul termine son premier rendez-vous premium, votre PROCHAIN rendez-vous rémunéré paie 90 % au lieu de 80 %.",
    "ref.friendsReferred": "Amis parrainés",
    "ref.bonusCredits": "Crédits bonus gagnés",
    "ref.freeSlots": "Créneaux gratuits gagnés",
    "ref.boosts": "Boosts 90 % disponibles",
    "ref.yourReferrals": "Vos filleuls",
    "ref.stJoined": "Inscrit",
    "ref.stChatting": "A commencé à discuter ✓ (+25 crédits)",
    "ref.stDate": "Rendez-vous terminé ✓",
    "ref.stSlot": "Créneau acheté ✓",
    "ref.topReferrers": "Meilleurs parrains du mois",
    "ref.referralsWord": "filleuls",
    "ref.copied": "Lien d'invitation copié !",
    "share.inviteMsg": "Rejoins-moi sur {app} — l'app de rencontres premium où les vrais rendez-vous arrivent vraiment. Inscris-toi avec mon lien :",
    "share.dreamMsg": "💘 Tu es invité(e) à un rendez-vous de rêve ! Rejoins-moi sur {app} et planifions le rendez-vous parfait :",
    "share.inviteBtn": "Inviter un ami",
    "share.dreamBtn": "💘 Invitation rendez-vous de rêve",
    "share.hint": "Écrivez votre propre message ou laissez vide pour utiliser le modèle — votre lien d'invitation est ajouté automatiquement.",
    "share.copied": "Message d'invitation copié — collez-le où vous voulez !",
    "landing.whyTitle": "Pourquoi choisir {app} ?",
    "landing.whySub": "Notre système de crédits garantit que chaque interaction est significative et intentionnelle.",
    "landing.f1Title": "Connexions de qualité",
    "landing.f1Desc": "Les crédits garantissent un intérêt sincère. Pas de spam, pas de bots — juste de vraies personnes cherchant de vraies connexions.",
    "landing.f2Title": "Expérience premium",
    "landing.f2DescLuxe": "Les femmes profitent d'un accès gratuit tandis que les hommes investissent dans des conversations significatives et des demandes de rencontre.",
    "landing.f2DescDluxe": "Les hommes profitent d'un accès gratuit tandis que les femmes investissent dans des conversations significatives et des offres de rendez-vous premium.",
    "landing.f3Title": "Profils vérifiés",
    "landing.f3Desc": "Tous les profils sont vérifiés pour garantir leur authenticité. Rencontrez de vraies personnes, créez de vraies connexions.",
    "landing.refBadge": "Parrainez et gagnez",
    "landing.refTitle1": "Invitez des amis,",
    "landing.refTitle2": "débloquez des récompenses",
    "landing.refDesc1": "Chaque membre reçoit un lien d'invitation personnel. Partagez-le avec vos amis et gagnez un",
    "landing.refDescBold": "créneau premium de 50 $ GRATUIT",
    "landing.refDesc2": "plus des avantages bonus exclusifs quand ils s'inscrivent et deviennent actifs.",
    "landing.refCard1Title": "Créneau premium de 50 $ GRATUIT",
    "landing.refCard1Desc": "Gagné pour chaque ami qui s'inscrit et devient actif",
    "landing.refCard2Title": "Avantages bonus",
    "landing.refCard2Desc": "Privilèges exclusifs réservés aux meilleurs parrains",
    "landing.refCta": "Rejoignez et obtenez votre lien",
    "landing.ctaTitle": "Prêt à trouver votre match ?",
    "landing.ctaSub": "Rejoignez des milliers de célibataires qui ont trouvé des connexions significatives sur {app}.",
    "landing.ctaBtn": "Créer un compte gratuit",
    "landing.footerTerms": "Conditions générales",
    "pp.balance": "Solde disponible",
    "pp.balanceNote": "Issu des offres de rendez-vous acceptées (80 % après frais de plateforme)",
    "pp.email": "Email PayPal *",
    "pp.emailHint": "C'est ici que nous enverrons vos paiements",
    "pp.confirmEmail": "Confirmer l'email PayPal *",
    "pp.confirmPh": "Saisissez à nouveau votre email",
    "pp.emailsMatch": "Les emails correspondent",
    "pp.verified": "Vérifié",
    "pp.username": "Nom d'utilisateur PayPal (optionnel)",
    "pp.qr": "QR code PayPal (optionnel)",
    "pp.qrUpload": "Téléverser le QR code",
    "pp.qrHint": "Téléversez votre QR code de paiement PayPal pour des virements faciles",
    "pp.save": "Enregistrer et vérifier les paramètres PayPal",
    "pp.howTitle": "ℹ️ Comment fonctionnent les paiements",
    "pp.how1": "Les membres envoient des offres de rendez-vous avec des montants (100 $ - 1000 $)",
    "pp.how2": "Quand vous acceptez et qu'ils paient, vous recevez 80 % (la plateforme garde 20 %)",
    "pp.how3": "Les paiements sont envoyés à votre email PayPal sous 3 à 5 jours ouvrés",
    "pp.how4": "Votre solde est mis à jour après chaque rendez-vous confirmé",
    "rel.title": "Relation officielle",
    "rel.activeWith": "💞 Officiellement ensemble avec {name}",
    "rel.activeSince": "Depuis {date} — vous êtes tous les deux invisibles pour les autres.",
    "rel.chat": "Discuter",
    "rel.planDate": "Planifier un rendez-vous",
    "rel.end": "Mettre fin à la relation",
    "rel.incomingTitle": "💍 {name} veut officialiser avec vous !",
    "rel.incomingDesc": "Acceptez et vous disparaîtrez tous les deux du fil des autres — l'app sera rien que pour vous deux.",
    "rel.accept": "Accepter 💞",
    "rel.decline": "Pas encore",
    "rel.waitingFor": "⏳ En attente de {name}",
    "rel.waitingDesc": "Votre demande d'officialisation attend sa réponse.",
    "rel.cancelRequest": "Annuler la demande",
    "rel.endTitle": "Mettre fin à la relation officielle ?",
    "rel.endDesc": "Vous et {name} redeviendrez visibles pour tout le monde et pourrez parcourir d'autres membres. Vos conversations et votre historique restent intacts.",
    "rel.keepIt": "La garder",
    "rel.goOfficial": "Officialiser — cachez-nous des autres",
    "rel.requestSent": "⏳ Demande envoyée — en attente de {name}",
    "rel.togetherSince": "💞 Officiellement ensemble depuis {date}",
    "rel.together": "💞 Officiellement ensemble",
    "rel.coupleTitle": "💞 Vous êtes officiellement ensemble",
    "rel.coupleDesc": "Vous et {name} êtes invisibles pour les autres. L'app est rien que pour vous deux — chat, rencontres et rendez-vous premium.",
    "rel.coupleHint": "Changement de plans ? Chacun de vous peut y mettre fin à tout moment dans les Paramètres.",
    "rel.toastSent": "💍 Demande d'officialisation envoyée à {name} !",
    "rel.toastTogether": "💞 Vous et {name} êtes officiellement ensemble !",
    "rel.toastEnded": "Relation terminée — vous êtes de nouveau visible sur l'app",
    "rel.toastPrivate": "Ce membre est dans une relation officielle 💞",
    "rel.toastActive": "Vous êtes dans une relation officielle — l'app est rien que pour vous deux 💞",
    "invite.admirerTitle": "Vous avez un admirateur secret 💘",
    "invite.dreamTitle": "{name} garde une invitation à un rendez-vous de rêve pour vous",
    "invite.admirerSub": "{name} a un message d'un admirateur secret pour vous — mais il reste scellé jusqu'à votre inscription.",
    "invite.dreamSub": "Quelqu'un a préparé quelque chose de spécial — les détails restent scellés jusqu'à votre inscription.",
    "invite.lock": "Inscrivez-vous gratuitement pour débloquer votre surprise",
    "invite.claimedNote": "Cette invitation a déjà été révélée. Rejoignez-nous quand même et découvrez qui vous attend !",
    "invite.reveal": "Révéler ma surprise",
    "invite.login": "Déjà membre ? Connectez-vous",
    "invite.expired": "Cette invitation a expiré",
    "invite.explore": "Découvrir LuxeMeet",
    "landing.goBadge": "Conçu pour les vraies fins heureuses",
    "landing.goTitle1": "Quand ça devient sérieux,",
    "landing.goTitle2": "Officialisez 💞",
    "landing.goDesc": "Vous avez trouvé la bonne personne ? Un geste et vous disparaissez tous les deux du fil des autres — pas de profils, pas de messages, pas de distractions. L'app devient rien que pour vous deux : chat privé, rencontres et rendez-vous premium. Et si les choses changent, chacun peut le désactiver à tout moment.",
    "landing.goChip1": "🙈 Invisibles pour les autres",
    "landing.goChip2": "💬 Tout reste ouvert entre vous deux",
    "landing.goChip3": "🔄 Réversible à tout moment",
    "common.years": "ans",
    "form.proposedDateTime": "Date et heure proposées",
    "form.duration": "Durée (optionnel)",
    "form.proposedLocation": "Lieu proposé",
    "form.messageOptional": "Message (optionnel)",
    "form.openEnded": "Sans limite",
    "form.writeMessage": "Écrivez votre message...",
    "form.addPersonalMessage": "Ajoutez un message personnel...",
    "form.searchVenue": "Recherchez le lieu ou l'adresse exacte...",
    "offerModal.selectDateType": "Choisissez le type de rendez-vous...",
    "offerModal.amountPlaceholder": "Saisissez le montant (100-1000)",
    "offerModal.amountHint": "Vous paierez ce montant si votre rendez-vous accepte ({fee}% de frais de plateforme)",
    "offerModal.transportHint": "Payé avec votre offre et reversé à 100% à votre rendez-vous pour le transport (sans frais).",
    "offerModal.durationHint": "La durée souhaitée du rendez-vous — des attentes claires pour vous deux.",
    "tour.subtitle": "Un essai de 60 secondes — rien n'est jamais facturé",
    "tour.step1Title": "Dites bonjour dans le chat",
    "tour.step1Desc": "{name} vous a déjà écrit — envoyez une réponse",
    "tour.step2Title": "Demandez un rendez-vous",
    "tour.step2Desc": "Totalement gratuit — regardez-le être accepté",
    "tour.step3Title": "Envoyez une offre de rendez-vous premium",
    "tour.step3DescSent": "Envoyée ! Simulez le paiement sur votre page Offres",
    "tour.step3Desc": "Sans emplacement, sans argent réel — simulation complète",
    "tour.go": "Go",
    "tour.doneTitle": "Vous maîtrisez LuxeMeet ! 🎉",
    "tour.doneDesc": "Chat, rendez-vous et offres premium — vous avez tout essayé. Maintenant, place au réel.",
    "tour.browseReal": "Parcourir les vrais membres",
    "common.freeTest": "Essai gratuit",
    "discover.aiTestNote": "Compagnon de test — chat, rendez-vous et offres premium sont des simulations GRATUITES. Jamais de paiement réel.",
    "discover.meetUp": "Se voir",
    "profile.msgTitle": "Envoyer un message à {name}",
    "profile.msgCostPayer": "Démarrer une conversation coûte 10 crédits, puis 5 crédits par message. Ses réponses sont gratuites.",
    "profile.msgFree": "Gratuit pour vous sur {app} — ce chat arrive dans sa boîte {app}, où répondre lui coûte des crédits.",
    "profile.sendMessage": "Envoyer le message",
    "profile.meetupTitle": "Demander un rendez-vous avec {name}",
    "profile.meetupCost": "Demander un rendez-vous coûte 25 crédits.",
    "profile.meetupFree": "Gratuit pour vous sur {app} — la demande apparaîtra dans ses rendez-vous {app}.",
    "profile.meetupTest": "🧪 Essai gratuit — votre compagnon IA acceptera automatiquement pour vous montrer tout le parcours. Aucun crédit facturé.",
    "profile.sendMeetup": "Envoyer la demande",
    "profile.costsMsg": "Message : 10 crédits (premier) / 5 crédits (réponse)",
    "profile.costsMeetup": "Demande de rendez-vous : 25 crédits",
    "offerModal.title": "Envoyer une offre de rendez-vous premium",
    "offerModal.desc": "Envoyez une offre de rendez-vous rémunérée à {name}",
    "offerModal.testBanner": "🧪 Essai avec {name} — pas d'emplacement requis, et le paiement est simulé (jamais facturé).",
    "offerModal.needSlot": "Vous devez d'abord acheter un emplacement premium",
    "offerModal.purchaseSlot": "Acheter un emplacement (50 $)",
    "offerModal.slotsAvailable": "Emplacements disponibles : {n}",
    "offerModal.testNoSlot": "Offre d'essai — aucun emplacement requis",
    "offerModal.repeatNoSlot": "Rendez-vous répété — aucun emplacement requis",
    "offerModal.amount": "Montant de l'offre *",
    "offerModal.transport": "Frais de transport (optionnel)",
    "offerModal.proposedDate": "Date proposée *",
    "offerModal.proposedTime": "Heure proposée *",
    "offerModal.duration": "Durée (optionnel)",
    "offerModal.location": "Lieu *",
    "offerModal.dateType": "Type de rendez-vous *",
    "offerModal.message": "Message (optionnel)",
    "offerModal.sendOffer": "Envoyer l'offre",
    "voucher.unlimitedActive": "Offres de rendez-vous illimitées actives 🏆",
    "voucher.unlimitedUntil": "Aucun emplacement requis jusqu'au {date} — privilège de champion.",
    "voucher.championPrize": "Prix du champion : 2 semaines d'offres illimitées",
    "voucher.giftFrom": "Cadeau de {name} : 2 semaines d'offres illimitées",
    "voucher.activate": "Activer mes 2 semaines",
    "voucher.giftIt": "Offrir",
    "voucher.haveCode": "Vous avez un code cadeau ?",
    "voucher.redeem": "Utiliser",
    "voucher.giftsSent": "Cadeaux envoyés",
    "ideas.near": "Inspiration rendez-vous près de",
    "ideas.plan": "Planifier ce rendez-vous",
    "ideas.popular": "Lieux de rendez-vous populaires sur la plateforme",
    "ideas.map": "Carte",
    "ideas.cityTitle": "Idées de rendez-vous pour une autre ville",
    "ideas.cityDesc": "Un voyage ou un rendez-vous ailleurs ? Choisissez une ville et nous y trouverons des idées.",
    "ideas.show": "Voir les idées",
    "ideas.whoFor": "Pour qui est ce rendez-vous ?",
    "ideas.pickDesc": "choisissez un match et nous pré-remplirons votre offre premium.",
    "ideas.emptyPrefix": "Pas encore de matchs — ajoutez quelqu'un en favori dans",
    "ideas.emptySuffix": "ou commencez d'abord une discussion.",
    "profile.videos": "VIDÉOS",
  },
  de: {
    "nav.events": "Events",
    "leaderboard.youOnBoard": "🏆 Du bist auf der Bestenliste!",
    "leaderboard.youOnBoardSub": "Mitglieder der anderen Seite sehen dich hier platziert. Weiter so!",
    "events.title": "Events",
    "events.subtitle": "Exklusive Mitglieder-Events — trefft euch im echten Leben.",
    "events.empty": "Zurzeit keine anstehenden Events — schau bald wieder vorbei!",
    "events.loading": "Events werden geladen…",
    "events.spotsLeft": "{n} Plätze frei",
    "events.soldOut": "Ausverkauft",
    "events.joinedChip": "Du bist dabei!",
    "events.free": "Kostenlos",
    "events.feeNote": "{price} $ + 2 $ Bearbeitungsgebühr",
    "events.payCredits": "Mit {n} Credits teilnehmen",
    "events.payPaypal": "Mit PayPal zahlen · {total} $",
    "events.joinFree": "Kostenlos teilnehmen",
    "events.notEnough": "Nicht genug Credits — dieses Event kostet {n} Credits",
    "events.joinedToast": "🎟️ Du bist dabei! Prüfe deine E-Mail für die Bestätigung.",
    "events.payCancelled": "Zahlung abgebrochen",
    "events.captureFail": "Wir konnten deine Zahlung nicht bestätigen — bitte versuche es erneut",
    "events.bannerTitle": "🎉 Anstehendes Event",
    "events.bannerCta": "Events ansehen",
    "notif.eventJoined.t": "🎟️ Du bist dabei!",
    "notif.eventJoined.b": "Dein Platz bei \"{title}\" ist bestätigt. Wir sehen uns dort!",
    "notif.eventCancelled.t": "😔 Event abgesagt",
    "notif.eventCancelled.b": "\"{title}\" wurde abgesagt. Falls du bezahlt hast, ist deine Erstattung unterwegs.",
    "terms.contactT": "Kontakt",
    "terms.contactP": "Fragen, Anliegen oder Feedback? Erreiche uns jederzeit:",
    "msdluxe.tapSound": "Für Ton tippen",
    "msdluxe.badge": "Deine KI-Gastgeberin",
    "msdluxe.title1": "Lerne Ms DLuxe kennen",
    "msdluxe.title2": "Sie zeigt dir alles",
    "msdluxe.desc": "Ms DLuxe erklärt persönlich, wie alles funktioniert — Credits, Premium-Date-Angebote, Verdienst und Sicherheit.",
    "msdluxe.luxeCard": "So funktioniert LuxeMeet",
    "msdluxe.dluxeCard": "So funktioniert DLuxe",
    "msdluxe.download": "Herunterladen",
    "msdluxe.share": "Speichern, posten, an Freunde schicken — sie gehören dir.",
    "nav.msdluxeVideos": "So funktioniert's · Ms DLuxe",
    "credits.requestRefund": "Erstattung anfordern",
    "credits.refundRequested": "Erstattung angefordert",
    "credits.refunded": "Erstattet",
    "credits.refundDeniedChip": "Nicht genehmigt",
    "credits.refundDialogTitle": "Erstattung anfordern",
    "credits.refundDialogDesc": "Sag uns, warum du eine Erstattung für diesen Kauf möchtest. Unser Team prüft jede Anfrage und du erhältst eine Benachrichtigung und E-Mail mit der Entscheidung.",
    "credits.refundReasonPh": "Warum möchtest du eine Erstattung?",
    "credits.refundSubmit": "Anfrage senden",
    "credits.refundSent": "Erstattungsanfrage gesendet — wir prüfen sie in Kürze",
    "safety.checkinToggle": "Sicherheits-Check-in",
    "safety.checkinDesc": "Wähle eine Zeit — wir fragen, ob du sicher zu Hause bist. Ohne Antwort innerhalb von 2 Stunden wird dein Freund alarmiert.",
    "safety.checkinPast": "Wähle eine Check-in-Zeit in der Zukunft",
    "safety.checkinScheduled": "Gesendet! Dein Freund hat die Details und dein Sicherheits-Check-in ist geplant.",
    "checkin.title": "Bist du sicher zu Hause angekommen?",
    "checkin.body": "Tippe zum Bestätigen — sonst erhält {email} eine Warnung.",
    "checkin.confirmBtn": "Ich bin sicher zu Hause ✅",
    "checkin.confirmed": "Schön, dass du sicher bist! Dein Freund wurde benachrichtigt 💛",
    "notif.safetyCheckin.t": "🛟 Bist du sicher zu Hause?",
    "notif.safetyCheckin.b": "Tippe zum Bestätigen, dass du sicher zu Hause bist — sonst erhält {email} in 2 Stunden eine Warnung.",
    "landing.freeCreditsPromo": "Neue Mitglieder erhalten 50 Gratis-Credits — genau genug, damit ein KI-Companion deinem Schwarm in den sozialen Medien eine Verehrer-Einladung schickt.",
    "landing.langHighlight": "In 8 Sprachen verfügbar mit integrierter Chat-Übersetzung — triff Menschen aus aller Welt.",
    "saPromo.title": "Deine Gratis-Credits warten",
    "saPromo.body": "Du hast {n} Credits — genug, damit ein KI-Companion deinem Schwarm in den sozialen Medien eine Verehrer-Einladung schickt.",
    "saPromo.cta": "Verehrer-Einladung senden",
    "notif.refundApproved.t": "✅ Erstattung genehmigt",
    "notif.refundApproved.b": "Deine Erstattung für {desc} wurde genehmigt — dein Konto wurde angepasst. Details per E-Mail.",
    "notif.refundDenied.t": "Update zu deiner Erstattungsanfrage",
    "notif.refundDenied.b": "Deine Erstattungsanfrage für {desc} wurde geprüft — Details per E-Mail.",
    "safety.share": "Plan mit Freund teilen",
    "safety.title": "Sende deinen Date-Plan an einen Freund",
    "safety.desc": "Zu deiner Sicherheit: Maile deine Reiseroute und das Profil deines Dates an eine Vertrauensperson.",
    "safety.emailPh": "freund@email.com",
    "safety.notePh": "Optionale Notiz an deinen Freund…",
    "safety.send": "Senden",
    "safety.sent": "Gesendet! Dein Freund hat die Details.",
    "discover.companionsTitle": "Lerne die KI-Companions kennen",
    "incog.title": "Inkognito-Modus",
    "incog.desc": "Bestimme, wer dein Profil finden kann, während du vollen Zugriff auf Chats, Angebote und Treffen behältst.",
    "incog.toggleLabel": "Mein Profil in Entdecken verbergen",
    "incog.toggleDesc": "Niemand kann dich beim Stöbern finden. Bestehende Unterhaltungen und Angebote funktionieren weiter.",
    "incog.on": "Inkognito-Modus AN — du bist in Entdecken verborgen",
    "incog.off": "Du bist wieder in Entdecken sichtbar",
    "incog.hiddenFrom": "Du bist außerdem individuell vor {n} Mitglied(ern) verborgen (über den Augen-Button auf deren Profil).",
    "ratep.title": "Privatsphäre der Date-Bewertungen",
    "ratep.desc": "Wähle, ob du an Date-Bewertungen teilnimmst und was auf deinem Profil erscheint.",
    "ratep.partLabel": "An Date-Bewertungen teilnehmen",
    "ratep.partDesc": "Wenn aus, kann niemand deine Dates bewerten und keine Bewertung erscheint auf deinem Profil",
    "ratep.commentsLabel": "Geschriebene Bewertungen auf meinem Profil zeigen",
    "ratep.commentsDesc": "Wenn aus, wird nur deine Sterne-Bewertung gezeigt — geschriebene Kommentare bleiben privat",
    "ratep.saved": "Bewertungseinstellungen gespeichert",
    "offers.planDate": "Date planen",
    "planDate.title": "Plane ein Date mit…",
    "planDate.desc": "Wähle jemanden aus der Mitgliederliste, um ein Premium-Date-Angebot zu senden.",
    "planDate.search": "Nach Namen suchen…",
    "planDate.empty": "Keine Mitglieder gefunden",
    "notif.promoRedeemed.t": "🎁 Promo-Code eingelöst!",
    "notif.promoRedeemed.b": "Dein Code {code} hat {what} zu deinem Konto hinzugefügt. Viel Spaß!",
    "notif.creditsGranted.t": "🎁 Credits hinzugefügt!",
    "notif.creditsGranted.b": "Das LuxeMeet-Team hat {n} Credits zu deinem Konto hinzugefügt.",
    "notif.slotGranted.t": "🎁 Gratis Premium-Date-Slot!",
    "notif.slotGranted.b": "Du hast {n} gratis $50-Premium-Date-Slot(s) erhalten — plane ein Date auf der Angebote-Seite!",
    "register.saRevealed": "💌 Dein heimlicher Verehrer wurde enthüllt — sieh in deine Benachrichtigungen und deinen Chat!",
    "tour.replayTitle": "60-Sekunden-Tour",
    "tour.replayDesc": "Die geführte Tour verpasst? Wiederhole sie jederzeit mit deinem KI-Companion.",
    "tour.replayBtn": "Nochmal ansehen",
    "notif.saReveal.t": "💌 Heimlicher Verehrer enthüllt!",
    "notif.saReveal.b": "Es war die ganze Zeit {admirer}! {name} hat dir die ganze Geschichte im Chat hinterlassen. Tippe, um das Profil anzusehen.",
    "register.saBanner": "💌 Dein heimlicher Verehrer wartet — erstelle dein kostenloses Konto und finde heraus, wer es ist.",
    "credits.earnerNote": "Chatten ist für dich in diesem Modus kostenlos — Credits sind für Extras wie Verehrer-Anfragen (50 Credits).",
    "si.trackJoined": "Beigetreten als {name} — Profil ansehen",
    "notif.siJoined.t": "🎉 Die Person ist da!",
    "notif.siJoined.b": "{invitee} ist gerade über deine Verehrer-Einladung an {handle} beigetreten. Finde die Person!",
    "si.trackTitle": "Deine Verehrer-Anfragen",
    "si.trackLine": "{kind} an {handle} auf {platform}",
    "si.trackVia": "über {name}",
    "si.trackKindAdmirer": "Verehrer-Nachricht",
    "si.trackKindDate": "Date-Anfrage",
    "si.trackPending": "Ausstehend",
    "si.trackSent": "Gesendet",
    "si.trackRefunded": "Erstattet",
    "discover.boosted": "Geboostet",
    "discover.inDemand": "🔥 Sehr gefragt",
    "discover.diamond": "Diamant",
    "discover.verifiedBadge": "Verifiziert",
    "gal.addPhoto": "Foto hinzufügen",
    "gal.addVideo": "Video hinzufügen",
    "gal.videoIntros": "Video-Intros ({n}/2)",
    "gal.videoRules": "Bis zu 2 kurze Videos (max. 60s, 50MB). KI-geprüft — keine Nacktheit oder sexuellen Inhalte.",
    "gal.noPhotos": "Noch keine Fotos. Füge dein erstes Foto hinzu!",
    "si.button": "Heimlicher Verehrer via Social Media",
    "si.title": "Heimlicher Verehrer über {name}",
    "si.desc": "{name} sendet eine heimliche Verehrer-Nachricht oder eine Date-Anfrage an eine Person deiner Wahl in den sozialen Medien — mit einer Einladung zur App. Versand innerhalb von 24 Stunden.",
    "si.typeLabel": "Was soll gesendet werden?",
    "si.typeAdmirer": "Heimliche Verehrer-Nachricht",
    "si.typeDate": "Date-Anfrage",
    "si.platform": "Plattform",
    "si.handle": "Benutzername der Person",
    "si.note": "Persönliche Note (optional)",
    "si.notePh": "Etwas, das {name} erwähnen soll?",
    "si.submit": "Anfrage senden ({n} Credits)",
    "si.success": "Anfrage eingereiht! Du bekommst eine Benachrichtigung, sobald {name} sie gesendet hat.",
    "si.errHandle": "Bitte gib den Social-Media-Namen der Person ein",
    "notif.siPending.t": "💌 Anfrage erhalten!",
    "notif.siPending.b": "{name} sendet deine {kind} an {handle} auf {platform}. 50 Credits wurden berechnet — du wirst benachrichtigt, sobald sie gesendet wurde.",
    "notif.siSent.t": "💘 Es ist raus!",
    "notif.siSent.b": "{name} hat deine {kind} an {handle} auf {platform} gesendet. Daumen drücken!",
    "notif.siDeclined.t": "Anfrage erstattet",
    "notif.siDeclined.b": "Deine {kind} über {name} konnte nicht gesendet werden. Deine 50 Credits wurden erstattet.",
    "notif.kindAdmirer": "heimliche Verehrer-Nachricht",
    "notif.kindDate": "Date-Anfrage",
    "help.title": "Luxe Assistant",
    "help.subtitle": "Frag mich alles über LuxeMeet",
    "help.hi": "Hallo{name}! 👋",
    "help.welcome": "Ich kann dir erklären, wie Credits, Premium-Date-Angebote, Treuhand, Bestätigungscodes und Auszahlungen funktionieren. Was möchtest du wissen?",
    "help.thinking": "Luxe denkt nach...",
    "help.inputPh": "Schreib deine Frage...",
    "help.error": "Entschuldige, ich habe gerade Schwierigkeiten. Bitte versuche es gleich noch einmal.",
    "chat.translate": "Übersetzen",
    "chat.showOriginal": "Original anzeigen",
    "chat.translating": "Übersetze...",
    "chat.translateFail": "Übersetzung gerade nicht möglich",
    "chat.sentCredits": "Nachricht gesendet ({n} Credits)",
    "chat.noCredits": "Nicht genügend Credits",
    "chat.tapToUse": "{ai} — zum Verwenden antippen",
    "chat.member": "{app}-Mitglied",
    "land.newMatch": "Neues Match!",
    "land.firstMove": "Mach den ersten Schritt",
    "land.dateTerms": "Dates zu deinen Bedingungen",
    "land.youChoose": "Du wählst. Du bietest.",
    "land.startChatting": "Jetzt chatten",
    "land.likes": "{n} Likes",
    "land.thisWeek": "Diese Woche",
    "promo.title": "Sieh, was es besonders macht",
    "promo.desc": "Ein kurzer Rundgang durch LuxeMeet & DLuxe — echte Dates, Premium-Angebote und KI-gestützte Romantik.",
    "promo.tapSound": "Für Ton tippen",
    "promo.shareInvite": "Teile den Film — dein Einladungslink ist enthalten 🎁",
    "promo.shareFriends": "Teile den Film mit Freunden",
    "promo.copiedInvite": "Filmlink mit deinem Einladungscode kopiert!",
    "promo.copied": "Filmlink kopiert!",
    "promo.shareMsg": "🎬 Schau dir das an — LuxeMeet, die Dating-App, bei der echte Dates wirklich stattfinden.",
    "promo.joinInvite": "Tritt über meinen Einladungslink bei:",
    "promo.shareTg": "🎬 Schau dir das an — die Dating-App, bei der echte Dates wirklich stattfinden",
    "promo.mute": "Musik stummschalten",
    "promo.unmute": "Musik einschalten",
    "prof.back": "Zurück",
    "prof.addPhotosHint": "Füge Fotos hinzu, um aufzufallen",
    "prof.noPhotos": "{name} hat noch keine Fotos hinzugefügt",
    "prof.addPhotos": "Fotos hinzufügen",
    "prof.aiCompanion": "KI-Begleitung",
    "prof.reviewOne": "Date-Bewertung",
    "prof.reviewMany": "Date-Bewertungen",
    "prof.bioEmptyOwn": "Deine Bio ist leer — ein paar Sätze über dich bewirken viel.",
    "prof.bioEmptyOther": "{name} umgibt sich mit einem Hauch von Geheimnis — sag Hallo, um mehr zu erfahren.",
    "prof.afterDate": "— {name}, nach dem Date",
    "prof.interests": "INTERESSEN",
    "prof.photos": "FOTOS",
    "prof.videos": "VIDEOS",
    "prof.thinking": "Denke nach...",
    "prof.suggestOpener": "{ai}: Opener vorschlagen",
    "prof.offerSent": "Angebot gesendet! Den Status findest du auf deiner Angebote-Seite.",
    "prof.tSuggestFail": "Vorschläge sind gerade nicht verfügbar",
    "prof.tRequestFail": "Anfrage konnte nicht gesendet werden",
    "prof.tFavAdded": "Zu Favoriten hinzugefügt ❤️",
    "prof.tFavRemoved": "Aus Favoriten entfernt",
    "prof.tFavFail": "Favoriten-Aktualisierung fehlgeschlagen",
    "prof.tVisibilityFail": "Sichtbarkeits-Aktualisierung fehlgeschlagen",
    "prof.tHidden": "Du bist jetzt für {name} in Entdecken verborgen",
    "prof.tVisible": "Du bist wieder für {name} sichtbar",
    "prof.tLoadFail": "Profil konnte nicht geladen werden",
    "prof.tMsgEmpty": "Bitte gib eine Nachricht ein",
    "prof.tNoCredits": "Nicht genügend Credits. Kaufe mehr Credits, um fortzufahren.",
    "prof.tMsgFail": "Nachricht konnte nicht gesendet werden",
    "prof.tMeetupMissing": "Bitte Datum und Ort angeben",
    "prof.tMeetupFail": "Treffen-Anfrage konnte nicht gesendet werden",
    "nb.title": "Benachrichtigungen",
    "nb.empty": "Noch keine Benachrichtigungen",
    "time.now": "gerade eben",
    "time.m": "vor {n} Min.",
    "time.h": "vor {n} Std.",
    "time.d": "vor {n} Tg.",
    "notif.photoVerified.t": "✅ Du bist verifiziert!",
    "notif.photoVerified.b": "Dein Selfie-Check war erfolgreich — das Verifiziert-Abzeichen wird jetzt in deinem Profil angezeigt.",
    "notif.relRequest.t": "💍 Offiziell werden?",
    "notif.relRequest.b": "{name} möchte es mit dir offiziell machen! Nimm in den Einstellungen an und ihr verschwindet beide aus dem Feed aller anderen.",
    "notif.relDeclined.t": "Anfrage, offiziell zu werden, abgelehnt",
    "notif.relDeclined.b": "{name} ist noch nicht bereit, offiziell zu werden.",
    "notif.relActive.t": "💞 Ihr seid offiziell zusammen!",
    "notif.relActive.b": "{name} hat JA gesagt. Ihr seid jetzt für alle anderen verborgen — die App gehört nur euch beiden.",
    "notif.relEnded.t": "Offizielle Beziehung beendet",
    "notif.relEnded.b": "{name} hat die offizielle Beziehung beendet. Ihr seid beide wieder in der App sichtbar.",
    "notif.dateReview.t": "{stars} Neue Date-Bewertung!",
    "notif.dateReview.b": "{name} hat euer Date mit {rating}/5 bewertet. {comment}",
    "notif.escrow.t": "💰 Date-Zahlung erhalten!",
    "notif.escrow.b": "{name} hat ${amount} für euer Date bezahlt. ${payout} liegen im Treuhandkonto. Bestätige das Date mit dem 6-stelligen Code, um bezahlt zu werden.",
    "notif.escrowBoost.t": "💰 Date-Zahlung erhalten!",
    "notif.escrowBoost.b": "{name} hat ${amount} für euer Date bezahlt. ${payout} liegen im Treuhandkonto — inklusive deines 90%-Empfehlungsboosts! Bestätige das Date mit dem 6-stelligen Code, um bezahlt zu werden.",
    "notif.offerPaid.t": "💘 Date gebucht!",
    "notif.offerPaid.b": "Deine Zahlung für das Date mit {name} ist bestätigt. Dein 6-stelliger Bestätigungscode liegt auf der Angebote-Seite bereit — teile ihn danach mit deinem Date.",
    "notif.refSlot.t": "🎁 Gratis Premium-Slot verdient!",
    "notif.refSlot.b": "{name}, den du geworben hast, hat gerade einen Premium-Slot gekauft — du hast einen GRATIS $50-Slot als Belohnung erhalten!",
    "notif.boostActivated.t": "🚀 Profil geboostet!",
    "notif.boostActivated.b": "Dein Profil wird die nächsten 24 Stunden ganz oben in Entdecken angezeigt.",
    "notif.creditsAdded.t": "🪙 Credits hinzugefügt!",
    "notif.creditsAdded.b": "{credits} Credits aus deinem {package}-Kauf sind jetzt auf deinem Konto. Neuer Kontostand: {balance}.",
    "notif.unlimited.t": "♾️ Unbegrenzte Angebote aktiviert!",
    "notif.unlimited.b": "Dein Champion-Preis ist aktiv — sende die nächsten 2 Wochen unbegrenzt Date-Angebote (keine Slots nötig)!",
    "notif.voucherGifted.t": "🎁 Du hast einen Champion-Gutschein erhalten!",
    "notif.voucherGifted.b": "{name} hat dir 2 Wochen unbegrenzte Date-Angebote geschenkt — aktiviere es in den Einstellungen vor dem {date}.",
    "notif.voucherRedeemed.t": "🎁 Dein Geschenk wurde eingelöst!",
    "notif.voucherRedeemed.b": "{name} hat den Champion-Gutschein eingelöst, den du verschenkt hast.",
    "notif.refBoost.t": "🎁 Empfehlungsbelohnung freigeschaltet!",
    "notif.refBoost.b": "{name}, den du geworben hast, hat sein erstes Premium-Date abgeschlossen — dein NÄCHSTES Verdienst-Date zahlt 90% statt 80% aus!",
    "notif.payoutProcessing.t": "✅ Date bestätigt!",
    "notif.payoutProcessing.b": "Deine Auszahlung von ${amount} wird bearbeitet und trifft innerhalb von 24-48 Stunden auf deinem PayPal ein.",
    "notif.offerExpiredSender.t": "⏰ Date-Angebot abgelaufen",
    "notif.offerExpiredSender.b": "Dein Date-Angebot über ${amount} ist nach 7 Tagen abgelaufen. Dein Premium-Slot wurde freigegeben, damit du ein neues Angebot senden kannst.",
    "notif.offerExpiredRecipient.t": "⏰ Date-Angebot abgelaufen",
    "notif.offerExpiredRecipient.b": "Ein von dir angenommenes Date-Angebot ist abgelaufen, weil die Zahlung nicht innerhalb von 7 Tagen abgeschlossen wurde.",
    "notif.dateReminder24.t": "💜 Date-Erinnerung: morgen!",
    "notif.dateReminder24.b": "Dein Date mit {name} ist morgen — {when}, {where}.",
    "notif.offerExpiringPay.t": "⏳ Angebot läuft in 24 Stunden ab!",
    "notif.offerExpiringPay.b": "Dein Date-Angebot über ${amount} an {name} läuft morgen ab — schließe die Zahlung ab, bevor es verfällt und dein Slot freigegeben wird.",
    "notif.offerExpiringWait.t": "⏳ Angebot läuft in 24 Stunden ab!",
    "notif.offerExpiringWait.b": "Dein Date-Angebot über ${amount} an {name} läuft morgen ab — warte auf ihre Antwort oder hake nach, bevor es verfällt und dein Slot freigegeben wird.",
    "notif.matchInsights.t": "💌 Deine wöchentlichen Match-Insights",
    "notif.matchInsights.b": "{views} Profilaufrufe und {favs} neue Favoriten diese Woche — darunter {names}. Sag Hallo oder booste dein Profil, um ein Date-Angebot anzustoßen!",
    "notif.streak1.t": "🔥 Serien-Fortschritt: {streak}/3",
    "notif.streak1.b": "Noch ein 4★+-Date und 150 Gratis-Credits gehören dir!",
    "notif.streakN.t": "🔥 Serien-Fortschritt: {streak}/3",
    "notif.streakN.b": "Noch {togo} 4★+-Dates bis zu 150 Gratis-Credits.",
    "notif.streakDone.t": "🔥 Serien-Fortschritt: {streak}/3",
    "notif.streakDone.b": "Deine Belohnung ist unterwegs!",
    "notif.rankUp.t": "🏆 Du bist #{rank} auf dem Top-Bewertet-Board",
    "notif.rankUp.b": "Du bist #{rank} auf dem Top-Bewertet-Board. 📈 {spots} Plätze besser als letzte Woche! Der Monats-#1 gewinnt 2 Wochen unbegrenzte Date-Angebote.",
    "notif.rankDown.t": "🏆 Du bist #{rank} auf dem Top-Bewertet-Board",
    "notif.rankDown.b": "Du bist #{rank} auf dem Top-Bewertet-Board. 📉 {spots} Plätze schlechter als letzte Woche — ein tolles Date bringt dich sofort zurück. Der Monats-#1 gewinnt 2 Wochen unbegrenzte Date-Angebote.",
    "notif.rankSteady.t": "🏆 Du bist #{rank} auf dem Top-Bewertet-Board",
    "notif.rankSteady.b": "Du bist #{rank} auf dem Top-Bewertet-Board. 🎯 Stabil im Vergleich zur letzten Woche. Der Monats-#1 gewinnt 2 Wochen unbegrenzte Date-Angebote.",
    "notif.rankNew.t": "🏆 Du bist #{rank} auf dem Top-Bewertet-Board",
    "notif.rankNew.b": "🎉 NEU: Du bist auf Platz #{rank} ins Top-Bewertet-Board eingestiegen! Der Monats-#1 gewinnt 2 Wochen unbegrenzte Date-Angebote.",
    "notif.rankOff.t": "🏆 Ranglisten-Update",
    "notif.rankOff.b": "Du bist diese Woche aus dem Top-Bewertet-Board gerutscht — ein tolles Date bringt dich zurück. Der Monats-#1 gewinnt 2 Wochen unbegrenzte Date-Angebote.",
    "notif.boostEnded.t": "⚡ Dein Boost ist beendet",
    "notif.boostEnded.b": "Dein 24-Stunden-Boost ist beendet. Er hat dir {views} Profilaufrufe eingebracht. Booste erneut über die Entdecken-Seite, um oben zu bleiben!",
    "notif.boostEndedExtra.t": "⚡ Dein Boost ist beendet",
    "notif.boostEndedExtra.b": "Dein 24-Stunden-Boost ist beendet. Er hat dir {views} Profilaufrufe eingebracht — etwa {extra} mehr als an einem normalen Tag. Booste erneut über die Entdecken-Seite, um oben zu bleiben!",
    "notif.dateSoon1h.t": "⏰ Dein Date beginnt bald!",
    "notif.dateSoon1h.b": "Dein Date mit {name} ist in weniger als einer Stunde — {time} bei {location}.{tip}",
    "notif.dateSoon24.t": "💜 Dein Date ist in 24 Stunden!",
    "notif.dateSoon24.b": "Dein Date mit {name} ist in 24 Stunden — {time} bei {location}.{tip}",
    "notif.dateSoonTip": " Öffne dein Angebot für den Live-Countdown, das Wetter und Outfit-Tipps!",
    "notif.badgeFire.t": "🔥 Du bist on fire!",
    "notif.badgeFire.b": "Du bist einer der 3 meistkontaktierten Männer auf DLuxe diesen Monat — das 🔥-Abzeichen wird jetzt in deinem Profil angezeigt.",
    "notif.hotStreak.t": "🔥 Heiße Serie! 150 GRATIS-Credits",
    "notif.hotStreak.b": "3 top-bewertete Dates in Folge — das Popular-Paket mit 150 Credits wurde deinem Konto GRATIS hinzugefügt. Halte die Serie am Leben!",
    "notif.badgeDiamond.t": "💎 Diamant-Abzeichen verdient!",
    "notif.badgeDiamond.b": "Du hast 3 Premium-Dates über $500+ abgeschlossen — das Diamant-Abzeichen glänzt jetzt in deinem Profil.",
    "notif.champion.t": "🏆 Ranglisten-Champion!",
    "notif.champion.b": "Du hast diesen Monat #1 in '{section}' erreicht! Preise: ein GRATIS 7-Tage-Profil-Boost (bereits aktiv) und ein Gutschein für 2 Wochen UNBEGRENZTE Date-Angebote — aktiviere ihn jederzeit in den nächsten 6 Monaten in den Einstellungen.",
    "notif.anniversary.t": "💞 {months} {monthsWord} zusammen!",
    "notif.anniversary.b": "Du und {name} seid gerade {months} {monthsWord} offiziell zusammen. Feiert es — Idee: {idea}",
    "notif.monthWord": "Monat",
    "notif.monthsWord": "Monate",
    "notif.annIdea0": "Stellt euer allererstes Date nach — gleicher Ort, gleiche Bestellung, neue Erinnerungen.",
    "notif.annIdea1": "Kocht zusammen ein Drei-Gänge-Dinner bei Kerzenschein, Handys aus.",
    "notif.annIdea2": "Sonnenuntergangs-Picknick mit den Lieblingssnacks des anderen und einer gemeinsamen Playlist.",
    "notif.annIdea3": "Bucht eine Paar-Spa-Stunde und stoßt danach mit etwas Prickelndem an.",
    "notif.annIdea4": "Macht einen Mini-Roadtrip in eine Stadt, die keiner von euch je besucht hat.",
    "notif.annIdea5": "Sternenguck-Nacht: Decken, heiße Schokolade und euer Lied in Dauerschleife.",
    "notif.annIdea6": "Tanzkurs für zwei — Salsa, Bachata oder was auch immer euch zum Lachen bringt.",
    "notif.annIdea7": "Museums- oder Galerie-Date, danach Dessert an einem schicken Ort.",
    "notif.annIdea8": "Schreibt euch gegenseitig einen Brief über euren bisherigen Lieblingsmoment und tauscht sie beim Abendessen.",
    "notif.annIdea9": "Dinner-Reservierung auf einer Dachterrasse — macht euch schick wie beim ersten Date.",
    "notif.annIdea10": "Wein- oder Schokoladenverkostung, gefolgt von einem gemütlichen Heimspaziergang.",
    "notif.annIdea11": "Plant euren Traumurlaub zusammen beim Frühstück im Bett — und bucht dann einen Teil davon.",
    "notif.companionInvite.t": "💌 {name} hat deine Überraschung!",
    "notif.companionInvite.b": "Deine geheimnisvolle Einladung wurde in deinem Chat enthüllt.",
    "notif.supportResolved.t": "✅ Support-Anfrage gelöst",
    "notif.supportResolved.b": "Deine {label} \"{subject}\" wurde geprüft und gelöst.",
    "notif.supportResolvedResp.t": "✅ Support-Anfrage gelöst",
    "notif.supportResolvedResp.b": "Deine {label} \"{subject}\" wurde geprüft und gelöst. Antwort: {resp}",
    "notif.labelRefund": "Rückerstattungsanfrage",
    "notif.labelComplaint": "Beschwerde",
    "notif.testMeetup.t": "{name} hat dein Treffen angenommen! 🎉",
    "notif.testMeetup.b": "Testlauf abgeschlossen — genau so sieht es aus, wenn ein echtes Mitglied annimmt. Es wurden keine Credits berechnet.",
    "notif.testCounter.t": "{name} hat ein Gegenangebot gesendet 💬",
    "notif.testCounter.b": "Testlauf: Gegenangebot über ${amount}. Nimm an oder lehne ab, um fortzufahren — immer noch kein echtes Geld.",
    "notif.testOfferAccepted.t": "{name} hat dein Date-Angebot angenommen! 💜",
    "notif.testOfferAccepted.b": "Testlauf: Klicke auf den Zahlung-simulieren-Button auf der Angebote-Seite, um den Rest des Ablaufs zu sehen — kein echtes Geld im Spiel.",
    "notif.testDateCompleted.t": "Test-Date mit {name} abgeschlossen! 🏆",
    "notif.testDateCompleted.b": "Das war der komplette Premium-Date-Ablauf — Angebot, Annahme, Zahlung, Code und Bestätigung. Kein echtes Geld wurde bewegt. Bereit, es mit einem echten Mitglied zu versuchen?",
    "notif.refChat.t": "🎁 +{credits} Credits verdient!",
    "notif.refChat.b": "{name} hat gerade angefangen zu chatten — {credits} Bonus-Credits wurden deinem Guthaben hinzugefügt.",
    "notif.payoutSent.t": "💸 Auszahlung gesendet!",
    "notif.payoutSent.b": "${amount} wurden an dein PayPal ({recipient}) gesendet.",
    "notif.favVerified.t": "✅ {name} ist jetzt verifiziert!",
    "notif.favVerified.b": "{name} aus deinen Favoriten hat gerade den Selfie-Check bestanden und das Verifiziert-Abzeichen erhalten.",
    "notif.favReviewed.t": "⭐ {name} hat eine tolle Bewertung erhalten!",
    "notif.favReviewed.b": "{name} aus deinen Favoriten hat gerade eine {rating}-Sterne-Date-Bewertung erhalten. Tolle Dates sind schnell ausgebucht!",
    "notif.favBoosted.t": "⚡ {name} hat gerade geboostet!",
    "notif.favBoosted.b": "{name} aus deinen Favoriten wird gerade ganz oben in Entdecken angezeigt — sag Hallo, solange sie im Rampenlicht steht!",
    "register.newMembers": "Neue Mitglieder erhalten",
    "register.promoLuxe1": "50 Gratis-Credits",
    "register.promoDluxe1": "Kostenloser Zugang + Einnahmen",
    "register.promoLuxe2": "Für Damen, die LuxeMeet beitreten",
    "register.promoDluxe2": "Herren treten DLuxe kostenlos bei — und verdienen mit Premium-Dates",
    "register.googleTerms": "Wenn du mit Google fortfährst, akzeptierst du unsere",
    "register.googleTermsLink": "AGB",
    "register.orEmail": "oder mit E-Mail registrieren",
    "register.hintF": "Frauen: kostenlos auf LuxeMeet (50 Start-Credits) — oder übernimm auf DLuxe die Führung mit Premium-Date-Angeboten an Männer.",
    "register.hintM": "Männer: investiere, um auf LuxeMeet in Kontakt zu treten — und genieße kostenlosen Zugang + verdiene mit Premium-Dates auf DLuxe.",
    "register.hintNone": "Wähle dein Geschlecht, um die verfügbaren Funktionen zu sehen",
    "register.refCode": "Empfehlungscode",
    "register.refOptional": "(optional)",
    "register.refPh": "Hast du einen Code? Gib ihn hier ein",
    "register.terms18": "Ich bin mindestens 18 Jahre alt und akzeptiere die",
    "register.termsLink": "AGB und die Haftungsfreistellung",
    "register.create": "Konto erstellen",
    "register.haveAccount": "Hast du schon ein Konto?",
    "register.errGender": "Bitte wähle dein Geschlecht",
    "register.errTerms": "Bitte akzeptiere die AGB, um fortzufahren",
    "register.errFail": "Registrierung fehlgeschlagen",
    "register.giftClaimed": "😕 Dieser Geschenkcode ({code}) wurde bereits eingelöst.",
    "register.giftExpired": "😕 Dieser Geschenkcode ({code}) ist abgelaufen.",
    "register.giftReady": "🎁 {name} hat dir einen Champion-Gutschein ({code}) geschenkt — er wird direkt nach deiner Registrierung deinem Konto gutgeschrieben!",
    "register.giftFriend": "Ein Freund",
    "set.tImgFile": "Bitte wähle eine Bilddatei",
    "set.tImgSize": "Das Bild muss kleiner als 5 MB sein",
    "set.tPhotoUpdated": "Profilfoto aktualisiert!",
    "set.tPhotoFail": "Foto-Upload fehlgeschlagen",
    "set.tPwMismatch": "Die neuen Passwörter stimmen nicht überein",
    "set.tPwShort": "Das Passwort muss mindestens 6 Zeichen lang sein",
    "set.tPwChanged": "Passwort erfolgreich geändert!",
    "set.tPwFail": "Passwortänderung fehlgeschlagen",
    "set.tProfileUpdated": "Profil aktualisiert!",
    "set.tProfileFail": "Profil-Aktualisierung fehlgeschlagen",
    "set.tLoggedOut": "Erfolgreich abgemeldet",
    "set.tDeactivated": "Konto deaktiviert. Melde dich innerhalb von 30 Tagen wieder an, um es zu reaktivieren.",
    "set.tDeleteFail": "Kontolöschung fehlgeschlagen",
    "pp.errInvalidEmail": "Bitte gib eine gültige E-Mail-Adresse ein",
    "pp.errNoMatch": "Die E-Mails stimmen nicht überein",
    "pp.errConfirm": "Bitte bestätige deine PayPal-E-Mail",
    "pp.errFix": "Bitte behebe die Fehler vor dem Speichern",
    "pp.savedOk": "PayPal-Einstellungen gespeichert und verifiziert!",
    "pp.saveFail": "Speichern der Einstellungen fehlgeschlagen",
    "pp.errImg": "Bitte lade eine Bilddatei hoch",
    "pp.errSize": "Die Datei muss kleiner als 5 MB sein",
    "pp.qrUploaded": "QR-Code hochgeladen!",
    "pp.qrFail": "QR-Code-Upload fehlgeschlagen",
    "terms.title": "Allgemeine Geschäftsbedingungen",
    "terms.updated": "Einschließlich Haftungsfreistellung — Zuletzt aktualisiert: Juni 2026 (v5)",
    "terms.back": "Zurück",
    "terms.footer": "© 2026 LuxeMeet & DLuxe. Alle Rechte vorbehalten.",
    "terms.s1t": "1. Annahme der Bedingungen",
    "terms.s1p1": "Mit der Erstellung eines Kontos oder der Nutzung von LuxeMeet oder seinem Begleitmodus DLuxe (zusammen \"die Plattform\") erklärst du dich mit diesen AGB und unserer Haftungsfreistellung einverstanden. Wenn du nicht einverstanden bist, nutze die Plattform nicht.",
    "terms.s2t": "2. Teilnahmeberechtigung (18+)",
    "terms.s2p1": "Du musst mindestens 18 Jahre alt sein, um LuxeMeet zu nutzen. Mit der Registrierung versicherst du, dass du 18 Jahre oder älter bist und diesen Vertrag rechtlich abschließen kannst. Konten von Minderjährigen werden sofort und ohne Rückerstattung gekündigt.",
    "terms.s3t": "3. Art des Dienstes",
    "terms.s3p1": "LuxeMeet ist ausschließlich eine Vermittlungsplattform. Wir stellen Werkzeuge bereit, mit denen Erwachsene sich kennenlernen, Nachrichten austauschen und Dates vereinbaren können. Wir sind an keiner Interaktion, Unterhaltung, Verabredung oder Vereinbarung zwischen Mitgliedern beteiligt. Wir führen keine strafrechtlichen Hintergrundprüfungen durch und geben keine Garantien für Identität, Verhalten, Absichten oder Kompatibilität eines Mitglieds.",
    "terms.s3p2": "Die Plattform kann Links zu unabhängigen Drittanbieterdiensten anzeigen, die bei der Date-Planung helfen — etwa OpenStreetMap und Google Maps für Orte, Uber für den Transport und Airbnb Experiences für Date-Ideen. Diese Dienste werden nicht von uns betrieben; ihre Nutzung unterliegt deren eigenen Bedingungen, und wir sind nicht für deren Inhalte, Preise oder Verfügbarkeit verantwortlich.",
    "terms.s4t": "4. Credits, Zahlungen & Premium-Date-Angebote",
    "terms.s4p1": "Männliche Mitglieder kaufen Credits, um Nachrichten zu senden und Treffen anzufragen, Premium-Angebots-Slots, um Date-Angebote zu senden, sowie optionale Profil-Boosts. Alle Zahlungen werden über PayPal abgewickelt. Die Preise werden beim Kauf angezeigt und können eine Bearbeitungsgebühr enthalten.",
    "terms.s4p2": "Bei Premium-Date-Angeboten wird der angebotene Betrag nach Zahlung treuhänderisch verwahrt. Wenn das Date stattfindet und die Empfängerin den 6-stelligen Bestätigungscode des Zahlers eingibt, wird die Auszahlung (abzüglich der Plattformprovision) an die Empfängerin freigegeben. Die Plattformprovision wird in der App offengelegt. Wiederholungs-Dates: Wenn ein Zahler ein neues Date mit jemandem bucht, mit dem er über die Plattform bereits ein Date abgeschlossen hat, ist kein Premium-Slot erforderlich und es gilt eine reduzierte Provision von 10% (die Empfängerin erhält 90% des Angebotsbetrags). Optionale Fahrtkostenzuschüsse werden zusammen mit dem Angebot gezahlt und zu 100% an die Empfängerin weitergegeben. Stornierte Date-Angebote werden 48 Stunden nach der Stornierung automatisch aus dem Angebotsverlauf entfernt. Champion-Gutscheine: Belohnungsgutscheine aus dem monatlichen Top-Mitglieder-Ranking können einmal per Einmal-Geschenkcode an eine andere Person verschenkt werden; nach dem Verschenken kann der Gutschein vom ursprünglichen Inhaber nicht mehr genutzt oder zurückgefordert werden, und erhaltene Geschenkgutscheine können nicht erneut verschenkt werden. Gutscheine haben keinen Barwert.",
    "terms.s4p3": "Rückerstattungen: Credits, Slots und Boosts sind nach der Bereitstellung nicht erstattungsfähig. Treuhänderisch verwahrte Date-Zahlungen sind nur erstattungsfähig, wenn das Date nicht stattfindet und das Angebot gemäß den Plattformregeln storniert wird oder abläuft. Zahlungen müssen von einem PayPal-Konto erfolgen, dessen E-Mail mit deiner LuxeMeet-Anmelde-E-Mail übereinstimmt; Zahlungen von abweichenden E-Mails können sich verzögern oder unwiederbringlich sein. Du kannst jederzeit über Einstellungen → Rückerstattungen & Beschwerden (oder \"Hilfe & Support\" im App-Menü) eine Rückerstattungsanfrage oder Beschwerde einreichen; jede Anfrage wird von unserem Team geprüft und du wirst über das Ergebnis in der App und per E-Mail benachrichtigt.",
    "terms.s5t": "5. Haftungsfreistellung & Risikoübernahme",
    "terms.s5p1": "DU STIMMST AUSDRÜCKLICH ZU, DASS DAS PERSÖNLICHE TREFFEN MIT EINEM ANDEREN MITGLIED VOLLSTÄNDIG AUF DEIN EIGENES RISIKO ERFOLGT. Im größtmöglichen gesetzlich zulässigen Umfang stellst du LuxeMeet, seine Eigentümer, Betreiber, Mitarbeiter und verbundenen Unternehmen von sämtlichen Ansprüchen, Forderungen, Schäden, Verletzungen, Verlusten oder Klagegründen frei — ob bekannt oder unbekannt — die sich aus deiner Nutzung der Plattform, deinen Interaktionen oder Kommunikationen mit anderen Mitgliedern und jedem über die Plattform vereinbarten persönlichen Treffen oder Date ergeben, einschließlich, aber nicht beschränkt auf Personenschäden, seelische Belastung, Sachschäden, Diebstahl, Betrug oder finanzielle Verluste.",
    "terms.s5p2": "Du bist allein für deine eigene Sicherheit verantwortlich. Wir empfehlen dringend, sich an öffentlichen Orten zu treffen, einem Freund zu sagen, wohin du gehst, deinen eigenen Transport zu organisieren und niemals Finanzinformationen mit anderen Mitgliedern zu teilen.",
    "terms.s6t": "6. Verhalten der Mitglieder",
    "terms.s6p1": "Du verpflichtest dich, Folgendes zu unterlassen: deine Identität oder dein Alter falsch darzustellen; andere Mitglieder zu belästigen, zu missbrauchen oder zu schädigen; außerhalb des Angebotssystems der Plattform Geld von Mitgliedern zu verlangen; die Plattform für kommerzielle, illegale oder ausbeuterische Zwecke zu nutzen (einschließlich Escort-Dienste oder Menschenhandel); explizite, anstößige oder rechtsverletzende Inhalte zu veröffentlichen; oder zu versuchen, die Zahlungssysteme der Plattform zu umgehen.",
    "terms.s6p2": "Inhaltsrichtlinie: Profilfotos und -videos dürfen keine Nacktheit oder sexuell explizite oder anzügliche Inhalte enthalten. Alle hochgeladenen Fotos und Videos werden vor der Veröffentlichung automatisch per KI geprüft und verbotene Inhalte werden abgelehnt. Wiederholte Versuche, verbotene Inhalte hochzuladen, können zu Maßnahmen gegen das Konto führen.",
    "terms.s6p3": "Verstöße können zur sofortigen Sperrung oder Kündigung ohne Rückerstattung sowie gegebenenfalls zur Weiterleitung an die Strafverfolgungsbehörden führen.",
    "terms.s7t": "7. Date-Bewertungen, Rezensionen & Favoriten",
    "terms.s7p1": "Nach einem abgeschlossenen Premium-Date können beide Teilnehmer das Date bewerten (1-5 Sterne) mit einem optionalen schriftlichen Kommentar. Die Teilnahme an Bewertungen ist freiwillig: Du kannst sie in den Einstellungen vollständig deaktivieren; dann kann niemand deine Dates bewerten und in deinem Profil erscheint keine Bewertung. Wenn du teilnimmst, kannst du separat wählen, ob schriftliche Kommentare öffentlich zusammen mit deiner Sternebewertung angezeigt werden.",
    "terms.s7p2": "Rezensionen müssen ehrlich, respektvoll und auf einem tatsächlichen Date basierend sein. Diffamierende, belästigende oder falsche Rezensionen können entfernt werden und zu Maßnahmen gegen das Konto führen. Mitglieder können außerdem andere Profile in einer privaten Favoritenliste speichern; deine Favoriten sind nur für dich sichtbar. Wenn du ein Mitglied favorisierst, kannst du Benachrichtigungen über dessen öffentliche Profilaktivität erhalten (etwa Boosts, Verifizierung oder neue Rezensionen).",
    "terms.s8t": "8. KI-Funktionen",
    "terms.s8p1": "Die Plattform bietet optionale KI-gestützte Funktionen, darunter die Schreibassistenten \"AI Wingman\" (für männliche Mitglieder) und \"AI Cupid\" (für weibliche Mitglieder) — die Chat-Eröffnungen und -Antworten, Notizen zu Premium-Date-Angeboten, Gegenangebots-Nachrichten, Treffen-Anfragen und Date-Rezensionskommentare entwerfen können — den \"Luxe\" In-App-Hilfeassistenten, KI-kuratierte Date-Ideen, KI-Stylist-Outfit-Vorschläge im Date-Countdown, wöchentliche KI-gestützte Match-Insights, KI-gestützte Profilfotos und KI-Selfie-basierte Fotoverifizierung. KI wird auch verwendet, um alle hochgeladenen Fotos und Galerievideos vor der Veröffentlichung automatisch auf verbotene Inhalte (Nacktheit und sexuelle Inhalte) zu prüfen. KI-Inhalte werden automatisch generiert und können ungenau sein. Du bist für alle Inhalte verantwortlich, die du sendest oder veröffentlichst, einschließlich KI-gestützter Inhalte. Profilfotos müssen dich wahrheitsgetreu darstellen; die Verwendung von KI-Bildern, die dein Aussehen wesentlich verfälschen, kann zu Maßnahmen gegen das Konto führen. Verifizierungs-Selfies werden ausschließlich für die Verifizierungsprüfung verwendet und niemals öffentlich angezeigt.",
    "terms.s9t": "9. Haftungsbeschränkung",
    "terms.s9p1": "IM GRÖSSTMÖGLICHEN GESETZLICH ZULÄSSIGEN UMFANG HAFTET LUXEMEET NICHT FÜR INDIREKTE, BEILÄUFIGE, BESONDERE, FOLGE- ODER STRAFSCHÄDEN ODER FÜR ENTGANGENE GEWINNE ODER DATENVERLUSTE, DIE AUS DEINER NUTZUNG DER PLATTFORM ENTSTEHEN. UNSERE GESAMTHAFTUNG FÜR JEGLICHE ANSPRÜCHE ÜBERSTEIGT NICHT DEN BETRAG, DEN DU IN DEN SECHS (6) MONATEN VOR DEM ANSPRUCH AN LUXEMEET GEZAHLT HAST.",
    "terms.s10t": "10. Datenschutz",
    "terms.s10p1": "Wir erfassen und verarbeiten Kontoinformationen, Nachrichten, Zahlungsaufzeichnungen und Nutzungsdaten, um die Plattform zu betreiben, Zahlungen und Auszahlungen abzuwickeln, Betrug zu verhindern und den Dienst zu verbessern. Profilaufrufe werden für Boost-Analysen erfasst. Du kannst in den Einstellungen den Inkognito-Modus aktivieren, um dein Profil vor dem Entdecken-Browsing zu verbergen — global oder vor bestimmten Mitgliedern — während deine bestehenden Unterhaltungen, Angebote und Treffen weiter funktionieren. Wir verkaufen deine persönlichen Daten nicht. E-Mails können zu Konto-, Zahlungs- und Engagement-Zwecken gesendet werden.",
    "terms.s11t": "11. Kündigung & Kontolöschung",
    "terms.s11p1": "Löschen deines Kontos: Du kannst dein Konto jederzeit über Einstellungen → Gefahrenzone löschen. Dein Profil wird sofort aus Entdecken, Ranglisten und Favoriten ausgeblendet. Es gilt eine 30-tägige Schonfrist: Wenn du dich innerhalb von 30 Tagen wieder anmeldest, wird dein Konto vollständig reaktiviert. Nach 30 Tagen werden dein Konto und deine persönlichen Daten (Profil, Fotos, Videos, Nachrichten, Favoriten und Benachrichtigungen) dauerhaft und unwiderruflich gelöscht oder anonymisiert. Ungenutzte Credits, Slots, Boosts und nicht abgehobene Guthaben verfallen bei der endgültigen Löschung. Für die finanzielle und rechtliche Compliance erforderliche Aufzeichnungen (wie abgeschlossene Zahlungsaufzeichnungen) können in anonymisierter Form aufbewahrt werden.",
    "terms.s11p2": "Wir können Konten sperren oder kündigen, die gegen diese Bedingungen verstoßen. Ungenutzte Credits, Slots und Boosts verfallen bei einer Kündigung aus wichtigem Grund.",
    "terms.s12t": "12. Änderungen dieser Bedingungen",
    "terms.s12p1": "Wir können diese Bedingungen von Zeit zu Zeit aktualisieren. Die fortgesetzte Nutzung der Plattform nach Inkrafttreten der Änderungen gilt als Annahme der überarbeiteten Bedingungen.",
    "terms.s13t": "13. DLuxe-Modus",
    "terms.s13p1": "Die Plattform umfasst einen Begleitmodus, \"DLuxe\", der über den Herz-Schalter in der App zugänglich ist. DLuxe spiegelt LuxeMeet mit vertauschten Zahlungsrollen: Weibliche Mitglieder zahlen für Interaktionen (Credits, Premium-Angebots-Slots, Boosts und monetäre Date-Angebote) und männliche Mitglieder können Date-Angebots-Auszahlungen erhalten. Alle Bedingungen gelten gleichermaßen für beide Modi, wobei rollenspezifische Bestimmungen für die Seite gelten, die im aktiven Modus zahlt oder Zahlungen erhält. Für beide Modi wird ein einziges Konto verwendet. Unterhaltungen und Treffen-Anfragen sind nach Modus getrennt: In LuxeMeet begonnene Interaktionen folgen den LuxeMeet-Zahlungsregeln (Männer zahlen) und in DLuxe begonnene folgen den DLuxe-Regeln (Frauen zahlen). Der Moduswechsel ändert nur, welcher Posteingang angezeigt wird, und niemals, wer innerhalb einer bestehenden Unterhaltung zahlt. Alle Plattformfunktionen — einschließlich KI-Assistenten, Ranglisten, Champion-Belohnungen und Gutschein-Verschenken — sind in beiden Modi mit modusgerechtem Branding verfügbar.",
    "terms.s14t": "14. Kontakt",
    "terms.s14p1": "Fragen zu diesen Bedingungen? Nutze den Hilfe-Assistenten in der App. Für Rückerstattungsanfragen und Beschwerden nutze Einstellungen → Rückerstattungen & Beschwerden (oder \"Hilfe & Support\" im App-Menü) — jede Einreichung wird geprüft und beantwortet.",
    "landing.badge": "Premium-Dating-Erlebnis",
    "landing.heroLuxe1": "Wo Qualität",
    "landing.heroLuxe2": "auf Verbindung trifft",
    "landing.heroDluxe1": "Wo Frauen",
    "landing.heroDluxe2": "die Führung übernehmen",
    "landing.taglineLuxe": "Eine exklusive Dating-Plattform, auf der echte Verbindungen zählen. Gentlemen investieren Credits, um in Kontakt zu treten – für echtes Interesse und hochwertige Gespräche.",
    "landing.taglineDluxe": "Eine exklusive Dating-Plattform, auf der selbstbewusste Frauen den ersten Schritt machen. Sie investieren Credits, um außergewöhnliche Männer kennenzulernen – für echtes Interesse und hochwertige Gespräche.",
    "landing.startJourney": "Starte deine Reise",
    "landing.haveAccount": "Ich habe ein Konto",
    "landing.watchFilm": "Film ansehen",
    "auth.signIn": "Anmelden",
    "auth.getStarted": "Loslegen",
    "login.welcomeBack": "Willkommen zurück",
    "login.subtitle": "Melde dich an, um deine Reise fortzusetzen",
    "login.google": "Mit Google fortfahren",
    "login.orEmail": "oder mit E-Mail fortfahren",
    "login.email": "E-Mail",
    "login.password": "Passwort",
    "login.emailPh": "E-Mail eingeben",
    "login.passwordPh": "Passwort eingeben",
    "login.forgot": "Passwort vergessen?",
    "login.noAccount": "Noch kein Konto?",
    "login.createOne": "Jetzt erstellen",
    "login.backHome": "Zurück zur Startseite",
    "register.title": "Konto erstellen",
    "register.subtitle": "Beginne deine Reise zu echten Verbindungen",
    "register.fullName": "Vollständiger Name",
    "register.namePh": "Namen eingeben",
    "register.passwordPh": "Passwort erstellen",
    "register.iAmA": "Ich bin",
    "register.man": "Mann",
    "register.woman": "Frau",
    "nav.discover": "Entdecken",
    "nav.favorites": "Favoriten",
    "nav.chat": "Chat",
    "nav.offers": "Angebote",
    "nav.meetups": "Treffen",
    "nav.top": "Top",
    "nav.credits": "Credits",
    "nav.earnings": "Einnahmen",
    "nav.settings": "Einstellungen",
    "nav.watchTour": "App-Tour ansehen",
    "nav.helpSupport": "Hilfe & Support",
    "discover.title": "Entdecken",
    "discover.subtitle": "Finde dein perfektes Match",
    "discover.newest": "Neueste",
    "discover.topRated": "Bestbewertet",
    "discover.sendOffer": "Premium-Date-Angebot senden",
    "discover.message": "Nachricht",
    "discover.aiCompanion": "KI-Begleitung",
    "discover.videoIntro": "Video",
    "settings.countryLanguage": "Land & Sprache",
    "settings.country": "Land",
    "settings.language": "Sprache",
    "settings.currency": "Währung",
    "settings.currencyNote": "Preise werden ungefähr in deiner Währung angezeigt – Zahlungen werden in USD abgewickelt.",
    "settings.refunds": "Rückerstattungen & Beschwerden",
    "settings.changePassword": "Passwort ändern",
    "settings.logout": "Abmelden",
    "settings.dangerZone": "Gefahrenzone",
    "settings.deleteAccount": "Mein Konto löschen",
    "credits.billedUsd": "abgerechnet in USD",
    "common.accept": "Annehmen",
    "common.decline": "Ablehnen",
    "common.pending": "Ausstehend",
    "common.accepted": "Angenommen",
    "common.declined": "Abgelehnt",
    "common.received": "Erhalten",
    "common.sent": "Gesendet",
    "common.yourBalance": "Dein Guthaben",
    "common.back": "Zurück",
    "common.cancel": "Abbrechen",
    "common.credits": "Credits",
    "common.viewMap": "Karte ansehen",
    "common.getUber": "Uber rufen",
    "common.hours": "Stunden",
    "chat.title": "Nachrichten",
    "chat.empty": "Noch keine Unterhaltungen",
    "chat.emptySub": "Verbinde dich mit anderen, um zu chatten!",
    "chat.discoverProfiles": "Profile entdecken",
    "chat.typeMessage": "Nachricht schreiben...",
    "chat.inbox": "Postfach",
    "chat.noMessages": "Noch keine Nachrichten. Starte die Unterhaltung!",
    "chat.startConvo": "Starte die Unterhaltung!",
    "chat.costStart": "Einen Chat zu starten kostet 10 Credits",
    "chat.costMessage": "Eine Nachricht kostet 5 Credits",
    "chat.inboxBadge": "{app}-Postfach",
    "common.testRun": "Testlauf",
    "offers.simulatePayment": "Zahlung simulieren (Test)",
    "offers.title": "Premium-Date-Angebote",
    "offers.dateOffers": "Date-Angebote",
    "offers.slots": "Deine Angebots-Slots",
    "offers.available": "Verfügbar",
    "offers.inUse": "In Nutzung",
    "offers.consumed": "Verbraucht",
    "offers.sentOffers": "Deine gesendeten Angebote",
    "offers.none": "Noch keine Angebote",
    "offers.noneSent": "Noch keine Angebote gesendet",
    "offers.reviewRespond": "Sieh dir deine Premium-Date-Angebote an und antworte darauf",
    "offers.subtitlePayer": "Kaufe Slots, um deinen Matches Premium-Date-Angebote zu senden",
    "offers.slotDesc": "50 $ pro Slot • Wiederverwendbar, bis ein Angebot angenommen wird",
    "offers.buySlot": "Slot kaufen",
    "offers.noneDesc": "Du hast noch keine Date-Angebote erhalten",
    "offers.noneSentDesc": "Kaufe einen Slot und sende dein erstes Premium-Date-Angebot",
    "offers.buyFirstSlot": "Kaufe deinen ersten Slot",
    "offers.respond": "Antworten",
    "offers.cancelOffer": "Angebot stornieren",
    "offers.viewCounter": "Gegenangebot ansehen",
    "offers.rateDate": "Dieses Date bewerten",
    "offers.dateDetails": "Date-Details & Bewertungen",
    "status.pending": "Ausstehend",
    "status.paymentNeeded": "Zahlung erforderlich",
    "status.awaitingConfirmation": "Warte auf Bestätigung",
    "status.countered": "Gegenangebot",
    "status.confirmed": "Bestätigt",
    "status.completed": "Abgeschlossen",
    "status.declined": "Abgelehnt",
    "status.expired": "Abgelaufen",
    "status.cancelled": "Storniert",
    "meetups.title": "Treffen-Anfragen",
    "meetups.none": "Noch keine Anfragen",
    "meetups.noneSent": "Keine Anfragen gesendet",
    "meetups.received": "Erhalten",
    "meetups.sent": "Gesendet",
    "meetups.noneDesc": "Treffen-Anfragen von anderen erscheinen hier.",
    "meetups.noneSentDesc": "Finde jemanden, den du treffen möchtest!",
    "meetups.browse": "Profile durchstöbern",
    "favorites.title": "Favoriten",
    "favorites.subtitle": "Profile, die du gespeichert hast",
    "favorites.none": "Noch keine Favoriten",
    "favorites.noneDesc": "Tippe auf das Herz bei einem Profil, das dir gefällt, und es wird hier gespeichert.",
    "favorites.browse": "Entdecken durchstöbern",
    "leaderboard.title": "Top-Mitglieder",
    "leaderboard.you": "Du",
    "leaderboard.subtitle": "Die gefragtesten, bestbewerteten und großzügigsten Mitglieder der Plattform. Verdiene Abzeichen und sichere dir deinen Platz.",
    "leaderboard.prizeNote": "Die monatliche Nr. 1 jeder Kategorie gewinnt einen kostenlosen 7-Tage-Boost + 2 Wochen unbegrenzte Date-Angebote.",
    "leaderboard.empty": "Noch keine Abzeichen-Träger — absolviere großartige Dates und sei der Erste!",
    "leaderboard.loading": "Rangliste wird geladen...",
    "leaderboard.fireTitle": "Am gefragtesten auf DLuxe",
    "leaderboard.fireSub": "Die 3 meistkontaktierten Männer auf DLuxe diesen Monat",
    "leaderboard.diamondTitle": "Diamant-Mitglieder",
    "leaderboard.diamondSub": "3+ Premium-Dates ab 500 $ abgeschlossen",
    "leaderboard.ratedTitle": "Bestbewertete Dater",
    "leaderboard.ratedSub": "Die höchsten Date-Bewertungen aus echten Rezensionen",
    "leaderboard.shareBadge": "Abzeichen teilen",
    "leaderboard.datesCompleted": "Premium-Dates abgeschlossen",
    "earnings.title": "Meine Einnahmen",
    "earnings.escrow": "Treuhand",
    "earnings.total": "Gesamt verdient",
    "earnings.dates": "Dates absolviert",
    "earnings.history": "Zahlungsverlauf",
    "earnings.none": "Noch keine Einnahmen",
    "credits.costs": "Credit-Kosten",
    "credits.startChat": "Neuen Chat starten",
    "credits.sendMessage": "Nachricht senden",
    "credits.requestMeetup": "Treffen anfragen",
    "credits.buy": "Credits kaufen",
    "credits.history": "Kaufverlauf",
    "credits.noHistory": "Noch keine Käufe",
    "credits.completePayment": "Zahlung abschließen",
    "credits.allSet": "Alles bereit!",
    "credits.freeLuxe": "Als Frau auf LuxeMeet genießt du kostenlosen Zugriff auf Nachrichten und alle Funktionen.",
    "credits.freeDluxe": "Als Mann auf DLuxe genießt du kostenlosen Zugriff auf Nachrichten und alle Funktionen.",
    "credits.bestValue": "Bester Wert",
    "credits.continuePayment": "Weiter zur Zahlung",
    "credits.processing": "Wird verarbeitet...",
    "profile.message": "Nachricht",
    "profile.requestMeetup": "Treffen anfragen",
    "tour.tryWith": "Teste es mit",
    "settings.title": "Einstellungen",
    "settings.photoHint": "Tippe auf die Kamera, um dein Foto zu ändern",
    "settings.profileInfo": "Profilinformationen",
    "settings.displayName": "Anzeigename",
    "settings.age": "Alter",
    "settings.location": "Standort",
    "settings.locationPh": "Stadt, Land",
    "settings.bio": "Über mich",
    "settings.bioPh": "Erzähle anderen etwas über dich...",
    "settings.interests": "Interessen",
    "settings.interestsPh": "Reisen, Musik, Essen (durch Kommas getrennt)",
    "settings.interestsHint": "Trenne Interessen mit Kommas",
    "settings.saveChanges": "Änderungen speichern",
    "settings.paypalTitle": "PayPal-Auszahlungseinstellungen",
    "settings.paypalDesc": "Füge deine PayPal-Daten hinzu, um Auszahlungen aus angenommenen Date-Angeboten zu erhalten",
    "settings.dangerDesc": "Das Löschen deines Kontos verbirgt dein Profil sofort. Andere Meinung? Melde dich innerhalb von 30 Tagen wieder an, um es zu reaktivieren — danach werden dein Konto und deine Daten dauerhaft gelöscht und ungenutzte Credits oder Guthaben verfallen.",
    "settings.deleteTitle": "Konto löschen?",
    "settings.deleteB1": "Dein Profil wird sofort für alle verborgen",
    "settings.deleteB2": "Melde dich innerhalb von 30 Tagen wieder an, um es zu reaktivieren",
    "settings.deleteB3": "Nach 30 Tagen wird alles dauerhaft gelöscht — Fotos, Nachrichten und ungenutzte Credits oder Guthaben",
    "settings.confirmPasswordLabel": "Bestätige dein Passwort",
    "settings.googleBlank": "Mit Google registriert? Feld leer lassen.",
    "settings.deactivateDelete": "Deaktivieren & löschen",
    "settings.currentPassword": "Aktuelles Passwort",
    "settings.newPassword": "Neues Passwort",
    "settings.confirmNewPassword": "Neues Passwort bestätigen",
    "ref.title": "Einladen & verdienen",
    "ref.desc": "Teile deinen Einladungslink. Du erhältst 25 Bonus-Credits, sobald ein eingeladener Freund zu chatten beginnt. Außerdem: Kauft ein Geworbener seinen ersten Premium-Slot, bekommst du einen $50-Slot GRATIS — und schließt ein Geworbener sein erstes Premium-Date ab, zahlt dein NÄCHSTES Verdienst-Date 90% statt 80% aus.",
    "ref.friendsReferred": "Geworbene Freunde",
    "ref.bonusCredits": "Verdiente Bonus-Credits",
    "ref.freeSlots": "Verdiente Gratis-Slots",
    "ref.boosts": "Verfügbare 90%-Boosts",
    "ref.yourReferrals": "Deine Geworbenen",
    "ref.stJoined": "Beigetreten",
    "ref.stChatting": "Chattet ✓ (+25 Credits)",
    "ref.stDate": "Date abgeschlossen ✓",
    "ref.stSlot": "Slot gekauft ✓",
    "ref.topReferrers": "Top-Werber des Monats",
    "ref.referralsWord": "Geworbene",
    "ref.copied": "Einladungslink kopiert!",
    "share.inviteMsg": "Komm zu mir auf {app} — die Premium-Dating-App, bei der echte Dates wirklich stattfinden. Melde dich mit meinem Link an:",
    "share.dreamMsg": "💘 Du bist zu einem Traumdate eingeladen! Komm zu mir auf {app} und lass uns das perfekte Date planen:",
    "share.inviteBtn": "Freund einladen",
    "share.dreamBtn": "💘 Traumdate-Einladung",
    "share.hint": "Schreibe deine eigene Nachricht oder lasse das Feld leer für die Vorlage — dein Einladungslink wird automatisch angehängt.",
    "share.copied": "Einladung kopiert — füge sie überall ein!",
    "landing.whyTitle": "Warum {app}?",
    "landing.whySub": "Unser Credit-System sorgt dafür, dass jede Interaktion bedeutungsvoll und bewusst ist.",
    "landing.f1Title": "Echte Verbindungen",
    "landing.f1Desc": "Credits garantieren echtes Interesse. Kein Spam, keine Bots — nur echte Menschen auf der Suche nach echten Verbindungen.",
    "landing.f2Title": "Premium-Erlebnis",
    "landing.f2DescLuxe": "Frauen genießen freien Zugang, während Männer in bedeutungsvolle Gespräche und Treffen investieren.",
    "landing.f2DescDluxe": "Männer genießen freien Zugang, während Frauen in bedeutungsvolle Gespräche und Premium-Date-Angebote investieren.",
    "landing.f3Title": "Verifizierte Profile",
    "landing.f3Desc": "Alle Profile werden auf Echtheit geprüft. Triff echte Menschen, knüpfe echte Verbindungen.",
    "landing.refBadge": "Empfehlen & verdienen",
    "landing.refTitle1": "Lade Freunde ein,",
    "landing.refTitle2": "sichere dir Belohnungen",
    "landing.refDesc1": "Jedes Mitglied erhält einen persönlichen Einladungslink. Teile ihn mit Freunden und verdiene einen",
    "landing.refDescBold": "GRATIS $50 Premium-Slot",
    "landing.refDesc2": "plus exklusive Bonus-Funktionen, wenn sie beitreten und aktiv werden.",
    "landing.refCard1Title": "GRATIS $50 Premium-Slot",
    "landing.refCard1Desc": "Für jeden Freund, der beitritt und aktiv wird",
    "landing.refCard2Title": "Bonus-Funktionen",
    "landing.refCard2Desc": "Exklusive Vorteile für Top-Werber",
    "landing.refCta": "Beitreten & Einladungslink holen",
    "landing.ctaTitle": "Bereit, dein Match zu finden?",
    "landing.ctaSub": "Schließe dich Tausenden Singles an, die auf {app} bedeutungsvolle Verbindungen gefunden haben.",
    "landing.ctaBtn": "Kostenloses Konto erstellen",
    "landing.footerTerms": "AGB",
    "pp.balance": "Verfügbares Guthaben",
    "pp.balanceNote": "Aus angenommenen Date-Angeboten (80% Auszahlung nach Plattformgebühr)",
    "pp.email": "PayPal-E-Mail *",
    "pp.emailHint": "Hierhin senden wir deine Auszahlungen",
    "pp.confirmEmail": "PayPal-E-Mail bestätigen *",
    "pp.confirmPh": "E-Mail erneut eingeben",
    "pp.emailsMatch": "E-Mails stimmen überein",
    "pp.verified": "Verifiziert",
    "pp.username": "PayPal-Nutzername (optional)",
    "pp.qr": "PayPal-QR-Code (optional)",
    "pp.qrUpload": "QR-Code hochladen",
    "pp.qrHint": "Lade deinen PayPal-Zahlungs-QR-Code für einfache Überweisungen hoch",
    "pp.save": "PayPal-Einstellungen speichern & verifizieren",
    "pp.howTitle": "ℹ️ So funktionieren Auszahlungen",
    "pp.how1": "Mitglieder senden Date-Angebote mit Geldbeträgen ($100-$1000)",
    "pp.how2": "Wenn du annimmst und sie zahlen, erhältst du 80% (Plattform behält 20%)",
    "pp.how3": "Auszahlungen gehen innerhalb von 3-5 Werktagen an deine PayPal-E-Mail",
    "pp.how4": "Dein Guthaben wird nach jedem bestätigten Date aktualisiert",
    "rel.title": "Offizielle Beziehung",
    "rel.activeWith": "💞 Offiziell zusammen mit {name}",
    "rel.activeSince": "Seit {date} — ihr seid beide für alle anderen verborgen.",
    "rel.chat": "Chatten",
    "rel.planDate": "Date planen",
    "rel.end": "Beziehung beenden",
    "rel.incomingTitle": "💍 {name} möchte es mit dir offiziell machen!",
    "rel.incomingDesc": "Nimm an und ihr verschwindet beide aus den Feeds der anderen — die App gehört dann nur euch beiden.",
    "rel.accept": "Annehmen 💞",
    "rel.decline": "Noch nicht",
    "rel.waitingFor": "⏳ Warten auf {name}",
    "rel.waitingDesc": "Deine Go-Official-Anfrage wartet auf Antwort.",
    "rel.cancelRequest": "Anfrage zurückziehen",
    "rel.endTitle": "Offizielle Beziehung beenden?",
    "rel.endDesc": "Du und {name} werdet wieder für alle sichtbar und könnt andere Mitglieder ansehen. Eure Chats und euer Verlauf bleiben erhalten.",
    "rel.keepIt": "Behalten",
    "rel.goOfficial": "Offiziell machen — versteck uns vor allen anderen",
    "rel.requestSent": "⏳ Anfrage gesendet — warte auf {name}",
    "rel.togetherSince": "💞 Offiziell zusammen seit {date}",
    "rel.together": "💞 Offiziell zusammen",
    "rel.coupleTitle": "💞 Ihr seid offiziell zusammen",
    "rel.coupleDesc": "Du und {name} seid für alle anderen verborgen. Die App gehört nur euch beiden — Chat, Treffen und Premium-Dates.",
    "rel.coupleHint": "Andere Pläne? Jeder von euch kann es jederzeit in den Einstellungen beenden.",
    "rel.toastSent": "💍 Go-Official-Anfrage an {name} gesendet!",
    "rel.toastTogether": "💞 Du und {name} seid offiziell zusammen!",
    "rel.toastEnded": "Beziehung beendet — du bist wieder in der App sichtbar",
    "rel.toastPrivate": "Dieses Mitglied ist in einer offiziellen Beziehung 💞",
    "rel.toastActive": "Du bist in einer offiziellen Beziehung — die App gehört jetzt nur euch beiden 💞",
    "invite.admirerTitle": "Du hast einen heimlichen Verehrer 💘",
    "invite.dreamTitle": "{name} hält eine Traumdate-Einladung für dich bereit",
    "invite.admirerSub": "{name} hat eine geheime Verehrer-Nachricht für dich — aber sie bleibt versiegelt, bis du beitrittst.",
    "invite.dreamSub": "Jemand hat etwas Besonderes geplant — die Details bleiben versiegelt, bis du beitrittst.",
    "invite.lock": "Registriere dich kostenlos, um deine Überraschung freizuschalten",
    "invite.claimedNote": "Diese Einladung wurde bereits enthüllt. Tritt trotzdem bei und sieh, wer auf dich wartet!",
    "invite.reveal": "Meine Überraschung enthüllen",
    "invite.login": "Schon Mitglied? Anmelden",
    "invite.expired": "Diese Einladung ist abgelaufen",
    "invite.explore": "LuxeMeet entdecken",
    "landing.goBadge": "Gemacht für echte Happy Ends",
    "landing.goTitle1": "Wenn es ernst wird,",
    "landing.goTitle2": "macht es offiziell 💞",
    "landing.goDesc": "Die richtige Person gefunden? Ein Tipp und ihr verschwindet beide aus den Feeds der anderen — keine Profile, keine Nachrichten, keine Ablenkungen. Die App gehört dann nur euch beiden: privater Chat, Treffen und Premium-Dates. Und wenn sich etwas ändert, kann jeder es jederzeit ausschalten.",
    "landing.goChip1": "🙈 Unsichtbar für alle anderen",
    "landing.goChip2": "💬 Zwischen euch beiden bleibt alles offen",
    "landing.goChip3": "🔄 Jederzeit umkehrbar",
    "common.years": "Jahre",
    "form.proposedDateTime": "Vorgeschlagenes Datum & Uhrzeit",
    "form.duration": "Dauer (optional)",
    "form.proposedLocation": "Vorgeschlagener Ort",
    "form.messageOptional": "Nachricht (optional)",
    "form.openEnded": "Offen",
    "form.writeMessage": "Schreibe deine Nachricht...",
    "form.addPersonalMessage": "Füge eine persönliche Nachricht hinzu...",
    "form.searchVenue": "Suche den genauen Ort oder die Adresse...",
    "offerModal.selectDateType": "Date-Typ wählen...",
    "offerModal.amountPlaceholder": "Betrag eingeben (100-1000)",
    "offerModal.amountHint": "Du zahlst diesen Betrag, wenn dein Date annimmt ({fee}% Plattformgebühr)",
    "offerModal.transportHint": "Wird mit deinem Angebot bezahlt und geht zu 100% als Fahrtkosten an dein Date (keine Gebühr).",
    "offerModal.durationHint": "Wie lange das Date dauern soll — klare Erwartungen für euch beide.",
    "tour.subtitle": "Eine 60-Sekunden-Probefahrt — es wird nie etwas berechnet",
    "tour.step1Title": "Sag Hallo im Chat",
    "tour.step1Desc": "{name} hat dir schon geschrieben — antworte einfach",
    "tour.step2Title": "Frag ein Treffen an",
    "tour.step2Desc": "Völlig kostenlos — sieh zu, wie es angenommen wird",
    "tour.step3Title": "Sende ein Premium-Date-Angebot",
    "tour.step3DescSent": "Gesendet! Simuliere die Zahlung auf deiner Angebote-Seite",
    "tour.step3Desc": "Kein Slot, kein echtes Geld — volle Simulation",
    "tour.go": "Los",
    "tour.doneTitle": "Du beherrschst LuxeMeet! 🎉",
    "tour.doneDesc": "Chat, Treffen und Premium-Dates — du hast alles ausprobiert. Jetzt finde das Echte.",
    "tour.browseReal": "Echte Mitglieder entdecken",
    "common.freeTest": "Gratis-Test",
    "discover.aiTestNote": "Test-Begleitung — Chat, Treffen & Premium-Dates sind KOSTENLOSE Simulationen. Nie echte Zahlungen.",
    "discover.meetUp": "Treffen",
    "profile.msgTitle": "Nachricht an {name} senden",
    "profile.msgCostPayer": "Ein Gespräch zu starten kostet 10 Credits, danach 5 Credits pro Nachricht. Antworten sind kostenlos.",
    "profile.msgFree": "Kostenlos für dich auf {app} — dieser Chat landet im {app}-Postfach, wo Antworten Credits kostet.",
    "profile.sendMessage": "Nachricht senden",
    "profile.meetupTitle": "Treffen mit {name} anfragen",
    "profile.meetupCost": "Ein Treffen anzufragen kostet 25 Credits.",
    "profile.meetupFree": "Kostenlos für dich auf {app} — die Anfrage erscheint in den {app}-Treffen.",
    "profile.meetupTest": "🧪 Gratis-Testlauf — deine KI-Begleitung nimmt automatisch an, damit du den ganzen Ablauf siehst. Keine Credits.",
    "profile.sendMeetup": "Anfrage senden",
    "profile.costsMsg": "Nachricht: 10 Credits (erste) / 5 Credits (Antwort)",
    "profile.costsMeetup": "Treffen-Anfrage: 25 Credits",
    "offerModal.title": "Premium-Date-Angebot senden",
    "offerModal.desc": "Sende {name} ein vergütetes Date-Angebot",
    "offerModal.testBanner": "🧪 Testlauf mit {name} — kein Slot nötig, die Zahlung wird simuliert (nie berechnet).",
    "offerModal.needSlot": "Du musst zuerst einen Premium-Slot kaufen",
    "offerModal.purchaseSlot": "Slot kaufen (50 $)",
    "offerModal.slotsAvailable": "Verfügbare Slots: {n}",
    "offerModal.testNoSlot": "Test-Angebot — kein Slot erforderlich",
    "offerModal.repeatNoSlot": "Wiederholungs-Date — kein Slot erforderlich",
    "offerModal.amount": "Angebotsbetrag *",
    "offerModal.transport": "Fahrtkosten (optional)",
    "offerModal.proposedDate": "Vorgeschlagenes Datum *",
    "offerModal.proposedTime": "Vorgeschlagene Uhrzeit *",
    "offerModal.duration": "Dauer (optional)",
    "offerModal.location": "Ort *",
    "offerModal.dateType": "Date-Typ *",
    "offerModal.message": "Nachricht (optional)",
    "offerModal.sendOffer": "Angebot senden",
    "voucher.unlimitedActive": "Unbegrenzte Date-Angebote aktiv 🏆",
    "voucher.unlimitedUntil": "Keine Slots nötig bis {date} — Champion-Privileg.",
    "voucher.championPrize": "Champion-Preis: 2 Wochen unbegrenzte Angebote",
    "voucher.giftFrom": "Geschenk von {name}: 2 Wochen unbegrenzte Angebote",
    "voucher.activate": "Meine 2 Wochen aktivieren",
    "voucher.giftIt": "Verschenken",
    "voucher.haveCode": "Hast du einen Geschenkcode?",
    "voucher.redeem": "Einlösen",
    "voucher.giftsSent": "Verschenkte Gutscheine",
    "ideas.near": "Date-Inspiration in der Nähe von",
    "ideas.plan": "Dieses Date planen",
    "ideas.popular": "Beliebte Date-Orte auf der Plattform",
    "ideas.map": "Karte",
    "ideas.cityTitle": "Date-Ideen für eine andere Stadt",
    "ideas.cityDesc": "Reise oder Date woanders geplant? Wähle eine Stadt und wir kuratieren Ideen dort.",
    "ideas.show": "Ideen anzeigen",
    "ideas.whoFor": "Für wen ist dieses Date?",
    "ideas.pickDesc": "wähle ein Match und wir füllen dein Premium-Angebot vor.",
    "ideas.emptyPrefix": "Noch keine Matches — favorisiere jemanden in",
    "ideas.emptySuffix": "oder starte zuerst einen Chat.",
    "profile.videos": "VIDEOS",
  },
  pt: {
    "nav.events": "Eventos",
    "leaderboard.youOnBoard": "🏆 Você está no ranking!",
    "leaderboard.youOnBoardSub": "os membros do outro lado veem você classificado aqui. Continue brilhando!",
    "events.title": "Eventos",
    "events.subtitle": "Eventos exclusivos para membros — venha conhecer pessoalmente.",
    "events.empty": "Nenhum evento por vir no momento — volte em breve!",
    "events.loading": "Carregando eventos…",
    "events.spotsLeft": "{n} vagas restantes",
    "events.soldOut": "Esgotado",
    "events.joinedChip": "Você está dentro!",
    "events.free": "Grátis",
    "events.feeNote": "${price} + $2 de taxa de processamento",
    "events.payCredits": "Participar com {n} créditos",
    "events.payPaypal": "Pagar com PayPal · ${total}",
    "events.joinFree": "Participar grátis",
    "events.notEnough": "Créditos insuficientes — este evento custa {n} créditos",
    "events.joinedToast": "🎟️ Você está dentro! Verifique seu e-mail para a confirmação.",
    "events.payCancelled": "Pagamento cancelado",
    "events.captureFail": "Não conseguimos confirmar seu pagamento — tente novamente",
    "events.bannerTitle": "🎉 Próximo evento",
    "events.bannerCta": "Ver eventos",
    "notif.eventJoined.t": "🎟️ Você vai!",
    "notif.eventJoined.b": "Sua vaga em \"{title}\" está confirmada. Nos vemos lá!",
    "notif.eventCancelled.t": "😔 Evento cancelado",
    "notif.eventCancelled.b": "\"{title}\" foi cancelado. Se você pagou, seu reembolso está a caminho.",
    "terms.contactT": "Fale conosco",
    "terms.contactP": "Dúvidas, preocupações ou feedback? Fale conosco a qualquer momento:",
    "msdluxe.tapSound": "Toque para o som",
    "msdluxe.badge": "Sua anfitriã de IA",
    "msdluxe.title1": "Conheça a Ms DLuxe",
    "msdluxe.title2": "Ela te mostra tudo",
    "msdluxe.desc": "A própria Ms DLuxe explica exatamente como funciona: créditos, ofertas de encontros premium, ganhos e segurança.",
    "msdluxe.luxeCard": "Como funciona o LuxeMeet",
    "msdluxe.dluxeCard": "Como funciona o DLuxe",
    "msdluxe.download": "Baixar",
    "msdluxe.share": "Salve, publique, envie para um amigo — são seus para compartilhar.",
    "nav.msdluxeVideos": "Como funciona · Ms DLuxe",
    "credits.requestRefund": "Solicitar reembolso",
    "credits.refundRequested": "Reembolso solicitado",
    "credits.refunded": "Reembolsado",
    "credits.refundDeniedChip": "Não aprovado",
    "credits.refundDialogTitle": "Solicitar um reembolso",
    "credits.refundDialogDesc": "Conte-nos por que você gostaria de um reembolso desta compra. Nossa equipe analisa cada pedido e você receberá uma notificação e e-mail com a decisão.",
    "credits.refundReasonPh": "Por que você gostaria de um reembolso?",
    "credits.refundSubmit": "Enviar pedido",
    "credits.refundSent": "Pedido de reembolso enviado — vamos analisá-lo em breve",
    "safety.checkinToggle": "Check-in de segurança",
    "safety.checkinDesc": "Escolha um horário — perguntaremos se você chegou bem em casa. Sem resposta em 2 horas, seu amigo recebe um alerta.",
    "safety.checkinPast": "Escolha um horário de check-in no futuro",
    "safety.checkinScheduled": "Enviado! Seu amigo tem os detalhes e seu check-in de segurança está agendado.",
    "checkin.title": "Você chegou bem em casa?",
    "checkin.body": "Toque para confirmar — caso contrário, {email} receberá um alerta.",
    "checkin.confirmBtn": "Cheguei bem em casa ✅",
    "checkin.confirmed": "Que bom que você está bem! Seu amigo foi notificado 💛",
    "notif.safetyCheckin.t": "🛟 Você chegou bem em casa?",
    "notif.safetyCheckin.b": "Toque para confirmar que você chegou bem — caso contrário, {email} receberá um alerta em 2 horas.",
    "landing.freeCreditsPromo": "Novos membros ganham 50 créditos grátis — exatamente o suficiente para um companheiro de IA enviar um convite de admirador secreto para seu crush nas redes sociais.",
    "landing.langHighlight": "Disponível em 8 idiomas com tradução de chat integrada — conheça pessoas do mundo todo.",
    "saPromo.title": "Seus créditos grátis estão esperando",
    "saPromo.body": "Você tem {n} créditos — o suficiente para um companheiro de IA enviar um convite de admirador secreto para seu crush nas redes sociais.",
    "saPromo.cta": "Enviar convite de admirador secreto",
    "notif.refundApproved.t": "✅ Reembolso aprovado",
    "notif.refundApproved.b": "Seu reembolso por {desc} foi aprovado — sua conta foi ajustada. Confira seu e-mail para detalhes.",
    "notif.refundDenied.t": "Atualização do seu pedido de reembolso",
    "notif.refundDenied.b": "Seu pedido de reembolso por {desc} foi analisado — confira seu e-mail para detalhes.",
    "safety.share": "Compartilhar plano com um amigo",
    "safety.title": "Envie seu plano de encontro a um amigo",
    "safety.desc": "Para sua segurança, envie por e-mail seu roteiro e o perfil do seu par a alguém de confiança.",
    "safety.emailPh": "amigo@email.com",
    "safety.notePh": "Nota opcional para seu amigo…",
    "safety.send": "Enviar",
    "safety.sent": "Enviado! Seu amigo tem os detalhes.",
    "discover.companionsTitle": "Conheça os companheiros de IA",
    "incog.title": "Modo anônimo",
    "incog.desc": "Controle quem pode encontrar seu perfil enquanto mantém acesso total a chats, ofertas e encontros.",
    "incog.toggleLabel": "Ocultar meu perfil do Descobrir",
    "incog.toggleDesc": "Ninguém pode te encontrar ao navegar. Conversas e ofertas existentes continuam funcionando.",
    "incog.on": "Modo anônimo ATIVADO — você está oculto no Descobrir",
    "incog.off": "Você está visível no Descobrir novamente",
    "incog.hiddenFrom": "Você também está oculto individualmente de {n} membro(s) (pelo botão de olho no perfil deles).",
    "ratep.title": "Privacidade das avaliações de encontros",
    "ratep.desc": "Escolha se você participa das avaliações de encontros e o que aparece no seu perfil.",
    "ratep.partLabel": "Participar das avaliações de encontros",
    "ratep.partDesc": "Quando desativado, ninguém pode avaliar seus encontros e nenhuma avaliação aparece no seu perfil",
    "ratep.commentsLabel": "Mostrar avaliações escritas no meu perfil",
    "ratep.commentsDesc": "Quando desativado, apenas sua classificação por estrelas é mostrada — comentários escritos ficam privados",
    "ratep.saved": "Preferências de avaliação salvas",
    "offers.planDate": "Planejar um encontro",
    "planDate.title": "Planeje um encontro com…",
    "planDate.desc": "Escolha qualquer pessoa da lista de membros para enviar uma oferta de encontro premium.",
    "planDate.search": "Buscar por nome…",
    "planDate.empty": "Nenhum membro encontrado",
    "notif.promoRedeemed.t": "🎁 Código promocional resgatado!",
    "notif.promoRedeemed.b": "Seu código {code} adicionou {what} à sua conta. Aproveite!",
    "notif.creditsGranted.t": "🎁 Créditos adicionados!",
    "notif.creditsGranted.b": "A equipe do LuxeMeet adicionou {n} créditos à sua conta.",
    "notif.slotGranted.t": "🎁 Vaga de encontro premium grátis!",
    "notif.slotGranted.b": "Você recebeu {n} vaga(s) grátis de oferta de encontro premium de $50 — planeje um encontro na página de Ofertas!",
    "register.saRevealed": "💌 Seu admirador secreto foi revelado — confira suas notificações e seu chat!",
    "tour.replayTitle": "Tour de 60 segundos",
    "tour.replayDesc": "Perdeu o test drive guiado? Repita quando quiser com seu companheiro de IA.",
    "tour.replayBtn": "Ver novamente",
    "notif.saReveal.t": "💌 Admirador secreto revelado!",
    "notif.saReveal.b": "Era {admirer} o tempo todo! {name} deixou a história completa no seu chat. Toque para ver o perfil.",
    "register.saBanner": "💌 Seu admirador secreto está esperando — crie sua conta grátis para descobrir quem é.",
    "credits.earnerNote": "Conversar é grátis para você neste modo — os créditos são usados para extras como pedidos de admirador secreto (50 créditos).",
    "si.trackJoined": "Entrou como {name} — ver perfil",
    "notif.siJoined.t": "🎉 Chegou!",
    "notif.siJoined.b": "{invitee} acabou de entrar pelo seu convite de admirador secreto para {handle}. Vá encontrá-lo(a)!",
    "si.trackTitle": "Seus pedidos de admirador secreto",
    "si.trackLine": "{kind} para {handle} no {platform}",
    "si.trackVia": "via {name}",
    "si.trackKindAdmirer": "Mensagem de admirador secreto",
    "si.trackKindDate": "Pedido de encontro",
    "si.trackPending": "Pendente",
    "si.trackSent": "Enviado",
    "si.trackRefunded": "Reembolsado",
    "discover.boosted": "Impulsionado",
    "discover.inDemand": "🔥 Em alta",
    "discover.diamond": "Diamante",
    "discover.verifiedBadge": "Verificado",
    "gal.addPhoto": "Adicionar foto",
    "gal.addVideo": "Adicionar vídeo",
    "gal.videoIntros": "Vídeos de apresentação ({n}/2)",
    "gal.videoRules": "Até 2 vídeos curtos (máx. 60s, 50MB). Verificados por IA — sem nudez ou conteúdo sexual.",
    "gal.noPhotos": "Ainda sem fotos. Adicione sua primeira foto para começar!",
    "si.button": "Admirador secreto nas redes",
    "si.title": "Admirador secreto via {name}",
    "si.desc": "{name} enviará uma mensagem de admirador secreto ou um pedido de encontro para quem você escolher nas redes sociais — com um convite para o app. Enviado em até 24 horas.",
    "si.typeLabel": "O que deve ser enviado?",
    "si.typeAdmirer": "Mensagem de admirador secreto",
    "si.typeDate": "Pedido de encontro",
    "si.platform": "Plataforma",
    "si.handle": "Nome de usuário da pessoa",
    "si.note": "Toque pessoal (opcional)",
    "si.notePh": "Algo que {name} deva mencionar?",
    "si.submit": "Enviar pedido ({n} créditos)",
    "si.success": "Pedido na fila! Você receberá uma notificação quando {name} enviar.",
    "si.errHandle": "Digite o usuário de rede social da pessoa",
    "notif.siPending.t": "💌 Pedido recebido!",
    "notif.siPending.b": "{name} enviará sua {kind} para {handle} no {platform}. 50 créditos foram cobrados — você será avisado quando for enviada.",
    "notif.siSent.t": "💘 Foi enviado!",
    "notif.siSent.b": "{name} enviou sua {kind} para {handle} no {platform}. Dedos cruzados!",
    "notif.siDeclined.t": "Pedido reembolsado",
    "notif.siDeclined.b": "Sua {kind} via {name} não pôde ser enviada. Seus 50 créditos foram reembolsados.",
    "notif.kindAdmirer": "mensagem de admirador secreto",
    "notif.kindDate": "pedido de encontro",
    "help.title": "Luxe Assistant",
    "help.subtitle": "Pergunte-me qualquer coisa sobre o LuxeMeet",
    "help.hi": "Oi{name}! 👋",
    "help.welcome": "Posso explicar como funcionam os créditos, as ofertas de encontros premium, a custódia, os códigos de confirmação e os pagamentos. O que você gostaria de saber?",
    "help.thinking": "Luxe está pensando...",
    "help.inputPh": "Digite sua pergunta...",
    "help.error": "Desculpe, estou com problemas no momento. Tente novamente em instantes.",
    "chat.translate": "Traduzir",
    "chat.showOriginal": "Ver original",
    "chat.translating": "Traduzindo...",
    "chat.translateFail": "Não foi possível traduzir agora",
    "chat.sentCredits": "Mensagem enviada ({n} créditos)",
    "chat.noCredits": "Créditos insuficientes",
    "chat.tapToUse": "{ai} — toque para usar",
    "chat.member": "Membro do {app}",
    "land.newMatch": "Novo match!",
    "land.firstMove": "Dê o primeiro passo",
    "land.dateTerms": "Encontros do seu jeito",
    "land.youChoose": "Você escolhe. Você oferece.",
    "land.startChatting": "Comece a conversar agora",
    "land.likes": "{n} curtidas",
    "land.thisWeek": "Esta semana",
    "promo.title": "Veja o que o torna especial",
    "promo.desc": "Um tour rápido pelo LuxeMeet e DLuxe — encontros reais, ofertas premium e romance com IA.",
    "promo.tapSound": "Toque para o som",
    "promo.shareInvite": "Compartilhe o filme — seu link de convite está incluído 🎁",
    "promo.shareFriends": "Compartilhe o filme com amigos",
    "promo.copiedInvite": "Link do filme com seu código de convite copiado!",
    "promo.copied": "Link do filme copiado!",
    "promo.shareMsg": "🎬 Veja isto — LuxeMeet, o app de namoro onde encontros reais realmente acontecem.",
    "promo.joinInvite": "Entre com meu link de convite:",
    "promo.shareTg": "🎬 Veja isto — o app de namoro onde encontros reais realmente acontecem",
    "promo.mute": "Silenciar a trilha",
    "promo.unmute": "Ativar a trilha",
    "prof.back": "Voltar",
    "prof.addPhotosHint": "Adicione fotos para ser notado",
    "prof.noPhotos": "{name} ainda não adicionou fotos",
    "prof.addPhotos": "Adicionar fotos",
    "prof.aiCompanion": "Companhia de IA",
    "prof.reviewOne": "avaliação de encontro",
    "prof.reviewMany": "avaliações de encontros",
    "prof.bioEmptyOwn": "Sua bio está vazia — algumas frases sobre você fazem toda a diferença.",
    "prof.bioEmptyOther": "{name} mantém um ar de mistério — diga oi para saber mais.",
    "prof.afterDate": "— {name}, depois do encontro",
    "prof.interests": "INTERESSES",
    "prof.photos": "FOTOS",
    "prof.videos": "VÍDEOS",
    "prof.thinking": "Pensando...",
    "prof.suggestOpener": "{ai}: sugerir uma abertura",
    "prof.offerSent": "Oferta enviada! Veja o status na sua página de Ofertas.",
    "prof.tSuggestFail": "Não foi possível obter sugestões agora",
    "prof.tRequestFail": "Não foi possível enviar a solicitação",
    "prof.tFavAdded": "Adicionado aos favoritos ❤️",
    "prof.tFavRemoved": "Removido dos favoritos",
    "prof.tFavFail": "Falha ao atualizar favoritos",
    "prof.tVisibilityFail": "Falha ao atualizar a visibilidade",
    "prof.tHidden": "Você agora está oculto para {name} no Descobrir",
    "prof.tVisible": "Você está visível para {name} novamente",
    "prof.tLoadFail": "Falha ao carregar o perfil",
    "prof.tMsgEmpty": "Digite uma mensagem",
    "prof.tNoCredits": "Créditos insuficientes. Compre mais créditos para continuar.",
    "prof.tMsgFail": "Falha ao enviar a mensagem",
    "prof.tMeetupMissing": "Preencha a data e o local",
    "prof.tMeetupFail": "Falha ao enviar a solicitação de encontro",
    "nb.title": "Notificações",
    "nb.empty": "Ainda não há notificações",
    "time.now": "agora mesmo",
    "time.m": "há {n}m",
    "time.h": "há {n}h",
    "time.d": "há {n}d",
    "notif.photoVerified.t": "✅ Você está verificado!",
    "notif.photoVerified.b": "Sua verificação por selfie foi aprovada — o selo Verificado agora aparece no seu perfil.",
    "notif.relRequest.t": "💍 Tornar oficial?",
    "notif.relRequest.b": "{name} quer tornar oficial com você! Aceite em Configurações e vocês dois desaparecerão do feed de todos.",
    "notif.relDeclined.t": "Pedido de tornar oficial recusado",
    "notif.relDeclined.b": "{name} ainda não está pronto para tornar oficial.",
    "notif.relActive.t": "💞 Vocês estão oficialmente juntos!",
    "notif.relActive.b": "{name} disse SIM. Agora vocês dois estão ocultos para os outros — o app é só de vocês.",
    "notif.relEnded.t": "Relacionamento oficial encerrado",
    "notif.relEnded.b": "{name} encerrou o relacionamento oficial. Vocês dois estão visíveis no app novamente.",
    "notif.dateReview.t": "{stars} Nova avaliação de encontro!",
    "notif.dateReview.b": "{name} avaliou seu encontro com {rating}/5. {comment}",
    "notif.escrow.t": "💰 Pagamento do encontro recebido!",
    "notif.escrow.b": "{name} pagou ${amount} pelo seu encontro. ${payout} está retido em custódia. Confirme o encontro com o código de 6 dígitos para receber.",
    "notif.escrowBoost.t": "💰 Pagamento do encontro recebido!",
    "notif.escrowBoost.b": "{name} pagou ${amount} pelo seu encontro. ${payout} está retido em custódia — inclui seu bônus de indicação de 90%! Confirme o encontro com o código de 6 dígitos para receber.",
    "notif.offerPaid.t": "💘 Encontro reservado!",
    "notif.offerPaid.b": "Seu pagamento pelo encontro com {name} foi confirmado. Seu código de confirmação de 6 dígitos está pronto na página de Ofertas — compartilhe com seu par depois.",
    "notif.refSlot.t": "🎁 Slot premium grátis conquistado!",
    "notif.refSlot.b": "{name}, que você indicou, acabou de comprar um slot premium — você recebeu um slot de $50 GRÁTIS como recompensa!",
    "notif.boostActivated.t": "🚀 Perfil impulsionado!",
    "notif.boostActivated.b": "Seu perfil agora está em destaque no topo do Descobrir pelas próximas 24 horas.",
    "notif.creditsAdded.t": "🪙 Créditos adicionados!",
    "notif.creditsAdded.b": "{credits} créditos da sua compra {package} já estão na sua conta. Novo saldo: {balance}.",
    "notif.unlimited.t": "♾️ Ofertas ilimitadas ativadas!",
    "notif.unlimited.b": "Seu prêmio de campeão está ativo — envie ofertas de encontro ilimitadas (sem precisar de slots) pelas próximas 2 semanas!",
    "notif.voucherGifted.t": "🎁 Você recebeu um vale de campeão!",
    "notif.voucherGifted.b": "{name} te presenteou com 2 semanas de ofertas de encontro ilimitadas — ative em Configurações antes de {date}.",
    "notif.voucherRedeemed.t": "🎁 Seu presente foi resgatado!",
    "notif.voucherRedeemed.b": "{name} resgatou o vale de campeão que você presenteou.",
    "notif.refBoost.t": "🎁 Recompensa de indicação desbloqueada!",
    "notif.refBoost.b": "{name}, que você indicou, completou seu primeiro encontro premium — seu PRÓXIMO encontro remunerado paga 90% em vez de 80%!",
    "notif.payoutProcessing.t": "✅ Encontro confirmado!",
    "notif.payoutProcessing.b": "Seu pagamento de ${amount} está sendo processado e chegará ao seu PayPal em 24-48 horas.",
    "notif.offerExpiredSender.t": "⏰ Oferta de encontro expirada",
    "notif.offerExpiredSender.b": "Sua oferta de encontro de ${amount} expirou após 7 dias. Seu slot premium foi liberado para você enviar uma nova oferta.",
    "notif.offerExpiredRecipient.t": "⏰ Oferta de encontro expirada",
    "notif.offerExpiredRecipient.b": "Uma oferta de encontro que você aceitou expirou porque o pagamento não foi concluído em 7 dias.",
    "notif.dateReminder24.t": "💜 Lembrete: encontro amanhã!",
    "notif.dateReminder24.b": "Seu encontro com {name} é amanhã — {when}, {where}.",
    "notif.offerExpiringPay.t": "⏳ A oferta expira em 24 horas!",
    "notif.offerExpiringPay.b": "Sua oferta de encontro de ${amount} para {name} expira amanhã — conclua o pagamento antes que ela desapareça e seu slot seja liberado.",
    "notif.offerExpiringWait.t": "⏳ A oferta expira em 24 horas!",
    "notif.offerExpiringWait.b": "Sua oferta de encontro de ${amount} para {name} expira amanhã — aguarde a resposta dela ou faça um follow-up antes que ela desapareça e seu slot seja liberado.",
    "notif.matchInsights.t": "💌 Suas estatísticas semanais de matches",
    "notif.matchInsights.b": "{views} visualizações de perfil e {favs} novos favoritos esta semana — incluindo {names}. Diga oi ou impulsione seu perfil para provocar uma oferta de encontro!",
    "notif.streak1.t": "🔥 Progresso da sequência: {streak}/3",
    "notif.streak1.b": "Mais um encontro 4★+ e 150 créditos grátis são seus!",
    "notif.streakN.t": "🔥 Progresso da sequência: {streak}/3",
    "notif.streakN.b": "Mais {togo} encontros 4★+ para desbloquear 150 créditos grátis.",
    "notif.streakDone.t": "🔥 Progresso da sequência: {streak}/3",
    "notif.streakDone.b": "Sua recompensa está a caminho!",
    "notif.rankUp.t": "🏆 Você é o #{rank} no ranking dos Mais Bem Avaliados",
    "notif.rankUp.b": "Você é o #{rank} no ranking dos Mais Bem Avaliados. 📈 Subiu {spots} posições desde a semana passada! O #1 mensal ganha 2 semanas de ofertas de encontro ilimitadas.",
    "notif.rankDown.t": "🏆 Você é o #{rank} no ranking dos Mais Bem Avaliados",
    "notif.rankDown.b": "Você é o #{rank} no ranking dos Mais Bem Avaliados. 📉 Caiu {spots} posições desde a semana passada — um ótimo encontro te traz de volta. O #1 mensal ganha 2 semanas de ofertas de encontro ilimitadas.",
    "notif.rankSteady.t": "🏆 Você é o #{rank} no ranking dos Mais Bem Avaliados",
    "notif.rankSteady.b": "Você é o #{rank} no ranking dos Mais Bem Avaliados. 🎯 Mantendo-se estável desde a semana passada. O #1 mensal ganha 2 semanas de ofertas de encontro ilimitadas.",
    "notif.rankNew.t": "🏆 Você é o #{rank} no ranking dos Mais Bem Avaliados",
    "notif.rankNew.b": "🎉 NOVO: você entrou no ranking dos Mais Bem Avaliados em #{rank}! O #1 mensal ganha 2 semanas de ofertas de encontro ilimitadas.",
    "notif.rankOff.t": "🏆 Atualização do ranking",
    "notif.rankOff.b": "Você saiu do ranking dos Mais Bem Avaliados esta semana — um ótimo encontro te coloca de volta. O #1 mensal ganha 2 semanas de ofertas de encontro ilimitadas.",
    "notif.boostEnded.t": "⚡ Seu impulso terminou",
    "notif.boostEnded.b": "Seu impulso de 24 horas terminou. Ele rendeu {views} visualizações de perfil. Impulsione novamente na página Descobrir para ficar no topo!",
    "notif.boostEndedExtra.t": "⚡ Seu impulso terminou",
    "notif.boostEndedExtra.b": "Seu impulso de 24 horas terminou. Ele rendeu {views} visualizações de perfil — cerca de {extra} a mais que um dia normal. Impulsione novamente na página Descobrir para ficar no topo!",
    "notif.dateSoon1h.t": "⏰ Seu encontro começa em breve!",
    "notif.dateSoon1h.b": "Seu encontro com {name} é em menos de uma hora — {time} em {location}.{tip}",
    "notif.dateSoon24.t": "💜 Seu encontro é em 24 horas!",
    "notif.dateSoon24.b": "Seu encontro com {name} é em 24 horas — {time} em {location}.{tip}",
    "notif.dateSoonTip": " Abra sua oferta para ver a contagem regressiva ao vivo, o clima e dicas de look!",
    "notif.badgeFire.t": "🔥 Você está pegando fogo!",
    "notif.badgeFire.b": "Você é um dos 3 homens mais contatados no DLuxe este mês — o selo 🔥 agora aparece no seu perfil.",
    "notif.hotStreak.t": "🔥 Sequência quente! 150 créditos GRÁTIS",
    "notif.hotStreak.b": "3 encontros muito bem avaliados seguidos — o pacote Popular de 150 créditos foi adicionado GRÁTIS à sua conta. Mantenha a sequência viva!",
    "notif.badgeDiamond.t": "💎 Selo de diamante conquistado!",
    "notif.badgeDiamond.b": "Você completou 3 encontros premium de $500+ — o selo de Diamante agora brilha no seu perfil.",
    "notif.champion.t": "🏆 Campeão do ranking!",
    "notif.champion.b": "Você terminou em #1 em '{section}' este mês! Prêmios: um impulso de perfil de 7 dias GRÁTIS (já ativo) e um vale de 2 semanas de ofertas de encontro ILIMITADAS — ative em Configurações a qualquer momento nos próximos 6 meses.",
    "notif.anniversary.t": "💞 {months} {monthsWord} juntos!",
    "notif.anniversary.b": "Você e {name} acabaram de completar {months} {monthsWord} oficiais. Comemorem — ideia: {idea}",
    "notif.monthWord": "mês",
    "notif.monthsWord": "meses",
    "notif.annIdea0": "Recriem o primeiro encontro de vocês — mesmo lugar, mesmo pedido, novas memórias.",
    "notif.annIdea1": "Cozinhem juntos um jantar de três pratos à luz de velas, celulares desligados.",
    "notif.annIdea2": "Piquenique ao pôr do sol com os lanches favoritos de cada um e uma playlist compartilhada.",
    "notif.annIdea3": "Reservem uma hora de spa a dois e brindem com algo espumante depois.",
    "notif.annIdea4": "Façam uma mini viagem de carro a uma cidade que nenhum dos dois conhece.",
    "notif.annIdea5": "Noite de observar estrelas: cobertores, chocolate quente e a música de vocês no repeat.",
    "notif.annIdea6": "Aula de dança para dois — salsa, bachata ou o que fizer vocês rirem.",
    "notif.annIdea7": "Encontro em museu ou galeria, depois sobremesa em um lugar chique.",
    "notif.annIdea8": "Escrevam um ao outro uma carta sobre o momento favorito até agora e troquem no jantar.",
    "notif.annIdea9": "Reserva de jantar em rooftop ou terraço — vistam-se como no primeiro encontro.",
    "notif.annIdea10": "Degustação de vinho ou chocolate seguida de uma caminhada lenta para casa.",
    "notif.annIdea11": "Planejem juntos a viagem dos sonhos no café da manhã na cama — e reservem uma parte dela.",
    "notif.companionInvite.t": "💌 {name} tem a sua surpresa!",
    "notif.companionInvite.b": "Seu convite misterioso foi revelado no seu chat.",
    "notif.supportResolved.t": "✅ Solicitação de suporte resolvida",
    "notif.supportResolved.b": "Sua {label} \"{subject}\" foi analisada e resolvida.",
    "notif.supportResolvedResp.t": "✅ Solicitação de suporte resolvida",
    "notif.supportResolvedResp.b": "Sua {label} \"{subject}\" foi analisada e resolvida. Resposta: {resp}",
    "notif.labelRefund": "solicitação de reembolso",
    "notif.labelComplaint": "reclamação",
    "notif.testMeetup.t": "{name} aceitou seu encontro! 🎉",
    "notif.testMeetup.b": "Teste concluído — é exatamente assim quando um membro real aceita. Nenhum crédito foi cobrado.",
    "notif.testCounter.t": "{name} enviou uma contraoferta 💬",
    "notif.testCounter.b": "Teste: contraproposta de ${amount}. Aceite ou recuse para continuar o fluxo — ainda sem dinheiro real.",
    "notif.testOfferAccepted.t": "{name} aceitou sua oferta de encontro! 💜",
    "notif.testOfferAccepted.b": "Teste: aperte o botão Simular Pagamento na página de Ofertas para ver o resto do fluxo — sem dinheiro real.",
    "notif.testDateCompleted.t": "Encontro de teste com {name} concluído! 🏆",
    "notif.testDateCompleted.b": "Esse foi o ciclo completo do encontro premium — oferta, aceitação, pagamento, código e confirmação. Nenhum dinheiro real foi movimentado. Pronto para tentar com um membro real?",
    "notif.refChat.t": "🎁 +{credits} créditos ganhos!",
    "notif.refChat.b": "{name} acabou de começar a conversar — {credits} créditos de bônus adicionados ao seu saldo.",
    "notif.payoutSent.t": "💸 Pagamento enviado!",
    "notif.payoutSent.b": "${amount} foi enviado para o seu PayPal ({recipient}).",
    "notif.favVerified.t": "✅ {name} agora está verificado!",
    "notif.favVerified.b": "{name}, dos seus favoritos, acabou de passar na verificação por selfie e ganhou o selo Verificado.",
    "notif.favReviewed.t": "⭐ {name} recebeu uma ótima avaliação!",
    "notif.favReviewed.b": "{name}, dos seus favoritos, acabou de receber uma avaliação de encontro de {rating} estrelas. Bons parceiros são reservados rápido!",
    "notif.favBoosted.t": "⚡ {name} acabou de se impulsionar!",
    "notif.favBoosted.b": "{name}, dos seus favoritos, está em destaque no topo do Descobrir agora — diga oi enquanto está nos holofotes!",
    "register.newMembers": "Novos membros recebem",
    "register.promoLuxe1": "50 créditos grátis",
    "register.promoDluxe1": "Acesso grátis + Ganhos",
    "register.promoLuxe2": "Para as mulheres que entram no LuxeMeet",
    "register.promoDluxe2": "Os homens entram no DLuxe grátis — e ganham com encontros premium",
    "register.googleTerms": "Ao continuar com o Google, você aceita nossos",
    "register.googleTermsLink": "Termos e Condições",
    "register.orEmail": "ou cadastre-se com e-mail",
    "register.hintF": "Mulheres: grátis no LuxeMeet (50 créditos iniciais) — ou tome a iniciativa no DLuxe com ofertas de encontros premium para homens.",
    "register.hintM": "Homens: invista para se conectar no LuxeMeet — e aproveite acesso grátis + ganhe com encontros premium no DLuxe.",
    "register.hintNone": "Selecione seu gênero para ver os recursos disponíveis",
    "register.refCode": "Código de indicação",
    "register.refOptional": "(opcional)",
    "register.refPh": "Tem um código? Digite aqui",
    "register.terms18": "Tenho 18 anos ou mais e aceito os",
    "register.termsLink": "Termos e Condições e o Termo de Isenção de Responsabilidade",
    "register.create": "Criar conta",
    "register.haveAccount": "Já tem uma conta?",
    "register.errGender": "Selecione seu gênero",
    "register.errTerms": "Aceite os Termos e Condições para continuar",
    "register.errFail": "Falha no cadastro",
    "register.giftClaimed": "😕 Este código de presente ({code}) já foi resgatado.",
    "register.giftExpired": "😕 Este código de presente ({code}) expirou.",
    "register.giftReady": "🎁 {name} te presenteou com um vale de campeão ({code}) — ele será adicionado à sua conta logo após o cadastro!",
    "register.giftFriend": "Um amigo",
    "set.tImgFile": "Selecione um arquivo de imagem",
    "set.tImgSize": "A imagem deve ter menos de 5MB",
    "set.tPhotoUpdated": "Foto de perfil atualizada!",
    "set.tPhotoFail": "Falha ao enviar a foto",
    "set.tPwMismatch": "As novas senhas não coincidem",
    "set.tPwShort": "A senha deve ter pelo menos 6 caracteres",
    "set.tPwChanged": "Senha alterada com sucesso!",
    "set.tPwFail": "Falha ao alterar a senha",
    "set.tProfileUpdated": "Perfil atualizado!",
    "set.tProfileFail": "Falha ao atualizar o perfil",
    "set.tLoggedOut": "Sessão encerrada com sucesso",
    "set.tDeactivated": "Conta desativada. Faça login novamente em até 30 dias para reativá-la.",
    "set.tDeleteFail": "Falha ao excluir a conta",
    "pp.errInvalidEmail": "Digite um e-mail válido",
    "pp.errNoMatch": "Os e-mails não coincidem",
    "pp.errConfirm": "Confirme seu e-mail do PayPal",
    "pp.errFix": "Corrija os erros antes de salvar",
    "pp.savedOk": "Configurações do PayPal salvas e verificadas!",
    "pp.saveFail": "Falha ao salvar as configurações",
    "pp.errImg": "Envie um arquivo de imagem",
    "pp.errSize": "O arquivo deve ter menos de 5MB",
    "pp.qrUploaded": "Código QR enviado!",
    "pp.qrFail": "Falha ao enviar o código QR",
    "terms.title": "Termos e Condições",
    "terms.updated": "Incluindo o Termo de Isenção de Responsabilidade — Última atualização: junho de 2026 (v5)",
    "terms.back": "Voltar",
    "terms.footer": "© 2026 LuxeMeet & DLuxe. Todos os direitos reservados.",
    "terms.s1t": "1. Aceitação dos Termos",
    "terms.s1p1": "Ao criar uma conta ou usar o LuxeMeet ou seu modo complementar DLuxe (juntos, \"a Plataforma\"), você concorda em ficar vinculado a estes Termos e Condições e ao nosso Termo de Isenção de Responsabilidade. Se não concordar, não use a Plataforma.",
    "terms.s2t": "2. Elegibilidade (18+)",
    "terms.s2p1": "Você deve ter pelo menos 18 anos para usar o LuxeMeet. Ao se cadastrar, você declara e garante que tem 18 anos ou mais e que pode legalmente celebrar este acordo. Contas pertencentes a menores serão encerradas imediatamente sem reembolso.",
    "terms.s3t": "3. Natureza do Serviço",
    "terms.s3p1": "O LuxeMeet é apenas uma plataforma de apresentação. Fornecemos ferramentas para que adultos se conheçam, troquem mensagens e organizem encontros. Não somos parte de nenhuma interação, conversa, encontro ou acordo entre membros. Não realizamos verificações de antecedentes criminais e não damos garantias sobre a identidade, conduta, intenções ou compatibilidade de nenhum membro.",
    "terms.s3p2": "A Plataforma pode exibir links para serviços independentes de terceiros para ajudar a planejar encontros — como OpenStreetMap e Google Maps para locais, Uber para transporte e Airbnb Experiences para ideias de encontros. Esses serviços não são operados por nós; seu uso é regido pelos próprios termos deles, e não somos responsáveis por seu conteúdo, preços ou disponibilidade.",
    "terms.s4t": "4. Créditos, Pagamentos e Ofertas de Encontros Premium",
    "terms.s4p1": "Membros masculinos compram créditos para enviar mensagens e solicitar encontros, slots de oferta premium para enviar ofertas de encontros e impulsos de perfil opcionais. Todos os pagamentos são processados pelo PayPal. Os preços são exibidos no momento da compra e podem incluir uma taxa de processamento.",
    "terms.s4p2": "Nas Ofertas de Encontros Premium, o valor oferecido fica retido em custódia após o pagamento. Quando o encontro acontece e o destinatário insere o código de confirmação de 6 dígitos do pagador, o pagamento (menos a comissão da plataforma) é liberado ao destinatário. A comissão da plataforma é divulgada no app. Encontros repetidos: quando um pagador reserva um novo encontro com alguém com quem já completou um encontro pela Plataforma, nenhum slot premium é necessário e aplica-se uma comissão reduzida de 10% (o destinatário recebe 90% do valor da oferta). Os subsídios de transporte opcionais são pagos junto com a oferta e repassados 100% ao destinatário. Ofertas de encontro canceladas são removidas automaticamente do histórico 48 horas após o cancelamento. Vales de campeão: vales de recompensa obtidos no ranking mensal de Melhores Membros podem ser presenteados uma vez a outra pessoa por meio de um código de presente de uso único; uma vez presenteado, o vale não pode ser usado nem recuperado pelo titular original, e vales recebidos como presente não podem ser presenteados novamente. Os vales não têm valor em dinheiro.",
    "terms.s4p3": "Reembolsos: créditos, slots e impulsos não são reembolsáveis após a entrega. Pagamentos de encontros em custódia só são reembolsáveis se o encontro não ocorrer e a oferta for cancelada ou expirar conforme as regras da plataforma. Os pagamentos devem ser feitos de uma conta PayPal cujo e-mail corresponda ao seu e-mail de login no LuxeMeet; pagamentos de e-mails divergentes podem atrasar ou ser irrecuperáveis. Você pode enviar um pedido de reembolso ou uma reclamação a qualquer momento em Configurações → Reembolsos e Reclamações (ou \"Ajuda e Suporte\" no menu do app); cada pedido é analisado pela nossa equipe e você será notificado do resultado no app e por e-mail.",
    "terms.s5t": "5. Isenção de Responsabilidade e Assunção de Risco",
    "terms.s5p1": "VOCÊ CONCORDA EXPRESSAMENTE QUE ENCONTRAR OUTRO MEMBRO PESSOALMENTE É INTEIRAMENTE POR SUA CONTA E RISCO. Na máxima extensão permitida por lei, você libera, exonera e isenta o LuxeMeet, seus proprietários, operadores, funcionários e afiliados de toda e qualquer reivindicação, demanda, dano, lesão, perda ou causa de ação — conhecida ou desconhecida — decorrente de ou relacionada ao seu uso da Plataforma, suas interações ou comunicações com outros membros e qualquer encontro presencial organizado através da Plataforma, incluindo, sem limitação, lesões pessoais, sofrimento emocional, danos à propriedade, roubo, fraude ou perda financeira.",
    "terms.s5p2": "Você é o único responsável pela sua própria segurança. Recomendamos fortemente encontrar-se em locais públicos, avisar um amigo aonde você vai, organizar seu próprio transporte e nunca compartilhar informações financeiras com outros membros.",
    "terms.s6t": "6. Conduta dos Membros",
    "terms.s6p1": "Você concorda em não: falsificar sua identidade ou idade; assediar, abusar ou prejudicar outros membros; solicitar dinheiro de membros fora do sistema de ofertas da Plataforma; usar a Plataforma para qualquer fim comercial, ilegal ou de exploração (incluindo serviços de acompanhantes ou tráfico humano); publicar conteúdo explícito, ofensivo ou infrator; ou tentar burlar os sistemas de pagamento da Plataforma.",
    "terms.s6p2": "Política de conteúdo: fotos e vídeos de perfil não devem conter nudez ou conteúdo sexualmente explícito ou sugestivo. Todas as fotos e vídeos enviados são automaticamente analisados por IA antes da publicação e o conteúdo proibido é rejeitado. Tentativas repetidas de enviar conteúdo proibido podem resultar em medidas na conta.",
    "terms.s6p3": "A violação pode resultar em suspensão ou encerramento imediato sem reembolso, e encaminhamento às autoridades quando apropriado.",
    "terms.s7t": "7. Avaliações de Encontros, Comentários e Favoritos",
    "terms.s7p1": "Após um encontro premium concluído, ambos os participantes podem avaliar o encontro (1-5 estrelas) com um comentário escrito opcional. A participação nas avaliações é opcional: você pode desativá-la completamente em Configurações, caso em que ninguém pode avaliar seus encontros e nenhuma avaliação aparece no seu perfil. Se participar, você pode escolher separadamente se os comentários escritos são exibidos publicamente com sua classificação de estrelas.",
    "terms.s7p2": "As avaliações devem ser honestas, respeitosas e baseadas em um encontro real. Avaliações difamatórias, de assédio ou falsas podem ser removidas e podem resultar em medidas na conta. Os membros também podem salvar outros perfis em uma lista privada de Favoritos; seus favoritos são visíveis apenas para você. Se você favoritar um membro, poderá receber notificações sobre a atividade pública do perfil dele (como impulsos, verificação ou novas avaliações).",
    "terms.s8t": "8. Recursos de IA",
    "terms.s8p1": "A Plataforma oferece recursos opcionais com tecnologia de IA, incluindo os assistentes de escrita \"AI Wingman\" (para membros masculinos) e \"AI Cupid\" (para membros femininos) — que podem redigir aberturas e respostas de chat, notas de ofertas de encontros premium, mensagens de contraoferta, mensagens de solicitação de encontro e comentários de avaliações de encontros — o assistente de ajuda \"Luxe\" no app, ideias de encontros selecionadas por IA, sugestões de looks do estilista de IA exibidas na contagem regressiva do encontro, estatísticas semanais de matches assistidas por IA, fotos de perfil assistidas por IA e verificação de fotos por selfie com IA. A IA também é usada para analisar automaticamente todas as fotos e vídeos de galeria enviados em busca de conteúdo proibido (nudez e conteúdo sexual) antes da publicação. O conteúdo de IA é gerado automaticamente e pode ser impreciso. Você é responsável por qualquer conteúdo que enviar ou publicar, incluindo conteúdo assistido por IA. As fotos de perfil devem representá-lo fielmente; usar imagens de IA que distorçam materialmente sua aparência pode resultar em medidas na conta. As selfies de verificação são usadas apenas para a checagem de verificação e nunca são exibidas publicamente.",
    "terms.s9t": "9. Limitação de Responsabilidade",
    "terms.s9p1": "NA MÁXIMA EXTENSÃO PERMITIDA POR LEI, O LUXEMEET NÃO SERÁ RESPONSÁVEL POR QUAISQUER DANOS INDIRETOS, INCIDENTAIS, ESPECIAIS, CONSEQUENTES OU PUNITIVOS, OU QUALQUER PERDA DE LUCROS OU DADOS, DECORRENTES DO SEU USO DA PLATAFORMA. NOSSA RESPONSABILIDADE TOTAL AGREGADA POR QUALQUER REIVINDICAÇÃO NÃO EXCEDERÁ O VALOR QUE VOCÊ PAGOU AO LUXEMEET NOS SEIS (6) MESES ANTERIORES À REIVINDICAÇÃO.",
    "terms.s10t": "10. Privacidade",
    "terms.s10p1": "Coletamos e processamos informações de conta, mensagens, registros de pagamento e dados de uso para operar a Plataforma, processar pagamentos e saques, prevenir fraudes e melhorar o serviço. As contagens de visualizações de perfil são registradas para as análises de impulso. Você pode ativar o Modo Anônimo em Configurações para ocultar seu perfil da navegação no Descobrir — globalmente ou de membros específicos — enquanto suas conversas, ofertas e encontros existentes continuam funcionando. Não vendemos seus dados pessoais. E-mails podem ser enviados para fins de conta, pagamento e engajamento.",
    "terms.s11t": "11. Encerramento e Exclusão de Conta",
    "terms.s11p1": "Excluindo sua conta: você pode excluir sua conta a qualquer momento em Configurações → Zona de Perigo. Seu perfil é ocultado imediatamente do Descobrir, rankings e favoritos. Aplica-se um período de carência de 30 dias: fazer login novamente em até 30 dias reativa totalmente sua conta. Após 30 dias, sua conta e dados pessoais (perfil, fotos, vídeos, mensagens, favoritos e notificações) são apagados ou anonimizados de forma permanente e irreversível. Créditos, slots, impulsos não utilizados e quaisquer saldos não sacados são perdidos com a exclusão permanente. Registros exigidos para conformidade financeira e legal (como registros de pagamentos concluídos) podem ser mantidos de forma anonimizada.",
    "terms.s11p2": "Podemos suspender ou encerrar contas que violem estes Termos. Créditos, slots e impulsos não utilizados são perdidos em caso de encerramento por justa causa.",
    "terms.s12t": "12. Alterações destes Termos",
    "terms.s12p1": "Podemos atualizar estes Termos periodicamente. O uso continuado da Plataforma após as alterações entrarem em vigor constitui aceitação dos Termos revisados.",
    "terms.s13t": "13. Modo DLuxe",
    "terms.s13p1": "A Plataforma inclui um modo complementar, \"DLuxe\", acessível pelo botão de coração no app. O DLuxe espelha o LuxeMeet com os papéis de pagamento invertidos: membros femininas pagam pelas interações (créditos, slots de oferta premium, impulsos e ofertas monetárias de encontros) e membros masculinos podem receber pagamentos de ofertas de encontros. Todos os Termos se aplicam igualmente a ambos os modos, com disposições específicas de papel aplicando-se a quem paga ou recebe pagamento no modo ativo. Uma única conta é usada nos dois modos. Conversas e solicitações de encontro são separadas por modo: interações iniciadas no LuxeMeet seguem as regras de pagamento do LuxeMeet (homens pagam) e interações iniciadas no DLuxe seguem as regras do DLuxe (mulheres pagam). Trocar de modo apenas muda qual caixa de entrada é exibida e nunca muda quem paga em uma conversa existente. Todos os recursos da Plataforma — incluindo assistentes de IA, rankings, recompensas de campeão e presente de vales — estão disponíveis em ambos os modos com a marca apropriada.",
    "terms.s14t": "14. Contato",
    "terms.s14p1": "Dúvidas sobre estes Termos? Use o assistente de Ajuda no app. Para pedidos de reembolso e reclamações, use Configurações → Reembolsos e Reclamações (ou \"Ajuda e Suporte\" no menu do app) — cada envio é analisado e respondido.",
    "landing.badge": "Experiência de encontros premium",
    "landing.heroLuxe1": "Onde a qualidade",
    "landing.heroLuxe2": "encontra a conexão",
    "landing.heroDluxe1": "Onde as mulheres",
    "landing.heroDluxe2": "tomam a iniciativa",
    "landing.taglineLuxe": "Uma plataforma de encontros exclusiva onde conexões autênticas são valorizadas. Os cavalheiros investem créditos para se conectar, garantindo interesse genuíno e interações de qualidade.",
    "landing.taglineDluxe": "Uma plataforma de encontros exclusiva onde mulheres ousadas dão o primeiro passo. Elas investem créditos para conhecer homens excepcionais, garantindo interesse genuíno e interações de qualidade.",
    "landing.startJourney": "Comece sua jornada",
    "landing.haveAccount": "Já tenho uma conta",
    "landing.watchFilm": "Assistir ao filme",
    "auth.signIn": "Entrar",
    "auth.getStarted": "Começar",
    "login.welcomeBack": "Bem-vindo de volta",
    "login.subtitle": "Entre para continuar sua jornada",
    "login.google": "Continuar com Google",
    "login.orEmail": "ou continue com e-mail",
    "login.email": "E-mail",
    "login.password": "Senha",
    "login.emailPh": "Digite seu e-mail",
    "login.passwordPh": "Digite sua senha",
    "login.forgot": "Esqueceu a senha?",
    "login.noAccount": "Não tem uma conta?",
    "login.createOne": "Crie uma",
    "login.backHome": "Voltar ao início",
    "register.title": "Crie sua conta",
    "register.subtitle": "Comece sua jornada rumo a conexões autênticas",
    "register.fullName": "Nome completo",
    "register.namePh": "Digite seu nome",
    "register.passwordPh": "Crie uma senha",
    "register.iAmA": "Eu sou",
    "register.man": "Homem",
    "register.woman": "Mulher",
    "nav.discover": "Descobrir",
    "nav.favorites": "Favoritos",
    "nav.chat": "Chat",
    "nav.offers": "Ofertas",
    "nav.meetups": "Encontros",
    "nav.top": "Top",
    "nav.credits": "Créditos",
    "nav.earnings": "Ganhos",
    "nav.settings": "Configurações",
    "nav.watchTour": "Ver o tour",
    "nav.helpSupport": "Ajuda e suporte",
    "discover.title": "Descobrir",
    "discover.subtitle": "Encontre seu par perfeito",
    "discover.newest": "Novos",
    "discover.topRated": "Mais bem avaliados",
    "discover.sendOffer": "Enviar oferta de encontro premium",
    "discover.message": "Mensagem",
    "discover.aiCompanion": "Companhia IA",
    "discover.videoIntro": "Vídeo",
    "settings.countryLanguage": "País e idioma",
    "settings.country": "País",
    "settings.language": "Idioma",
    "settings.currency": "Moeda",
    "settings.currencyNote": "Os preços são exibidos de forma aproximada na sua moeda; os pagamentos são processados em USD.",
    "settings.refunds": "Reembolsos e reclamações",
    "settings.changePassword": "Alterar senha",
    "settings.logout": "Sair",
    "settings.dangerZone": "Zona de perigo",
    "settings.deleteAccount": "Excluir minha conta",
    "credits.billedUsd": "cobrado em USD",
    "common.accept": "Aceitar",
    "common.decline": "Recusar",
    "common.pending": "Pendente",
    "common.accepted": "Aceita",
    "common.declined": "Recusada",
    "common.received": "Recebidas",
    "common.sent": "Enviadas",
    "common.yourBalance": "Seu saldo",
    "common.back": "Voltar",
    "common.cancel": "Cancelar",
    "common.credits": "Créditos",
    "common.viewMap": "Ver mapa",
    "common.getUber": "Chamar um Uber",
    "common.hours": "horas",
    "chat.title": "Mensagens",
    "chat.empty": "Ainda não há conversas",
    "chat.emptySub": "Conecte-se com pessoas para começar a conversar!",
    "chat.discoverProfiles": "Descobrir perfis",
    "chat.typeMessage": "Digite uma mensagem...",
    "chat.inbox": "Caixa",
    "chat.noMessages": "Ainda não há mensagens. Comece a conversa!",
    "chat.startConvo": "Comece a conversa!",
    "chat.costStart": "Iniciar um chat custa 10 créditos",
    "chat.costMessage": "Enviar uma mensagem custa 5 créditos",
    "chat.inboxBadge": "Caixa {app}",
    "common.testRun": "Teste",
    "offers.simulatePayment": "Simular pagamento (teste)",
    "offers.title": "Ofertas de encontro premium",
    "offers.dateOffers": "Ofertas de encontro",
    "offers.slots": "Seus slots de ofertas",
    "offers.available": "Disponíveis",
    "offers.inUse": "Em uso",
    "offers.consumed": "Consumidos",
    "offers.sentOffers": "Suas ofertas enviadas",
    "offers.none": "Ainda não há ofertas",
    "offers.noneSent": "Nenhuma oferta enviada",
    "offers.reviewRespond": "Analise e responda às suas ofertas de encontro premium",
    "offers.subtitlePayer": "Compre slots para enviar ofertas de encontro premium aos seus matches",
    "offers.slotDesc": "US$ 50 por slot • Reutilizável até uma oferta ser aceita",
    "offers.buySlot": "Comprar slot",
    "offers.noneDesc": "Você ainda não recebeu ofertas de encontro",
    "offers.noneSentDesc": "Compre um slot e envie sua primeira oferta de encontro premium",
    "offers.buyFirstSlot": "Compre seu primeiro slot",
    "offers.respond": "Responder",
    "offers.cancelOffer": "Cancelar oferta",
    "offers.viewCounter": "Ver contraproposta",
    "offers.rateDate": "Avaliar este encontro",
    "offers.dateDetails": "Detalhes e avaliações do encontro",
    "status.pending": "Pendente",
    "status.paymentNeeded": "Pagamento necessário",
    "status.awaitingConfirmation": "Aguardando confirmação",
    "status.countered": "Contraproposta",
    "status.confirmed": "Confirmado",
    "status.completed": "Concluído",
    "status.declined": "Recusado",
    "status.expired": "Expirado",
    "status.cancelled": "Cancelado",
    "meetups.title": "Pedidos de encontro",
    "meetups.none": "Ainda não há pedidos",
    "meetups.noneSent": "Nenhum pedido enviado",
    "meetups.received": "Recebidos",
    "meetups.sent": "Enviados",
    "meetups.noneDesc": "Pedidos de encontro de outras pessoas aparecerão aqui.",
    "meetups.noneSentDesc": "Encontre alguém que você gostaria de conhecer!",
    "meetups.browse": "Explorar perfis",
    "favorites.title": "Favoritos",
    "favorites.subtitle": "Perfis que você salvou",
    "favorites.none": "Ainda não há favoritos",
    "favorites.noneDesc": "Toque no coração de um perfil que você ama e ele será salvo aqui.",
    "favorites.browse": "Explorar Descobrir",
    "leaderboard.title": "Melhores membros",
    "leaderboard.you": "Você",
    "leaderboard.subtitle": "Os membros mais requisitados, mais bem avaliados e mais generosos da plataforma. Ganhe distintivos para garantir seu lugar.",
    "leaderboard.prizeNote": "O nº 1 mensal de cada seção ganha um boost grátis de 7 dias + 2 semanas de ofertas de encontro ilimitadas.",
    "leaderboard.empty": "Ainda não há membros com distintivos — complete ótimos encontros para ser o primeiro!",
    "leaderboard.loading": "Carregando o ranking...",
    "leaderboard.fireTitle": "Os mais requisitados no DLuxe",
    "leaderboard.fireSub": "Os 3 homens mais contatados no DLuxe este mês",
    "leaderboard.diamondTitle": "Membros Diamante",
    "leaderboard.diamondSub": "Completaram 3+ encontros premium de US$ 500 ou mais",
    "leaderboard.ratedTitle": "Mais bem avaliados",
    "leaderboard.ratedSub": "As melhores avaliações de encontros reais",
    "leaderboard.shareBadge": "Compartilhar distintivo",
    "leaderboard.datesCompleted": "encontros premium concluídos",
    "earnings.title": "Meus ganhos",
    "earnings.escrow": "Em custódia",
    "earnings.total": "Total ganho",
    "earnings.dates": "Encontros realizados",
    "earnings.history": "Histórico de pagamentos",
    "earnings.none": "Ainda não há ganhos",
    "credits.costs": "Custos em créditos",
    "credits.startChat": "Iniciar um novo chat",
    "credits.sendMessage": "Enviar uma mensagem",
    "credits.requestMeetup": "Solicitar um encontro",
    "credits.buy": "Comprar créditos",
    "credits.history": "Histórico de compras",
    "credits.noHistory": "Ainda não há compras",
    "credits.completePayment": "Concluir pagamento",
    "credits.allSet": "Tudo pronto!",
    "credits.freeLuxe": "Como mulher no LuxeMeet, você tem acesso gratuito às mensagens e a todos os recursos.",
    "credits.freeDluxe": "Como homem no DLuxe, você tem acesso gratuito às mensagens e a todos os recursos.",
    "credits.bestValue": "Melhor valor",
    "credits.continuePayment": "Continuar para o pagamento",
    "credits.processing": "Processando...",
    "profile.message": "Mensagem",
    "profile.requestMeetup": "Solicitar encontro",
    "tour.tryWith": "Experimente com",
    "settings.title": "Configurações",
    "settings.photoHint": "Toque na câmera para trocar a foto",
    "settings.profileInfo": "Informações do perfil",
    "settings.displayName": "Nome de exibição",
    "settings.age": "Idade",
    "settings.location": "Localização",
    "settings.locationPh": "Cidade, País",
    "settings.bio": "Bio",
    "settings.bioPh": "Conte aos outros sobre você...",
    "settings.interests": "Interesses",
    "settings.interestsPh": "Viagens, Música, Comida (separados por vírgulas)",
    "settings.interestsHint": "Separe os interesses com vírgulas",
    "settings.saveChanges": "Salvar alterações",
    "settings.paypalTitle": "Configurações de pagamento PayPal",
    "settings.paypalDesc": "Adicione seus dados do PayPal para receber os pagamentos das ofertas de encontro aceitas",
    "settings.dangerDesc": "Excluir sua conta oculta seu perfil imediatamente. Mudou de ideia? Basta entrar novamente em até 30 dias para reativar — depois disso, sua conta e dados pessoais são apagados permanentemente e créditos ou saldos não usados são perdidos.",
    "settings.deleteTitle": "Excluir sua conta?",
    "settings.deleteB1": "Seu perfil é ocultado de todos imediatamente",
    "settings.deleteB2": "Entre novamente em até 30 dias para reativar",
    "settings.deleteB3": "Após 30 dias tudo é apagado permanentemente — fotos, mensagens e quaisquer créditos ou saldo não usados",
    "settings.confirmPasswordLabel": "Confirme sua senha",
    "settings.googleBlank": "Cadastrou-se com o Google? Deixe em branco.",
    "settings.deactivateDelete": "Desativar e excluir",
    "settings.currentPassword": "Senha atual",
    "settings.newPassword": "Nova senha",
    "settings.confirmNewPassword": "Confirmar nova senha",
    "ref.title": "Convide e ganhe",
    "ref.desc": "Compartilhe seu link de convite. Você ganha 25 créditos bônus assim que um amigo convidado começa a conversar. Além disso: quando um indicado compra seu primeiro slot premium, você ganha um slot de $50 GRÁTIS — e quando um indicado completa seu primeiro date premium, seu PRÓXIMO date remunerado paga 90% em vez de 80%.",
    "ref.friendsReferred": "Amigos indicados",
    "ref.bonusCredits": "Créditos bônus ganhos",
    "ref.freeSlots": "Slots grátis ganhos",
    "ref.boosts": "Boosts de 90% disponíveis",
    "ref.yourReferrals": "Seus indicados",
    "ref.stJoined": "Entrou",
    "ref.stChatting": "Começou a conversar ✓ (+25 créditos)",
    "ref.stDate": "Completou um date ✓",
    "ref.stSlot": "Comprou um slot ✓",
    "ref.topReferrers": "Maiores indicadores do mês",
    "ref.referralsWord": "indicados",
    "ref.copied": "Link de convite copiado!",
    "share.inviteMsg": "Junte-se a mim no {app} — o app de encontros premium onde dates de verdade acontecem. Cadastre-se com meu link:",
    "share.dreamMsg": "💘 Você foi convidado para um Date dos Sonhos! Junte-se a mim no {app} e vamos planejar o date perfeito:",
    "share.inviteBtn": "Convidar um amigo",
    "share.dreamBtn": "💘 Convite Date dos Sonhos",
    "share.hint": "Escreva sua própria mensagem ou deixe em branco para usar o modelo — seu link de convite é adicionado automaticamente.",
    "share.copied": "Mensagem de convite copiada — cole onde quiser!",
    "landing.whyTitle": "Por que escolher o {app}?",
    "landing.whySub": "Nosso sistema de créditos garante que cada interação seja significativa e intencional.",
    "landing.f1Title": "Conexões de qualidade",
    "landing.f1Desc": "Créditos garantem interesse genuíno. Sem spam, sem bots — apenas pessoas reais buscando conexões reais.",
    "landing.f2Title": "Experiência premium",
    "landing.f2DescLuxe": "Elas têm acesso grátis enquanto eles investem em conversas significativas e pedidos de encontro.",
    "landing.f2DescDluxe": "Eles têm acesso grátis enquanto elas investem em conversas significativas e ofertas de dates premium.",
    "landing.f3Title": "Perfis verificados",
    "landing.f3Desc": "Todos os perfis são verificados para garantir autenticidade. Conheça pessoas reais, crie conexões reais.",
    "landing.refBadge": "Indique e ganhe",
    "landing.refTitle1": "Convide amigos,",
    "landing.refTitle2": "desbloqueie recompensas",
    "landing.refDesc1": "Cada membro tem um link de convite pessoal. Compartilhe com amigos e ganhe um",
    "landing.refDescBold": "slot premium de $50 GRÁTIS",
    "landing.refDesc2": "além de recursos bônus exclusivos quando eles entram e ficam ativos.",
    "landing.refCard1Title": "Slot premium de $50 GRÁTIS",
    "landing.refCard1Desc": "Ganho por cada amigo que entra e fica ativo",
    "landing.refCard2Title": "Recursos bônus",
    "landing.refCard2Desc": "Vantagens exclusivas reservadas aos maiores indicadores",
    "landing.refCta": "Entre e pegue seu link",
    "landing.ctaTitle": "Pronto para encontrar seu par?",
    "landing.ctaSub": "Junte-se a milhares de solteiros que encontraram conexões significativas no {app}.",
    "landing.ctaBtn": "Criar conta grátis",
    "landing.footerTerms": "Termos e condições",
    "pp.balance": "Saldo disponível",
    "pp.balanceNote": "De ofertas de encontro aceitas (repasse de 80% após taxa da plataforma)",
    "pp.email": "E-mail do PayPal *",
    "pp.emailHint": "É para cá que enviaremos seus pagamentos",
    "pp.confirmEmail": "Confirmar e-mail do PayPal *",
    "pp.confirmPh": "Digite seu e-mail novamente",
    "pp.emailsMatch": "Os e-mails coincidem",
    "pp.verified": "Verificado",
    "pp.username": "Usuário do PayPal (opcional)",
    "pp.qr": "QR Code do PayPal (opcional)",
    "pp.qrUpload": "Enviar QR Code",
    "pp.qrHint": "Envie seu QR code de pagamento do PayPal para transferências fáceis",
    "pp.save": "Salvar e verificar configurações do PayPal",
    "pp.howTitle": "ℹ️ Como funcionam os pagamentos",
    "pp.how1": "Membros enviam ofertas de encontro com valores ($100-$1000)",
    "pp.how2": "Quando você aceita e eles pagam, você recebe 80% (a plataforma fica com 20%)",
    "pp.how3": "Os pagamentos são processados para seu e-mail do PayPal em 3-5 dias úteis",
    "pp.how4": "Seu saldo é atualizado após cada date confirmado",
    "rel.title": "Relacionamento oficial",
    "rel.activeWith": "💞 Oficialmente juntos com {name}",
    "rel.activeSince": "Desde {date} — vocês dois estão ocultos para todos os outros.",
    "rel.chat": "Conversar",
    "rel.planDate": "Planejar um encontro",
    "rel.end": "Terminar o relacionamento",
    "rel.incomingTitle": "💍 {name} quer oficializar com você!",
    "rel.incomingDesc": "Aceite e vocês dois desaparecerão do feed dos outros — o app será só de vocês dois.",
    "rel.accept": "Aceitar 💞",
    "rel.decline": "Ainda não",
    "rel.waitingFor": "⏳ Aguardando {name}",
    "rel.waitingDesc": "Seu pedido de oficialização está aguardando resposta.",
    "rel.cancelRequest": "Cancelar pedido",
    "rel.endTitle": "Terminar o relacionamento oficial?",
    "rel.endDesc": "Você e {name} voltarão a ficar visíveis para todos e poderão ver outros membros. Suas conversas e histórico permanecem intactos.",
    "rel.keepIt": "Manter",
    "rel.goOfficial": "Oficializar — nos esconda de todos os outros",
    "rel.requestSent": "⏳ Pedido enviado — aguardando {name}",
    "rel.togetherSince": "💞 Oficialmente juntos desde {date}",
    "rel.together": "💞 Oficialmente juntos",
    "rel.coupleTitle": "💞 Vocês estão oficialmente juntos",
    "rel.coupleDesc": "Você e {name} estão ocultos para todos os outros. O app é só de vocês dois — chat, encontros e dates premium.",
    "rel.coupleHint": "Mudou de planos? Qualquer um dos dois pode terminar a qualquer momento nas Configurações.",
    "rel.toastSent": "💍 Pedido de oficialização enviado para {name}!",
    "rel.toastTogether": "💞 Você e {name} estão oficialmente juntos!",
    "rel.toastEnded": "Relacionamento terminado — você está visível no app novamente",
    "rel.toastPrivate": "Este membro está em um relacionamento oficial 💞",
    "rel.toastActive": "Você está em um relacionamento oficial — o app agora é só de vocês dois 💞",
    "invite.admirerTitle": "Você tem um admirador secreto 💘",
    "invite.dreamTitle": "{name} guarda um convite para um encontro dos sonhos para você",
    "invite.admirerSub": "{name} tem uma mensagem de um admirador secreto esperando por você — mas ela fica selada até você entrar.",
    "invite.dreamSub": "Alguém planejou algo especial — os detalhes ficam selados até você entrar.",
    "invite.lock": "Cadastre-se grátis para desbloquear sua surpresa",
    "invite.claimedNote": "Este convite já foi revelado. Entre mesmo assim e veja quem está esperando por você!",
    "invite.reveal": "Revelar minha surpresa",
    "invite.login": "Já é membro? Entrar",
    "invite.expired": "Este convite expirou",
    "invite.explore": "Explorar o LuxeMeet",
    "landing.goBadge": "Feito para finais de verdade",
    "landing.goTitle1": "Quando fica sério,",
    "landing.goTitle2": "oficializem 💞",
    "landing.goDesc": "Encontrou a pessoa certa? Um toque e vocês dois somem do feed de todos — sem perfis, sem mensagens, sem distrações. O app vira só de vocês dois: chat privado, encontros e dates premium. E se algo mudar, qualquer um pode desativar a qualquer momento.",
    "landing.goChip1": "🙈 Invisíveis para todos os outros",
    "landing.goChip2": "💬 Tudo continua aberto entre vocês dois",
    "landing.goChip3": "🔄 Reversível a qualquer momento",
    "common.years": "anos",
    "form.proposedDateTime": "Data e hora propostas",
    "form.duration": "Duração (opcional)",
    "form.proposedLocation": "Local proposto",
    "form.messageOptional": "Mensagem (opcional)",
    "form.openEnded": "Sem limite",
    "form.writeMessage": "Escreva sua mensagem...",
    "form.addPersonalMessage": "Adicione uma mensagem pessoal...",
    "form.searchVenue": "Busque o local ou endereço exato...",
    "offerModal.selectDateType": "Selecione o tipo de encontro...",
    "offerModal.amountPlaceholder": "Digite o valor (100-1000)",
    "offerModal.amountHint": "Você pagará este valor se seu par aceitar (taxa de {fee}% da plataforma)",
    "offerModal.transportHint": "Pago junto com sua oferta e repassado 100% ao seu par para transporte (sem taxa).",
    "offerModal.durationHint": "Quanto tempo você quer que o encontro dure — expectativas claras para os dois.",
    "tour.subtitle": "Um test drive de 60 segundos — nada é cobrado, nunca",
    "tour.step1Title": "Diga oi no chat",
    "tour.step1Desc": "{name} já te mandou mensagem — envie uma resposta",
    "tour.step2Title": "Peça um encontro",
    "tour.step2Desc": "Totalmente grátis — veja ser aceito",
    "tour.step3Title": "Envie uma oferta de encontro premium",
    "tour.step3DescSent": "Enviada! Simule o pagamento na sua página de Ofertas",
    "tour.step3Desc": "Sem slot, sem dinheiro real — simulação completa",
    "tour.go": "Ir",
    "tour.doneTitle": "Você dominou o LuxeMeet! 🎉",
    "tour.doneDesc": "Chat, encontros e ofertas premium — você testou tudo. Agora vá atrás do real.",
    "tour.browseReal": "Explorar membros reais",
    "common.freeTest": "Teste grátis",
    "discover.aiTestNote": "Companhia de teste — chat, encontros e ofertas premium são simulações GRÁTIS. Nunca há pagamento real.",
    "discover.meetUp": "Encontrar",
    "profile.msgTitle": "Enviar mensagem para {name}",
    "profile.msgCostPayer": "Iniciar uma conversa custa 10 créditos, depois 5 créditos por mensagem. As respostas são grátis.",
    "profile.msgFree": "Grátis para você no {app} — este chat vai para a caixa {app}, onde responder custa créditos.",
    "profile.sendMessage": "Enviar mensagem",
    "profile.meetupTitle": "Pedir um encontro com {name}",
    "profile.meetupCost": "Pedir um encontro custa 25 créditos.",
    "profile.meetupFree": "Grátis para você no {app} — o pedido aparecerá nos encontros do {app}.",
    "profile.meetupTest": "🧪 Teste grátis — sua companhia IA aceitará automaticamente para você ver o fluxo completo. Sem créditos.",
    "profile.sendMeetup": "Enviar pedido",
    "profile.costsMsg": "Mensagem: 10 créditos (primeira) / 5 créditos (resposta)",
    "profile.costsMeetup": "Pedido de encontro: 25 créditos",
    "offerModal.title": "Enviar oferta de encontro premium",
    "offerModal.desc": "Envie uma oferta monetária de encontro para {name}",
    "offerModal.testBanner": "🧪 Teste com {name} — sem slot, e o pagamento é simulado (nunca cobrado).",
    "offerModal.needSlot": "Você precisa comprar um slot premium primeiro",
    "offerModal.purchaseSlot": "Comprar slot (US$ 50)",
    "offerModal.slotsAvailable": "Slots disponíveis: {n}",
    "offerModal.testNoSlot": "Oferta de teste — sem slot",
    "offerModal.repeatNoSlot": "Encontro repetido — sem slot",
    "offerModal.amount": "Valor da oferta *",
    "offerModal.transport": "Transporte (opcional)",
    "offerModal.proposedDate": "Data proposta *",
    "offerModal.proposedTime": "Hora proposta *",
    "offerModal.duration": "Duração (opcional)",
    "offerModal.location": "Local *",
    "offerModal.dateType": "Tipo de encontro *",
    "offerModal.message": "Mensagem (opcional)",
    "offerModal.sendOffer": "Enviar oferta",
    "voucher.unlimitedActive": "Ofertas de encontro ilimitadas ativas 🏆",
    "voucher.unlimitedUntil": "Sem slots até {date} — privilégio de campeão.",
    "voucher.championPrize": "Prêmio de campeão: 2 semanas de ofertas ilimitadas",
    "voucher.giftFrom": "Presente de {name}: 2 semanas de ofertas ilimitadas",
    "voucher.activate": "Ativar minhas 2 semanas",
    "voucher.giftIt": "Presentear",
    "voucher.haveCode": "Tem um código de presente?",
    "voucher.redeem": "Resgatar",
    "voucher.giftsSent": "Presentes enviados",
    "ideas.near": "Inspiração de encontros perto de",
    "ideas.plan": "Planejar este encontro",
    "ideas.popular": "Locais de encontro populares na plataforma",
    "ideas.map": "Mapa",
    "ideas.cityTitle": "Ideias de encontro para outra cidade",
    "ideas.cityDesc": "Planejando uma viagem ou encontro em outro lugar? Escolha uma cidade e traremos ideias de lá.",
    "ideas.show": "Mostrar ideias",
    "ideas.whoFor": "Para quem é este encontro?",
    "ideas.pickDesc": "escolha um match e pré-preencheremos sua oferta premium.",
    "ideas.emptyPrefix": "Ainda sem matches — favorite alguém em",
    "ideas.emptySuffix": "ou comece um chat primeiro.",
    "profile.videos": "VÍDEOS",
  },
  it: {
    "nav.events": "Eventi",
    "leaderboard.youOnBoard": "🏆 Sei in classifica!",
    "leaderboard.youOnBoardSub": "i membri dell'altro lato ti vedono in classifica qui. Continua a brillare!",
    "events.title": "Eventi",
    "events.subtitle": "Eventi esclusivi per i membri — incontriamoci dal vivo.",
    "events.empty": "Nessun evento in programma al momento — torna presto!",
    "events.loading": "Caricamento eventi…",
    "events.spotsLeft": "{n} posti rimasti",
    "events.soldOut": "Esaurito",
    "events.joinedChip": "Ci sei!",
    "events.free": "Gratuito",
    "events.feeNote": "{price} $ + 2 $ di commissione",
    "events.payCredits": "Partecipa con {n} crediti",
    "events.payPaypal": "Paga con PayPal · {total} $",
    "events.joinFree": "Partecipa gratis",
    "events.notEnough": "Crediti insufficienti — questo evento costa {n} crediti",
    "events.joinedToast": "🎟️ Ci sei! Controlla la tua email per la conferma.",
    "events.payCancelled": "Pagamento annullato",
    "events.captureFail": "Non siamo riusciti a confermare il pagamento — riprova",
    "events.bannerTitle": "🎉 Prossimo evento",
    "events.bannerCta": "Vedi eventi",
    "notif.eventJoined.t": "🎟️ Ci vai!",
    "notif.eventJoined.b": "Il tuo posto a \"{title}\" è confermato. Ci vediamo lì!",
    "notif.eventCancelled.t": "😔 Evento annullato",
    "notif.eventCancelled.b": "\"{title}\" è stato annullato. Se hai pagato, il rimborso è in arrivo.",
    "terms.contactT": "Contattaci",
    "terms.contactP": "Domande, dubbi o feedback? Contattaci in qualsiasi momento:",
    "msdluxe.tapSound": "Tocca per l'audio",
    "msdluxe.badge": "La tua padrona di casa IA",
    "msdluxe.title1": "Ti presentiamo Ms DLuxe",
    "msdluxe.title2": "Ti farà fare un giro",
    "msdluxe.desc": "Ms DLuxe in persona spiega esattamente come funziona: crediti, offerte di appuntamenti premium, guadagni e sicurezza.",
    "msdluxe.luxeCard": "Come funziona LuxeMeet",
    "msdluxe.dluxeCard": "Come funziona DLuxe",
    "msdluxe.download": "Scarica",
    "msdluxe.share": "Salvali, pubblicali, mandali a un amico — sono tuoi da condividere.",
    "nav.msdluxeVideos": "Come funziona · Ms DLuxe",
    "credits.requestRefund": "Richiedi rimborso",
    "credits.refundRequested": "Rimborso richiesto",
    "credits.refunded": "Rimborsato",
    "credits.refundDeniedChip": "Non approvato",
    "credits.refundDialogTitle": "Richiedi un rimborso",
    "credits.refundDialogDesc": "Dicci perché vorresti un rimborso per questo acquisto. Il nostro team esamina ogni richiesta e riceverai una notifica e un'email con la decisione.",
    "credits.refundReasonPh": "Perché vorresti un rimborso?",
    "credits.refundSubmit": "Invia richiesta",
    "credits.refundSent": "Richiesta di rimborso inviata — la esamineremo a breve",
    "safety.checkinToggle": "Check-in di sicurezza",
    "safety.checkinDesc": "Scegli un orario — ti chiederemo se sei tornato/a a casa sano/a e salvo/a. Senza risposta entro 2 ore, il tuo amico riceve un avviso.",
    "safety.checkinPast": "Scegli un orario di check-in nel futuro",
    "safety.checkinScheduled": "Inviato! Il tuo amico ha i dettagli e il tuo check-in di sicurezza è programmato.",
    "checkin.title": "Sei tornato/a a casa sano/a e salvo/a?",
    "checkin.body": "Tocca per confermare — altrimenti {email} riceverà un avviso.",
    "checkin.confirmBtn": "Sono a casa sano/a e salvo/a ✅",
    "checkin.confirmed": "Felici che tu sia al sicuro! Il tuo amico è stato avvisato 💛",
    "notif.safetyCheckin.t": "🛟 Sei tornato/a a casa sano/a e salvo/a?",
    "notif.safetyCheckin.b": "Tocca per confermare che sei a casa — altrimenti {email} riceverà un avviso entro 2 ore.",
    "landing.freeCreditsPromo": "I nuovi membri ricevono 50 crediti gratis — esattamente quanto basta perché un compagno IA invii un invito da ammiratore segreto alla tua cotta sui social.",
    "landing.langHighlight": "Disponibile in 8 lingue con traduzione della chat integrata — incontra persone da tutto il mondo.",
    "saPromo.title": "I tuoi crediti gratuiti ti aspettano",
    "saPromo.body": "Hai {n} crediti — abbastanza perché un compagno IA invii un invito da ammiratore segreto alla tua cotta sui social.",
    "saPromo.cta": "Invia un invito da ammiratore segreto",
    "notif.refundApproved.t": "✅ Rimborso approvato",
    "notif.refundApproved.b": "Il tuo rimborso per {desc} è stato approvato — il tuo account è stato aggiornato. Controlla la tua email per i dettagli.",
    "notif.refundDenied.t": "Aggiornamento sulla richiesta di rimborso",
    "notif.refundDenied.b": "La tua richiesta di rimborso per {desc} è stata esaminata — controlla la tua email per i dettagli.",
    "safety.share": "Condividi il piano con un amico",
    "safety.title": "Invia il tuo piano dell'appuntamento a un amico",
    "safety.desc": "Per la tua sicurezza, invia via email il tuo itinerario e il profilo del tuo appuntamento a una persona di fiducia.",
    "safety.emailPh": "amico@email.com",
    "safety.notePh": "Nota facoltativa per il tuo amico…",
    "safety.send": "Invia",
    "safety.sent": "Inviato! Il tuo amico ha i dettagli.",
    "discover.companionsTitle": "Incontra i compagni IA",
    "incog.title": "Modalità incognito",
    "incog.desc": "Controlla chi può trovare il tuo profilo mantenendo pieno accesso a chat, offerte e incontri.",
    "incog.toggleLabel": "Nascondi il mio profilo da Scopri",
    "incog.toggleDesc": "Nessuno può trovarti navigando. Le conversazioni e le offerte esistenti continuano a funzionare.",
    "incog.on": "Modalità incognito ATTIVA — sei nascosto da Scopri",
    "incog.off": "Sei di nuovo visibile in Scopri",
    "incog.hiddenFrom": "Sei anche nascosto individualmente a {n} membro/i (tramite il pulsante occhio sul loro profilo).",
    "ratep.title": "Privacy delle valutazioni degli appuntamenti",
    "ratep.desc": "Scegli se partecipare alle valutazioni degli appuntamenti e cosa mostrare sul tuo profilo.",
    "ratep.partLabel": "Partecipa alle valutazioni degli appuntamenti",
    "ratep.partDesc": "Se disattivato, nessuno può valutare i tuoi appuntamenti e nessuna valutazione appare sul tuo profilo",
    "ratep.commentsLabel": "Mostra recensioni scritte sul mio profilo",
    "ratep.commentsDesc": "Se disattivato, viene mostrata solo la valutazione a stelle — i commenti scritti restano privati",
    "ratep.saved": "Preferenze di valutazione salvate",
    "offers.planDate": "Pianifica un appuntamento",
    "planDate.title": "Pianifica un appuntamento con…",
    "planDate.desc": "Scegli chiunque dalla lista dei membri per inviare un'offerta di appuntamento premium.",
    "planDate.search": "Cerca per nome…",
    "planDate.empty": "Nessun membro trovato",
    "notif.promoRedeemed.t": "🎁 Codice promo riscattato!",
    "notif.promoRedeemed.b": "Il tuo codice {code} ha aggiunto {what} al tuo account. Divertiti!",
    "notif.creditsGranted.t": "🎁 Crediti aggiunti!",
    "notif.creditsGranted.b": "Il team di LuxeMeet ha aggiunto {n} crediti al tuo account.",
    "notif.slotGranted.t": "🎁 Slot premium gratuito!",
    "notif.slotGranted.b": "Hai ricevuto {n} slot gratuito/i per offerte di appuntamenti premium da 50 $ — pianifica un appuntamento dalla pagina Offerte!",
    "register.saRevealed": "💌 Il tuo ammiratore segreto è stato svelato — controlla le notifiche e la chat!",
    "tour.replayTitle": "Tour di 60 secondi",
    "tour.replayDesc": "Hai perso il tour guidato? Ripetilo quando vuoi con il tuo compagno IA.",
    "tour.replayBtn": "Rivedi",
    "notif.saReveal.t": "💌 Ammiratore segreto svelato!",
    "notif.saReveal.b": "Era {admirer} da sempre! {name} ti ha lasciato tutta la storia in chat. Tocca per vedere il profilo.",
    "register.saBanner": "💌 Il tuo ammiratore segreto ti aspetta — crea il tuo account gratuito per scoprire chi è.",
    "credits.earnerNote": "Chattare è gratis per te in questa modalità — i crediti servono per extra come le richieste da ammiratore segreto (50 crediti).",
    "si.trackJoined": "Iscritto come {name} — vedi profilo",
    "notif.siJoined.t": "🎉 È arrivato/a!",
    "notif.siJoined.b": "{invitee} si è appena iscritto/a grazie al tuo invito da ammiratore segreto a {handle}. Vai a cercarlo/a!",
    "si.trackTitle": "Le tue richieste da ammiratore segreto",
    "si.trackLine": "{kind} a {handle} su {platform}",
    "si.trackVia": "tramite {name}",
    "si.trackKindAdmirer": "Messaggio da ammiratore segreto",
    "si.trackKindDate": "Richiesta di appuntamento",
    "si.trackPending": "In attesa",
    "si.trackSent": "Inviato",
    "si.trackRefunded": "Rimborsato",
    "discover.boosted": "In evidenza",
    "discover.inDemand": "🔥 Molto richiesto",
    "discover.diamond": "Diamante",
    "discover.verifiedBadge": "Verificato",
    "gal.addPhoto": "Aggiungi foto",
    "gal.addVideo": "Aggiungi video",
    "gal.videoIntros": "Video di presentazione ({n}/2)",
    "gal.videoRules": "Fino a 2 brevi video (max 60s, 50MB). Controllati dall'IA — niente nudità o contenuti sessuali.",
    "gal.noPhotos": "Ancora nessuna foto. Aggiungi la tua prima foto per iniziare!",
    "si.button": "Ammiratore segreto sui social",
    "si.title": "Ammiratore segreto tramite {name}",
    "si.desc": "{name} invierà un messaggio da ammiratore segreto o una richiesta di appuntamento a chi scegli sui social — con un invito all'app. Inviato entro 24 ore.",
    "si.typeLabel": "Cosa deve essere inviato?",
    "si.typeAdmirer": "Messaggio da ammiratore segreto",
    "si.typeDate": "Richiesta di appuntamento",
    "si.platform": "Piattaforma",
    "si.handle": "Il loro nome utente",
    "si.note": "Tocco personale (facoltativo)",
    "si.notePh": "Qualcosa che {name} dovrebbe menzionare?",
    "si.submit": "Invia richiesta ({n} crediti)",
    "si.success": "Richiesta in coda! Riceverai una notifica quando {name} l'avrà inviata.",
    "si.errHandle": "Inserisci il loro nome utente social",
    "notif.siPending.t": "💌 Richiesta ricevuta!",
    "notif.siPending.b": "{name} invierà il tuo {kind} a {handle} su {platform}. Sono stati addebitati 50 crediti — riceverai una notifica appena inviato.",
    "notif.siSent.t": "💘 È partito!",
    "notif.siSent.b": "{name} ha inviato il tuo {kind} a {handle} su {platform}. Incrociamo le dita!",
    "notif.siDeclined.t": "Richiesta rimborsata",
    "notif.siDeclined.b": "Il tuo {kind} tramite {name} non è stato inviato. I tuoi 50 crediti sono stati rimborsati.",
    "notif.kindAdmirer": "messaggio da ammiratore segreto",
    "notif.kindDate": "richiesta di appuntamento",
    "help.title": "Luxe Assistant",
    "help.subtitle": "Chiedimi qualsiasi cosa su LuxeMeet",
    "help.hi": "Ciao{name}! 👋",
    "help.welcome": "Posso spiegarti come funzionano i crediti, le offerte di appuntamenti premium, il deposito a garanzia, i codici di conferma e i pagamenti. Cosa vorresti sapere?",
    "help.thinking": "Luxe sta pensando...",
    "help.inputPh": "Scrivi la tua domanda...",
    "help.error": "Scusa, sto avendo problemi al momento. Riprova tra un attimo.",
    "chat.translate": "Traduci",
    "chat.showOriginal": "Mostra originale",
    "chat.translating": "Traduzione...",
    "chat.translateFail": "Impossibile tradurre al momento",
    "chat.sentCredits": "Messaggio inviato ({n} crediti)",
    "chat.noCredits": "Crediti insufficienti",
    "chat.tapToUse": "{ai} — tocca per usare",
    "chat.member": "Membro di {app}",
    "land.newMatch": "Nuovo match!",
    "land.firstMove": "Fai la prima mossa",
    "land.dateTerms": "Appuntamenti alle tue condizioni",
    "land.youChoose": "Scegli tu. Offri tu.",
    "land.startChatting": "Inizia a chattare ora",
    "land.likes": "{n} Mi piace",
    "land.thisWeek": "Questa settimana",
    "promo.title": "Scopri cosa lo rende speciale",
    "promo.desc": "Un rapido tour di LuxeMeet e DLuxe — appuntamenti reali, offerte premium e romanticismo potenziato dall'IA.",
    "promo.tapSound": "Tocca per l'audio",
    "promo.shareInvite": "Condividi il film — il tuo link di invito è incluso 🎁",
    "promo.shareFriends": "Condividi il film con gli amici",
    "promo.copiedInvite": "Link del film con il tuo codice di invito copiato!",
    "promo.copied": "Link del film copiato!",
    "promo.shareMsg": "🎬 Guarda qui — LuxeMeet, l'app di incontri dove gli appuntamenti veri accadono davvero.",
    "promo.joinInvite": "Iscriviti con il mio link di invito:",
    "promo.shareTg": "🎬 Guarda qui — l'app di incontri dove gli appuntamenti veri accadono davvero",
    "promo.mute": "Disattiva la musica",
    "promo.unmute": "Attiva la musica",
    "prof.back": "Indietro",
    "prof.addPhotosHint": "Aggiungi foto per farti notare",
    "prof.noPhotos": "{name} non ha ancora aggiunto foto",
    "prof.addPhotos": "Aggiungi foto",
    "prof.aiCompanion": "Compagna IA",
    "prof.reviewOne": "recensione di appuntamento",
    "prof.reviewMany": "recensioni di appuntamenti",
    "prof.bioEmptyOwn": "La tua bio è vuota — un paio di frasi su di te fanno la differenza.",
    "prof.bioEmptyOther": "{name} mantiene un'aria di mistero — saluta per saperne di più.",
    "prof.afterDate": "— {name}, dopo l'appuntamento",
    "prof.interests": "INTERESSI",
    "prof.photos": "FOTO",
    "prof.videos": "VIDEO",
    "prof.thinking": "Sto pensando...",
    "prof.suggestOpener": "{ai}: suggerisci un'apertura",
    "prof.offerSent": "Offerta inviata! Controlla lo stato nella pagina Offerte.",
    "prof.tSuggestFail": "Impossibile ottenere suggerimenti al momento",
    "prof.tRequestFail": "Impossibile inviare la richiesta",
    "prof.tFavAdded": "Aggiunto ai preferiti ❤️",
    "prof.tFavRemoved": "Rimosso dai preferiti",
    "prof.tFavFail": "Aggiornamento dei preferiti non riuscito",
    "prof.tVisibilityFail": "Aggiornamento della visibilità non riuscito",
    "prof.tHidden": "Ora sei nascosto a {name} in Scopri",
    "prof.tVisible": "Sei di nuovo visibile a {name}",
    "prof.tLoadFail": "Caricamento del profilo non riuscito",
    "prof.tMsgEmpty": "Inserisci un messaggio",
    "prof.tNoCredits": "Crediti insufficienti. Acquista altri crediti per continuare.",
    "prof.tMsgFail": "Invio del messaggio non riuscito",
    "prof.tMeetupMissing": "Inserisci data e luogo",
    "prof.tMeetupFail": "Invio della richiesta di incontro non riuscito",
    "nb.title": "Notifiche",
    "nb.empty": "Nessuna notifica",
    "time.now": "proprio ora",
    "time.m": "{n} min fa",
    "time.h": "{n} h fa",
    "time.d": "{n} g fa",
    "notif.photoVerified.t": "✅ Sei verificato!",
    "notif.photoVerified.b": "La verifica del selfie è andata a buon fine — il badge Verificato ora appare sul tuo profilo.",
    "notif.relRequest.t": "💍 Rendiamolo ufficiale?",
    "notif.relRequest.b": "{name} vuole rendere la cosa ufficiale con te! Accetta nelle Impostazioni e scomparirete entrambi dal feed degli altri.",
    "notif.relDeclined.t": "Richiesta di ufficializzare rifiutata",
    "notif.relDeclined.b": "{name} non è ancora pronto a ufficializzare.",
    "notif.relActive.t": "💞 State ufficialmente insieme!",
    "notif.relActive.b": "{name} ha detto SÌ. Ora siete entrambi nascosti agli altri — l'app è solo per voi due.",
    "notif.relEnded.t": "Relazione ufficiale terminata",
    "notif.relEnded.b": "{name} ha terminato la relazione ufficiale. Siete di nuovo visibili sull'app.",
    "notif.dateReview.t": "{stars} Nuova recensione dell'appuntamento!",
    "notif.dateReview.b": "{name} ha valutato il vostro appuntamento {rating}/5. {comment}",
    "notif.escrow.t": "💰 Pagamento dell'appuntamento ricevuto!",
    "notif.escrow.b": "{name} ha pagato ${amount} per il vostro appuntamento. ${payout} è in deposito a garanzia. Conferma l'appuntamento con il suo codice a 6 cifre per essere pagata.",
    "notif.escrowBoost.t": "💰 Pagamento dell'appuntamento ricevuto!",
    "notif.escrowBoost.b": "{name} ha pagato ${amount} per il vostro appuntamento. ${payout} è in deposito a garanzia — include il tuo boost referral del 90%! Conferma l'appuntamento con il suo codice a 6 cifre per essere pagata.",
    "notif.offerPaid.t": "💘 Appuntamento prenotato!",
    "notif.offerPaid.b": "Il tuo pagamento per l'appuntamento con {name} è confermato. Il tuo codice di conferma a 6 cifre è pronto nella pagina Offerte — condividilo con il tuo appuntamento dopo.",
    "notif.refSlot.t": "🎁 Slot premium gratuito guadagnato!",
    "notif.refSlot.b": "{name}, che hai invitato, ha appena acquistato uno slot premium — hai ricevuto uno slot da $50 GRATIS come ricompensa!",
    "notif.boostActivated.t": "🚀 Profilo potenziato!",
    "notif.boostActivated.b": "Il tuo profilo è ora in evidenza in cima a Scopri per le prossime 24 ore.",
    "notif.creditsAdded.t": "🪙 Crediti aggiunti!",
    "notif.creditsAdded.b": "{credits} crediti dal tuo acquisto {package} sono ora sul tuo account. Nuovo saldo: {balance}.",
    "notif.unlimited.t": "♾️ Offerte illimitate attivate!",
    "notif.unlimited.b": "Il tuo premio campione è attivo — invia offerte di appuntamento illimitate (senza slot) per le prossime 2 settimane!",
    "notif.voucherGifted.t": "🎁 Hai ricevuto un buono campione!",
    "notif.voucherGifted.b": "{name} ti ha regalato 2 settimane di offerte di appuntamento illimitate — attivalo nelle Impostazioni prima del {date}.",
    "notif.voucherRedeemed.t": "🎁 Il tuo regalo è stato riscattato!",
    "notif.voucherRedeemed.b": "{name} ha riscattato il buono campione che gli hai regalato.",
    "notif.refBoost.t": "🎁 Ricompensa referral sbloccata!",
    "notif.refBoost.b": "{name}, che hai invitato, ha completato il suo primo appuntamento premium — il tuo PROSSIMO appuntamento retribuito paga il 90% invece dell'80%!",
    "notif.payoutProcessing.t": "✅ Appuntamento confermato!",
    "notif.payoutProcessing.b": "Il tuo pagamento di ${amount} è in elaborazione e arriverà sul tuo PayPal entro 24-48 ore.",
    "notif.offerExpiredSender.t": "⏰ Offerta di appuntamento scaduta",
    "notif.offerExpiredSender.b": "La tua offerta di appuntamento di ${amount} è scaduta dopo 7 giorni. Il tuo slot premium è stato liberato così puoi inviare una nuova offerta.",
    "notif.offerExpiredRecipient.t": "⏰ Offerta di appuntamento scaduta",
    "notif.offerExpiredRecipient.b": "Un'offerta di appuntamento che avevi accettato è scaduta perché il pagamento non è stato completato entro 7 giorni.",
    "notif.dateReminder24.t": "💜 Promemoria: appuntamento domani!",
    "notif.dateReminder24.b": "Il tuo appuntamento con {name} è domani — {when}, {where}.",
    "notif.offerExpiringPay.t": "⏳ L'offerta scade tra 24 ore!",
    "notif.offerExpiringPay.b": "La tua offerta di appuntamento di ${amount} a {name} scade domani — completa il pagamento prima che sparisca e il tuo slot venga liberato.",
    "notif.offerExpiringWait.t": "⏳ L'offerta scade tra 24 ore!",
    "notif.offerExpiringWait.b": "La tua offerta di appuntamento di ${amount} a {name} scade domani — attendi la sua risposta o falle un promemoria prima che sparisca e il tuo slot venga liberato.",
    "notif.matchInsights.t": "💌 Le tue statistiche settimanali dei match",
    "notif.matchInsights.b": "{views} visualizzazioni del profilo e {favs} nuovi preferiti questa settimana — tra cui {names}. Saluta o potenzia il tuo profilo per far scattare un'offerta di appuntamento!",
    "notif.streak1.t": "🔥 Progresso della serie: {streak}/3",
    "notif.streak1.b": "Ancora un appuntamento 4★+ e 150 crediti gratuiti sono tuoi!",
    "notif.streakN.t": "🔥 Progresso della serie: {streak}/3",
    "notif.streakN.b": "Ancora {togo} appuntamenti 4★+ per sbloccare 150 crediti gratuiti.",
    "notif.streakDone.t": "🔥 Progresso della serie: {streak}/3",
    "notif.streakDone.b": "La tua ricompensa è in arrivo!",
    "notif.rankUp.t": "🏆 Sei #{rank} nella classifica dei Più Votati",
    "notif.rankUp.b": "Sei #{rank} nella classifica dei Più Votati. 📈 Sei salito di {spots} posizioni dalla settimana scorsa! Il #1 mensile vince 2 settimane di offerte di appuntamento illimitate.",
    "notif.rankDown.t": "🏆 Sei #{rank} nella classifica dei Più Votati",
    "notif.rankDown.b": "Sei #{rank} nella classifica dei Più Votati. 📉 Sei sceso di {spots} posizioni dalla settimana scorsa — un ottimo appuntamento ti riporta su. Il #1 mensile vince 2 settimane di offerte di appuntamento illimitate.",
    "notif.rankSteady.t": "🏆 Sei #{rank} nella classifica dei Più Votati",
    "notif.rankSteady.b": "Sei #{rank} nella classifica dei Più Votati. 🎯 Posizione stabile rispetto alla settimana scorsa. Il #1 mensile vince 2 settimane di offerte di appuntamento illimitate.",
    "notif.rankNew.t": "🏆 Sei #{rank} nella classifica dei Più Votati",
    "notif.rankNew.b": "🎉 NUOVO: sei entrato nella classifica dei Più Votati al #{rank}! Il #1 mensile vince 2 settimane di offerte di appuntamento illimitate.",
    "notif.rankOff.t": "🏆 Aggiornamento classifica",
    "notif.rankOff.b": "Sei uscito dalla classifica dei Più Votati questa settimana — un ottimo appuntamento ti ci riporta. Il #1 mensile vince 2 settimane di offerte di appuntamento illimitate.",
    "notif.boostEnded.t": "⚡ Il tuo boost è terminato",
    "notif.boostEnded.b": "Il tuo boost di 24 ore è terminato. Ti ha portato {views} visualizzazioni del profilo. Potenzia di nuovo dalla pagina Scopri per restare in cima!",
    "notif.boostEndedExtra.t": "⚡ Il tuo boost è terminato",
    "notif.boostEndedExtra.b": "Il tuo boost di 24 ore è terminato. Ti ha portato {views} visualizzazioni del profilo — circa {extra} in più di un giorno normale. Potenzia di nuovo dalla pagina Scopri per restare in cima!",
    "notif.dateSoon1h.t": "⏰ Il tuo appuntamento inizia a breve!",
    "notif.dateSoon1h.b": "Il tuo appuntamento con {name} è tra meno di un'ora — {time} presso {location}.{tip}",
    "notif.dateSoon24.t": "💜 Il tuo appuntamento è tra 24 ore!",
    "notif.dateSoon24.b": "Il tuo appuntamento con {name} è tra 24 ore — {time} presso {location}.{tip}",
    "notif.dateSoonTip": " Apri la tua offerta per il conto alla rovescia dal vivo, il meteo e i consigli sull'outfit!",
    "notif.badgeFire.t": "🔥 Sei in fiamme!",
    "notif.badgeFire.b": "Sei uno dei 3 uomini più contattati su DLuxe questo mese — il badge 🔥 ora appare sul tuo profilo.",
    "notif.hotStreak.t": "🔥 Serie di fuoco! 150 crediti GRATIS",
    "notif.hotStreak.b": "3 appuntamenti molto ben valutati di fila — il pacchetto Popular da 150 crediti è stato aggiunto GRATIS al tuo account. Mantieni viva la serie!",
    "notif.badgeDiamond.t": "💎 Badge diamante guadagnato!",
    "notif.badgeDiamond.b": "Hai completato 3 appuntamenti premium da $500+ — il badge Diamante ora brilla sul tuo profilo.",
    "notif.champion.t": "🏆 Campione della classifica!",
    "notif.champion.b": "Hai chiuso al #1 in '{section}' questo mese! Premi: un boost del profilo di 7 giorni GRATIS (già attivo) e un buono per 2 settimane di offerte di appuntamento ILLIMITATE — attivalo nelle Impostazioni in qualsiasi momento nei prossimi 6 mesi.",
    "notif.anniversary.t": "💞 {months} {monthsWord} insieme!",
    "notif.anniversary.b": "Tu e {name} avete appena raggiunto {months} {monthsWord} ufficiali. Festeggiate — idea: {idea}",
    "notif.monthWord": "mese",
    "notif.monthsWord": "mesi",
    "notif.annIdea0": "Ricreate il vostro primissimo appuntamento — stesso posto, stessa ordinazione, nuovi ricordi.",
    "notif.annIdea1": "Cucinate insieme una cena di tre portate a lume di candela, telefoni spenti.",
    "notif.annIdea2": "Picnic al tramonto con gli snack preferiti dell'altro e una playlist condivisa.",
    "notif.annIdea3": "Prenotate un'ora di spa di coppia e brindate con qualcosa di frizzante dopo.",
    "notif.annIdea4": "Fate un mini viaggio on the road verso una città che nessuno dei due ha mai visitato.",
    "notif.annIdea5": "Notte di stelle: coperte, cioccolata calda e la vostra canzone in loop.",
    "notif.annIdea6": "Lezione di ballo per due — salsa, bachata o qualsiasi cosa vi faccia ridere.",
    "notif.annIdea7": "Appuntamento al museo o in galleria, poi dessert in un posto elegante.",
    "notif.annIdea8": "Scrivetevi una lettera sul vostro momento preferito finora e scambiatevela a cena.",
    "notif.annIdea9": "Prenotazione per cena su un rooftop o una terrazza — vestitevi come al primo appuntamento.",
    "notif.annIdea10": "Degustazione di vino o cioccolato seguita da una passeggiata lenta verso casa.",
    "notif.annIdea11": "Pianificate insieme il viaggio dei vostri sogni a colazione a letto — poi prenotatene una parte.",
    "notif.companionInvite.t": "💌 {name} ha la tua sorpresa!",
    "notif.companionInvite.b": "Il tuo invito misterioso è stato rivelato nella tua chat.",
    "notif.supportResolved.t": "✅ Richiesta di supporto risolta",
    "notif.supportResolved.b": "La tua {label} \"{subject}\" è stata esaminata e risolta.",
    "notif.supportResolvedResp.t": "✅ Richiesta di supporto risolta",
    "notif.supportResolvedResp.b": "La tua {label} \"{subject}\" è stata esaminata e risolta. Risposta: {resp}",
    "notif.labelRefund": "richiesta di rimborso",
    "notif.labelComplaint": "reclamo",
    "notif.testMeetup.t": "{name} ha accettato il tuo incontro! 🎉",
    "notif.testMeetup.b": "Prova completata — è esattamente così quando un membro reale accetta. Nessun credito è stato addebitato.",
    "notif.testCounter.t": "{name} ha inviato una controfferta 💬",
    "notif.testCounter.b": "Prova: ha contro-offerto ${amount}. Accetta o rifiuta per continuare il flusso — ancora nessun denaro reale.",
    "notif.testOfferAccepted.t": "{name} ha accettato la tua offerta di appuntamento! 💜",
    "notif.testOfferAccepted.b": "Prova: premi il pulsante Simula Pagamento nella pagina Offerte per vedere il resto del flusso — nessun denaro reale.",
    "notif.testDateCompleted.t": "Appuntamento di prova con {name} completato! 🏆",
    "notif.testDateCompleted.b": "Quello era il ciclo completo dell'appuntamento premium — offerta, accettazione, pagamento, codice e conferma. Nessun denaro reale è stato mosso. Pronto a provarci con un membro reale?",
    "notif.refChat.t": "🎁 +{credits} crediti guadagnati!",
    "notif.refChat.b": "{name} ha appena iniziato a chattare — {credits} crediti bonus aggiunti al tuo saldo.",
    "notif.payoutSent.t": "💸 Pagamento inviato!",
    "notif.payoutSent.b": "${amount} è stato inviato al tuo PayPal ({recipient}).",
    "notif.favVerified.t": "✅ {name} è ora verificato!",
    "notif.favVerified.b": "{name} dai tuoi preferiti ha appena superato la verifica selfie e ha ottenuto il badge Verificato.",
    "notif.favReviewed.t": "⭐ {name} ha ricevuto un'ottima recensione!",
    "notif.favReviewed.b": "{name} dai tuoi preferiti ha appena ricevuto una recensione di appuntamento da {rating} stelle. I migliori vengono prenotati in fretta!",
    "notif.favBoosted.t": "⚡ {name} si è appena potenziato!",
    "notif.favBoosted.b": "{name} dai tuoi preferiti è in evidenza in cima a Scopri proprio ora — saluta finché è sotto i riflettori!",
    "register.newMembers": "I nuovi membri ricevono",
    "register.promoLuxe1": "50 crediti gratuiti",
    "register.promoDluxe1": "Accesso gratuito + Guadagni",
    "register.promoLuxe2": "Per le donne che si iscrivono a LuxeMeet",
    "register.promoDluxe2": "Gli uomini si iscrivono a DLuxe gratis — e guadagnano con appuntamenti premium",
    "register.googleTerms": "Continuando con Google, accetti i nostri",
    "register.googleTermsLink": "Termini e Condizioni",
    "register.orEmail": "oppure registrati con l'email",
    "register.hintF": "Donne: gratis su LuxeMeet (50 crediti iniziali) — oppure prendi l'iniziativa su DLuxe con offerte di appuntamenti premium agli uomini.",
    "register.hintM": "Uomini: investi per connetterti su LuxeMeet — e goditi l'accesso gratuito + guadagna con gli appuntamenti premium su DLuxe.",
    "register.hintNone": "Seleziona il tuo genere per vedere le funzionalità disponibili",
    "register.refCode": "Codice di invito",
    "register.refOptional": "(facoltativo)",
    "register.refPh": "Hai un codice? Inseriscilo qui",
    "register.terms18": "Ho almeno 18 anni e accetto i",
    "register.termsLink": "Termini e Condizioni e la Liberatoria di Responsabilità",
    "register.create": "Crea account",
    "register.haveAccount": "Hai già un account?",
    "register.errGender": "Seleziona il tuo genere",
    "register.errTerms": "Accetta i Termini e Condizioni per continuare",
    "register.errFail": "Registrazione non riuscita",
    "register.giftClaimed": "😕 Questo codice regalo ({code}) è già stato riscattato.",
    "register.giftExpired": "😕 Questo codice regalo ({code}) è scaduto.",
    "register.giftReady": "🎁 {name} ti ha regalato un buono campione ({code}) — sarà aggiunto al tuo account subito dopo la registrazione!",
    "register.giftFriend": "Un amico",
    "set.tImgFile": "Seleziona un file immagine",
    "set.tImgSize": "L'immagine deve essere inferiore a 5MB",
    "set.tPhotoUpdated": "Foto profilo aggiornata!",
    "set.tPhotoFail": "Caricamento della foto non riuscito",
    "set.tPwMismatch": "Le nuove password non coincidono",
    "set.tPwShort": "La password deve contenere almeno 6 caratteri",
    "set.tPwChanged": "Password cambiata con successo!",
    "set.tPwFail": "Cambio password non riuscito",
    "set.tProfileUpdated": "Profilo aggiornato!",
    "set.tProfileFail": "Aggiornamento del profilo non riuscito",
    "set.tLoggedOut": "Disconnessione riuscita",
    "set.tDeactivated": "Account disattivato. Accedi di nuovo entro 30 giorni per riattivarlo.",
    "set.tDeleteFail": "Eliminazione dell'account non riuscita",
    "pp.errInvalidEmail": "Inserisci un indirizzo email valido",
    "pp.errNoMatch": "Le email non coincidono",
    "pp.errConfirm": "Conferma la tua email PayPal",
    "pp.errFix": "Correggi gli errori prima di salvare",
    "pp.savedOk": "Impostazioni PayPal salvate e verificate!",
    "pp.saveFail": "Salvataggio delle impostazioni non riuscito",
    "pp.errImg": "Carica un file immagine",
    "pp.errSize": "Il file deve essere inferiore a 5MB",
    "pp.qrUploaded": "Codice QR caricato!",
    "pp.qrFail": "Caricamento del codice QR non riuscito",
    "terms.title": "Termini e Condizioni",
    "terms.updated": "Inclusa la Liberatoria di Responsabilità — Ultimo aggiornamento: giugno 2026 (v5)",
    "terms.back": "Indietro",
    "terms.footer": "© 2026 LuxeMeet & DLuxe. Tutti i diritti riservati.",
    "terms.s1t": "1. Accettazione dei Termini",
    "terms.s1p1": "Creando un account o utilizzando LuxeMeet o la sua modalità complementare DLuxe (insieme, \"la Piattaforma\"), accetti di essere vincolato da questi Termini e Condizioni e dalla nostra Liberatoria di Responsabilità. Se non sei d'accordo, non utilizzare la Piattaforma.",
    "terms.s2t": "2. Idoneità (18+)",
    "terms.s2p1": "Devi avere almeno 18 anni per utilizzare LuxeMeet. Registrandoti, dichiari e garantisci di avere 18 anni o più e di poter stipulare legalmente questo accordo. Gli account appartenenti a minori saranno chiusi immediatamente senza rimborso.",
    "terms.s3t": "3. Natura del Servizio",
    "terms.s3p1": "LuxeMeet è esclusivamente una piattaforma di presentazione. Forniamo strumenti affinché adulti possano incontrarsi, scambiarsi messaggi e organizzare appuntamenti. Non siamo parte di alcuna interazione, conversazione, appuntamento o accordo tra membri. Non effettuiamo controlli sui precedenti penali e non offriamo alcuna garanzia sull'identità, la condotta, le intenzioni o la compatibilità di alcun membro.",
    "terms.s3p2": "La Piattaforma può mostrare link a servizi indipendenti di terze parti per aiutare a pianificare gli appuntamenti — come OpenStreetMap e Google Maps per i luoghi, Uber per i trasporti e Airbnb Experiences per idee di appuntamenti. Questi servizi non sono gestiti da noi; il loro utilizzo è regolato dai rispettivi termini e non siamo responsabili dei loro contenuti, prezzi o disponibilità.",
    "terms.s4t": "4. Crediti, Pagamenti e Offerte di Appuntamenti Premium",
    "terms.s4p1": "I membri maschili acquistano crediti per inviare messaggi e richiedere incontri, slot di offerta premium per inviare offerte di appuntamenti e boost del profilo facoltativi. Tutti i pagamenti sono elaborati da PayPal. I prezzi sono mostrati al momento dell'acquisto e possono includere una commissione di gestione.",
    "terms.s4p2": "Per le Offerte di Appuntamenti Premium, l'importo offerto viene trattenuto in deposito a garanzia una volta pagato. Quando l'appuntamento ha luogo e la destinataria inserisce il codice di conferma a 6 cifre del pagante, il pagamento (al netto della commissione della piattaforma) viene rilasciato alla destinataria. La commissione della piattaforma è indicata nell'app. Appuntamenti ripetuti: quando un pagante prenota un nuovo appuntamento con qualcuno con cui ha già completato un appuntamento tramite la Piattaforma, non è richiesto alcuno slot premium e si applica una commissione ridotta del 10% (la destinataria riceve il 90% dell'importo offerto). Le indennità di trasporto facoltative vengono pagate insieme all'offerta e trasferite al 100% alla destinataria. Le offerte di appuntamento annullate vengono rimosse automaticamente dalla cronologia 48 ore dopo l'annullamento. Buoni campione: i buoni premio ottenuti tramite la classifica mensile dei Migliori Membri possono essere regalati una sola volta a un'altra persona tramite un codice regalo monouso; una volta regalato, il buono non può essere utilizzato né recuperato dal titolare originale, e i buoni ricevuti in regalo non possono essere regalati di nuovo. I buoni non hanno valore in contanti.",
    "terms.s4p3": "Rimborsi: crediti, slot e boost non sono rimborsabili una volta consegnati. I pagamenti di appuntamenti in deposito sono rimborsabili solo se l'appuntamento non avviene e l'offerta viene annullata o scade secondo le regole della piattaforma. I pagamenti devono essere effettuati da un account PayPal la cui email corrisponda alla tua email di accesso a LuxeMeet; i pagamenti da email non corrispondenti possono subire ritardi o essere irrecuperabili. Puoi inviare una richiesta di rimborso o un reclamo in qualsiasi momento tramite Impostazioni → Rimborsi e Reclami (o \"Aiuto e Supporto\" nel menu dell'app); ogni richiesta viene esaminata dal nostro team e sarai informato dell'esito nell'app e via email.",
    "terms.s5t": "5. Liberatoria di Responsabilità e Assunzione del Rischio",
    "terms.s5p1": "ACCETTI ESPRESSAMENTE CHE INCONTRARE UN ALTRO MEMBRO DI PERSONA È INTERAMENTE A TUO RISCHIO. Nella misura massima consentita dalla legge, liberi, esoneri e mantieni indenne LuxeMeet, i suoi proprietari, operatori, dipendenti e affiliati da ogni e qualsiasi rivendicazione, richiesta, danno, lesione, perdita o causa di azione — nota o ignota — derivante da o relativa al tuo utilizzo della Piattaforma, alle tue interazioni o comunicazioni con altri membri e a qualsiasi incontro o appuntamento di persona organizzato tramite la Piattaforma, inclusi senza limitazione lesioni personali, disagio emotivo, danni alla proprietà, furto, frode o perdita finanziaria.",
    "terms.s5p2": "Sei l'unico responsabile della tua sicurezza. Raccomandiamo vivamente di incontrarsi in luoghi pubblici, dire a un amico dove stai andando, organizzare il proprio trasporto e non condividere mai informazioni finanziarie con altri membri.",
    "terms.s6t": "6. Condotta dei Membri",
    "terms.s6p1": "Accetti di non: falsificare la tua identità o età; molestare, abusare o danneggiare altri membri; sollecitare denaro dai membri al di fuori del sistema di offerte della Piattaforma; utilizzare la Piattaforma per scopi commerciali, illegali o di sfruttamento (inclusi servizi di escort o tratta di esseri umani); pubblicare contenuti espliciti, offensivi o in violazione; o tentare di aggirare i sistemi di pagamento della Piattaforma.",
    "terms.s6p2": "Politica sui contenuti: le foto e i video del profilo non devono contenere nudità o contenuti sessualmente espliciti o allusivi. Tutte le foto e i video caricati vengono automaticamente controllati dall'IA prima della pubblicazione e i contenuti vietati vengono rifiutati. Tentativi ripetuti di caricare contenuti vietati possono comportare provvedimenti sull'account.",
    "terms.s6p3": "La violazione può comportare la sospensione o la chiusura immediata senza rimborso e la segnalazione alle forze dell'ordine ove opportuno.",
    "terms.s7t": "7. Valutazioni degli Appuntamenti, Recensioni e Preferiti",
    "terms.s7p1": "Dopo un appuntamento premium completato, entrambi i partecipanti possono valutare l'appuntamento (1-5 stelle) con un commento scritto facoltativo. La partecipazione alle valutazioni è facoltativa: puoi disattivarla completamente nelle Impostazioni, nel qual caso nessuno può valutare i tuoi appuntamenti e nessuna valutazione appare sul tuo profilo. Se partecipi, puoi scegliere separatamente se i commenti scritti vengono mostrati pubblicamente con la tua valutazione a stelle.",
    "terms.s7p2": "Le recensioni devono essere oneste, rispettose e basate su un appuntamento reale. Recensioni diffamatorie, moleste o false possono essere rimosse e comportare provvedimenti sull'account. I membri possono inoltre salvare altri profili in una lista privata di Preferiti; i tuoi preferiti sono visibili solo a te. Se aggiungi un membro ai preferiti, potresti ricevere notifiche sull'attività pubblica del suo profilo (come boost, verifica o nuove recensioni).",
    "terms.s8t": "8. Funzionalità di IA",
    "terms.s8p1": "La Piattaforma offre funzionalità facoltative basate sull'IA, tra cui gli assistenti di scrittura \"AI Wingman\" (per i membri maschili) e \"AI Cupid\" (per i membri femminili) — che possono redigere aperture e risposte di chat, note per offerte di appuntamenti premium, messaggi di controfferta, messaggi di richiesta di incontro e commenti di recensioni — l'assistente di aiuto \"Luxe\" nell'app, idee di appuntamenti curate dall'IA, suggerimenti di outfit dello stilista IA mostrati nel conto alla rovescia dell'appuntamento, statistiche settimanali dei match assistite dall'IA, foto del profilo assistite dall'IA e verifica fotografica basata su selfie con IA. L'IA viene inoltre utilizzata per controllare automaticamente tutte le foto e i video della galleria caricati alla ricerca di contenuti vietati (nudità e contenuti sessuali) prima della pubblicazione. I contenuti IA sono generati automaticamente e possono essere imprecisi. Sei responsabile di qualsiasi contenuto che invii o pubblichi, incluso quello assistito dall'IA. Le foto del profilo devono rappresentarti fedelmente; l'uso di immagini IA che travisano materialmente il tuo aspetto può comportare provvedimenti sull'account. I selfie di verifica sono utilizzati esclusivamente per il controllo di verifica e non vengono mai mostrati pubblicamente.",
    "terms.s9t": "9. Limitazione di Responsabilità",
    "terms.s9p1": "NELLA MISURA MASSIMA CONSENTITA DALLA LEGGE, LUXEMEET NON SARÀ RESPONSABILE DI DANNI INDIRETTI, INCIDENTALI, SPECIALI, CONSEQUENZIALI O PUNITIVI, NÉ DI PERDITE DI PROFITTI O DATI, DERIVANTI DAL TUO UTILIZZO DELLA PIATTAFORMA. LA NOSTRA RESPONSABILITÀ TOTALE AGGREGATA PER QUALSIASI RECLAMO NON SUPERERÀ L'IMPORTO CHE HAI PAGATO A LUXEMEET NEI SEI (6) MESI PRECEDENTI IL RECLAMO.",
    "terms.s10t": "10. Privacy",
    "terms.s10p1": "Raccogliamo ed elaboriamo informazioni sull'account, messaggi, registri di pagamento e dati di utilizzo per gestire la Piattaforma, elaborare pagamenti e versamenti, prevenire frodi e migliorare il servizio. I conteggi delle visualizzazioni del profilo vengono tracciati per le analisi dei boost. Puoi attivare la Modalità Incognito nelle Impostazioni per nascondere il tuo profilo dalla navigazione in Scopri — globalmente o da membri specifici — mentre le tue conversazioni, offerte e incontri esistenti continuano a funzionare. Non vendiamo i tuoi dati personali. Potrebbero essere inviate email per finalità di account, pagamento e coinvolgimento.",
    "terms.s11t": "11. Cessazione ed Eliminazione dell'Account",
    "terms.s11p1": "Eliminazione dell'account: puoi eliminare il tuo account in qualsiasi momento da Impostazioni → Zona Pericolo. Il tuo profilo viene immediatamente nascosto da Scopri, classifiche e preferiti. Si applica un periodo di tolleranza di 30 giorni: accedendo di nuovo entro 30 giorni il tuo account viene completamente riattivato. Dopo 30 giorni, il tuo account e i dati personali (profilo, foto, video, messaggi, preferiti e notifiche) vengono cancellati o anonimizzati in modo permanente e irreversibile. Crediti, slot, boost non utilizzati e qualsiasi saldo non prelevato vengono persi con la cancellazione definitiva. I registri richiesti per la conformità finanziaria e legale (come i registri dei pagamenti completati) possono essere conservati in forma anonimizzata.",
    "terms.s11p2": "Possiamo sospendere o chiudere gli account che violano questi Termini. Crediti, slot e boost non utilizzati vengono persi in caso di chiusura per giusta causa.",
    "terms.s12t": "12. Modifiche a questi Termini",
    "terms.s12p1": "Possiamo aggiornare questi Termini di tanto in tanto. L'uso continuato della Piattaforma dopo l'entrata in vigore delle modifiche costituisce accettazione dei Termini rivisti.",
    "terms.s13t": "13. Modalità DLuxe",
    "terms.s13p1": "La Piattaforma include una modalità complementare, \"DLuxe\", accessibile tramite l'interruttore a cuore nell'app. DLuxe rispecchia LuxeMeet con i ruoli di pagamento invertiti: le membri femminili pagano per le interazioni (crediti, slot di offerta premium, boost e offerte monetarie di appuntamenti) e i membri maschili possono ricevere pagamenti dalle offerte di appuntamenti. Tutti i Termini si applicano ugualmente a entrambe le modalità, con le disposizioni specifiche del ruolo che si applicano alla parte che paga o riceve il pagamento nella modalità attiva. Un unico account viene utilizzato in entrambe le modalità. Le conversazioni e le richieste di incontro sono separate per modalità: le interazioni avviate su LuxeMeet seguono le regole di pagamento di LuxeMeet (pagano gli uomini) e quelle avviate su DLuxe seguono le regole di DLuxe (pagano le donne). Cambiare modalità cambia solo quale casella di posta viene visualizzata e non cambia mai chi paga in una conversazione esistente. Tutte le funzionalità della Piattaforma — inclusi assistenti IA, classifiche, premi campione e regalo di buoni — sono disponibili in entrambe le modalità con il branding appropriato.",
    "terms.s14t": "14. Contatto",
    "terms.s14p1": "Domande su questi Termini? Usa l'assistente di Aiuto nell'app. Per richieste di rimborso e reclami, usa Impostazioni → Rimborsi e Reclami (o \"Aiuto e Supporto\" nel menu dell'app) — ogni invio viene esaminato e riceve risposta.",
    "landing.badge": "Esperienza di incontri premium",
    "landing.heroLuxe1": "Dove la qualità",
    "landing.heroLuxe2": "incontra la connessione",
    "landing.heroDluxe1": "Dove le donne",
    "landing.heroDluxe2": "prendono l'iniziativa",
    "landing.taglineLuxe": "Una piattaforma di incontri esclusiva dove contano le connessioni autentiche. I gentiluomini investono crediti per connettersi, garantendo interesse genuino e interazioni di qualità.",
    "landing.taglineDluxe": "Una piattaforma di incontri esclusiva dove le donne audaci fanno la prima mossa. Investono crediti per incontrare uomini eccezionali, garantendo interesse genuino e interazioni di qualità.",
    "landing.startJourney": "Inizia il tuo viaggio",
    "landing.haveAccount": "Ho già un account",
    "landing.watchFilm": "Guarda il film",
    "auth.signIn": "Accedi",
    "auth.getStarted": "Inizia",
    "login.welcomeBack": "Bentornato",
    "login.subtitle": "Accedi per continuare il tuo viaggio",
    "login.google": "Continua con Google",
    "login.orEmail": "oppure continua con l'e-mail",
    "login.email": "E-mail",
    "login.password": "Password",
    "login.emailPh": "Inserisci la tua e-mail",
    "login.passwordPh": "Inserisci la tua password",
    "login.forgot": "Password dimenticata?",
    "login.noAccount": "Non hai un account?",
    "login.createOne": "Creane uno",
    "login.backHome": "Torna alla home",
    "register.title": "Crea il tuo account",
    "register.subtitle": "Inizia il tuo percorso verso connessioni autentiche",
    "register.fullName": "Nome completo",
    "register.namePh": "Inserisci il tuo nome",
    "register.passwordPh": "Crea una password",
    "register.iAmA": "Sono",
    "register.man": "Uomo",
    "register.woman": "Donna",
    "nav.discover": "Scopri",
    "nav.favorites": "Preferiti",
    "nav.chat": "Chat",
    "nav.offers": "Offerte",
    "nav.meetups": "Incontri",
    "nav.top": "Top",
    "nav.credits": "Crediti",
    "nav.earnings": "Guadagni",
    "nav.settings": "Impostazioni",
    "nav.watchTour": "Guarda il tour",
    "nav.helpSupport": "Aiuto e supporto",
    "discover.title": "Scopri",
    "discover.subtitle": "Trova il tuo match perfetto",
    "discover.newest": "Più recenti",
    "discover.topRated": "Più votati",
    "discover.sendOffer": "Invia offerta di appuntamento premium",
    "discover.message": "Messaggio",
    "discover.aiCompanion": "Compagno IA",
    "discover.videoIntro": "Video",
    "settings.countryLanguage": "Paese e lingua",
    "settings.country": "Paese",
    "settings.language": "Lingua",
    "settings.currency": "Valuta",
    "settings.currencyNote": "I prezzi sono mostrati in modo approssimativo nella tua valuta; i pagamenti vengono elaborati in USD.",
    "settings.refunds": "Rimborsi e reclami",
    "settings.changePassword": "Cambia password",
    "settings.logout": "Esci",
    "settings.dangerZone": "Zona pericolosa",
    "settings.deleteAccount": "Elimina il mio account",
    "credits.billedUsd": "addebitato in USD",
    "common.accept": "Accetta",
    "common.decline": "Rifiuta",
    "common.pending": "In attesa",
    "common.accepted": "Accettata",
    "common.declined": "Rifiutata",
    "common.received": "Ricevute",
    "common.sent": "Inviate",
    "common.yourBalance": "Il tuo saldo",
    "common.back": "Indietro",
    "common.cancel": "Annulla",
    "common.credits": "Crediti",
    "common.viewMap": "Vedi mappa",
    "common.getUber": "Chiama un Uber",
    "common.hours": "ore",
    "chat.title": "Messaggi",
    "chat.empty": "Ancora nessuna conversazione",
    "chat.emptySub": "Connettiti con le persone per iniziare a chattare!",
    "chat.discoverProfiles": "Scopri profili",
    "chat.typeMessage": "Scrivi un messaggio...",
    "chat.inbox": "Inbox",
    "chat.noMessages": "Ancora nessun messaggio. Inizia la conversazione!",
    "chat.startConvo": "Inizia la conversazione!",
    "chat.costStart": "Avviare una chat costa 10 crediti",
    "chat.costMessage": "Inviare un messaggio costa 5 crediti",
    "chat.inboxBadge": "Inbox {app}",
    "common.testRun": "Prova",
    "offers.simulatePayment": "Simula pagamento (prova)",
    "offers.title": "Offerte di appuntamenti premium",
    "offers.dateOffers": "Offerte di appuntamenti",
    "offers.slots": "I tuoi slot per offerte",
    "offers.available": "Disponibili",
    "offers.inUse": "In uso",
    "offers.consumed": "Utilizzati",
    "offers.sentOffers": "Le tue offerte inviate",
    "offers.none": "Ancora nessuna offerta",
    "offers.noneSent": "Nessuna offerta inviata",
    "offers.reviewRespond": "Esamina e rispondi alle tue offerte di appuntamenti premium",
    "offers.subtitlePayer": "Acquista slot per inviare offerte di appuntamenti premium ai tuoi match",
    "offers.slotDesc": "50 $ per slot • Riutilizzabile finché un'offerta non viene accettata",
    "offers.buySlot": "Acquista slot",
    "offers.noneDesc": "Non hai ancora ricevuto offerte di appuntamenti",
    "offers.noneSentDesc": "Acquista uno slot e invia la tua prima offerta di appuntamento premium",
    "offers.buyFirstSlot": "Acquista il tuo primo slot",
    "offers.respond": "Rispondi",
    "offers.cancelOffer": "Annulla offerta",
    "offers.viewCounter": "Vedi controfferta",
    "offers.rateDate": "Valuta questo appuntamento",
    "offers.dateDetails": "Dettagli e recensioni dell'appuntamento",
    "status.pending": "In attesa",
    "status.paymentNeeded": "Pagamento richiesto",
    "status.awaitingConfirmation": "In attesa di conferma",
    "status.countered": "Controfferta",
    "status.confirmed": "Confermato",
    "status.completed": "Completato",
    "status.declined": "Rifiutato",
    "status.expired": "Scaduto",
    "status.cancelled": "Annullato",
    "meetups.title": "Richieste di incontro",
    "meetups.none": "Ancora nessuna richiesta",
    "meetups.noneSent": "Nessuna richiesta inviata",
    "meetups.received": "Ricevute",
    "meetups.sent": "Inviate",
    "meetups.noneDesc": "Le richieste di incontro degli altri appariranno qui.",
    "meetups.noneSentDesc": "Trova qualcuno che vorresti incontrare!",
    "meetups.browse": "Sfoglia profili",
    "favorites.title": "Preferiti",
    "favorites.subtitle": "Profili che hai salvato",
    "favorites.none": "Ancora nessun preferito",
    "favorites.noneDesc": "Tocca il cuore su un profilo che ami e verrà salvato qui.",
    "favorites.browse": "Sfoglia Scopri",
    "leaderboard.title": "Membri top",
    "leaderboard.you": "Tu",
    "leaderboard.subtitle": "I membri più richiesti, più votati e più generosi della piattaforma. Guadagna badge per conquistare il tuo posto.",
    "leaderboard.prizeNote": "Il n. 1 mensile di ogni sezione vince un boost gratuito di 7 giorni + 2 settimane di offerte di appuntamenti illimitate.",
    "leaderboard.empty": "Ancora nessun detentore di badge — completa appuntamenti fantastici per essere il primo!",
    "leaderboard.loading": "Caricamento della classifica...",
    "leaderboard.fireTitle": "I più richiesti su DLuxe",
    "leaderboard.fireSub": "I 3 uomini più contattati su DLuxe questo mese",
    "leaderboard.diamondTitle": "Membri Diamante",
    "leaderboard.diamondSub": "Hanno completato 3+ appuntamenti premium da 500 $ o più",
    "leaderboard.ratedTitle": "I più votati",
    "leaderboard.ratedSub": "Le migliori valutazioni da recensioni reali",
    "leaderboard.shareBadge": "Condividi badge",
    "leaderboard.datesCompleted": "appuntamenti premium completati",
    "earnings.title": "I miei guadagni",
    "earnings.escrow": "In deposito",
    "earnings.total": "Totale guadagnato",
    "earnings.dates": "Appuntamenti completati",
    "earnings.history": "Cronologia pagamenti",
    "earnings.none": "Ancora nessun guadagno",
    "credits.costs": "Costi in crediti",
    "credits.startChat": "Avvia una nuova chat",
    "credits.sendMessage": "Invia un messaggio",
    "credits.requestMeetup": "Richiedi un incontro",
    "credits.buy": "Acquista crediti",
    "credits.history": "Cronologia acquisti",
    "credits.noHistory": "Ancora nessun acquisto",
    "credits.completePayment": "Completa il pagamento",
    "credits.allSet": "Sei a posto!",
    "credits.freeLuxe": "Come donna su LuxeMeet, hai accesso gratuito ai messaggi e a tutte le funzionalità.",
    "credits.freeDluxe": "Come uomo su DLuxe, hai accesso gratuito ai messaggi e a tutte le funzionalità.",
    "credits.bestValue": "Miglior valore",
    "credits.continuePayment": "Continua al pagamento",
    "credits.processing": "Elaborazione...",
    "profile.message": "Messaggio",
    "profile.requestMeetup": "Richiedi incontro",
    "tour.tryWith": "Provalo con",
    "settings.title": "Impostazioni",
    "settings.photoHint": "Tocca la fotocamera per cambiare foto",
    "settings.profileInfo": "Informazioni del profilo",
    "settings.displayName": "Nome visualizzato",
    "settings.age": "Età",
    "settings.location": "Posizione",
    "settings.locationPh": "Città, Paese",
    "settings.bio": "Bio",
    "settings.bioPh": "Racconta qualcosa di te...",
    "settings.interests": "Interessi",
    "settings.interestsPh": "Viaggi, Musica, Cibo (separati da virgole)",
    "settings.interestsHint": "Separa gli interessi con le virgole",
    "settings.saveChanges": "Salva modifiche",
    "settings.paypalTitle": "Impostazioni pagamenti PayPal",
    "settings.paypalDesc": "Aggiungi i tuoi dati PayPal per ricevere i pagamenti delle offerte di appuntamento accettate",
    "settings.dangerDesc": "Eliminare il tuo account nasconde subito il tuo profilo. Hai cambiato idea? Accedi di nuovo entro 30 giorni per riattivarlo — dopo, il tuo account e i dati personali vengono cancellati definitivamente e i crediti o saldi non usati vanno persi.",
    "settings.deleteTitle": "Eliminare il tuo account?",
    "settings.deleteB1": "Il tuo profilo viene subito nascosto a tutti",
    "settings.deleteB2": "Accedi di nuovo entro 30 giorni per riattivarlo",
    "settings.deleteB3": "Dopo 30 giorni tutto viene cancellato definitivamente — foto, messaggi e qualsiasi credito o saldo non usato",
    "settings.confirmPasswordLabel": "Conferma la tua password",
    "settings.googleBlank": "Registrato con Google? Lascia vuoto.",
    "settings.deactivateDelete": "Disattiva ed elimina",
    "settings.currentPassword": "Password attuale",
    "settings.newPassword": "Nuova password",
    "settings.confirmNewPassword": "Conferma nuova password",
    "ref.title": "Invita e guadagna",
    "ref.desc": "Condividi il tuo link di invito. Guadagni 25 crediti bonus appena un amico invitato inizia a chattare. Inoltre: quando un invitato compra il suo primo slot premium ricevi uno slot da $50 GRATIS — e quando un invitato completa il suo primo appuntamento premium, il tuo PROSSIMO appuntamento retribuito paga il 90% invece dell'80%.",
    "ref.friendsReferred": "Amici invitati",
    "ref.bonusCredits": "Crediti bonus guadagnati",
    "ref.freeSlots": "Slot gratis guadagnati",
    "ref.boosts": "Boost al 90% disponibili",
    "ref.yourReferrals": "I tuoi invitati",
    "ref.stJoined": "Iscritto",
    "ref.stChatting": "Ha iniziato a chattare ✓ (+25 crediti)",
    "ref.stDate": "Appuntamento completato ✓",
    "ref.stSlot": "Slot acquistato ✓",
    "ref.topReferrers": "Migliori ambasciatori del mese",
    "ref.referralsWord": "invitati",
    "ref.copied": "Link di invito copiato!",
    "share.inviteMsg": "Unisciti a me su {app} — l'app di incontri premium dove gli appuntamenti veri accadono davvero. Iscriviti con il mio link:",
    "share.dreamMsg": "💘 Sei invitato/a a un appuntamento da sogno! Unisciti a me su {app} e organizziamo l'appuntamento perfetto:",
    "share.inviteBtn": "Invita un amico",
    "share.dreamBtn": "💘 Invito appuntamento da sogno",
    "share.hint": "Scrivi il tuo messaggio o lascia vuoto per usare il modello — il tuo link di invito viene aggiunto automaticamente.",
    "share.copied": "Messaggio di invito copiato — incollalo dove vuoi!",
    "landing.whyTitle": "Perché scegliere {app}?",
    "landing.whySub": "Il nostro sistema a crediti garantisce che ogni interazione sia significativa e intenzionale.",
    "landing.f1Title": "Connessioni di qualità",
    "landing.f1Desc": "I crediti garantiscono interesse genuino. Niente spam, niente bot — solo persone vere in cerca di connessioni vere.",
    "landing.f2Title": "Esperienza premium",
    "landing.f2DescLuxe": "Le donne hanno accesso gratuito mentre gli uomini investono in conversazioni significative e richieste di incontro.",
    "landing.f2DescDluxe": "Gli uomini hanno accesso gratuito mentre le donne investono in conversazioni significative e offerte di appuntamenti premium.",
    "landing.f3Title": "Profili verificati",
    "landing.f3Desc": "Tutti i profili sono verificati per garantirne l'autenticità. Incontra persone vere, crea connessioni vere.",
    "landing.refBadge": "Invita e guadagna",
    "landing.refTitle1": "Invita gli amici,",
    "landing.refTitle2": "sblocca le ricompense",
    "landing.refDesc1": "Ogni membro ha un link di invito personale. Condividilo con gli amici e guadagna uno",
    "landing.refDescBold": "slot premium da $50 GRATIS",
    "landing.refDesc2": "più funzioni bonus esclusive quando si iscrivono e diventano attivi.",
    "landing.refCard1Title": "Slot premium da $50 GRATIS",
    "landing.refCard1Desc": "Guadagnato per ogni amico che si iscrive e diventa attivo",
    "landing.refCard2Title": "Funzioni bonus",
    "landing.refCard2Desc": "Vantaggi esclusivi riservati ai migliori ambasciatori",
    "landing.refCta": "Iscriviti e ottieni il tuo link",
    "landing.ctaTitle": "Pronto a trovare la tua anima gemella?",
    "landing.ctaSub": "Unisciti a migliaia di single che hanno trovato connessioni significative su {app}.",
    "landing.ctaBtn": "Crea un account gratis",
    "landing.footerTerms": "Termini e condizioni",
    "pp.balance": "Saldo disponibile",
    "pp.balanceNote": "Da offerte di appuntamento accettate (80% dopo la commissione della piattaforma)",
    "pp.email": "Email PayPal *",
    "pp.emailHint": "È qui che invieremo i tuoi pagamenti",
    "pp.confirmEmail": "Conferma email PayPal *",
    "pp.confirmPh": "Reinserisci la tua email",
    "pp.emailsMatch": "Le email coincidono",
    "pp.verified": "Verificato",
    "pp.username": "Username PayPal (opzionale)",
    "pp.qr": "QR code PayPal (opzionale)",
    "pp.qrUpload": "Carica QR code",
    "pp.qrHint": "Carica il tuo QR code di pagamento PayPal per bonifici facili",
    "pp.save": "Salva e verifica impostazioni PayPal",
    "pp.howTitle": "ℹ️ Come funzionano i pagamenti",
    "pp.how1": "I membri inviano offerte di appuntamento con importi ($100-$1000)",
    "pp.how2": "Quando accetti e pagano, ricevi l'80% (la piattaforma trattiene il 20%)",
    "pp.how3": "I pagamenti vengono inviati alla tua email PayPal entro 3-5 giorni lavorativi",
    "pp.how4": "Il tuo saldo si aggiorna dopo ogni appuntamento confermato",
    "rel.title": "Relazione ufficiale",
    "rel.activeWith": "💞 Ufficialmente insieme a {name}",
    "rel.activeSince": "Dal {date} — siete entrambi nascosti a tutti gli altri.",
    "rel.chat": "Chatta",
    "rel.planDate": "Organizza un appuntamento",
    "rel.end": "Termina la relazione",
    "rel.incomingTitle": "💍 {name} vuole rendere la cosa ufficiale con te!",
    "rel.incomingDesc": "Accetta e sparirete entrambi dal feed degli altri — l'app sarà solo per voi due.",
    "rel.accept": "Accetta 💞",
    "rel.decline": "Non ancora",
    "rel.waitingFor": "⏳ In attesa di {name}",
    "rel.waitingDesc": "La tua richiesta di ufficializzazione è in attesa di risposta.",
    "rel.cancelRequest": "Annulla richiesta",
    "rel.endTitle": "Terminare la relazione ufficiale?",
    "rel.endDesc": "Tu e {name} tornerete visibili a tutti e potrete sfogliare altri membri. Le vostre chat e la cronologia restano intatte.",
    "rel.keepIt": "Mantienila",
    "rel.goOfficial": "Ufficializza — nascondici a tutti gli altri",
    "rel.requestSent": "⏳ Richiesta inviata — in attesa di {name}",
    "rel.togetherSince": "💞 Ufficialmente insieme dal {date}",
    "rel.together": "💞 Ufficialmente insieme",
    "rel.coupleTitle": "💞 Siete ufficialmente insieme",
    "rel.coupleDesc": "Tu e {name} siete nascosti a tutti gli altri. L'app è solo per voi due — chat, incontri e appuntamenti premium.",
    "rel.coupleHint": "Cambio di programma? Ognuno di voi può terminarla in qualsiasi momento nelle Impostazioni.",
    "rel.toastSent": "💍 Richiesta di ufficializzazione inviata a {name}!",
    "rel.toastTogether": "💞 Tu e {name} siete ufficialmente insieme!",
    "rel.toastEnded": "Relazione terminata — sei di nuovo visibile nell'app",
    "rel.toastPrivate": "Questo membro è in una relazione ufficiale 💞",
    "rel.toastActive": "Sei in una relazione ufficiale — l'app ora è solo per voi due 💞",
    "invite.admirerTitle": "Hai un ammiratore segreto 💘",
    "invite.dreamTitle": "{name} custodisce un invito a un appuntamento da sogno per te",
    "invite.admirerSub": "{name} ha un messaggio di un ammiratore segreto che ti aspetta — ma resta sigillato finché non ti iscrivi.",
    "invite.dreamSub": "Qualcuno ha organizzato qualcosa di speciale — i dettagli restano sigillati finché non ti iscrivi.",
    "invite.lock": "Iscriviti gratis per sbloccare la tua sorpresa",
    "invite.claimedNote": "Questo invito è già stato svelato. Iscriviti comunque e scopri chi ti sta aspettando!",
    "invite.reveal": "Svela la mia sorpresa",
    "invite.login": "Già membro? Accedi",
    "invite.expired": "Questo invito è scaduto",
    "invite.explore": "Esplora LuxeMeet",
    "landing.goBadge": "Fatto per i finali veri",
    "landing.goTitle1": "Quando diventa una cosa seria,",
    "landing.goTitle2": "ufficializzate 💞",
    "landing.goDesc": "Hai trovato la persona giusta? Un tocco e sparite entrambi dal feed degli altri — niente profili, niente messaggi, niente distrazioni. L'app diventa solo per voi due: chat privata, incontri e appuntamenti premium. E se le cose cambiano, ognuno può disattivarla in qualsiasi momento.",
    "landing.goChip1": "🙈 Invisibili a tutti gli altri",
    "landing.goChip2": "💬 Tra voi due resta tutto aperto",
    "landing.goChip3": "🔄 Reversibile in qualsiasi momento",
    "common.years": "anni",
    "form.proposedDateTime": "Data e ora proposte",
    "form.duration": "Durata (opzionale)",
    "form.proposedLocation": "Luogo proposto",
    "form.messageOptional": "Messaggio (opzionale)",
    "form.openEnded": "Senza limite",
    "form.writeMessage": "Scrivi il tuo messaggio...",
    "form.addPersonalMessage": "Aggiungi un messaggio personale...",
    "form.searchVenue": "Cerca il luogo o l'indirizzo esatto...",
    "offerModal.selectDateType": "Seleziona il tipo di appuntamento...",
    "offerModal.amountPlaceholder": "Inserisci l'importo (100-1000)",
    "offerModal.amountHint": "Pagherai questo importo se il tuo appuntamento accetta ({fee}% di commissione)",
    "offerModal.transportHint": "Pagato insieme alla tua offerta e girato al 100% al tuo appuntamento per il trasporto (senza commissioni).",
    "offerModal.durationHint": "Quanto vuoi che duri l'appuntamento — aspettative chiare per entrambi.",
    "tour.subtitle": "Un test di 60 secondi — non viene mai addebitato nulla",
    "tour.step1Title": "Saluta in chat",
    "tour.step1Desc": "{name} ti ha già scritto — invia una risposta",
    "tour.step2Title": "Richiedi un incontro",
    "tour.step2Desc": "Totalmente gratis — guarda come viene accettato",
    "tour.step3Title": "Invia un'offerta di appuntamento premium",
    "tour.step3DescSent": "Inviata! Simula il pagamento nella pagina Offerte",
    "tour.step3Desc": "Niente slot, niente soldi veri — simulazione completa",
    "tour.go": "Vai",
    "tour.doneTitle": "Hai padroneggiato LuxeMeet! 🎉",
    "tour.doneDesc": "Chat, incontri e appuntamenti premium — hai provato tutto. Ora vai a cercare quello vero.",
    "tour.browseReal": "Sfoglia membri reali",
    "common.freeTest": "Prova gratis",
    "discover.aiTestNote": "Compagno di prova — chat, incontri e appuntamenti premium sono simulazioni GRATUITE. Mai pagamenti reali.",
    "discover.meetUp": "Vedersi",
    "profile.msgTitle": "Invia un messaggio a {name}",
    "profile.msgCostPayer": "Iniziare una conversazione costa 10 crediti, poi 5 crediti a messaggio. Le sue risposte sono gratis.",
    "profile.msgFree": "Gratis per te su {app} — questa chat arriva nella sua inbox {app}, dove rispondere costa crediti.",
    "profile.sendMessage": "Invia messaggio",
    "profile.meetupTitle": "Richiedi un incontro con {name}",
    "profile.meetupCost": "Richiedere un incontro costa 25 crediti.",
    "profile.meetupFree": "Gratis per te su {app} — la richiesta apparirà nei suoi incontri {app}.",
    "profile.meetupTest": "🧪 Prova gratuita — il tuo compagno IA accetterà automaticamente per mostrarti tutto il flusso. Nessun credito.",
    "profile.sendMeetup": "Invia richiesta",
    "profile.costsMsg": "Messaggio: 10 crediti (primo) / 5 crediti (risposta)",
    "profile.costsMeetup": "Richiesta di incontro: 25 crediti",
    "offerModal.title": "Invia offerta di appuntamento premium",
    "offerModal.desc": "Invia un'offerta economica di appuntamento a {name}",
    "offerModal.testBanner": "🧪 Prova con {name} — nessuno slot necessario, il pagamento è simulato (mai addebitato).",
    "offerModal.needSlot": "Devi prima acquistare uno slot premium",
    "offerModal.purchaseSlot": "Acquista slot (50 $)",
    "offerModal.slotsAvailable": "Slot disponibili: {n}",
    "offerModal.testNoSlot": "Offerta di prova — nessuno slot richiesto",
    "offerModal.repeatNoSlot": "Appuntamento ripetuto — nessuno slot richiesto",
    "offerModal.amount": "Importo dell'offerta *",
    "offerModal.transport": "Trasporto (opzionale)",
    "offerModal.proposedDate": "Data proposta *",
    "offerModal.proposedTime": "Ora proposta *",
    "offerModal.duration": "Durata (opzionale)",
    "offerModal.location": "Luogo *",
    "offerModal.dateType": "Tipo di appuntamento *",
    "offerModal.message": "Messaggio (opzionale)",
    "offerModal.sendOffer": "Invia offerta",
    "voucher.unlimitedActive": "Offerte di appuntamenti illimitate attive 🏆",
    "voucher.unlimitedUntil": "Nessuno slot necessario fino al {date} — privilegio da campione.",
    "voucher.championPrize": "Premio campione: 2 settimane di offerte illimitate",
    "voucher.giftFrom": "Regalo di {name}: 2 settimane di offerte illimitate",
    "voucher.activate": "Attiva le mie 2 settimane",
    "voucher.giftIt": "Regala",
    "voucher.haveCode": "Hai un codice regalo?",
    "voucher.redeem": "Riscatta",
    "voucher.giftsSent": "Regali inviati",
    "ideas.near": "Ispirazione per appuntamenti vicino a",
    "ideas.plan": "Organizza questo appuntamento",
    "ideas.popular": "Luoghi per appuntamenti popolari sulla piattaforma",
    "ideas.map": "Mappa",
    "ideas.cityTitle": "Idee per appuntamenti in un'altra città",
    "ideas.cityDesc": "Stai pianificando un viaggio o un appuntamento altrove? Scegli una città e cureremo idee lì.",
    "ideas.show": "Mostra idee",
    "ideas.whoFor": "Per chi è questo appuntamento?",
    "ideas.pickDesc": "scegli un match e precompileremo la tua offerta premium.",
    "ideas.emptyPrefix": "Ancora nessun match — aggiungi qualcuno ai preferiti in",
    "ideas.emptySuffix": "o inizia prima una chat.",
    "profile.videos": "VIDEO",
  },
};
